import { jsx as h, jsxs as M, Fragment as We } from "react/jsx-runtime";
import * as T from "react";
import ge, { forwardRef as A, useMemo as K, useRef as oe, useState as U, useEffect as Y, useReducer as Fh, useCallback as fe, isValidElement as Xd, cloneElement as tn, useLayoutEffect as nn, createContext as be, useContext as se, Children as Tt, createRef as Vh, useId as yr, Component as Oh, useInsertionEffect as Zd, Fragment as qd, createElement as zh, useImperativeHandle as Nh } from "react";
import { styled as v, css as C, useTheme as ie, keyframes as Gs, createGlobalStyle as Wh } from "styled-components";
import * as Jd from "react-dom";
import { createPortal as _h } from "react-dom";
import Qd from "react-textarea-autosize";
const jh = {
  brand: "#FF0032",
  premium: "linear-gradient(48deg, #9BD5FF 6.25%, #9B93FF 44.27%, #9A8DFF 58.33%, #7C86FE 84.9%)",
  text: {
    primary: "#1D2023",
    secondary: "#626C77",
    tertiary: "#969FA8",
    inverted: "#FAFAFA",
    positive: "#12B23F",
    negative: "#D8400C",
    primaryLink: "#0070E5",
    visitedLink: "#883888",
    primaryLinkInverted: "#45B6FC",
    secondaryLink: "#626C77",
    inactiveTabbar: "#6E7782"
  },
  background: {
    primary: "#FFFFFF",
    primaryElevated: "#FFFFFF",
    modal: "#FFFFFF",
    stroke: "rgba(188, 195, 208, 0.5)",
    secondary: "#F2F3F7",
    secondaryElevated: "#FFFFFF",
    overlay: "rgba(29, 32, 35, 0.4)",
    overlayAlternative: "rgba(29, 32, 35, 0.4)",
    inverted: "#1D2023",
    hover: "rgba(188, 195, 208, 0.25)",
    bar: "rgba(255, 255, 255, 0.88)",
    disabled: "#F8F8FB",
    strokeDisabled: "rgba(188, 195, 208, 0.25)",
    lower: "#F2F3F7"
  },
  icons: {
    primary: "#1D2023",
    secondary: "#8D969F",
    tertiary: "#BBC1C7"
  },
  control: {
    primaryActive: "#FF0032",
    secondaryActive: "#1D2023",
    tertiaryActive: "#F2F3F7",
    blur: "rgba(255, 255, 255, 0.08)",
    stroke: "#8D969F",
    inactive: "rgba(188, 195, 208, 0.5)",
    alternative: "#FFFFFF",
    activeTabbar: "#FF0032",
    inactiveTabbar: "#8D969F",
    hoverPrimary: "rgba(188, 195, 208, 0.4)",
    hoverAlternative: "rgba(242, 243, 247, 0.12)"
  },
  accent: {
    active: "#007CFF",
    positive: "#26CD58",
    warning: "#FAC031",
    negative: "#f95721",
    activeInverted: "#45B6FC",
    positiveInverted: "#74DF8B",
    warningInverted: "#FAD67D",
    negativeInverted: "#FA8A64",
    notification: "#FF0032"
  }
}, Hh = {
  brand: "#FF0032",
  premium: "linear-gradient(48deg, #9BD5FF 6.25%, #9B93FF 44.27%, #9A8DFF 58.33%, #7C86FE 84.9%)",
  text: {
    primary: "#FAFAFA",
    secondary: "#969FA8",
    tertiary: "#626C77",
    inverted: "#1D2023",
    positive: "#74DF8B",
    negative: "#FFA080",
    primaryLink: "#45B6FC",
    visitedLink: "#B767B7",
    primaryLinkInverted: "#0070E5",
    secondaryLink: "#969FA8",
    inactiveTabbar: "#FFFFFF75"
  },
  background: {
    primary: "#000000",
    primaryElevated: "#1D2023",
    modal: "#2C3135",
    stroke: "#7F8C9959",
    secondary: "#626C7740",
    secondaryElevated: "#626C7740",
    overlay: "rgba(29, 32, 35, 0.9)",
    overlayAlternative: "rgba(0, 0, 0, 0.64)",
    inverted: "#FFFFFF",
    hover: "rgba(188, 195, 208, 0.5)",
    bar: "rgba(0, 0, 0, 0.7)",
    disabled: "rgba(98, 108, 119, 0.15)",
    strokeDisabled: "rgba(127, 140, 153, 0.1)",
    lower: "#000000"
  },
  icons: {
    primary: "#FAFAFA",
    secondary: "#969FA8",
    tertiary: "#626C77"
  },
  control: {
    primaryActive: "#ff0032",
    secondaryActive: "#FFFFFF",
    tertiaryActive: "rgba(127, 140, 153, 0.35)",
    blur: "rgba(255, 255, 255, 0.08)",
    stroke: "#636B72",
    inactive: "rgba(127, 140, 153, 0.35)",
    alternative: "rgba(127, 140, 153, 0.35)",
    activeTabbar: "#FFFFFF",
    inactiveTabbar: "rgba(188, 195, 208, 0.5)",
    hoverPrimary: "rgba(188, 195, 208, 0.4)",
    hoverAlternative: "rgba(188, 195, 208, 0.4)"
  },
  accent: {
    active: "#45B6FC",
    positive: "#74DF8B",
    warning: "#FAD67D",
    negative: "#FA8A64",
    activeInverted: "#007CFF",
    positiveInverted: "#26CD58",
    warningInverted: "#FAC031",
    negativeInverted: "#F95721",
    notification: "#FF0032"
  }
}, Uh = {
  brand: "#8F8FFF",
  premium: "linear-gradient(48deg, #9BD5FF 6.25%, #9B93FF 44.27%, #9A8DFF 58.33%, #7C86FE 84.9%)",
  text: {
    primary: "#1D2023",
    secondary: "#626C77",
    tertiary: "#969fA8",
    inverted: "#FAFAFA",
    positive: "#12B23F",
    negative: "#D8400C",
    primaryLink: "#0070E5",
    visitedLink: "#883888",
    primaryLinkInverted: "#45B6FC",
    secondaryLink: "#626C77",
    inactiveTabbar: "#6E7782"
  },
  background: {
    primary: "#ffffff",
    primaryElevated: "#ffffff",
    modal: "#FFFFFF",
    stroke: "rgba(188, 195, 208, 0.5)",
    secondary: "#F2F3F7",
    secondaryElevated: "#FFFFFF",
    overlay: "rgba(29, 32, 35, 0.4)",
    overlayAlternative: "rgba(29, 32, 35, 0.4)",
    inverted: "#1D2023",
    hover: "rgba(188, 195, 208, 0.25)",
    bar: "rgba(255, 255, 255, 0.88)",
    disabled: "#F8F8FB",
    strokeDisabled: "rgba(188, 195, 208, 0.25)",
    lower: "#F2F3F7"
  },
  icons: {
    primary: "#1D2023",
    secondary: "#8D969F",
    tertiary: "#BBC1C7"
  },
  control: {
    primaryActive: "#8F8FFF",
    secondaryActive: "#1D2023",
    tertiaryActive: "#F2F3F7",
    blur: "rgba(255, 255, 255, 0.08)",
    stroke: "#8D969F",
    inactive: "rgba(188, 195, 208, 0.5)",
    alternative: "#FFFFFF",
    activeTabbar: "#8F8FFF",
    inactiveTabbar: "#8D969F",
    hoverPrimary: "rgba(188, 195, 208, 0.4)",
    hoverAlternative: "rgba(242, 243, 247, 0.12)"
  },
  accent: {
    active: "#007CFF",
    positive: "#26CD58",
    warning: "#FAC031",
    negative: "#F95721",
    activeInverted: "#45B6FC",
    positiveInverted: "#74DF8B",
    warningInverted: "#FAD67D",
    negativeInverted: "#FA8A64",
    notification: "#FF0032"
  }
}, Gh = {
  brand: "#8F8FFF",
  premium: "linear-gradient(48deg, #9BD5FF 6.25%, #9B93FF 44.27%, #9A8DFF 58.33%, #7C86FE 84.9%)",
  text: {
    primary: "#FAFAFA",
    secondary: "#969FA8",
    tertiary: "#626C77",
    inverted: "#1D2023",
    positive: "#74DF8B",
    negative: "#FFA080",
    primaryLink: "#45B6FC",
    visitedLink: "#B767B7",
    primaryLinkInverted: "#0070E5",
    secondaryLink: "#969FA8",
    inactiveTabbar: "#FFFFFF75"
  },
  background: {
    primary: "#000000",
    primaryElevated: "#1D2023",
    modal: "#2C3135",
    stroke: "#7F8C9959",
    secondary: "#626C7740",
    secondaryElevated: "#626C7740",
    overlay: "rgba(29, 32, 35, 0.9)",
    overlayAlternative: "rgba(0, 0, 0, 0.64)",
    inverted: "#FFFFFF",
    hover: "rgba(188, 195, 208, 0.5)",
    bar: "rgba(0, 0, 0, 0.7)",
    disabled: "rgba(98, 108, 119, 0.15)",
    strokeDisabled: "rgba(127, 140, 153, 0.1)",
    lower: "#000000"
  },
  icons: {
    primary: "#BCC3D080",
    secondary: "#969FA8",
    tertiary: "#626C77"
  },
  control: {
    primaryActive: "#8F8FFF",
    secondaryActive: "#FFFFFF",
    tertiaryActive: "rgba(127, 140, 153, 0.35)",
    blur: "rgba(255, 255, 255, 0.08)",
    stroke: "#636B72",
    inactive: "rgba(127, 140, 153, 0.35)",
    alternative: "rgba(127, 140, 153, 0.35)",
    activeTabbar: "#FFFFFF",
    inactiveTabbar: "rgba(188, 195, 208, 0.5)",
    hoverPrimary: "rgba(188, 195, 208, 0.4)",
    hoverAlternative: "rgba(188, 195, 208, 0.4)"
  },
  accent: {
    active: "#45B6FC",
    positive: "#74DF8B",
    warning: "#FAD67D",
    negative: "#FA8A64",
    activeInverted: "#007CFF",
    positiveInverted: "#26CD58",
    warningInverted: "#FAC031",
    negativeInverted: "#F95721",
    notification: "#FF0032"
  }
}, me = {
  mobile: 360,
  tablet: 768,
  desktopXS: 960,
  desktopS: 1280,
  desktopM: 1440,
  desktopL: 1680,
  desktopXL: 1920
}, Ho = {
  constant: {
    greyscale0: "#ffffff",
    greyscale100: "#f2f3f7",
    greyscale200: "#e2e5eb",
    greyscale300: "#bbc1c7",
    greyscale400: "#969fa8",
    greyscale500: "#626c77",
    greyscale600: "#434a51",
    greyscale700: "#2c3135",
    greyscale800: "#1d2023",
    greyscale900: "#000000",
    blackberry: {
      lightest: "#e7eafa",
      light: "#6384e0",
      normal: "#014fce",
      dark: "#003db7",
      darkest: "#002094"
    },
    blueberry: {
      lightest: "#e1f3fe",
      light: "#45b6fc",
      normal: "#0097fd",
      dark: "#007cff",
      darkest: "#0048aa"
    },
    mint: {
      lightest: "#dff9f5",
      light: "#00d9bc",
      normal: "#00c19b",
      dark: "#03a17b",
      darkest: "#00724d"
    },
    apple: {
      lightest: "#e8faeb",
      light: "#74df8b",
      normal: "#26cd58",
      dark: "#04aa42",
      darkest: "#027722"
    },
    lime: {
      lightest: "#f8fee7",
      light: "#d3f36b",
      normal: "#c1eb1d",
      dark: "#a6c100",
      darkest: "#808201"
    },
    banana: {
      lightest: "#fffde8",
      light: "#fdf177",
      normal: "#fbe739",
      dark: "#fac031",
      darkest: "#f37f19"
    },
    orange: {
      lightest: "#fbe9e7",
      light: "#ffa080",
      normal: "#f95721",
      dark: "#e04a17",
      darkest: "#ba360a"
    },
    raspberry: {
      lightest: "#ffe4e9",
      light: "#f55f7e",
      normal: "#ea1f49",
      dark: "#c51345",
      darkest: "#8e003f"
    },
    cranberry: {
      lightest: "#f9e7f0",
      light: "#e677ad",
      normal: "#e54887",
      dark: "#bb4079",
      darkest: "#7f3363"
    },
    plum: {
      lightest: "#f0e7f0",
      light: "#a86ea7",
      normal: "#883888",
      dark: "#6d2d79",
      darkest: "#471c61"
    }
  }
}, re = {
  mtsSans: '"MTS Sans", "Arial", "Helvetica", sans-serif',
  mtsWide: '"MTS Wide", sans-serif',
  mtsCompact: '"MTS Compact", sans-serif',
  mtsText: '"MTS Text", sans-serif'
}, Kh = {
  promo1UppWide: {
    family: re.mtsWide,
    weight: 500,
    size: 72,
    lineHeight: 72,
    textTransform: "uppercase"
  },
  promo1Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 72,
    lineHeight: 72
  },
  promo2UppWide: {
    family: re.mtsWide,
    weight: 500,
    size: 56,
    lineHeight: 56,
    textTransform: "uppercase"
  },
  promo2Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 56,
    lineHeight: 56
  },
  promo3UppWide: {
    family: re.mtsWide,
    weight: 500,
    size: 44,
    lineHeight: 44,
    textTransform: "uppercase"
  },
  promo3Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 44,
    lineHeight: 44
  },
  promo4UppWide: {
    family: re.mtsWide,
    weight: 500,
    size: 36,
    lineHeight: 36,
    textTransform: "uppercase"
  },
  promo4Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 36,
    lineHeight: 36
  },
  h1Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 36,
    lineHeight: 40
  },
  h1Comp: {
    family: re.mtsCompact,
    weight: 500,
    size: 36,
    lineHeight: 40
  },
  h2Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 32,
    lineHeight: 36
  },
  h2Comp: {
    family: re.mtsCompact,
    weight: 500,
    size: 32,
    lineHeight: 36
  },
  h3Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 24,
    lineHeight: 28
  },
  h3Comp: {
    family: re.mtsCompact,
    weight: 500,
    size: 24,
    lineHeight: 28
  },
  h3Text: {
    family: re.mtsText,
    weight: 500,
    size: 24,
    lineHeight: 28
  },
  h4Wide: {
    family: re.mtsWide,
    weight: 500,
    size: 20,
    lineHeight: 24
  },
  h4Comp: {
    family: re.mtsCompact,
    weight: 500,
    size: 20,
    lineHeight: 24
  },
  h4Text: {
    family: re.mtsText,
    weight: 500,
    size: 20,
    lineHeight: 24
  },
  p1RegularComp: {
    family: re.mtsCompact,
    weight: 400,
    size: 24,
    lineHeight: 32
  },
  p1RegularText: {
    family: re.mtsText,
    weight: 400,
    size: 24,
    lineHeight: 32
  },
  p2RegularComp: {
    family: re.mtsCompact,
    weight: 400,
    size: 20,
    lineHeight: 28
  },
  p2RegularText: {
    family: re.mtsText,
    weight: 400,
    size: 20,
    lineHeight: 28
  },
  p3BoldComp: {
    family: re.mtsCompact,
    weight: 700,
    size: 17,
    lineHeight: 24
  },
  p3MediumComp: {
    family: re.mtsCompact,
    weight: 500,
    size: 17,
    lineHeight: 24
  },
  p3MediumText: {
    family: re.mtsText,
    weight: 500,
    size: 17,
    lineHeight: 24
  },
  p3RegularComp: {
    family: re.mtsCompact,
    weight: 400,
    size: 17,
    lineHeight: 24
  },
  p3RegularText: {
    family: re.mtsText,
    weight: 400,
    size: 17,
    lineHeight: 24
  },
  p4BoldUppWide: {
    family: re.mtsWide,
    weight: 700,
    size: 14,
    lineHeight: 20,
    letterSpacing: 0.8,
    textTransform: "uppercase"
  },
  p4BoldComp: {
    family: re.mtsCompact,
    weight: 700,
    size: 14,
    lineHeight: 20
  },
  p4MediumComp: {
    family: re.mtsCompact,
    weight: 500,
    size: 14,
    lineHeight: 20
  },
  p4MediumUppComp: {
    family: re.mtsCompact,
    weight: 500,
    size: 14,
    lineHeight: 20,
    textTransform: "uppercase"
  },
  p4MediumUppText: {
    family: re.mtsText,
    weight: 500,
    size: 14,
    lineHeight: 20,
    textTransform: "uppercase"
  },
  p4RegularComp: {
    family: re.mtsCompact,
    weight: 400,
    size: 14,
    lineHeight: 20
  },
  p4RegularText: {
    family: re.mtsText,
    weight: 400,
    size: 14,
    lineHeight: 20
  },
  c1BoldUppWide: {
    family: re.mtsWide,
    weight: 700,
    size: 12,
    lineHeight: 16,
    letterSpacing: 0.8,
    textTransform: "uppercase"
  },
  c1BoldComp: {
    family: re.mtsCompact,
    weight: 700,
    size: 12,
    lineHeight: 16
  },
  c1MediumUppComp: {
    family: re.mtsCompact,
    weight: 500,
    size: 12,
    lineHeight: 16,
    textTransform: "uppercase"
  },
  c1MediumComp: {
    family: re.mtsCompact,
    weight: 500,
    size: 12,
    lineHeight: 16
  },
  c1RegularComp: {
    family: re.mtsCompact,
    weight: 400,
    size: 12,
    lineHeight: 16
  },
  c2BoldUppWide: {
    family: re.mtsWide,
    weight: 700,
    size: 10,
    lineHeight: 12,
    letterSpacing: 0.8,
    textTransform: "uppercase"
  }
}, ae = (e) => {
  const { size: t, weight: n, family: r, lineHeight: o, textTransform: i, letterSpacing: s } = Kh[e];
  return `
    font-size: ${t}px;
    font-family: ${r};
    font-weight: ${n};
    line-height: ${o}px;
    letter-spacing: ${s ? `${s}px` : "unset"}; 
    text-transform: ${i || "unset"};
  `;
}, Uo = {
  "shadow-lowest": "0 0 6px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.08)",
  "shadow-low": "0 0 16px rgba(0, 0, 0, 0.08), 0 4px 16px rgba(0, 0, 0, 0.08)",
  "shadow-middle": "0 4px 24px rgba(0, 0, 0, 0.12), 0 8px 16px rgba(0, 0, 0, 0.08)",
  "shadow-upper-middle": "0 -2px 24px rgba(0, 0, 0, 0.08), 0 -8px 24px rgba(0, 0, 0, 0.1)",
  "shadow-high": "0 4px 24px rgba(0, 0, 0, 0.12), 0 12px 20px rgba(0, 0, 0, 0.14)"
}, Et = {
  s0: 0,
  s2: 2,
  s4: 4,
  s8: 8,
  s12: 12,
  s16: 16,
  s20: 20,
  s24: 24,
  s32: 32,
  s36: 36,
  s40: 40,
  s48: 48,
  s64: 64,
  s80: 80
}, fE = {
  breakpoints: me,
  fonts: re,
  shadows: Uo,
  spacings: Et,
  colors: {
    ...Ho,
    ...jh
  }
}, hE = {
  breakpoints: me,
  fonts: re,
  shadows: Uo,
  spacings: Et,
  colors: {
    ...Ho,
    ...Hh
  }
}, mE = {
  breakpoints: me,
  fonts: re,
  shadows: Uo,
  spacings: Et,
  colors: {
    ...Ho,
    ...Uh
  }
}, gE = {
  breakpoints: me,
  fonts: re,
  shadows: Uo,
  spacings: Et,
  colors: {
    ...Ho,
    ...Gh
  }
}, Yh = v.p`
  color: ${(e) => e.color || e.theme.colors.text.primary};
  ${(e) => e.textAlign && C`
      text-align: ${e.textAlign};
    `};
  ${(e) => ae(e.font || "p4MediumComp")};
`, jt = ({
  children: e,
  ...t
}) => /* @__PURE__ */ h(Yh, { ...t, children: e }), eu = A((e, t) => {
  const { withMargin: n, className: r, direction: o = "horizontal", ...i } = e;
  return /* @__PURE__ */ h(
    Xh,
    {
      ...i,
      "data-testid": "divider",
      ref: t,
      className: r,
      withMargin: n,
      direction: o
    }
  );
}), Xh = v.hr`
  all: unset;
  display: flex;
  background: ${({ theme: e }) => e.colors.background.stroke};

  ${({ direction: e, withMargin: t }) => {
  if (e === "vertical")
    return C`
        flex-direction: column;
        width: 1px;
        min-width: 1px;
        max-width: 1px;
        height: 100%;
        margin: ${t ? "12px 8px 12px 7px" : 0};
      `;
  if (e === "horizontal")
    return C`
        flex-direction: row;
        width: 100%;
        height: 1px;
        min-height: 1px;
        max-height: 1px;
        margin: ${t ? "7px 12px 8px" : 0};
      `;
}}
`, ss = {
  16: {
    radius: "4px",
    gap: "2px",
    font: "c1RegularComp"
  },
  20: {
    radius: "6px",
    gap: "4px",
    font: "p4RegularComp"
  },
  24: {
    radius: "8px",
    gap: "4px",
    font: "p3RegularComp"
  }
}, Zh = {
  none: "transparent",
  solid: "currentColor",
  dashed: "linear-gradient(to right, currentColor 0%, currentColor 50%, transparent 50%);"
}, qh = v.a((e) => {
  const { theme: t, size: n = 20, iconPosition: r, color: o = "primary" } = e, i = {
    primary: t.colors.text.primaryLink,
    secondary: t.colors.text.secondaryLink,
    black: t.colors.text.primary,
    white: t.colors.text.inverted,
    inverted: t.colors.text.primaryLinkInverted
  };
  return C`
    all: unset;
    cursor: pointer;
    text-decoration: none;
    outline: none;
    display: inline-flex;
    flex-direction: ${r === "end" ? "row" : "row-reverse"};
    align-items: center;
    gap: ${ss[n].gap};
    width: fit-content;
    box-sizing: border-box;
    border-radius: ${ss[n].radius};
    color: ${i[o]};
    &:focus-visible {
      border: ${`1px solid ${t.colors.accent.active}`};
      border-radius: 4px;
      padding: 2px 2px 1px 2px;
    }
    &:visited {
      color: ${t.colors.text.visitedLink};
    }
    &:active {
      color: ${t.colors.text.visitedLink};
    }
    svg {
      color: ${i[o]};
    }
  `;
}), Jh = v(jt)`
  display: block;
  margin: 0;
  box-sizing: border-box;
  position: relative;
  ${({ fontInherit: e }) => e && C`
      font: inherit;
    `}
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 0;
    background: ${({ underline: e = "none" }) => Zh[e]};
    background-size: 8px 1px;
  }
  &:hover::before {
    background: ${({ underline: e }) => e === "none" ? "currentColor" : "transparent"};
  }
`, rl = {
  Link: qh,
  LinkText: Jh
}, Qh = A((e, t) => {
  const {
    icon: n,
    iconPosition: r = "end",
    children: o,
    href: i,
    size: s = 16,
    color: a = "primary",
    underline: l = "none",
    fontInherit: c = !1,
    textDecoration: d,
    className: u,
    ...p
  } = e, f = K(() => d && d === "underline" ? "solid" : l, [d, l]);
  return /* @__PURE__ */ M(
    rl.Link,
    {
      ...p,
      ref: t,
      href: i,
      className: u,
      size: s,
      iconPosition: r,
      color: a,
      children: [
        /* @__PURE__ */ h(
          rl.LinkText,
          {
            forwardedAs: "p",
            font: ss[s].font,
            color: "currentColor",
            underline: f,
            fontInherit: c,
            children: o
          }
        ),
        n && /* @__PURE__ */ h(q, { icon: n, color: "currentColor", width: 16, height: 16 })
      ]
    }
  );
}), tu = [
  {
    token: "link",
    component: Qh,
    content: !0,
    defaultProps: {
      target: "_self",
      fontInherit: !0
    },
    props: [
      {
        name: "href",
        required: !0
      },
      {
        name: "target",
        content: ["_blank", "_self", "_parent", "_top"]
      }
    ]
  },
  {
    token: "hr",
    component: eu
  },
  {
    token: "h1",
    component: jt,
    content: !0,
    defaultProps: {
      as: "h1",
      font: "h1Comp"
    }
  },
  {
    token: "h2",
    component: jt,
    content: !0,
    defaultProps: {
      as: "h2",
      font: "h2Comp"
    }
  },
  {
    token: "h3",
    component: jt,
    content: !0,
    defaultProps: {
      as: "h3",
      font: "h3Comp"
    }
  },
  {
    token: "h4",
    component: jt,
    content: !0,
    defaultProps: {
      as: "h4",
      font: "h4Comp"
    }
  },
  {
    token: "h5",
    component: jt,
    content: !0,
    defaultProps: {
      as: "h5",
      font: "p3RegularText"
    }
  },
  {
    token: "br",
    component: "br"
  },
  {
    token: "medium",
    component: "b",
    content: !0
  },
  {
    token: "bold",
    component: "strong",
    content: !0
  },
  {
    token: "sup",
    component: "sup",
    content: !0
  },
  {
    token: "sub",
    component: "sub",
    content: !0
  }
], vE = {
  token: "Токен в DSL  (string, обязательно)",
  // TODO : get component name as strings without breaking tree-shaking (not to import every component from kit)
  component: "Компонент из кита, или html тег, на который надо заменить токен (component||string(теги), обязательно)",
  content: "Флаг указывающий, что токен содержит в себе текст. (bool, default : false)",
  defautlProps: {
    propName: "Проп и его значение которое должно передаться в компонент по умолчанию, если не предполагается его изменение, то в описании пропсов его указывать не надо"
  },
  props: [
    {
      name: "Название пропа который передаться в компонент as is",
      required: "Обязателен ли проп (bool, default : false)",
      content: "Возможные значения для пропа, если не указано, то проходит всё (array||undefined, default : undefined)"
    }
  ]
}, em = new RegExp(
  tu.map(({ token: e, content: t }) => t ? `(?={${e}.+?{/${e}})` : `(?={${e}})`).join("|"),
  "gm"
), tm = (e, t) => {
  t.forEach((n) => {
    const { name: r, required: o, content: i } = n, s = e[r];
    if (o && !s)
      throw new Error(`Required prop "${r}" is missing`);
    if (i && s && !i.includes(s))
      throw new Error(`Prop "${r}" value doesn't match allowed content: ${i}`);
  });
}, nm = (e, t, n) => {
  const r = e.split(new RegExp(`{${t}(.+?)}`)).filter((i) => !!i)[0].trim().split(/(.+?)="(.*?)"/).filter((i) => !!i);
  if (r.length % 2)
    throw new Error("Empty props is not allowed");
  const o = r.reduce((i, s, a) => (a % 2 || i.push(r.slice(a, a + 2)), i), []).reduce(
    (i, s) => Object.assign(i, { [s[0].trim()]: s[1] }),
    {}
  );
  return tm(o, n), o;
}, rm = (e, t) => {
  try {
    const { token: n, props: r, component: o, defaultProps: i, content: s } = t, a = new RegExp(
      s ? `({/${n}}|{${n}${r ? ".*?" : ""}})` : `({${n}${r ? ".*?" : ""}})`,
      "gm"
    ), l = e.split(a).filter((b) => !!b), [c, d, ...u] = l, p = u[1], f = s ? p : d, m = r ? nm(c, n, r) : {}, g = o, y = {
      ...i,
      ...m,
      ...s && { children: d }
    };
    return [/* @__PURE__ */ h(g, { ...y }), f];
  } catch (n) {
    return n instanceof Error && console.log(n.message), e;
  }
}, om = (e) => {
  const t = e.split(em).map((n) => {
    const r = tu.find((o) => new RegExp(`^{${o.token}`, "gm").test(n));
    return r ? rm(n, r) : n;
  });
  return Array.isArray(t) ? ge.Children.toArray(t) : e;
}, H = A(
  (e, t) => {
    const { as: n, children: r, className: o, font: i = "p4MediumComp", color: s, textAlign: a, ...l } = e;
    return /* @__PURE__ */ h(
      jt,
      {
        as: n || "span",
        ref: t,
        className: o,
        color: s,
        textAlign: a,
        font: i,
        ...l,
        children: typeof r == "string" ? om(r) : r
      }
    );
  }
), nu = "https://mtsdengi.ru", ru = Object.freeze({
  /**
   Lek
   */
  ALL: "L",
  "008": "L",
  /**
   Algerian Dinar 
   */
  DZD: "DA",
  "012": "DA",
  /**
   Argentine Peso
  */
  ARS: "$",
  "032": "$",
  /**
   Australian Dollar 
  */
  AUD: "$",
  "036": "$",
  /**
   Bahamian Dollar
   */
  BSD: "B$",
  "044": "B$",
  /**
   Bahraini Dinar
   */
  BHD: "BD",
  "048": "BD",
  /**
   Taka 
   */
  BDT: "৳",
  "050": "৳",
  /**
   Armenian Dram
   */
  AMD: "֏",
  "051": "֏",
  /**
   Barbados Dollar 
   */
  BBD: "Bds$",
  "052": "Bds$",
  /**
   Bermudian Dollar
   */
  BMD: "$",
  "060": "$",
  /**
   Ngultrum 
   */
  BTN: "Nu",
  "064": "Nu",
  /**
   Boliviano 
   */
  BOB: "Bs",
  "068": "Bs",
  /**
   Pula
   */
  BWP: "P",
  "072": "P",
  /**
   Belize Dollar 
   */
  BZD: "Bz$",
  "084": "Bz$",
  /**
   Solomon Islands Dollar
   */
  SBD: "$",
  "090": "$",
  /**
   Brunei Dollar
   */
  BND: "$",
  "096": "$",
  /**
   Kyat 
   */
  MMK: "K",
  104: "K",
  /**
   Burundi Franc
   */
  BIF: "FBu",
  108: "FBu",
  /**
   Riel
   */
  KHR: "៛",
  116: "៛",
  /**
   Canadian Dollar
   */
  CAD: "$",
  124: "$",
  /**
   Cabo Verde Escudo
   */
  CVE: "$",
  132: "$",
  /** 
   Cayman Islands Dollar
   */
  KYD: "$",
  136: "$",
  /**
   Sri Lanka Rupee 
   */
  LKR: "Rs",
  144: "Rs",
  /**
   Chilean Peso
   */
  CLP: "$",
  152: "$",
  /**
   China Yuan
   */
  CNY: "¥",
  156: "¥",
  /**
   Colombian Peso
   */
  COP: "COL$",
  170: "COL$",
  /**
   Comorian Franc
   */
  KMF: "₣",
  174: "₣",
  /**
   Costa Rican Colon
   */
  CRC: "₡",
  188: "₡",
  /**
   Kuna
   */
  HRK: "Kn",
  191: "Kn",
  /**
   Cuban Peso
   */
  CUP: "$",
  192: "$",
  /**
   Czech Koruna
   */
  CZK: "Kč",
  203: "Kč",
  /**
   Danish Krone
   */
  DKK: "kr.",
  208: "kr.",
  /**
   Dominican Peso
   */
  DOP: "RD$",
  214: "RD$",
  /**
   El Salvador Colon
   */
  SVC: "₡",
  222: "₡",
  /**
   Ethiopian Birr
   */
  ETB: "Br",
  230: "Br",
  /**
   Nakfa 
   */
  ERN: "Nfk",
  232: "Nfk",
  /**
   Falkland Islands Pound 
   */
  FKP: "FK£",
  238: "FK£",
  /**
   Fiji Dollar 
   */
  FJD: "$",
  242: "$",
  /**
   Djibouti Franc
   */
  DJF: "₣",
  262: "₣",
  /**
   Dalasi
   */
  GMD: "D",
  270: "D",
  /**
   Gibraltar Pound 
   */
  GIP: "£",
  292: "£",
  /**
   Quetzal
   */
  GTQ: "Q",
  320: "Q",
  /**
   Guinean Franc
   */
  GNF: "₣",
  324: "₣",
  /**
   Guyana Dollar
   */
  GYD: "G$",
  328: "G$",
  /**
   Gourde
   */
  HTG: "G",
  332: "G",
  /**
   Lempira
   */
  HNL: "L",
  340: "L",
  /**
   Hong Kong Dollar
   */
  HKD: "HK$",
  344: "HK$",
  /**
   Forint 
   */
  HUF: "ƒ",
  348: "ƒ",
  /**
   Iceland Krona
   */
  ISK: "kr",
  352: "kr",
  /**
   Indian Rupee
   */
  INR: "₹",
  356: "₹",
  /**
   Rupiah
   */
  IDR: "Rp",
  360: "Rp",
  /**
   Iranian Rial
   */
  IRR: "﷼",
  364: "﷼",
  /**
   Iraqi Dinar
   */
  IQD: "د.ع",
  368: "د.ع",
  /**
   New Israeli Sheqel
   */
  ILS: "₪",
  376: "₪",
  /**
   Jamaican Dollar
   */
  JMD: "J$",
  388: "J$",
  /**
   Japanese Yen
   */
  JPY: "¥",
  392: "¥",
  /**
   Tenge
   */
  KZT: "₸",
  398: "₸",
  /**
   Jordanian Dinar 
   */
  JOD: "JD",
  400: "JD",
  /**
   Kenyan Shilling
   */
  KES: "KSh",
  404: "KSh",
  /**
   North Korean Won
   */
  KPW: "₩",
  408: "₩",
  /**
   South Korean Won
   */
  KRW: "₩",
  410: "₩",
  /**
   Kuwaiti Dinar
   */
  KWD: "د.ك",
  414: "د.ك",
  /**
   Som
   */
  KGS: "c",
  417: "c",
  /**
   Lao Kip
   */
  LAK: "₭",
  418: "₭",
  /**
   Lebanese Pound
   */
  LBP: ".ل.ل",
  422: ".ل.ل",
  /**
   Loti 
   */
  LSL: "L",
  426: "L",
  /**
   Liberian Dollar
   */
  LRD: "Lib$",
  430: "Lib$",
  /**
   Libyan Dinar
   */
  LYD: ".د.ل",
  434: ".د.ل",
  /**
   Pataca 
   */
  MOP: "MOP$",
  446: "MOP$",
  /**
   Malawi Kwacha
   */
  MWK: "MK",
  454: "MK",
  /**
   Malaysian Ringgit 
   */
  MYR: "RM",
  458: "RM",
  /**
   Rufiyaa
   */
  MVR: "Rf",
  462: "Rf",
  /**
   Mauritius Rupee
   */
  MUR: "₨",
  480: "₨",
  /**
   Mexican peso
   */
  MXN: "$",
  484: "$",
  /**
   Tugrik
   */
  MNT: "₮",
  496: "₮",
  /**
   Moldovan leu
   */
  MDL: "L",
  498: "L",
  /**
   Moroccan Dirham
  */
  MAD: "DH",
  504: "DH",
  /**
   Rial Omani
   */
  OMR: "OMR",
  512: "OMR",
  /**
   Namibia Dollar 
   */
  NAD: "N$",
  516: "N$",
  /**
   Nepalese Rupee
   */
  NPR: "N₨",
  524: "N₨",
  /**
   Netherlands Antillean Guilder 
   */
  ANG: "ƒ",
  532: "ƒ",
  /**
   Aruban Florin
   */
  AWG: "Afl",
  533: "Afl",
  /**
   Vatu
   */
  VUV: "Vt",
  548: "Vt",
  /**
   New Zealand Dollar 
   */
  NZD: "$",
  554: "$",
  /**
   Cordoba Oro
   */
  NIO: "C$",
  558: "C$",
  /**
   Nigerian Naira
   */
  NGN: "₦",
  566: "₦",
  /**
   Norwegian Krone 
   */
  NOK: "kr",
  578: "kr",
  /**
   Pakistan Rupee
   */
  PKR: "₨",
  586: "₨",
  /**
   Balboa
   */
  PAB: "B/.",
  590: "B/.",
  /**
   Kina
   */
  PGK: "K",
  598: "K",
  /**
   Guarani
   */
  PYG: "₲",
  600: "₲",
  /**
   Sol
   */
  PEN: "S/.",
  604: "S/.",
  /**
   Philippine Peso
   */
  PHP: "₱",
  608: "₱",
  /**
   Qatari Rial 
   */
  QAR: "QR",
  634: "QR",
  /**
   Russian ruble
   */
  RUB: "₽",
  643: "₽",
  /**
   Rwanda Franc
   */
  RWF: "FRw",
  646: "FRw",
  /**
   Saint Helena Pound
   */
  SHP: "£",
  654: "£",
  /**
   Saudi Riyal
    */
  SAR: "SR",
  682: "SR",
  /**
   Seychelles Rupee
   */
  SCR: "SRe",
  690: "SRe",
  /**
   Leone
   */
  SLL: "Le",
  694: "Le",
  /**
   Singapore Dollar
   */
  SGD: "$",
  702: "$",
  /**
   Vietnamese Dong
   */
  VND: "₫",
  704: "₫",
  /**
   Somali Shilling 
   */
  SOS: "Sh.So",
  706: "Sh.So",
  /**
   Rand
   */
  ZAR: "R",
  710: "R",
  /**
   South Sudanese Pound
   */
  SSP: "Db",
  728: "Db",
  /**
   Lilangeni (pl. Emalangeni) 
   */
  SZL: "E",
  748: "E",
  /**
   Swedish Krona
   */
  SEK: "kr",
  752: "kr",
  /**
   Swiss Franc
   */
  CHF: "₣",
  756: "₣",
  /**
   Syrian Pound
   */
  SYP: "LS",
  760: "LS",
  /**
   Thai Baht
   */
  THB: "฿",
  764: "฿",
  /**
   Pa’anga
   */
  TOP: "$",
  776: "$",
  /**
   Trinidad and Tobago Dollar
   */
  TTD: "TT$",
  780: "TT$",
  /**
   UAE Dirham
   */
  AED: "AED",
  784: "AED",
  /**
   Tunisian Dinar
   */
  TND: "DT",
  788: "DT",
  /**
   Uganda Shilling
   */
  UGX: "Ush",
  800: "Ush",
  /**
   Denar
   */
  MKD: "DEN",
  807: "DEN",
  /**
   Russian ruble
   */
  RUR: "₽",
  810: "₽",
  /**
   Egyptian Pound
   */
  EGP: ".ج.م",
  818: ".ج.م",
  /**
   British Pound Sterling
   */
  GBP: "£",
  826: "£",
  /**
   Tanzanian Shilling
   */
  TZS: "TSh",
  834: "TSh",
  /**
   US Dollar
   */
  USD: "$",
  840: "$",
  /**
   Peso Uruguayo
   */
  UYU: "$U",
  858: "$U",
  /**
   Uzbek Sum
   */
  UZS: "So'm",
  860: "So'm",
  /**
   Tala
   */
  WST: "$",
  882: "$",
  /**
   Yemeni Rial
   */
  YER: ".ر.ي",
  886: ".ر.ي",
  /**
   New Taiwan Dollar
   */
  TWD: "NT$",
  901: "NT$",
  /**
   Leone
   */
  SLE: "Le",
  925: "Le",
  /**
   Bolívar Soberano
   */
  VED: "Bs.S.",
  926: "Bs.S.",
  /**
   Bolívar Soberano
   */
  VES: "Bs.S.",
  928: "Bs.S.",
  /**
   Ouguiya
   */
  MRU: "UM",
  929: "UM",
  /**
   Dobra
   */
  STN: "₡",
  930: "₡",
  /**
   Peso Convertible 
   */
  CUC: "CUC$",
  931: "CUC$",
  /**
   Zimbabwe Dollar
   */
  ZWL: "$",
  932: "$",
  /**
   Belarusian Ruble
   */
  BYN: "Br",
  933: "Br",
  /**
   Turkmenistan New Manat
   */
  TMT: "T",
  934: "T",
  /**
   Ghana Cedi
   */
  GHS: "GH₵",
  936: "GH₵",
  /**
   Sudanese Pound 
   */
  SDG: "ج.س",
  938: "ج.س",
  /**
   Uruguay Peso en Unidades Indexadas
   */
  UYI: "$U",
  940: "$U",
  /**
   Serbian Dinar
   */
  RSD: "din",
  941: "din",
  /**
   Mozambique Metical
   */
  MZN: "MT",
  943: "MT",
  /**
   Azerbaijani Manat
   */
  AZN: "₼",
  944: "₼",
  /**
   Romanian Leu
   */
  RON: "lei",
  946: "lei",
  /**
   Turkish Lira
   */
  TRY: "₺",
  949: "₺",
  /**
   CFA Franc BEAC
   */
  XAF: "₣",
  950: "₣",
  /**
   East Caribbean Dollar 
   */
  XCD: "EC$",
  951: "EC$",
  /**
   CFA Franc BCEAO 
   */
  XOF: "₣",
  952: "₣",
  /**
   CFP Franc
   */
  XPF: "₣",
  953: "₣",
  /**
   SDR (Special Drawing Rights)
   */
  XDR: "XDR",
  960: "XDR",
  /**
   Zambian Kwacha 
   */
  ZMW: "K",
  967: "K",
  /**
   Surinam Dollar
   */
  SRD: "$",
  968: "$",
  /**
   Malagasy Ariary
   */
  MGA: "Ar.",
  969: "Ar.",
  /**
   Unidad de Valor Real
   */
  COU: "COU",
  970: "COU",
  /**
   Afghani
   */
  AFN: "Afs",
  971: "Afs",
  /**
   Tajik Somoni
   */
  TJS: "c",
  972: "c",
  /**
   Kwanza 
   */
  AOA: "Kz",
  973: "Kz",
  /**
   Bulgarian Lev
   */
  BGN: "лв.",
  975: "лв.",
  /**
   Congolese Franc
   */
  CDF: "₣",
  976: "₣",
  /**
   Convertible Mark
   */
  BAM: "KM",
  977: "KM",
  /**
   Euro
   */
  EUR: "€",
  978: "€",
  /**
   Ukrainian Hryvnia
   */
  UAH: "₴",
  980: "₴",
  /**
   Lari
   */
  GEL: "₾",
  981: "₾",
  /**
   Polish Zloty
   */
  PLN: "zł",
  985: "zł",
  /**
   Brazilian Real 
   */
  BRL: "R$",
  986: "R$"
}), im = (e, t) => {
  const n = String(e).replace(",", "."), r = n.includes(".") ? 2 : 0;
  return new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: r,
    maximumFractionDigits: r,
    ...t
  }).format(Number(n));
}, yE = A((e, t) => {
  const n = ie(), {
    children: r,
    color: o,
    font: i = "p3MediumText",
    currency: s = "RUB",
    income: a,
    as: l = "p",
    ...c
  } = e, d = ru[s];
  return /* @__PURE__ */ M(H, { ...c, ref: t, color: o || n.colors.text.primary, font: i, as: l, children: [
    a && "+",
    `${im(r)} ${d}`
  ] });
});
var sm = (e) => typeof e != "string" ? {} : e.split(/ ?; ?/).reduce((t, n) => {
  const [r, o] = n.split(/ ?: ?/).map((i, s) => s === 0 ? i.replace(/\s+/g, "") : i.trim());
  if (r && o) {
    const i = r.replace(/(\w)-(\w)/g, (a, l, c) => `${l}${c.toUpperCase()}`);
    let s = o.trim();
    Number.isNaN(Number(o)) || (s = Number(o)), t[r.startsWith("-") ? r : i] = s;
  }
  return t;
}, {});
function am(e = 6) {
  const t = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let n = "";
  for (let r = e; r > 0; --r)
    n += t[Math.round(Math.random() * (t.length - 1))];
  return n;
}
var lm = [
  "br",
  "col",
  "colgroup",
  "dl",
  "hr",
  "iframe",
  "img",
  "input",
  "link",
  "menuitem",
  "meta",
  "ol",
  "param",
  "select",
  "table",
  "tbody",
  "tfoot",
  "thead",
  "tr",
  "ul",
  "wbr"
], ol = {
  // HTML
  "accept-charset": "acceptCharset",
  acceptcharset: "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  enctype: "encType",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  icon: "icon",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  typemustmatch: "typeMustMatch",
  usemap: "useMap",
  // SVG
  accentheight: "accentHeight",
  "accent-height": "accentHeight",
  alignmentbaseline: "alignmentBaseline",
  "alignment-baseline": "alignmentBaseline",
  allowreorder: "allowReorder",
  arabicform: "arabicForm",
  "arabic-form": "arabicForm",
  attributename: "attributeName",
  attributetype: "attributeType",
  autoreverse: "autoReverse",
  basefrequency: "baseFrequency",
  baselineshift: "baselineShift",
  "baseline-shift": "baselineShift",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  capheight: "capHeight",
  "cap-height": "capHeight",
  clippath: "clipPath",
  "clip-path": "clipPath",
  clippathunits: "clipPathUnits",
  cliprule: "clipRule",
  "clip-rule": "clipRule",
  colorinterpolation: "colorInterpolation",
  "color-interpolation": "colorInterpolation",
  colorinterpolationfilters: "colorInterpolationFilters",
  "color-interpolation-filters": "colorInterpolationFilters",
  colorprofile: "colorProfile",
  "color-profile": "colorProfile",
  colorrendering: "colorRendering",
  "color-rendering": "colorRendering",
  contentscripttype: "contentScriptType",
  contentstyletype: "contentStyleType",
  diffuseconstant: "diffuseConstant",
  dominantbaseline: "dominantBaseline",
  "dominant-baseline": "dominantBaseline",
  edgemode: "edgeMode",
  enablebackground: "enableBackground",
  "enable-background": "enableBackground",
  externalresourcesrequired: "externalResourcesRequired",
  fillopacity: "fillOpacity",
  "fill-opacity": "fillOpacity",
  fillrule: "fillRule",
  "fill-rule": "fillRule",
  filterres: "filterRes",
  filterunits: "filterUnits",
  floodopacity: "floodOpacity",
  "flood-opacity": "floodOpacity",
  floodcolor: "floodColor",
  "flood-color": "floodColor",
  fontfamily: "fontFamily",
  "font-family": "fontFamily",
  fontsize: "fontSize",
  "font-size": "fontSize",
  fontsizeadjust: "fontSizeAdjust",
  "font-size-adjust": "fontSizeAdjust",
  fontstretch: "fontStretch",
  "font-stretch": "fontStretch",
  fontstyle: "fontStyle",
  "font-style": "fontStyle",
  fontvariant: "fontVariant",
  "font-variant": "fontVariant",
  fontweight: "fontWeight",
  "font-weight": "fontWeight",
  glyphname: "glyphName",
  "glyph-name": "glyphName",
  glyphorientationhorizontal: "glyphOrientationHorizontal",
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphorientationvertical: "glyphOrientationVertical",
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  horizadvx: "horizAdvX",
  "horiz-adv-x": "horizAdvX",
  horizoriginx: "horizOriginX",
  "horiz-origin-x": "horizOriginX",
  imagerendering: "imageRendering",
  "image-rendering": "imageRendering",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  letterspacing: "letterSpacing",
  "letter-spacing": "letterSpacing",
  lightingcolor: "lightingColor",
  "lighting-color": "lightingColor",
  limitingconeangle: "limitingConeAngle",
  markerend: "markerEnd",
  "marker-end": "markerEnd",
  markerheight: "markerHeight",
  markermid: "markerMid",
  "marker-mid": "markerMid",
  markerstart: "markerStart",
  "marker-start": "markerStart",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  overlineposition: "overlinePosition",
  "overline-position": "overlinePosition",
  overlinethickness: "overlineThickness",
  "overline-thickness": "overlineThickness",
  paintorder: "paintOrder",
  "paint-order": "paintOrder",
  "panose-1": "panose1",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointerevents: "pointerEvents",
  "pointer-events": "pointerEvents",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  renderingintent: "renderingIntent",
  "rendering-intent": "renderingIntent",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  shaperendering: "shapeRendering",
  "shape-rendering": "shapeRendering",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  stopcolor: "stopColor",
  "stop-color": "stopColor",
  stopopacity: "stopOpacity",
  "stop-opacity": "stopOpacity",
  strikethroughposition: "strikethroughPosition",
  "strikethrough-position": "strikethroughPosition",
  strikethroughthickness: "strikethroughThickness",
  "strikethrough-thickness": "strikethroughThickness",
  strokedasharray: "strokeDasharray",
  "stroke-dasharray": "strokeDasharray",
  strokedashoffset: "strokeDashoffset",
  "stroke-dashoffset": "strokeDashoffset",
  strokelinecap: "strokeLinecap",
  "stroke-linecap": "strokeLinecap",
  strokelinejoin: "strokeLinejoin",
  "stroke-linejoin": "strokeLinejoin",
  strokemiterlimit: "strokeMiterlimit",
  "stroke-miterlimit": "strokeMiterlimit",
  strokewidth: "strokeWidth",
  "stroke-width": "strokeWidth",
  strokeopacity: "strokeOpacity",
  "stroke-opacity": "strokeOpacity",
  suppresscontenteditablewarning: "suppressContentEditableWarning",
  suppresshydrationwarning: "suppressHydrationWarning",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textanchor: "textAnchor",
  "text-anchor": "textAnchor",
  textdecoration: "textDecoration",
  "text-decoration": "textDecoration",
  textlength: "textLength",
  textrendering: "textRendering",
  "text-rendering": "textRendering",
  underlineposition: "underlinePosition",
  "underline-position": "underlinePosition",
  underlinethickness: "underlineThickness",
  "underline-thickness": "underlineThickness",
  unicodebidi: "unicodeBidi",
  "unicode-bidi": "unicodeBidi",
  unicoderange: "unicodeRange",
  "unicode-range": "unicodeRange",
  unitsperem: "unitsPerEm",
  "units-per-em": "unitsPerEm",
  unselectable: "unselectable",
  valphabetic: "vAlphabetic",
  "v-alphabetic": "vAlphabetic",
  vectoreffect: "vectorEffect",
  "vector-effect": "vectorEffect",
  vertadvy: "vertAdvY",
  "vert-adv-y": "vertAdvY",
  vertoriginx: "vertOriginX",
  "vert-origin-x": "vertOriginX",
  vertoriginy: "vertOriginY",
  "vert-origin-y": "vertOriginY",
  vhanging: "vHanging",
  "v-hanging": "vHanging",
  videographic: "vIdeographic",
  "v-ideographic": "vIdeographic",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  vmathematical: "vMathematical",
  "v-mathematical": "vMathematical",
  wordspacing: "wordSpacing",
  "word-spacing": "wordSpacing",
  writingmode: "writingMode",
  "writing-mode": "writingMode",
  xchannelselector: "xChannelSelector",
  xheight: "xHeight",
  "x-height": "xHeight",
  xlinkactuate: "xlinkActuate",
  "xlink:actuate": "xlinkActuate",
  xlinkarcrole: "xlinkArcrole",
  "xlink:arcrole": "xlinkArcrole",
  xlinkhref: "xlinkHref",
  "xlink:href": "xlinkHref",
  xlinkrole: "xlinkRole",
  "xlink:role": "xlinkRole",
  xlinkshow: "xlinkShow",
  "xlink:show": "xlinkShow",
  xlinktitle: "xlinkTitle",
  "xlink:title": "xlinkTitle",
  xlinktype: "xlinkType",
  "xlink:type": "xlinkType",
  xmlbase: "xmlBase",
  "xml:base": "xmlBase",
  xmllang: "xmlLang",
  "xml:lang": "xmlLang",
  "xml:space": "xmlSpace",
  xmlnsxlink: "xmlnsXlink",
  "xmlns:xlink": "xmlnsXlink",
  xmlspace: "xmlSpace",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan",
  // event handlers
  onblur: "onBlur",
  onchange: "onChange",
  onclick: "onClick",
  oncontextmenu: "onContextMenu",
  ondoubleclick: "onDoubleClick",
  ondrag: "onDrag",
  ondragend: "onDragEnd",
  ondragenter: "onDragEnter",
  ondragexit: "onDragExit",
  ondragleave: "onDragLeave",
  ondragover: "onDragOver",
  ondragstart: "onDragStart",
  ondrop: "onDrop",
  onerror: "onError",
  onfocus: "onFocus",
  oninput: "onInput",
  oninvalid: "onInvalid",
  onkeydown: "onKeyDown",
  onkeypress: "onKeyPress",
  onkeyup: "onKeyUp",
  onload: "onLoad",
  onmousedown: "onMouseDown",
  onmouseenter: "onMouseEnter",
  onmouseleave: "onMouseLeave",
  onmousemove: "onMouseMove",
  onmouseout: "onMouseOut",
  onmouseover: "onMouseOver",
  onmouseup: "onMouseUp",
  onscroll: "onScroll",
  onsubmit: "onSubmit",
  ontouchcancel: "onTouchCancel",
  ontouchend: "onTouchEnd",
  ontouchmove: "onTouchMove",
  ontouchstart: "onTouchStart",
  onwheel: "onWheel"
};
function cm(e, t) {
  var i;
  const { key: n, level: r, ...o } = t;
  switch (e.nodeType) {
    case 1:
      return T.createElement(
        um(e.nodeName),
        dm(e, n),
        il(e.childNodes, r, o)
      );
    case 3: {
      const s = ((i = e.nodeValue) == null ? void 0 : i.toString()) ?? "";
      if (!o.allowWhiteSpaces && /^\s+$/.test(s) && !/[\u00A0\u202F]/.test(s))
        return null;
      if (!e.parentNode)
        return s;
      const a = e.parentNode.nodeName.toLowerCase();
      return lm.includes(a) ? (/\S/.test(s) && console.warn(
        `A textNode is not allowed inside '${a}'. Your text "${s}" will be ignored`
      ), null) : s;
    }
    case 8:
      return null;
    case 11:
      return il(e.childNodes, r, t);
    default:
      return null;
  }
}
function dm(e, t) {
  const n = {
    key: t
  };
  if (e instanceof Element) {
    const r = e.getAttribute("class");
    r && (n.className = r), [...e.attributes].forEach((o) => {
      switch (o.name) {
        case "class":
          break;
        case "style":
          n[o.name] = sm(o.value);
          break;
        case "allowfullscreen":
        case "allowpaymentrequest":
        case "async":
        case "autofocus":
        case "autoplay":
        case "checked":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "formnovalidate":
        case "hidden":
        case "ismap":
        case "itemscope":
        case "loop":
        case "multiple":
        case "muted":
        case "nomodule":
        case "novalidate":
        case "open":
        case "readonly":
        case "required":
        case "reversed":
        case "selected":
        case "typemustmatch":
          n[ol[o.name] || o.name] = !0;
          break;
        default:
          n[ol[o.name] || o.name] = o.value;
      }
    });
  }
  return n;
}
function il(e, t, n) {
  const r = [...e].map(
    (o, i) => mo(o, {
      ...n,
      index: i,
      level: t + 1
    })
  ).filter(Boolean);
  return r.length ? r : null;
}
function um(e) {
  return /[a-z]+[A-Z]+[a-z]+/.test(e) ? e : e.toLowerCase();
}
function mo(e, t = {}) {
  if (!e || !(e instanceof Node))
    return null;
  const { actions: n = [], index: r = 0, level: o = 0, randomKey: i } = t;
  let s = e, a = `${o}-${r}`;
  const l = [];
  return i && o === 0 && (a = `${am()}-${a}`), Array.isArray(n) && n.forEach((c) => {
    c.condition(s, a, o) && (typeof c.pre == "function" && (s = c.pre(s, a, o), s instanceof Node || (s = e, process.env.NODE_ENV !== "production" && console.warn(
      "The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)"
    ))), typeof c.post == "function" && l.push(c.post(s, a, o)));
  }), l.length ? l : cm(s, { key: a, level: o, ...t });
}
function pm(e, t = {}) {
  if (!e || typeof e != "string")
    return null;
  const {
    includeAllNodes: n = !1,
    nodeOnly: r = !1,
    selector: o = "body > *",
    type: i = "text/html"
  } = t;
  try {
    const a = new DOMParser().parseFromString(e, i);
    if (n) {
      const { childNodes: c } = a.body;
      return r ? c : [...c].map((d) => mo(d, t));
    }
    const l = a.querySelector(o) || a.body.childNodes[0];
    if (!(l instanceof Node))
      throw new TypeError("Error parsing input");
    return r ? l : mo(l, t);
  } catch (s) {
    process.env.NODE_ENV !== "production" && console.error(s);
  }
  return null;
}
function ou(e, t = {}) {
  return typeof e == "string" ? pm(e, t) : e instanceof Node ? mo(e, t) : null;
}
var fm = Object.defineProperty, hm = (e, t, n) => t in e ? fm(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Vr = (e, t, n) => (hm(e, typeof t != "symbol" ? t + "" : t, n), n), sl = "react-inlinesvg", al = 10, de = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
  READY: "ready",
  UNSUPPORTED: "unsupported"
};
function so() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function mm() {
  return vm() && typeof window < "u" && window !== null;
}
async function iu(e, t) {
  const n = await fetch(e, t), r = n.headers.get("content-type"), [o] = (r ?? "").split(/ ?; ?/);
  if (n.status > 299)
    throw new Error("Not found");
  if (!["image/svg+xml", "text/plain"].some((i) => o.includes(i)))
    throw new Error(`Content type isn't valid: ${o}`);
  return n.text();
}
function gm(e = 1) {
  return new Promise((t) => {
    setTimeout(t, e * 1e3);
  });
}
function vm() {
  if (!document)
    return !1;
  const e = document.createElement("div");
  e.innerHTML = "<svg />";
  const t = e.firstChild;
  return !!t && t.namespaceURI === "http://www.w3.org/2000/svg";
}
function ym(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function bm(e) {
  const t = "abcdefghijklmnopqrstuvwxyz", r = `${t}${t.toUpperCase()}1234567890`;
  let o = "";
  for (let i = 0; i < e; i++)
    o += ym(r);
  return o;
}
function xm(e, ...t) {
  const n = {};
  for (const r in e)
    ({}).hasOwnProperty.call(e, r) && (t.includes(r) || (n[r] = e[r]));
  return n;
}
var wm = class {
  constructor() {
    Vr(this, "cacheApi"), Vr(this, "cacheStore"), Vr(this, "subscribers", []), Vr(this, "isReady", !1), this.cacheStore = /* @__PURE__ */ new Map();
    let e = sl, t = !1;
    so() && (e = window.REACT_INLINESVG_CACHE_NAME ?? sl, t = !!window.REACT_INLINESVG_PERSISTENT_CACHE && "caches" in window), t ? caches.open(e).then((n) => {
      this.cacheApi = n, this.isReady = !0, this.subscribers.forEach((r) => r());
    }).catch((n) => {
      this.isReady = !0, console.error(`Failed to open cache: ${n.message}`);
    }) : this.isReady = !0;
  }
  onReady(e) {
    this.isReady ? e() : this.subscribers.push(e);
  }
  async get(e, t) {
    var n;
    return await (this.cacheApi ? this.fetchAndAddToPersistentCache(e, t) : this.fetchAndAddToInternalCache(e, t)), ((n = this.cacheStore.get(e)) == null ? void 0 : n.content) ?? "";
  }
  set(e, t) {
    this.cacheStore.set(e, t);
  }
  isCached(e) {
    var t;
    return ((t = this.cacheStore.get(e)) == null ? void 0 : t.status) === de.LOADED;
  }
  async fetchAndAddToInternalCache(e, t) {
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === de.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: de.IDLE }), await this.fetchAndAddToInternalCache(e, t);
      });
      return;
    }
    if (!(n != null && n.content)) {
      this.cacheStore.set(e, { content: "", status: de.LOADING });
      try {
        const r = await iu(e, t);
        this.cacheStore.set(e, { content: r, status: de.LOADED });
      } catch (r) {
        throw this.cacheStore.set(e, { content: "", status: de.FAILED }), r;
      }
    }
  }
  async fetchAndAddToPersistentCache(e, t) {
    var o, i, s;
    const n = this.cacheStore.get(e);
    if ((n == null ? void 0 : n.status) === de.LOADED)
      return;
    if ((n == null ? void 0 : n.status) === de.LOADING) {
      await this.handleLoading(e, async () => {
        this.cacheStore.set(e, { content: "", status: de.IDLE }), await this.fetchAndAddToPersistentCache(e, t);
      });
      return;
    }
    this.cacheStore.set(e, { content: "", status: de.LOADING });
    const r = await ((o = this.cacheApi) == null ? void 0 : o.match(e));
    if (r) {
      const a = await r.text();
      this.cacheStore.set(e, { content: a, status: de.LOADED });
      return;
    }
    try {
      await ((i = this.cacheApi) == null ? void 0 : i.add(new Request(e, t)));
      const a = await ((s = this.cacheApi) == null ? void 0 : s.match(e)), l = await (a == null ? void 0 : a.text()) ?? "";
      this.cacheStore.set(e, { content: l, status: de.LOADED });
    } catch (a) {
      throw this.cacheStore.set(e, { content: "", status: de.FAILED }), a;
    }
  }
  async handleLoading(e, t) {
    var r;
    let n = 0;
    for (; ((r = this.cacheStore.get(e)) == null ? void 0 : r.status) === de.LOADING && n < al; )
      await gm(0.1), n += 1;
    n >= al && await t();
  }
  keys() {
    return [...this.cacheStore.keys()];
  }
  data() {
    return [...this.cacheStore.entries()].map(([e, t]) => ({ [e]: t }));
  }
  async delete(e) {
    this.cacheApi && await this.cacheApi.delete(e), this.cacheStore.delete(e);
  }
  async clear() {
    if (this.cacheApi) {
      const e = await this.cacheApi.keys();
      for (const t of e)
        await this.cacheApi.delete(t);
    }
    this.cacheStore.clear();
  }
};
function ll(e) {
  const t = oe();
  return Y(() => {
    t.current = e;
  }), t.current;
}
function $m(e) {
  const {
    baseURL: t,
    content: n,
    description: r,
    handleError: o,
    hash: i,
    preProcessor: s,
    title: a,
    uniquifyIDs: l = !1
  } = e;
  try {
    const c = Cm(n, s), d = ou(c, { nodeOnly: !0 });
    if (!d || !(d instanceof SVGSVGElement))
      throw new Error("Could not convert the src to a DOM Node");
    const u = su(d, { baseURL: t, hash: i, uniquifyIDs: l });
    if (r) {
      const p = u.querySelector("desc");
      p != null && p.parentNode && p.parentNode.removeChild(p);
      const f = document.createElementNS("http://www.w3.org/2000/svg", "desc");
      f.innerHTML = r, u.prepend(f);
    }
    if (typeof a < "u") {
      const p = u.querySelector("title");
      if (p != null && p.parentNode && p.parentNode.removeChild(p), a) {
        const f = document.createElementNS("http://www.w3.org/2000/svg", "title");
        f.innerHTML = a, u.prepend(f);
      }
    }
    return u;
  } catch (c) {
    return o(c);
  }
}
function Cm(e, t) {
  return t ? t(e) : e;
}
function su(e, t) {
  const { baseURL: n = "", hash: r, uniquifyIDs: o } = t, i = ["id", "href", "xlink:href", "xlink:role", "xlink:arcrole"], s = ["href", "xlink:href"], a = (l, c) => s.includes(l) && (c ? !c.includes("#") : !1);
  return o && [...e.children].forEach((l) => {
    var c;
    if ((c = l.attributes) != null && c.length) {
      const d = Object.values(l.attributes).map((u) => {
        const p = u, f = /url\((.*?)\)/.exec(u.value);
        return f != null && f[1] && (p.value = u.value.replace(f[0], `url(${n}${f[1]}__${r})`)), p;
      });
      i.forEach((u) => {
        const p = d.find((f) => f.name === u);
        p && !a(u, p.value) && (p.value = `${p.value}__${r}`);
      });
    }
    return l.children.length ? su(l, t) : l;
  }), e;
}
var hn;
function km(e) {
  const {
    cacheRequests: t = !0,
    children: n = null,
    description: r,
    fetchOptions: o,
    innerRef: i,
    loader: s = null,
    onError: a,
    onLoad: l,
    src: c,
    title: d,
    uniqueHash: u
  } = e, [p, f] = Fh(
    (D, I) => ({
      ...D,
      ...I
    }),
    {
      content: "",
      element: null,
      isCached: t && hn.isCached(e.src),
      status: de.IDLE
    }
  ), { content: m, element: g, isCached: y, status: b } = p, w = ll(e), x = ll(p), $ = oe(u ?? bm(8)), E = oe(!1), S = oe(!1), F = fe(
    (D) => {
      E.current && (f({
        status: D.message === "Browser does not support SVG" ? de.UNSUPPORTED : de.FAILED
      }), a == null || a(D));
    },
    [a]
  ), R = fe((D, I = !1) => {
    E.current && f({
      content: D,
      isCached: I,
      status: de.LOADED
    });
  }, []), L = fe(async () => {
    const D = await iu(c, o);
    R(D);
  }, [o, R, c]), P = fe(() => {
    try {
      const D = $m({ ...e, handleError: F, hash: $.current, content: m }), I = ou(D);
      if (!I || !Xd(I))
        throw new Error("Could not convert the src to a React element");
      f({
        element: I,
        status: de.READY
      });
    } catch (D) {
      F(new Error(D.message));
    }
  }, [m, F, e]), j = fe(async () => {
    const D = /^data:image\/svg[^,]*?(;base64)?,(.*)/u.exec(c);
    let I;
    if (D ? I = D[1] ? window.atob(D[2]) : decodeURIComponent(D[2]) : c.includes("<svg") && (I = c), I) {
      R(I);
      return;
    }
    try {
      if (t) {
        const z = await hn.get(c, o);
        R(z, !0);
      } else
        await L();
    } catch (z) {
      F(z);
    }
  }, [t, L, o, F, R, c]), _ = fe(async () => {
    E.current && f({
      content: "",
      element: null,
      isCached: !1,
      status: de.LOADING
    });
  }, []);
  Y(
    () => {
      if (E.current = !0, !so() || S.current)
        return () => {
        };
      try {
        if (b === de.IDLE) {
          if (!mm())
            throw new Error("Browser does not support SVG");
          if (!c)
            throw new Error("Missing src");
          _();
        }
      } catch (D) {
        F(D);
      }
      return S.current = !0, () => {
        E.current = !1;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), Y(() => {
    if (so() && w)
      if (w.src !== c) {
        if (!c) {
          F(new Error("Missing src"));
          return;
        }
        _();
      } else (w.title !== d || w.description !== r) && P();
  }, [r, P, F, _, w, c, d]), Y(() => {
    x && (x.status !== de.LOADING && b === de.LOADING && j(), x.status !== de.LOADED && b === de.LOADED && P(), x.status !== de.READY && b === de.READY && (l == null || l(c, y)));
  }, [j, P, y, l, x, c, b]);
  const G = xm(
    e,
    "baseURL",
    "cacheRequests",
    "children",
    "description",
    "fetchOptions",
    "innerRef",
    "loader",
    "onError",
    "onLoad",
    "preProcessor",
    "src",
    "title",
    "uniqueHash",
    "uniquifyIDs"
  );
  return so() ? g ? tn(g, { ref: i, ...G }) : [de.UNSUPPORTED, de.FAILED].includes(b) ? n : s : s;
}
function Sm(e) {
  hn || (hn = new wm());
  const { loader: t } = e, n = oe(!1), [r, o] = U(hn.isReady);
  return Y(() => {
    n.current || (hn.onReady(() => {
      o(!0);
    }), n.current = !0);
  }, []), r ? /* @__PURE__ */ h(km, { ...e }) : t;
}
const Tm = `${nu}/icons/`, Em = ({ icon: e, color: t, width: n, height: r, className: o }) => ge.cloneElement(e, { className: o, width: n, height: r, fill: t }), q = A((e, t) => {
  const {
    src: n = "",
    icon: r,
    color: o,
    width: i,
    height: s,
    fluid: a = !1,
    iconPath: l,
    className: c,
    ...d
  } = e, u = K(() => Tm + `${l}.svg`, [l]), p = K(() => {
    const f = {
      width: "100%",
      height: "100%"
    }, m = {
      ...i && { width: i },
      ...s && { height: s }
    };
    return a ? f : m;
  }, [i, s, a]);
  return r ? /* @__PURE__ */ h(Em, { ...p, icon: r, color: o || "currentColor", className: c }) : /* @__PURE__ */ h(
    Rm,
    {
      ...d,
      innerRef: t,
      src: l ? u : n,
      fill: o || "currentColor",
      className: c,
      ...p,
      $fluid: a
    }
  );
}), Rm = v(Sm)`
  ${({ width: e, height: t, $fluid: n }) => {
  if (!e && !t && !n)
    return C`
        &[viewBox='0 0 16 16'] {
          width: 16px;
          height: 16px;
        }
        &[viewBox='0 0 24 24'] {
          width: 24px;
          height: 24px;
        }
        &[viewBox='0 0 28 28'] {
          width: 28px;
          height: 28px;
        }
        &[viewBox='0 0 32 32'] {
          width: 32px;
          height: 32px;
        }
        &[viewBox='0 0 44 44'] {
          width: 44px;
          height: 44px;
        }
        &[viewBox='0 0 52 52'] {
          width: 52px;
          height: 52px;
        }
      `;
}}
`, ao = {
  16: {
    radius: "6px",
    gap: "2px",
    padding: "1px 4px",
    font: "c1MediumComp"
  },
  20: {
    radius: "6px",
    gap: "2px",
    padding: "2px 4px",
    font: "c1MediumComp",
    iconSize: 16
  },
  24: {
    radius: "8px",
    gap: "4px",
    padding: "2px 6px",
    font: "p4MediumComp",
    iconSize: 16
  },
  32: {
    radius: "12px",
    gap: "4px",
    padding: "4px 8px",
    font: "p3MediumComp",
    iconSize: 24
  }
}, Am = (e) => {
  const { radius: t, gap: n, padding: r } = ao[e];
  return `
    border-radius: ${t};
    gap: ${n};
    padding:  ${r};
  `;
}, bE = A((e, t) => {
  const n = ie(), {
    children: r,
    size: o = 24,
    textColor: i,
    backgroundColor: s,
    className: a,
    icon: l,
    iconColor: c,
    ...d
  } = e, u = K(() => {
    if (!l) return;
    const p = c || i || n.colors.text.primary;
    return ge.cloneElement(l, {
      color: p,
      width: ao[o].iconSize,
      height: ao[o].iconSize
    });
  }, [o, c, i, l]);
  return /* @__PURE__ */ M(
    Pm,
    {
      ...d,
      ref: t,
      className: a,
      size: o,
      backgroundColor: s,
      children: [
        o !== 16 && l && u,
        /* @__PURE__ */ h(H, { as: "p", font: ao[o].font, color: i || n.colors.text.primary, children: r })
      ]
    }
  );
}), Pm = v.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  background: ${({ backgroundColor: e, theme: t }) => e || t.colors.background.secondary};
  ${(e) => Am(e.size || 24)}
`, Or = {
  16: {
    font: "c1MediumComp",
    size: "16px",
    padding: "0 4px"
  },
  20: {
    font: "c1MediumComp",
    size: "20px",
    padding: "2px 6px"
  },
  24: {
    font: "p4MediumComp",
    size: "24px",
    // Todo Костыль из-за косячного шрифта. Необходимо тестирование в других браузерах.
    padding: "3px 8px 1px"
  }
}, Mm = v.div((e) => {
  const { theme: t, $variant: n = "primary", $size: r } = e, o = {
    primary: t.colors.accent.notification,
    secondary: t.colors.background.secondary,
    secondaryElevated: t.colors.background.secondaryElevated
  };
  return C`
    all: unset;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    border-radius: 100px;
    min-width: ${Or[r].size || "20px"};
    min-height: ${Or[r].size || "20px"};
    padding: ${Or[r].padding};
    color: ${n === "primary" ? t.colors.constant.greyscale0 : t.colors.text.primary};
    background: ${o[n]};
    ${ae(Or[r].font)}
    // Todo Костыль из-за косячного шрифта. Необходимо тестирование в других браузерах.
    ${r !== 24 && C`
      line-height: 15px;
    `}
  `;
}), Dm = v.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: ${({ theme: e }) => e.colors.accent.notification};
  ${({ $withBorder: e, theme: t }) => e && C`
        border: 1px solid ${t.colors.background.primary};
        box-sizing: content-box;
      `}
`, au = {
  Counter: Mm,
  Notification: Dm
}, Bm = A((e, t) => {
  const { ariaLabel: n, withBorder: r = !1, className: o, ...i } = e;
  return /* @__PURE__ */ h(
    au.Notification,
    {
      $withBorder: r,
      ...i,
      className: o,
      ref: t,
      "aria-label": n
    }
  );
}), Lm = A((e, t) => {
  const {
    size: n,
    ariaLabel: r,
    variant: o = "secondary",
    value: i = 0,
    max: s = Number.POSITIVE_INFINITY,
    className: a,
    ...l
  } = e;
  return /* @__PURE__ */ h(
    au.Counter,
    {
      ...l,
      className: a,
      ref: t,
      "aria-label": r,
      $size: n,
      $variant: o,
      children: i > s ? `${s}+` : i
    }
  );
}), lu = A((e, t) => {
  const { size: n } = e;
  return n === "notification" ? /* @__PURE__ */ h(Bm, { ...e, ref: t }) : /* @__PURE__ */ h(Lm, { ...e, ref: t });
}), Im = ({ size: e }) => {
  const t = ie();
  return e === 44 ? /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-24-style-outline", color: t.colors.icons.secondary }) : /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-16-style-outline", color: t.colors.icons.secondary });
}, Fm = v.button`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${({ $size: e, $variant: t, theme: { colors: n }, $extraBefore: r, $extraAfter: o }) => C`
    border-radius: ${{
  44: 16,
  32: 12,
  24: 8
}[e]}px;
    gap: ${{
  44: 4,
  32: 4,
  24: 2
}[e]}px;
    max-height: ${{
  44: 44,
  32: 32,
  24: 24
}[e]}px;
    padding: ${() => {
  const i = o ? -2 : 0, s = r ? -2 : 0;
  return {
    44: `12px ${12 + i}px 12px ${12 + s}px`,
    32: `6px ${10 + i}px 6px ${10 + s}px`,
    24: `2px ${8 + i}px 2px ${8 + s}px`
  }[e];
}};

    &:disabled {
      background-color: ${n.control.inactive};
      opacity: 0.6;
      color: ${n.text.tertiary};
      cursor: not-allowed;
    }

    &:not(:disabled) {
      background-color: ${{
  primary: n.control.tertiaryActive,
  secondary: n.control.alternative,
  selected: n.background.inverted,
  selectedAlternative: n.background.secondary
}[t]};
      color: ${{
  primary: n.text.primary,
  secondary: n.text.primary,
  selected: n.text.inverted,
  selectedAlternative: n.text.primary
}[t]};
      box-shadow: ${t === "selectedAlternative" ? `inset 0 0 0 1px ${n.control.secondaryActive}` : "none"};

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          background: ${t === "selected" ? `linear-gradient(${n.control.hoverAlternative},${n.control.hoverAlternative}), ${n.control.secondaryActive}` : `linear-gradient(${n.background.hover},${n.background.hover}), ${n.control.tertiaryActive}`};
        }
      }

      &:focus-visible {
        z-index: 1;
        outline: 1px solid ${n.accent.active};
        outline-offset: 1px;
      }

      &:active {
        transform: scale(0.98);
      }
    }
  `}
`, Vm = {
  Chip: Fm
}, Om = (e, t) => {
  const {
    children: n,
    extraBefore: r,
    extraAfter: o,
    variant: i = "primary",
    size: s = 44,
    disabled: a = !1,
    ...l
  } = e;
  return /* @__PURE__ */ M(
    Vm.Chip,
    {
      ref: t,
      $variant: i,
      $size: s,
      disabled: a,
      $extraBefore: !!r,
      $extraAfter: !!o,
      ...l,
      children: [
        r,
        n,
        o
      ]
    }
  );
}, rn = A(Om);
rn.displayName = "BaseChip";
const as = v.div`
  display: inline-grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  border-radius: ${({ $size: e }) => ({ 44: 8, 32: 6, 24: 6 })[e]}px;
  transition: transform ease-in-out;
  transition-duration: 125ms;
`, zm = v(rn)`
  ${({ theme: { colors: e }, $variant: t, $size: n }) => C`
    padding: ${{
  44: "10px 10px 10px 12px",
  32: "4px 8px 4px 8px",
  24: "2px 6px 2px 6px"
}[n]};

    &&:disabled {
      svg {
        fill: ${e.icons.secondary};
      }
    }

    &&:not(:disabled) {
      &:hover {
        background: ${{
  primary: e.control.tertiaryActive,
  secondary: e.control.alternative
}[t]};

        ${as} {
          background: ${e.control.hoverPrimary};
        }
      }

      &:active {
        transform: none;

        ${as} {
          transform: scale(0.98);
          background: ${e.control.hoverPrimary};
        }
      }
    }
  `}
`, Nm = {
  24: "p4RegularComp",
  32: "p3RegularComp",
  44: "p3RegularComp"
}, Wm = v(H)(
  ({ $size: e }) => C`
    color: inherit;
    ${ae(Nm[e])};
  `
), Ti = {
  ButtonIcon: as,
  Chip: zm,
  ChipText: Wm
}, _m = (e, t) => {
  const {
    children: n,
    onClear: r,
    variant: o = "primary",
    size: i = 44,
    disabled: s = !1,
    ...a
  } = e;
  return /* @__PURE__ */ h(
    Ti.Chip,
    {
      ref: t,
      variant: o,
      $variant: o,
      size: i,
      $size: i,
      disabled: s,
      onClick: r,
      extraAfter: /* @__PURE__ */ h(Ti.ButtonIcon, { $size: i, children: /* @__PURE__ */ h(q, { icon: /* @__PURE__ */ h(Im, { size: i }) }) }),
      ...a,
      children: /* @__PURE__ */ h(Ti.ChipText, { $size: i, children: n })
    }
  );
}, Ks = A(_m);
Ks.displayName = "FormChip";
const jm = v(rn)`
  cursor: pointer;
  position: relative;

  &:disabled {
    cursor: not-allowed;
  }

  &:not(:disabled) {
    &:active {
      transform: scale(0.98);
    }

    &:focus-visible {
      z-index: 1;
      outline: 1px solid ${({ theme: e }) => e.colors.accent.active};
      outline-offset: 1px;
    }
  }
`, Hm = v(H)`
  color: inherit;
  ${ae("p4RegularComp")};
`, Um = v.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`, cl = {
  Chip: jm,
  ChipText: Hm,
  EmblemWrapper: Um
}, Gm = (e, t) => {
  const {
    children: n,
    selected: r = !1,
    disabled: o = !1,
    size: i = 44,
    variant: s = "default",
    icon: a,
    emblem: l,
    ...c
  } = e, d = a || (l ? /* @__PURE__ */ h(cl.EmblemWrapper, { children: l }) : null), u = (() => {
    switch (!0) {
      case (r && s === "alternative"):
        return "selectedAlternative";
      case (r && s === "default"):
        return "selected";
      default:
        return "primary";
    }
  })();
  return /* @__PURE__ */ h(
    rn,
    {
      ...c,
      ref: t,
      variant: u,
      size: i,
      disabled: o,
      extraBefore: d,
      children: /* @__PURE__ */ h(cl.ChipText, { children: n })
    }
  );
}, cu = A(Gm);
cu.displayName = "ChoiceChip";
const Km = v.div`
  ${({ $selected: e }) => C`
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    opacity: ${e ? 1 : 0};
    max-width: ${e ? 32 : 0}px;
    transition: all 0.12s ease;
  `}
`, Ym = v(rn)`
  ${({ $selected: e, $size: t, $withIcon: n }) => C`
    gap: ${e || n ? 4 : 0}px;
    padding-left: ${{
  44: e || n ? 10 : 12,
  32: e || n ? 8 : 10
}[t]}px;
  `}
`, Xm = v(H)`
  color: inherit;
  ${ae("p4RegularComp")};
`, Zm = v.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`, zr = {
  Check: Km,
  Chip: Ym,
  ChipText: Xm,
  EmblemWrapper: Zm
}, qm = (e, t) => {
  const {
    children: n,
    selected: r = !1,
    disabled: o = !1,
    size: i = 44,
    variant: s = "default",
    icon: a,
    emblem: l,
    ...c
  } = e, d = ie(), u = (() => {
    switch (!0) {
      case (r && s === "alternative"):
        return "selectedAlternative";
      case (r && s === "default"):
        return "selected";
      default:
        return "primary";
    }
  })(), p = a || (l ? /* @__PURE__ */ h(zr.EmblemWrapper, { children: l }) : null);
  return /* @__PURE__ */ h(
    zr.Chip,
    {
      ref: t,
      $selected: r,
      $size: i,
      variant: u,
      size: i,
      disabled: o,
      $withIcon: !!a || !!l,
      extraBefore: p || /* @__PURE__ */ h(zr.Check, { $selected: r, children: /* @__PURE__ */ h(
        q,
        {
          iconPath: "granat/check/size-16-style-outline",
          color: d.colors.icons.secondary
        }
      ) }),
      ...c,
      children: /* @__PURE__ */ h(zr.ChipText, { children: n })
    }
  );
}, du = A(qm);
du.displayName = "ChoiceChipMultiselect";
const Jm = v(rn)(
  ({ theme: { colors: e }, $variant: t, $selected: n }) => C`
    ${n && `
      &:not(:disabled) {
        &:hover {
          background: ${{
    default: e.background.inverted,
    alternative: e.background.secondary
  }[t]};

          ${uu} {
            background: ${e.control.hoverPrimary};
          }
        }
      }
    `}
  `
), Qm = v.div`
  display: flex;
  justify-content: center;
  align-items: center;
`, eg = v(q)`
  ${({ $active: e }) => C`
    transition: transform 200ms ease;
    transform: rotate(${e ? 180 : 0}deg);
  `}
`, uu = v.div`
  display: inline-grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  transition: transform ease-in-out;
  transition-duration: 125ms;
`, tg = v(H)`
  color: inherit;
  ${ae("p4RegularComp")};
`, ng = v.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`, rg = A((e, t) => {
  const {
    children: n,
    selected: r,
    active: o,
    disabled: i,
    size: s = 44,
    variant: a = "default",
    icon: l,
    emblem: c,
    ...d
  } = e, u = ie(), p = (() => {
    switch (!0) {
      case ((o || r) && a === "alternative"):
        return "selectedAlternative";
      case ((o || r) && a === "default"):
        return "selected";
      default:
        return "primary";
    }
  })();
  return /* @__PURE__ */ h(
    Jm,
    {
      ...d,
      ref: t,
      variant: p,
      $variant: a,
      $selected: r,
      size: s,
      disabled: i,
      extraBefore: l || (c ? /* @__PURE__ */ h(ng, { children: c }) : null),
      extraAfter: r ? /* @__PURE__ */ h(uu, { children: /* @__PURE__ */ h(
        q,
        {
          iconPath: "granat/cross/size-16-style-outline",
          color: u.colors.icons.secondary
        }
      ) }) : /* @__PURE__ */ h(Qm, { children: /* @__PURE__ */ h(
        eg,
        {
          $active: o,
          iconPath: "granat/chevron-down/size-24-style-outline",
          width: 16,
          height: 16,
          color: u.colors.icons.secondary
        }
      ) }),
      children: /* @__PURE__ */ h(tg, { children: n })
    }
  );
}), og = v.div`
  display: flex;
  justify-content: center;
  align-items: center;
`, ig = v(q)`
  ${({ $active: e }) => C`
    transition: transform 200ms ease;
    transform: rotate(${e ? 180 : 0}deg);
  `}
`, sg = v(H)`
  color: inherit;
  ${ae("p4RegularComp")};
`, ag = v.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`, lg = A(
  (e, t) => {
    const {
      children: n,
      selected: r,
      active: o,
      disabled: i,
      size: s = 44,
      variant: a = "default",
      counter: l,
      icon: c,
      emblem: d,
      ...u
    } = e, p = ie(), f = (() => {
      switch (!0) {
        case ((o || r) && a === "alternative"):
          return "selectedAlternative";
        case ((o || r) && a === "default"):
          return "selected";
        default:
          return "primary";
      }
    })();
    return /* @__PURE__ */ h(
      rn,
      {
        ...u,
        ref: t,
        variant: f,
        size: s,
        disabled: i,
        extraBefore: c || (d ? /* @__PURE__ */ h(ag, { children: d }) : null),
        extraAfter: /* @__PURE__ */ M(We, { children: [
          l && /* @__PURE__ */ h(lu, { variant: "primary", value: l, size: 16 }),
          /* @__PURE__ */ h(og, { children: /* @__PURE__ */ h(
            ig,
            {
              $active: o,
              iconPath: "granat/chevron-down/size-24-style-outline",
              width: 16,
              height: 16,
              color: p.colors.icons.secondary
            }
          ) })
        ] }),
        children: /* @__PURE__ */ h(sg, { children: n })
      }
    );
  }
), xE = {
  FormChip: Ks,
  ChoiceChip: cu,
  ChoiceChipMultiselect: du,
  ChoiceChipMenu: rg,
  ChoiceChipMenuMultiselect: lg
}, cg = v.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: ${({ $paddingTop: e = 36, $customPadding: t }) => t || `${e}px 20px 12px 20px`};
  word-break: break-word;
`, dg = v.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  max-height: ${({ maxHeight: e }) => e || "24px"};
`, ug = v.div`
  display: flex;
  flex-direction: row;
  gap: ${({ gap: e }) => e || "4px"};
  align-items: center;
  flex-grow: 1;
`, Ei = {
  Wrapper: cg,
  TitleRow: dg,
  Title: ug
}, zn = {
  h1: {
    font: "h1Wide",
    subtitleFont: "p3RegularComp",
    counterSize: 20,
    counterGap: "6px",
    lineHeight: "40px"
  },
  h2: {
    font: "h2Wide",
    subtitleFont: "p3RegularComp",
    counterSize: 20,
    counterGap: "6px",
    lineHeight: "36px"
  },
  h3: {
    font: "h3Wide",
    subtitleFont: "p4RegularComp",
    counterSize: 16,
    counterGap: "4px",
    lineHeight: "28px"
  },
  h4: {
    font: "h4Wide",
    subtitleFont: "p4RegularComp",
    counterSize: 16,
    counterGap: "4px",
    lineHeight: "24px"
  },
  h4Comp: {
    font: "h4Comp",
    subtitleFont: "p4RegularComp",
    counterSize: 16,
    counterGap: "4px",
    lineHeight: "24px"
  }
}, wE = A((e, t) => {
  const n = ie(), {
    title: r,
    subtitle: o,
    counter: i,
    font: s = "compact",
    actionButton: a,
    className: l,
    paddingTop: c,
    customPadding: d,
    size: u = "h4",
    ...p
  } = e, f = K(() => {
    if (i)
      return ge.cloneElement(i, {
        size: zn[u].counterSize
      });
  }, [u, i]);
  return /* @__PURE__ */ M(Ei.Wrapper, { $paddingTop: c, $customPadding: d, children: [
    /* @__PURE__ */ M(
      Ei.TitleRow,
      {
        ...p,
        ref: t,
        className: l,
        maxHeight: zn[u].lineHeight,
        children: [
          /* @__PURE__ */ M(Ei.Title, { gap: zn[u].counterGap, children: [
            /* @__PURE__ */ h(
              H,
              {
                font: u ? zn[u].font : s === "compact" ? "h4Comp" : "h4Wide",
                color: n.colors.text.primary,
                children: r
              }
            ),
            i && f
          ] }),
          a
        ]
      }
    ),
    o && /* @__PURE__ */ h(
      H,
      {
        font: zn[u].subtitleFont || "p4RegularComp",
        color: n.colors.text.secondary,
        children: o
      }
    )
  ] });
}), pg = v.div`
  display: flex;
  flex-direction: row;
  height: 52px;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  padding: ${({ $paddingTop: e = 20, $customPadding: t }) => t || `${e}px 20px 8px 20px`};
  box-sizing: border-box;
`, fg = v.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  overflow: hidden;
  height: 24px;
  align-items: flex-end;
  word-break: break-word;
`, hg = v(H)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, Ri = {
  Wrapper: pg,
  Title: fg,
  TextEl: hg
}, $E = A((e, t) => {
  const n = ie(), { title: r, actionButton: o, className: i, paddingTop: s, customPadding: a } = e;
  return /* @__PURE__ */ M(
    Ri.Wrapper,
    {
      ref: t,
      className: i,
      $paddingTop: s,
      $customPadding: a,
      children: [
        /* @__PURE__ */ h(Ri.Title, { children: /* @__PURE__ */ h(
          Ri.TextEl,
          {
            forwardedAs: "p",
            font: "p4MediumUppText",
            color: n.colors.text.secondary,
            children: r
          }
        ) }),
        o
      ]
    }
  );
}), mg = v.div`
  ${({ theme: e, variant: t = "primary", disabled: n }) => {
  const r = {
    primary: e.colors.text.primaryLink,
    secondary: e.colors.text.secondary,
    black: e.colors.text.primary,
    white: e.colors.constant.greyscale0,
    disabled: e.colors.text.tertiary
  };
  return C`
      color: ${n ? r.disabled : r[t]};
      pointer-events: ${n && "none"};
    `;
}}
`, gg = v.button`
  appearance: none;
  outline: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 32px;
  border: 1px solid transparent;
  cursor: pointer;
  border-radius: 8px;
  background-color: transparent;
  margin: 0;
  box-sizing: border-box;
  padding: 2px;
  &:focus-visible {
    border: ${({ theme: e }) => `1px solid ${e.colors.accent.active}`};
  }
`, vg = v.div`
  display: grid;
  grid-template-rows: ${({ active: e }) => e ? "1fr" : "0fr"};
  transition: grid-template-rows 0.5s ease-in-out;
`, yg = v.div`
  overflow: hidden;
`, bg = v.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ active: e }) => e && "scaleY(-1)"};
`, xg = v(H)`
  box-sizing: border-box;
  &:hover {
    border-bottom: 1px solid currentColor;
  }
`, an = {
  Wrapper: mg,
  Button: gg,
  TextEl: xg,
  ContentWrapper: vg,
  Content: yg,
  IconWrapper: bg
}, CE = A((e, t) => {
  const {
    variant: n = "primary",
    label: r,
    active: o,
    children: i,
    disabled: s,
    defaultActive: a,
    onToggle: l,
    ...c
  } = e, [d, u] = U(
    typeof a < "u" && a
  ), p = () => {
    typeof a < "u" && u((f) => !f), l == null || l();
  };
  return /* @__PURE__ */ M(an.Wrapper, { ...c, variant: n, disabled: s, ref: t, children: [
    /* @__PURE__ */ M(an.Button, { type: "button", onClick: p, children: [
      /* @__PURE__ */ h(an.TextEl, { forwardedAs: "p", font: "p3RegularComp", color: "currentColor", children: r }),
      /* @__PURE__ */ h(an.IconWrapper, { active: typeof o < "u" ? o : d, children: /* @__PURE__ */ h(q, { iconPath: "granat/chevron-down/size-16-style-outline" }) })
    ] }),
    /* @__PURE__ */ h(an.ContentWrapper, { active: typeof o < "u" ? o : d, children: /* @__PURE__ */ h(an.Content, { children: i }) })
  ] });
}), mt = {
  20: {
    size: "20px",
    borderRadius: "6px"
  },
  24: {
    size: "24px",
    borderRadius: "8px"
  },
  32: {
    size: "32px",
    borderRadius: "12px"
  },
  44: {
    size: "44px",
    borderRadius: "16px"
  },
  52: {
    size: "52px",
    borderRadius: "16px"
  },
  64: {
    size: "64px",
    borderRadius: "20px"
  },
  80: {
    size: "80px",
    borderRadius: "24px"
  }
}, kE = A((e, t) => {
  const { size: n = 52, className: r, imageSrc: o, icon: i, backgroundColor: s, stroke: a = !0, ...l } = e;
  return /* @__PURE__ */ h(
    wg,
    {
      ...l,
      ref: t,
      $size: n,
      className: r,
      $stroke: a,
      $backgroundColor: s,
      children: i || /* @__PURE__ */ h("img", { src: o })
    }
  );
}), wg = v.div`
  ${({ $size: e, theme: t, $stroke: n, $backgroundColor: r }) => C`
    width: ${mt[e].size};
    height: ${mt[e].size};
    border-radius: ${mt[e].borderRadius};
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${r || "transparent"};
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: ${mt[e].size};
      height: ${mt[e].size};
      border-radius: ${mt[e].borderRadius};
      border: ${n && `1px solid ${t.colors.background.stroke}`};
    }
    img {
      width: ${mt[e].size};
      height: ${mt[e].size};
      object-fit: cover;
      object-position: center center;
    }
  `}
`, $g = (e) => {
  const t = ie(), {
    label: n,
    caption: r,
    bold: o = !1,
    reverse: i = !1,
    alignRight: s = !1,
    textColor: a,
    className: l
  } = e;
  return /* @__PURE__ */ M(Cg, { reverse: i, alignRight: s, className: l, children: [
    /* @__PURE__ */ h(
      H,
      {
        as: "p",
        font: s || o ? "p3MediumComp" : "p3RegularComp",
        color: a || t.colors.text.primary,
        children: n
      }
    ),
    r && /* @__PURE__ */ h(
      H,
      {
        as: "p",
        font: o ? "p3RegularComp" : "p4RegularComp",
        color: t.colors.text.secondary,
        children: r
      }
    )
  ] });
}, Cg = v.div`
  display: flex;
  flex-direction: ${({ reverse: e }) => e ? "column-reverse" : "column"};
  align-items: ${({ alignRight: e }) => e ? "flex-end" : "flex-start"};
  justify-content: center;
  padding: 4px 0;
`, kg = A((e, t) => {
  const {
    slotBefore: n,
    slotAfter: r,
    label: o = "Label",
    caption: i,
    reverse: s,
    bold: a,
    alignRight: l,
    textColor: c,
    backgroundColor: d,
    onClick: u,
    className: p,
    customPadding: f,
    alignItems: m = "center",
    ...g
  } = e;
  return /* @__PURE__ */ M(
    Sg,
    {
      ...g,
      ref: t,
      className: p,
      onClick: () => {
        u && u();
      },
      $clickable: !!u,
      $backgroundColor: d,
      $padding: f,
      $align: m,
      children: [
        n && /* @__PURE__ */ h("div", { children: n }),
        /* @__PURE__ */ h(Tg, { children: /* @__PURE__ */ h(
          $g,
          {
            label: o,
            caption: i,
            reverse: s,
            bold: a,
            alignRight: l,
            textColor: c
          }
        ) }),
        r && /* @__PURE__ */ h("div", { children: r })
      ]
    }
  );
}), Sg = v.div`
  display: flex;
  width: 100%;
  background-color: ${({ $backgroundColor: e }) => e || "transparent"};
  flex-direction: row;
  align-items: ${({ $align: e }) => e === "top" ? "flex-start" : "center"};
  padding: ${({ $padding: e }) => e || "10px 20px"};
  gap: 12px;
  cursor: ${({ $clickable: e }) => e ? "pointer" : "default"};
  transition: background-color 0.3s ease-in-out;
  &:hover {
    background-color: ${({ $clickable: e, theme: t }) => e && t.colors.background.hover};
  }
`, Tg = v.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
  word-break: break-word;
`, Eg = (e) => {
  const { background: t, backgroundColor: n, iconColor: r, icon: o } = e;
  return /* @__PURE__ */ h(Rg, { background: t, backgroundColor: n, children: /* @__PURE__ */ h(q, { icon: o, width: 24, height: 24, color: r }) });
}, Rg = v.div`
  width: ${({ background: e }) => e ? "52px" : "auto"};
  height: ${({ background: e }) => e ? "52px" : "auto"};
  background: ${({ theme: e, backgroundColor: t, background: n }) => n ? t || e.colors.background.secondary : "unset"};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`, Ag = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ T.createElement("title", { id: t }, e) : null, /* @__PURE__ */ T.createElement("path", { d: "M9 5.012c0-.9 1.077-1.35 1.706-.714l3.096 3.13C15.934 9.582 17 10.66 17 12s-1.066 2.417-3.198 4.573l-3.096 3.129c-.63.637-1.706.186-1.706-.715 0-.267.105-.524.293-.714l3.095-3.13c1.106-1.118 1.79-1.815 2.223-2.389.39-.517.39-.697.39-.751v-.006c0-.053 0-.234-.39-.751-.432-.574-1.117-1.272-2.223-2.39L9.293 5.727A1.02 1.02 0 0 1 9 5.012" })), Pg = A(Ag), SE = (e) => {
  const { label: t, arrow: n } = e, r = ie();
  return /* @__PURE__ */ M(Mg, { children: [
    /* @__PURE__ */ h(H, { as: "p", font: "p3RegularComp", color: r.colors.text.secondary, children: t }),
    n && /* @__PURE__ */ h(q, { icon: /* @__PURE__ */ h(Pg, {}), width: 24, height: 24, color: r.colors.icons.secondary })
  ] });
}, Mg = v.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`, TE = (e) => {
  const { stroke: t = !1, imageSrc: n } = e;
  return /* @__PURE__ */ h(Dg, { stroke: t, children: /* @__PURE__ */ h("img", { src: n }) });
}, Dg = v.div`
  width: 52px;
  height: 52px;
  background: ${({ theme: e }) => e.colors.background.secondary};
  border-radius: 16px;
  border: ${({ theme: e, stroke: t }) => t ? `1px solid ${e.colors.background.stroke}` : "none"};
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    object-position: 50% 50%;
  }
`;
function Go() {
  return typeof window < "u";
}
function Dt(e) {
  return pu(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Le(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function rt(e) {
  var t;
  return (t = (pu(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function pu(e) {
  return Go() ? e instanceof Node || e instanceof Le(e).Node : !1;
}
function pe(e) {
  return Go() ? e instanceof Element || e instanceof Le(e).Element : !1;
}
function $e(e) {
  return Go() ? e instanceof HTMLElement || e instanceof Le(e).HTMLElement : !1;
}
function ls(e) {
  return !Go() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Le(e).ShadowRoot;
}
function br(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = _e(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Bg(e) {
  return ["table", "td", "th"].includes(Dt(e));
}
function Ko(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Ys(e) {
  const t = Xs(), n = pe(e) ? _e(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Lg(e) {
  let t = ft(e);
  for (; $e(t) && !Rt(t); ) {
    if (Ys(t))
      return t;
    if (Ko(t))
      return null;
    t = ft(t);
  }
  return null;
}
function Xs() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Rt(e) {
  return ["html", "body", "#document"].includes(Dt(e));
}
function _e(e) {
  return Le(e).getComputedStyle(e);
}
function Yo(e) {
  return pe(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ft(e) {
  if (Dt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ls(e) && e.host || // Fallback.
    rt(e)
  );
  return ls(t) ? t.host : t;
}
function fu(e) {
  const t = ft(e);
  return Rt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : $e(t) && br(t) ? t : fu(t);
}
function $t(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = fu(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = Le(o);
  if (i) {
    const a = cs(s);
    return t.concat(s, s.visualViewport || [], br(o) ? o : [], a && n ? $t(a) : []);
  }
  return t.concat(o, $t(o, [], n));
}
function cs(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function st(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function Pe(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && ls(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function Zs() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function hu() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function Ig(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : ds() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function mu(e) {
  return Vg() ? !1 : !ds() && e.width === 0 && e.height === 0 || ds() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function gu() {
  return /apple/i.test(navigator.vendor);
}
function ds() {
  const e = /android/i;
  return e.test(Zs()) || e.test(hu());
}
function Fg() {
  return Zs().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Vg() {
  return hu().includes("jsdom/");
}
function cr(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function Og(e) {
  return "nativeEvent" in e;
}
function zg(e) {
  return e.matches("html,body");
}
function De(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Ai(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function wt(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const Ng = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function qs(e) {
  return $e(e) && e.matches(Ng);
}
function Pi(e) {
  e.preventDefault(), e.stopPropagation();
}
function Wg(e) {
  return e ? e.getAttribute("role") === "combobox" && qs(e) : !1;
}
const _g = ["top", "right", "bottom", "left"], dr = Math.min, Oe = Math.max, go = Math.round, Nr = Math.floor, At = (e) => ({
  x: e,
  y: e
}), jg = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Hg = {
  start: "end",
  end: "start"
};
function xr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Zt(e) {
  return e.split("-")[0];
}
function wr(e) {
  return e.split("-")[1];
}
function Ug(e) {
  return e === "x" ? "y" : "x";
}
function vu(e) {
  return e === "y" ? "height" : "width";
}
function En(e) {
  return ["top", "bottom"].includes(Zt(e)) ? "y" : "x";
}
function yu(e) {
  return Ug(En(e));
}
function Gg(e, t, n) {
  n === void 0 && (n = !1);
  const r = wr(e), o = yu(e), i = vu(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = vo(s)), [s, vo(s)];
}
function Kg(e) {
  const t = vo(e);
  return [us(e), t, us(t)];
}
function us(e) {
  return e.replace(/start|end/g, (t) => Hg[t]);
}
function Yg(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function Xg(e, t, n, r) {
  const o = wr(e);
  let i = Yg(Zt(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(us)))), i;
}
function vo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => jg[t]);
}
function Zg(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function qg(e) {
  return typeof e != "number" ? Zg(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function yo(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Jg = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], bo = /* @__PURE__ */ Jg.join(","), bu = typeof Element > "u", Rn = bu ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, xo = !bu && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, wo = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", s = i || n && t && e(t.parentNode);
  return s;
}, Qg = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, e0 = function(t, n, r) {
  if (wo(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(bo));
  return n && Rn.call(t, bo) && o.unshift(t), o = o.filter(r), o;
}, t0 = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var s = i.shift();
    if (!wo(s, !1))
      if (s.tagName === "SLOT") {
        var a = s.assignedElements(), l = a.length ? a : s.children, c = e(l, !0, r);
        r.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: s,
          candidates: c
        });
      } else {
        var d = Rn.call(s, bo);
        d && r.filter(s) && (n || !t.includes(s)) && o.push(s);
        var u = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), p = !wo(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (u && p) {
          var f = e(u === !0 ? s.children : u.children, !0, r);
          r.flatten ? o.push.apply(o, f) : o.push({
            scopeParent: s,
            candidates: f
          });
        } else
          i.unshift.apply(i, s.children);
      }
  }
  return o;
}, xu = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, wu = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Qg(t)) && !xu(t) ? 0 : t.tabIndex;
}, n0 = function(t, n) {
  var r = wu(t);
  return r < 0 && n && !xu(t) ? 0 : r;
}, r0 = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, $u = function(t) {
  return t.tagName === "INPUT";
}, o0 = function(t) {
  return $u(t) && t.type === "hidden";
}, i0 = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, s0 = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, a0 = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || xo(t), r = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var i = s0(o, t.form);
  return !i || i === t;
}, l0 = function(t) {
  return $u(t) && t.type === "radio";
}, c0 = function(t) {
  return l0(t) && !a0(t);
}, d0 = function(t) {
  var n, r = t && xo(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var s, a, l;
    for (i = !!((s = o) !== null && s !== void 0 && (a = s.ownerDocument) !== null && a !== void 0 && a.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var c, d, u;
      r = xo(o), o = (c = r) === null || c === void 0 ? void 0 : c.host, i = !!((d = o) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(o));
    }
  }
  return i;
}, dl = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, u0 = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = Rn.call(t, "details>summary:first-of-type"), s = i ? t.parentElement : t;
  if (Rn.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var a = t; t; ) {
        var l = t.parentElement, c = xo(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return dl(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = a;
    }
    if (d0(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return dl(t);
  return !1;
}, p0 = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Rn.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, f0 = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  wo(n) || o0(n) || u0(n, t) || // For a details element with a summary, the summary element gets the focus
  i0(n) || p0(n));
}, ps = function(t, n) {
  return !(c0(n) || wu(n) < 0 || !f0(t, n));
}, h0 = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, m0 = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var s = !!o.scopeParent, a = s ? o.scopeParent : o, l = n0(a, s), c = s ? e(o.candidates) : a;
    l === 0 ? s ? n.push.apply(n, c) : n.push(a) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: s,
      content: c
    });
  }), r.sort(r0).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, Xo = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = t0([t], n.includeContainer, {
    filter: ps.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: h0
  }) : r = e0(t, n.includeContainer, ps.bind(null, n)), m0(r);
}, g0 = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Rn.call(t, bo) === !1 ? !1 : ps(n, t);
};
function ul(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = En(t), s = yu(t), a = vu(s), l = Zt(t), c = i === "y", d = r.x + r.width / 2 - o.width / 2, u = r.y + r.height / 2 - o.height / 2, p = r[a] / 2 - o[a] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      f = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      f = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      f = {
        x: r.x - o.width,
        y: u
      };
      break;
    default:
      f = {
        x: r.x,
        y: r.y
      };
  }
  switch (wr(t)) {
    case "start":
      f[s] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      f[s] += p * (n && c ? -1 : 1);
      break;
  }
  return f;
}
const v0 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: u
  } = ul(c, r, l), p = r, f = {}, m = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: y,
      fn: b
    } = a[g], {
      x: w,
      y: x,
      data: $,
      reset: E
    } = await b({
      x: d,
      y: u,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: f,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = w ?? d, u = x ?? u, f = {
      ...f,
      [y]: {
        ...f[y],
        ...$
      }
    }, E && m <= 50 && (m++, typeof E == "object" && (E.placement && (p = E.placement), E.rects && (c = E.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: d,
      y: u
    } = ul(c, p, l)), g = -1);
  }
  return {
    x: d,
    y: u,
    placement: p,
    strategy: o,
    middlewareData: f
  };
};
async function $o(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = xr(t, e), m = qg(f), y = a[p ? u === "floating" ? "reference" : "floating" : u], b = yo(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(y))) == null || n ? y : y.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), w = u === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), $ = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = yo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: w,
    offsetParent: x,
    strategy: l
  }) : w);
  return {
    top: (b.top - E.top + m.top) / $.y,
    bottom: (E.bottom - b.bottom + m.bottom) / $.y,
    left: (b.left - E.left + m.left) / $.x,
    right: (E.right - b.right + m.right) / $.x
  };
}
const y0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: l,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...y
      } = xr(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = Zt(o), w = En(a), x = Zt(a) === a, $ = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), E = p || (x || !g ? [vo(a)] : Kg(a)), S = m !== "none";
      !p && S && E.push(...Xg(a, g, m, $));
      const F = [a, ...E], R = await $o(t, y), L = [];
      let P = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && L.push(R[b]), u) {
        const D = Gg(o, s, $);
        L.push(R[D[0]], R[D[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: L
      }], !L.every((D) => D <= 0)) {
        var j, _;
        const D = (((j = i.flip) == null ? void 0 : j.index) || 0) + 1, I = F[D];
        if (I)
          return {
            data: {
              index: D,
              overflows: P
            },
            reset: {
              placement: I
            }
          };
        let z = (_ = P.filter((O) => O.overflows[0] <= 0).sort((O, V) => O.overflows[1] - V.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!z)
          switch (f) {
            case "bestFit": {
              var G;
              const O = (G = P.filter((V) => {
                if (S) {
                  const N = En(V.placement);
                  return N === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((N) => N > 0).reduce((N, B) => N + B, 0)]).sort((V, N) => V[1] - N[1])[0]) == null ? void 0 : G[0];
              O && (z = O);
              break;
            }
            case "initialPlacement":
              z = a;
              break;
          }
        if (o !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
};
function pl(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function fl(e) {
  return _g.some((t) => e[t] >= 0);
}
const b0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = xr(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await $o(t, {
            ...o,
            elementContext: "reference"
          }), s = pl(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: fl(s)
            }
          };
        }
        case "escaped": {
          const i = await $o(t, {
            ...o,
            altBoundary: !0
          }), s = pl(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: fl(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function x0(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Zt(n), a = wr(n), l = En(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, d = i && l ? -1 : 1, u = xr(t, e);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: m
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return a && typeof m == "number" && (f = a === "end" ? m * -1 : m), l ? {
    x: f * d,
    y: p * c
  } : {
    x: p * c,
    y: f * d
  };
}
const w0 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, l = await x0(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, $0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: l = () => {
        },
        ...c
      } = xr(e, t), d = await $o(t, c), u = Zt(o), p = wr(o), f = En(o) === "y", {
        width: m,
        height: g
      } = i.floating;
      let y, b;
      u === "top" || u === "bottom" ? (y = u, b = p === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (b = u, y = p === "end" ? "top" : "bottom");
      const w = g - d.top - d.bottom, x = m - d.left - d.right, $ = dr(g - d[y], w), E = dr(m - d[b], x), S = !t.middlewareData.shift;
      let F = $, R = E;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (R = x), (r = t.middlewareData.shift) != null && r.enabled.y && (F = w), S && !p) {
        const P = Oe(d.left, 0), j = Oe(d.right, 0), _ = Oe(d.top, 0), G = Oe(d.bottom, 0);
        f ? R = m - 2 * (P !== 0 || j !== 0 ? P + j : Oe(d.left, d.right)) : F = g - 2 * (_ !== 0 || G !== 0 ? _ + G : Oe(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: R,
        availableHeight: F
      });
      const L = await s.getDimensions(a.floating);
      return m !== L.width || g !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Cu(e) {
  const t = _e(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = $e(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = go(n) !== i || go(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Js(e) {
  return pe(e) ? e : e.contextElement;
}
function $n(e) {
  const t = Js(e);
  if (!$e(t))
    return At(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Cu(t);
  let s = (i ? go(n.width) : n.width) / r, a = (i ? go(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const C0 = /* @__PURE__ */ At(0);
function ku(e) {
  const t = Le(e);
  return !Xs() || !t.visualViewport ? C0 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function k0(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Le(e) ? !1 : t;
}
function qt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Js(e);
  let s = At(1);
  t && (r ? pe(r) && (s = $n(r)) : s = $n(e));
  const a = k0(i, n, r) ? ku(i) : At(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, d = o.width / s.x, u = o.height / s.y;
  if (i) {
    const p = Le(i), f = r && pe(r) ? Le(r) : r;
    let m = p, g = cs(m);
    for (; g && r && f !== m; ) {
      const y = $n(g), b = g.getBoundingClientRect(), w = _e(g), x = b.left + (g.clientLeft + parseFloat(w.paddingLeft)) * y.x, $ = b.top + (g.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, c *= y.y, d *= y.x, u *= y.y, l += x, c += $, m = Le(g), g = cs(m);
    }
  }
  return yo({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function S0(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = rt(r), a = t ? Ko(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = At(1);
  const d = At(0), u = $e(r);
  if ((u || !u && !i) && ((Dt(r) !== "body" || br(s)) && (l = Yo(r)), $e(r))) {
    const p = qt(r);
    c = $n(r), d.x = p.x + r.clientLeft, d.y = p.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y
  };
}
function T0(e) {
  return Array.from(e.getClientRects());
}
function fs(e, t) {
  const n = Yo(e).scrollLeft;
  return t ? t.left + n : qt(rt(e)).left + n;
}
function E0(e) {
  const t = rt(e), n = Yo(e), r = e.ownerDocument.body, o = Oe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Oe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + fs(e);
  const a = -n.scrollTop;
  return _e(r).direction === "rtl" && (s += Oe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function R0(e, t) {
  const n = Le(e), r = rt(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = Xs();
    (!c || c && t === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function A0(e, t) {
  const n = qt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = $e(e) ? $n(e) : At(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function hl(e, t, n) {
  let r;
  if (t === "viewport")
    r = R0(e, n);
  else if (t === "document")
    r = E0(rt(e));
  else if (pe(t))
    r = A0(t, n);
  else {
    const o = ku(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return yo(r);
}
function Su(e, t) {
  const n = ft(e);
  return n === t || !pe(n) || Rt(n) ? !1 : _e(n).position === "fixed" || Su(n, t);
}
function P0(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = $t(e, [], !1).filter((a) => pe(a) && Dt(a) !== "body"), o = null;
  const i = _e(e).position === "fixed";
  let s = i ? ft(e) : e;
  for (; pe(s) && !Rt(s); ) {
    const a = _e(s), l = Ys(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || br(s) && !l && Su(e, s)) ? r = r.filter((d) => d !== s) : o = a, s = ft(s);
  }
  return t.set(e, r), r;
}
function M0(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Ko(t) ? [] : P0(t, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, d) => {
    const u = hl(t, d, o);
    return c.top = Oe(u.top, c.top), c.right = dr(u.right, c.right), c.bottom = dr(u.bottom, c.bottom), c.left = Oe(u.left, c.left), c;
  }, hl(t, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function D0(e) {
  const {
    width: t,
    height: n
  } = Cu(e);
  return {
    width: t,
    height: n
  };
}
function B0(e, t, n) {
  const r = $e(t), o = rt(t), i = n === "fixed", s = qt(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = At(0);
  if (r || !r && !i)
    if ((Dt(t) !== "body" || br(o)) && (a = Yo(t)), r) {
      const f = qt(t, !0, i, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else o && (l.x = fs(o));
  let c = 0, d = 0;
  if (o && !r && !i) {
    const f = o.getBoundingClientRect();
    d = f.top + a.scrollTop, c = f.left + a.scrollLeft - // RTL <body> scrollbar.
    fs(o, f);
  }
  const u = s.left + a.scrollLeft - l.x - c, p = s.top + a.scrollTop - l.y - d;
  return {
    x: u,
    y: p,
    width: s.width,
    height: s.height
  };
}
function Mi(e) {
  return _e(e).position === "static";
}
function ml(e, t) {
  if (!$e(e) || _e(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return rt(e) === n && (n = n.ownerDocument.body), n;
}
function Tu(e, t) {
  const n = Le(e);
  if (Ko(e))
    return n;
  if (!$e(e)) {
    let o = ft(e);
    for (; o && !Rt(o); ) {
      if (pe(o) && !Mi(o))
        return o;
      o = ft(o);
    }
    return n;
  }
  let r = ml(e, t);
  for (; r && Bg(r) && Mi(r); )
    r = ml(r, t);
  return r && Rt(r) && Mi(r) && !Ys(r) ? n : r || Lg(e) || n;
}
const L0 = async function(e) {
  const t = this.getOffsetParent || Tu, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: B0(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function I0(e) {
  return _e(e).direction === "rtl";
}
const F0 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: S0,
  getDocumentElement: rt,
  getClippingRect: M0,
  getOffsetParent: Tu,
  getElementRects: L0,
  getClientRects: T0,
  getDimensions: D0,
  getScale: $n,
  isElement: pe,
  isRTL: I0
};
function V0(e, t) {
  let n = null, r;
  const o = rt(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: d,
      width: u,
      height: p
    } = e.getBoundingClientRect();
    if (a || t(), !u || !p)
      return;
    const f = Nr(d), m = Nr(o.clientWidth - (c + u)), g = Nr(o.clientHeight - (d + p)), y = Nr(c), w = {
      rootMargin: -f + "px " + -m + "px " + -g + "px " + -y + "px",
      threshold: Oe(0, dr(1, l)) || 1
    };
    let x = !0;
    function $(E) {
      const S = E[0].intersectionRatio;
      if (S !== l) {
        if (!x)
          return s();
        S ? s(!1, S) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver($, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver($, w);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Eu(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Js(e), d = o || i ? [...c ? $t(c) : [], ...$t(t)] : [];
  d.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const u = c && a ? V0(c, n) : null;
  let p = -1, f = null;
  s && (f = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === c && f && (f.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = f) == null || x.observe(t);
    })), n();
  }), c && !l && f.observe(c), f.observe(t));
  let m, g = l ? qt(e) : null;
  l && y();
  function y() {
    const b = qt(e);
    g && (b.x !== g.x || b.y !== g.y || b.width !== g.width || b.height !== g.height) && n(), g = b, m = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    d.forEach((w) => {
      o && w.removeEventListener("scroll", n), i && w.removeEventListener("resize", n);
    }), u == null || u(), (b = f) == null || b.disconnect(), f = null, l && cancelAnimationFrame(m);
  };
}
const O0 = w0, z0 = y0, N0 = $0, W0 = b0, _0 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: F0,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return v0(e, t, {
    ...o,
    platform: i
  });
};
var lo = typeof document < "u" ? nn : Y;
function Co(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Co(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Co(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ru(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function gl(e, t) {
  const n = Ru(e);
  return Math.round(t * n) / n;
}
function Di(e) {
  const t = T.useRef(e);
  return lo(() => {
    t.current = e;
  }), t;
}
function j0(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = e, [d, u] = T.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, f] = T.useState(r);
  Co(p, r) || f(r);
  const [m, g] = T.useState(null), [y, b] = T.useState(null), w = T.useCallback((V) => {
    V !== S.current && (S.current = V, g(V));
  }, []), x = T.useCallback((V) => {
    V !== F.current && (F.current = V, b(V));
  }, []), $ = i || m, E = s || y, S = T.useRef(null), F = T.useRef(null), R = T.useRef(d), L = l != null, P = Di(l), j = Di(o), _ = Di(c), G = T.useCallback(() => {
    if (!S.current || !F.current)
      return;
    const V = {
      placement: t,
      strategy: n,
      middleware: p
    };
    j.current && (V.platform = j.current), _0(S.current, F.current, V).then((N) => {
      const B = {
        ...N,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: _.current !== !1
      };
      D.current && !Co(R.current, B) && (R.current = B, Jd.flushSync(() => {
        u(B);
      }));
    });
  }, [p, t, n, j, _]);
  lo(() => {
    c === !1 && R.current.isPositioned && (R.current.isPositioned = !1, u((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [c]);
  const D = T.useRef(!1);
  lo(() => (D.current = !0, () => {
    D.current = !1;
  }), []), lo(() => {
    if ($ && (S.current = $), E && (F.current = E), $ && E) {
      if (P.current)
        return P.current($, E, G);
      G();
    }
  }, [$, E, G, P, L]);
  const I = T.useMemo(() => ({
    reference: S,
    floating: F,
    setReference: w,
    setFloating: x
  }), [w, x]), z = T.useMemo(() => ({
    reference: $,
    floating: E
  }), [$, E]), O = T.useMemo(() => {
    const V = {
      position: n,
      left: 0,
      top: 0
    };
    if (!z.floating)
      return V;
    const N = gl(z.floating, d.x), B = gl(z.floating, d.y);
    return a ? {
      ...V,
      transform: "translate(" + N + "px, " + B + "px)",
      ...Ru(z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: N,
      top: B
    };
  }, [n, a, z.floating, d.x, d.y]);
  return T.useMemo(() => ({
    ...d,
    update: G,
    refs: I,
    elements: z,
    floatingStyles: O
  }), [d, G, I, z, O]);
}
const Au = (e, t) => ({
  ...O0(e),
  options: [e, t]
}), Pu = (e, t) => ({
  ...z0(e),
  options: [e, t]
}), H0 = (e, t) => ({
  ...N0(e),
  options: [e, t]
}), U0 = (e, t) => ({
  ...W0(e),
  options: [e, t]
}), Mu = {
  ...T
}, G0 = Mu.useInsertionEffect, K0 = G0 || ((e) => e());
function Xe(e) {
  const t = T.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return K0(() => {
    t.current = e;
  }), T.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
let vl = 0;
function ln(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: o = !1
  } = t;
  r && cancelAnimationFrame(vl);
  const i = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  o ? i() : vl = requestAnimationFrame(i);
}
var Ee = typeof document < "u" ? nn : Y;
function ur() {
  return ur = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ur.apply(this, arguments);
}
let yl = !1, Y0 = 0;
const bl = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Y0++
);
function X0() {
  const [e, t] = T.useState(() => yl ? bl() : void 0);
  return Ee(() => {
    e == null && t(bl());
  }, []), T.useEffect(() => {
    yl = !0;
  }, []), e;
}
const Z0 = Mu.useId, Qs = Z0 || X0;
let hs;
process.env.NODE_ENV !== "production" && (hs = /* @__PURE__ */ new Set());
function q0() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = hs) != null && e.has(o))) {
    var i;
    (i = hs) == null || i.add(o), console.error(o);
  }
}
function J0() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((o) => o !== n)) || []);
    }
  };
}
const Q0 = /* @__PURE__ */ T.createContext(null), ev = /* @__PURE__ */ T.createContext(null), ea = () => {
  var e;
  return ((e = T.useContext(Q0)) == null ? void 0 : e.id) || null;
}, Zo = () => T.useContext(ev);
function Jt(e) {
  return "data-floating-ui-" + e;
}
function Ze(e) {
  const t = oe(e);
  return Ee(() => {
    t.current = e;
  }), t;
}
const xl = /* @__PURE__ */ Jt("safe-polygon");
function Bi(e, t, n) {
  return n && !cr(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function tv(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    events: i,
    elements: s
  } = e, {
    enabled: a = !0,
    delay: l = 0,
    handleClose: c = null,
    mouseOnly: d = !1,
    restMs: u = 0,
    move: p = !0
  } = t, f = Zo(), m = ea(), g = Ze(c), y = Ze(l), b = Ze(n), w = T.useRef(), x = T.useRef(-1), $ = T.useRef(), E = T.useRef(-1), S = T.useRef(!0), F = T.useRef(!1), R = T.useRef(() => {
  }), L = T.useCallback(() => {
    var I;
    const z = (I = o.current.openEvent) == null ? void 0 : I.type;
    return (z == null ? void 0 : z.includes("mouse")) && z !== "mousedown";
  }, [o]);
  T.useEffect(() => {
    if (!a) return;
    function I(z) {
      let {
        open: O
      } = z;
      O || (clearTimeout(x.current), clearTimeout(E.current), S.current = !0);
    }
    return i.on("openchange", I), () => {
      i.off("openchange", I);
    };
  }, [a, i]), T.useEffect(() => {
    if (!a || !g.current || !n) return;
    function I(O) {
      L() && r(!1, O, "hover");
    }
    const z = De(s.floating).documentElement;
    return z.addEventListener("mouseleave", I), () => {
      z.removeEventListener("mouseleave", I);
    };
  }, [s.floating, n, r, a, g, L]);
  const P = T.useCallback(function(I, z, O) {
    z === void 0 && (z = !0), O === void 0 && (O = "hover");
    const V = Bi(y.current, "close", w.current);
    V && !$.current ? (clearTimeout(x.current), x.current = window.setTimeout(() => r(!1, I, O), V)) : z && (clearTimeout(x.current), r(!1, I, O));
  }, [y, r]), j = Xe(() => {
    R.current(), $.current = void 0;
  }), _ = Xe(() => {
    if (F.current) {
      const I = De(s.floating).body;
      I.style.pointerEvents = "", I.removeAttribute(xl), F.current = !1;
    }
  });
  T.useEffect(() => {
    if (!a) return;
    function I() {
      return o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1;
    }
    function z(B) {
      if (clearTimeout(x.current), S.current = !1, d && !cr(w.current) || u > 0 && !Bi(y.current, "open"))
        return;
      const X = Bi(y.current, "open", w.current);
      X ? x.current = window.setTimeout(() => {
        b.current || r(!0, B, "hover");
      }, X) : r(!0, B, "hover");
    }
    function O(B) {
      if (I()) return;
      R.current();
      const X = De(s.floating);
      if (clearTimeout(E.current), g.current && o.current.floatingContext) {
        n || clearTimeout(x.current), $.current = g.current({
          ...o.current.floatingContext,
          tree: f,
          x: B.clientX,
          y: B.clientY,
          onClose() {
            _(), j(), P(B, !0, "safe-polygon");
          }
        });
        const we = $.current;
        X.addEventListener("mousemove", we), R.current = () => {
          X.removeEventListener("mousemove", we);
        };
        return;
      }
      (w.current === "touch" ? !Pe(s.floating, B.relatedTarget) : !0) && P(B);
    }
    function V(B) {
      I() || o.current.floatingContext && (g.current == null || g.current({
        ...o.current.floatingContext,
        tree: f,
        x: B.clientX,
        y: B.clientY,
        onClose() {
          _(), j(), P(B);
        }
      })(B));
    }
    if (pe(s.domReference)) {
      var N;
      const B = s.domReference;
      return n && B.addEventListener("mouseleave", V), (N = s.floating) == null || N.addEventListener("mouseleave", V), p && B.addEventListener("mousemove", z, {
        once: !0
      }), B.addEventListener("mouseenter", z), B.addEventListener("mouseleave", O), () => {
        var X;
        n && B.removeEventListener("mouseleave", V), (X = s.floating) == null || X.removeEventListener("mouseleave", V), p && B.removeEventListener("mousemove", z), B.removeEventListener("mouseenter", z), B.removeEventListener("mouseleave", O);
      };
    }
  }, [s, a, e, d, u, p, P, j, _, r, n, b, f, y, g, o]), Ee(() => {
    var I;
    if (a && n && (I = g.current) != null && I.__options.blockPointerEvents && L()) {
      F.current = !0;
      const O = s.floating;
      if (pe(s.domReference) && O) {
        var z;
        const V = De(s.floating).body;
        V.setAttribute(xl, "");
        const N = s.domReference, B = f == null || (z = f.nodesRef.current.find((X) => X.id === m)) == null || (z = z.context) == null ? void 0 : z.elements.floating;
        return B && (B.style.pointerEvents = ""), V.style.pointerEvents = "none", N.style.pointerEvents = "auto", O.style.pointerEvents = "auto", () => {
          V.style.pointerEvents = "", N.style.pointerEvents = "", O.style.pointerEvents = "";
        };
      }
    }
  }, [a, n, m, s, f, g, L]), Ee(() => {
    n || (w.current = void 0, j(), _());
  }, [n, j, _]), T.useEffect(() => () => {
    j(), clearTimeout(x.current), clearTimeout(E.current), _();
  }, [a, s.domReference, j, _]);
  const G = T.useMemo(() => {
    function I(z) {
      w.current = z.pointerType;
    }
    return {
      onPointerDown: I,
      onPointerEnter: I,
      onMouseMove(z) {
        const {
          nativeEvent: O
        } = z;
        function V() {
          !S.current && !b.current && r(!0, O, "hover");
        }
        d && !cr(w.current) || n || u === 0 || (clearTimeout(E.current), w.current === "touch" ? V() : E.current = window.setTimeout(V, u));
      }
    };
  }, [d, r, n, b, u]), D = T.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(x.current);
    },
    onMouseLeave(I) {
      P(I.nativeEvent, !1);
    }
  }), [P]);
  return T.useMemo(() => a ? {
    reference: G,
    floating: D
  } : {}, [a, G, D]);
}
function nv(e, t) {
  var n;
  let r = [], o = (n = e.find((i) => i.id === t)) == null ? void 0 : n.parentId;
  for (; o; ) {
    const i = e.find((s) => s.id === o);
    o = i == null ? void 0 : i.parentId, i && (r = r.concat(i));
  }
  return r;
}
function Zn(e, t) {
  let n = e.filter((o) => {
    var i;
    return o.parentId === t && ((i = o.context) == null ? void 0 : i.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((o) => {
      var i;
      return (i = r) == null ? void 0 : i.some((s) => {
        var a;
        return o.parentId === s.id && ((a = o.context) == null ? void 0 : a.open);
      });
    }), n = n.concat(r);
  return n;
}
let cn = /* @__PURE__ */ new WeakMap(), Wr = /* @__PURE__ */ new WeakSet(), _r = {}, Li = 0;
const rv = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, Du = (e) => e && (e.host || Du(e.parentNode)), ov = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = Du(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function iv(e, t, n, r) {
  const o = "data-floating-ui-inert", i = r ? "inert" : n ? "aria-hidden" : null, s = ov(t, e), a = /* @__PURE__ */ new Set(), l = new Set(s), c = [];
  _r[o] || (_r[o] = /* @__PURE__ */ new WeakMap());
  const d = _r[o];
  s.forEach(u), p(t), a.clear();
  function u(f) {
    !f || a.has(f) || (a.add(f), f.parentNode && u(f.parentNode));
  }
  function p(f) {
    !f || l.has(f) || [].forEach.call(f.children, (m) => {
      if (Dt(m) !== "script")
        if (a.has(m))
          p(m);
        else {
          const g = i ? m.getAttribute(i) : null, y = g !== null && g !== "false", b = (cn.get(m) || 0) + 1, w = (d.get(m) || 0) + 1;
          cn.set(m, b), d.set(m, w), c.push(m), b === 1 && y && Wr.add(m), w === 1 && m.setAttribute(o, ""), !y && i && m.setAttribute(i, "true");
        }
    });
  }
  return Li++, () => {
    c.forEach((f) => {
      const m = (cn.get(f) || 0) - 1, g = (d.get(f) || 0) - 1;
      cn.set(f, m), d.set(f, g), m || (!Wr.has(f) && i && f.removeAttribute(i), Wr.delete(f)), g || f.removeAttribute(o);
    }), Li--, Li || (cn = /* @__PURE__ */ new WeakMap(), cn = /* @__PURE__ */ new WeakMap(), Wr = /* @__PURE__ */ new WeakSet(), _r = {});
  };
}
function wl(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = De(e[0]).body;
  return iv(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, t, n);
}
const pr = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function Bu(e, t) {
  const n = Xo(e, pr());
  t === "prev" && n.reverse();
  const r = n.indexOf(st(De(e)));
  return n.slice(r + 1)[0];
}
function Lu() {
  return Bu(document.body, "next");
}
function Iu() {
  return Bu(document.body, "prev");
}
function qn(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !Pe(n, r);
}
function sv(e) {
  Xo(e, pr()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function $l(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const qo = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let av;
function Cl(e) {
  e.key === "Tab" && (e.target, clearTimeout(av));
}
const ko = /* @__PURE__ */ T.forwardRef(function(t, n) {
  const [r, o] = T.useState();
  Ee(() => (gu() && o("button"), document.addEventListener("keydown", Cl), () => {
    document.removeEventListener("keydown", Cl);
  }), []);
  const i = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Jt("focus-guard")]: "",
    style: qo
  };
  return /* @__PURE__ */ T.createElement("span", ur({}, t, i));
}), Fu = /* @__PURE__ */ T.createContext(null), kl = /* @__PURE__ */ Jt("portal");
function lv(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = Qs(), o = Ou(), [i, s] = T.useState(null), a = T.useRef(null);
  return Ee(() => () => {
    i == null || i.remove(), queueMicrotask(() => {
      a.current = null;
    });
  }, [i]), Ee(() => {
    if (!r || a.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const c = document.createElement("div");
    c.id = r, c.setAttribute(kl, ""), l.appendChild(c), a.current = c, s(c);
  }, [t, r]), Ee(() => {
    if (!r || a.current) return;
    let l = n || (o == null ? void 0 : o.portalNode);
    l && !pe(l) && (l = l.current), l = l || document.body;
    let c = null;
    t && (c = document.createElement("div"), c.id = t, l.appendChild(c));
    const d = document.createElement("div");
    d.id = r, d.setAttribute(kl, ""), l = c || l, l.appendChild(d), a.current = d, s(d);
  }, [t, n, r, o]), i;
}
function Vu(e) {
  const {
    children: t,
    id: n,
    root: r = null,
    preserveTabOrder: o = !0
  } = e, i = lv({
    id: n,
    root: r
  }), [s, a] = T.useState(null), l = T.useRef(null), c = T.useRef(null), d = T.useRef(null), u = T.useRef(null), p = s == null ? void 0 : s.modal, f = s == null ? void 0 : s.open, m = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!s && // Guards are only for non-modal focus management.
    !s.modal && // Don't render if unmount is transitioning.
    s.open && o && !!(r || i)
  );
  return T.useEffect(() => {
    if (!i || !o || p)
      return;
    function g(y) {
      i && qn(y) && (y.type === "focusin" ? $l : sv)(i);
    }
    return i.addEventListener("focusin", g, !0), i.addEventListener("focusout", g, !0), () => {
      i.removeEventListener("focusin", g, !0), i.removeEventListener("focusout", g, !0);
    };
  }, [i, o, p]), T.useEffect(() => {
    i && (f || $l(i));
  }, [f, i]), /* @__PURE__ */ T.createElement(Fu.Provider, {
    value: T.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: l,
      afterOutsideRef: c,
      beforeInsideRef: d,
      afterInsideRef: u,
      portalNode: i,
      setFocusManagerState: a
    }), [o, i])
  }, m && i && /* @__PURE__ */ T.createElement(ko, {
    "data-type": "outside",
    ref: l,
    onFocus: (g) => {
      if (qn(g, i)) {
        var y;
        (y = d.current) == null || y.focus();
      } else {
        const b = Iu() || (s == null ? void 0 : s.refs.domReference.current);
        b == null || b.focus();
      }
    }
  }), m && i && /* @__PURE__ */ T.createElement("span", {
    "aria-owns": i.id,
    style: qo
  }), i && /* @__PURE__ */ Jd.createPortal(t, i), m && i && /* @__PURE__ */ T.createElement(ko, {
    "data-type": "outside",
    ref: c,
    onFocus: (g) => {
      if (qn(g, i)) {
        var y;
        (y = u.current) == null || y.focus();
      } else {
        const b = Lu() || (s == null ? void 0 : s.refs.domReference.current);
        b == null || b.focus(), s != null && s.closeOnFocusOut && (s == null || s.onOpenChange(!1, g.nativeEvent, "focus-out"));
      }
    }
  }));
}
const Ou = () => T.useContext(Fu), ms = "data-floating-ui-focusable";
function cv(e) {
  return e ? e.hasAttribute(ms) ? e : e.querySelector("[" + ms + "]") || e : null;
}
const Sl = 20;
let Nt = [];
function Ii(e) {
  Nt = Nt.filter((n) => n.isConnected);
  let t = e;
  if (!(!t || Dt(t) === "body")) {
    if (!g0(t, pr())) {
      const n = Xo(t, pr())[0];
      n && (t = n);
    }
    Nt.push(t), Nt.length > Sl && (Nt = Nt.slice(-Sl));
  }
}
function Tl() {
  return Nt.slice().reverse().find((e) => e.isConnected);
}
const dv = /* @__PURE__ */ T.forwardRef(function(t, n) {
  return /* @__PURE__ */ T.createElement("button", ur({}, t, {
    type: "button",
    ref: n,
    tabIndex: -1,
    style: qo
  }));
});
function zu(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: o = ["content"],
    guards: i = !0,
    initialFocus: s = 0,
    returnFocus: a = !0,
    restoreFocus: l = !1,
    modal: c = !0,
    visuallyHiddenDismiss: d = !1,
    closeOnFocusOut: u = !0
  } = e, {
    open: p,
    refs: f,
    nodeId: m,
    onOpenChange: g,
    events: y,
    dataRef: b,
    floatingId: w,
    elements: {
      domReference: x,
      floating: $
    }
  } = t, E = typeof s == "number" && s < 0, S = Wg(x) && E, F = rv() ? i : !0, R = Ze(o), L = Ze(s), P = Ze(a), j = Zo(), _ = Ou(), G = T.useRef(null), D = T.useRef(null), I = T.useRef(!1), z = T.useRef(!1), O = T.useRef(-1), V = _ != null, N = cv($), B = Xe(function(J) {
    return J === void 0 && (J = N), J ? Xo(J, pr()) : [];
  }), X = Xe((J) => {
    const Q = B(J);
    return R.current.map((ne) => x && ne === "reference" ? x : N && ne === "floating" ? N : Q).filter(Boolean).flat();
  });
  T.useEffect(() => {
    I.current = !1;
  }, [r]), T.useEffect(() => {
    if (r || !c) return;
    function J(ne) {
      if (ne.key === "Tab") {
        Pe(N, st(De(N))) && B().length === 0 && !S && Pi(ne);
        const Z = X(), ue = wt(ne);
        R.current[0] === "reference" && ue === x && (Pi(ne), ne.shiftKey ? ln(Z[Z.length - 1]) : ln(Z[1])), R.current[1] === "floating" && ue === N && ne.shiftKey && (Pi(ne), ln(Z[0]));
      }
    }
    const Q = De(N);
    return Q.addEventListener("keydown", J), () => {
      Q.removeEventListener("keydown", J);
    };
  }, [r, x, N, c, R, S, B, X]), T.useEffect(() => {
    if (r || !$) return;
    function J(Q) {
      const ne = wt(Q), ue = B().indexOf(ne);
      ue !== -1 && (O.current = ue);
    }
    return $.addEventListener("focusin", J), () => {
      $.removeEventListener("focusin", J);
    };
  }, [r, $, B]), T.useEffect(() => {
    if (r || !u) return;
    function J() {
      z.current = !0, setTimeout(() => {
        z.current = !1;
      });
    }
    function Q(ne) {
      const Z = ne.relatedTarget;
      queueMicrotask(() => {
        const ue = !(Pe(x, Z) || Pe($, Z) || Pe(Z, $) || Pe(_ == null ? void 0 : _.portalNode, Z) || Z != null && Z.hasAttribute(Jt("focus-guard")) || j && (Zn(j.nodesRef.current, m).find((le) => {
          var ve, Se;
          return Pe((ve = le.context) == null ? void 0 : ve.elements.floating, Z) || Pe((Se = le.context) == null ? void 0 : Se.elements.domReference, Z);
        }) || nv(j.nodesRef.current, m).find((le) => {
          var ve, Se;
          return ((ve = le.context) == null ? void 0 : ve.elements.floating) === Z || ((Se = le.context) == null ? void 0 : Se.elements.domReference) === Z;
        })));
        if (l && ue && st(De(N)) === De(N).body) {
          $e(N) && N.focus();
          const le = O.current, ve = B(), Se = ve[le] || ve[ve.length - 1] || N;
          $e(Se) && Se.focus();
        }
        (S || !c) && Z && ue && !z.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        Z !== Tl() && (I.current = !0, g(!1, ne, "focus-out"));
      });
    }
    if ($ && $e(x))
      return x.addEventListener("focusout", Q), x.addEventListener("pointerdown", J), $.addEventListener("focusout", Q), () => {
        x.removeEventListener("focusout", Q), x.removeEventListener("pointerdown", J), $.removeEventListener("focusout", Q);
      };
  }, [r, x, $, N, c, m, j, _, g, u, l, B, S]), T.useEffect(() => {
    var J;
    if (r) return;
    const Q = Array.from((_ == null || (J = _.portalNode) == null ? void 0 : J.querySelectorAll("[" + Jt("portal") + "]")) || []);
    if ($) {
      const ne = [$, ...Q, G.current, D.current, R.current.includes("reference") || S ? x : null].filter((ue) => ue != null), Z = c || S ? wl(ne, F, !F) : wl(ne);
      return () => {
        Z();
      };
    }
  }, [r, x, $, c, R, _, S, F]), Ee(() => {
    if (r || !$e(N)) return;
    const J = De(N), Q = st(J);
    queueMicrotask(() => {
      const ne = X(N), Z = L.current, ue = (typeof Z == "number" ? ne[Z] : Z.current) || N, le = Pe(N, Q);
      !E && !le && p && ln(ue, {
        preventScroll: ue === N
      });
    });
  }, [r, p, N, E, X, L]), Ee(() => {
    if (r || !N) return;
    let J = !1;
    const Q = De(N), ne = st(Q);
    let ue = b.current.openEvent;
    Ii(ne);
    function le(Se) {
      let {
        open: Ir,
        reason: Fr,
        event: ht,
        nested: Si
      } = Se;
      Ir && (ue = ht), Fr === "escape-key" && f.domReference.current && Ii(f.domReference.current), Fr === "hover" && ht.type === "mouseleave" && (I.current = !0), Fr === "outside-press" && (Si ? (I.current = !1, J = !0) : I.current = !(Ig(ht) || mu(ht)));
    }
    y.on("openchange", le);
    const ve = Q.createElement("span");
    return ve.setAttribute("tabindex", "-1"), ve.setAttribute("aria-hidden", "true"), Object.assign(ve.style, qo), V && x && x.insertAdjacentElement("afterend", ve), () => {
      y.off("openchange", le);
      const Se = st(Q), Ir = Pe($, Se) || j && Zn(j.nodesRef.current, m).some((Si) => {
        var nl;
        return Pe((nl = Si.context) == null ? void 0 : nl.elements.floating, Se);
      });
      (Ir || ue && ["click", "mousedown"].includes(ue.type)) && f.domReference.current && Ii(f.domReference.current);
      const ht = Tl() || ve;
      queueMicrotask(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        P.current && !I.current && $e(ht) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(ht !== Se && Se !== Q.body) || Ir) && ht.focus({
          preventScroll: J
        }), ve.remove();
      });
    };
  }, [r, $, N, P, b, f, y, j, m, V, x]), Ee(() => {
    if (!r && _)
      return _.setFocusManagerState({
        modal: c,
        closeOnFocusOut: u,
        open: p,
        onOpenChange: g,
        refs: f
      }), () => {
        _.setFocusManagerState(null);
      };
  }, [r, _, c, p, g, f, u]), Ee(() => {
    if (r || !N || typeof MutationObserver != "function" || E) return;
    const J = () => {
      const ne = N.getAttribute("tabindex"), Z = B(), ue = st(De($)), le = Z.indexOf(ue);
      le !== -1 && (O.current = le), R.current.includes("floating") || ue !== f.domReference.current && Z.length === 0 ? ne !== "0" && N.setAttribute("tabindex", "0") : ne !== "-1" && N.setAttribute("tabindex", "-1");
    };
    J();
    const Q = new MutationObserver(J);
    return Q.observe(N, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      Q.disconnect();
    };
  }, [r, $, N, f, R, B, E]);
  function te(J) {
    return r || !d || !c ? null : /* @__PURE__ */ T.createElement(dv, {
      ref: J === "start" ? G : D,
      onClick: (Q) => g(!1, Q.nativeEvent)
    }, typeof d == "string" ? d : "Dismiss");
  }
  const we = !r && F && (c ? !S : !0) && (V || c);
  return /* @__PURE__ */ T.createElement(T.Fragment, null, we && /* @__PURE__ */ T.createElement(ko, {
    "data-type": "inside",
    ref: _ == null ? void 0 : _.beforeInsideRef,
    onFocus: (J) => {
      if (c) {
        const ne = X();
        ln(o[0] === "reference" ? ne[0] : ne[ne.length - 1]);
      } else if (_ != null && _.preserveTabOrder && _.portalNode)
        if (I.current = !1, qn(J, _.portalNode)) {
          const ne = Lu() || x;
          ne == null || ne.focus();
        } else {
          var Q;
          (Q = _.beforeOutsideRef.current) == null || Q.focus();
        }
    }
  }), !S && te("start"), n, te("end"), we && /* @__PURE__ */ T.createElement(ko, {
    "data-type": "inside",
    ref: _ == null ? void 0 : _.afterInsideRef,
    onFocus: (J) => {
      if (c)
        ln(X()[0]);
      else if (_ != null && _.preserveTabOrder && _.portalNode)
        if (u && (I.current = !0), qn(J, _.portalNode)) {
          const ne = Iu() || x;
          ne == null || ne.focus();
        } else {
          var Q;
          (Q = _.afterOutsideRef.current) == null || Q.focus();
        }
    }
  }));
}
let jr = 0;
function uv() {
  const e = /iP(hone|ad|od)|iOS/.test(Zs()), t = document.body.style, r = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", o = window.innerWidth - document.documentElement.clientWidth, i = t.left ? parseFloat(t.left) : window.scrollX, s = t.top ? parseFloat(t.top) : window.scrollY;
  if (t.overflow = "hidden", o && (t[r] = o + "px"), e) {
    var a, l;
    const c = ((a = window.visualViewport) == null ? void 0 : a.offsetLeft) || 0, d = ((l = window.visualViewport) == null ? void 0 : l.offsetTop) || 0;
    Object.assign(t, {
      position: "fixed",
      top: -(s - Math.floor(d)) + "px",
      left: -(i - Math.floor(c)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(t, {
      overflow: "",
      [r]: ""
    }), e && (Object.assign(t, {
      position: "",
      top: "",
      left: "",
      right: ""
    }), window.scrollTo(i, s));
  };
}
let El = () => {
};
const Nu = /* @__PURE__ */ T.forwardRef(function(t, n) {
  const {
    lockScroll: r = !1,
    ...o
  } = t;
  return Ee(() => {
    if (r)
      return jr++, jr === 1 && (El = uv()), () => {
        jr--, jr === 0 && El();
      };
  }, [r]), /* @__PURE__ */ T.createElement("div", ur({
    ref: n
  }, o, {
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...o.style
    }
  }));
});
function Rl(e) {
  return $e(e.target) && e.target.tagName === "BUTTON";
}
function Al(e) {
  return qs(e);
}
function Jo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    elements: {
      domReference: i
    }
  } = e, {
    enabled: s = !0,
    event: a = "click",
    toggle: l = !0,
    ignoreMouse: c = !1,
    keyboardHandlers: d = !0
  } = t, u = T.useRef(), p = T.useRef(!1), f = T.useMemo(() => ({
    onPointerDown(m) {
      u.current = m.pointerType;
    },
    onMouseDown(m) {
      const g = u.current;
      m.button === 0 && a !== "click" && (cr(g, !0) && c || (n && l && (!o.current.openEvent || o.current.openEvent.type === "mousedown") ? r(!1, m.nativeEvent, "click") : (m.preventDefault(), r(!0, m.nativeEvent, "click"))));
    },
    onClick(m) {
      const g = u.current;
      if (a === "mousedown" && u.current) {
        u.current = void 0;
        return;
      }
      cr(g, !0) && c || (n && l && (!o.current.openEvent || o.current.openEvent.type === "click") ? r(!1, m.nativeEvent, "click") : r(!0, m.nativeEvent, "click"));
    },
    onKeyDown(m) {
      u.current = void 0, !(m.defaultPrevented || !d || Rl(m)) && (m.key === " " && !Al(i) && (m.preventDefault(), p.current = !0), m.key === "Enter" && r(!(n && l), m.nativeEvent, "click"));
    },
    onKeyUp(m) {
      m.defaultPrevented || !d || Rl(m) || Al(i) || m.key === " " && p.current && (p.current = !1, r(!(n && l), m.nativeEvent, "click"));
    }
  }), [o, i, a, c, d, r, n, l]);
  return T.useMemo(() => s ? {
    reference: f
  } : {}, [s, f]);
}
const pv = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, fv = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, Pl = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function Qo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    dataRef: i
  } = e, {
    enabled: s = !0,
    escapeKey: a = !0,
    outsidePress: l = !0,
    outsidePressEvent: c = "pointerdown",
    referencePress: d = !1,
    referencePressEvent: u = "pointerdown",
    ancestorScroll: p = !1,
    bubbles: f,
    capture: m
  } = t, g = Zo(), y = Xe(typeof l == "function" ? l : () => !1), b = typeof l == "function" ? y : l, w = T.useRef(!1), x = T.useRef(!1), {
    escapeKey: $,
    outsidePress: E
  } = Pl(f), {
    escapeKey: S,
    outsidePress: F
  } = Pl(m), R = Xe((D) => {
    var I;
    if (!n || !s || !a || D.key !== "Escape")
      return;
    const z = (I = i.current.floatingContext) == null ? void 0 : I.nodeId, O = g ? Zn(g.nodesRef.current, z) : [];
    if (!$ && (D.stopPropagation(), O.length > 0)) {
      let V = !0;
      if (O.forEach((N) => {
        var B;
        if ((B = N.context) != null && B.open && !N.context.dataRef.current.__escapeKeyBubbles) {
          V = !1;
          return;
        }
      }), !V)
        return;
    }
    r(!1, Og(D) ? D.nativeEvent : D, "escape-key");
  }), L = Xe((D) => {
    var I;
    const z = () => {
      var O;
      R(D), (O = wt(D)) == null || O.removeEventListener("keydown", z);
    };
    (I = wt(D)) == null || I.addEventListener("keydown", z);
  }), P = Xe((D) => {
    var I;
    const z = w.current;
    w.current = !1;
    const O = x.current;
    if (x.current = !1, c === "click" && O || z || typeof b == "function" && !b(D))
      return;
    const V = wt(D), N = "[" + Jt("inert") + "]", B = De(o.floating).querySelectorAll(N);
    let X = pe(V) ? V : null;
    for (; X && !Rt(X); ) {
      const Q = ft(X);
      if (Rt(Q) || !pe(Q))
        break;
      X = Q;
    }
    if (B.length && pe(V) && !zg(V) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Pe(V, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(B).every((Q) => !Pe(X, Q)))
      return;
    if ($e(V) && G) {
      const Q = V.clientWidth > 0 && V.scrollWidth > V.clientWidth, ne = V.clientHeight > 0 && V.scrollHeight > V.clientHeight;
      let Z = ne && D.offsetX > V.clientWidth;
      if (ne && _e(V).direction === "rtl" && (Z = D.offsetX <= V.offsetWidth - V.clientWidth), Z || Q && D.offsetY > V.clientHeight)
        return;
    }
    const te = (I = i.current.floatingContext) == null ? void 0 : I.nodeId, we = g && Zn(g.nodesRef.current, te).some((Q) => {
      var ne;
      return Ai(D, (ne = Q.context) == null ? void 0 : ne.elements.floating);
    });
    if (Ai(D, o.floating) || Ai(D, o.domReference) || we)
      return;
    const J = g ? Zn(g.nodesRef.current, te) : [];
    if (J.length > 0) {
      let Q = !0;
      if (J.forEach((ne) => {
        var Z;
        if ((Z = ne.context) != null && Z.open && !ne.context.dataRef.current.__outsidePressBubbles) {
          Q = !1;
          return;
        }
      }), !Q)
        return;
    }
    r(!1, D, "outside-press");
  }), j = Xe((D) => {
    var I;
    const z = () => {
      var O;
      P(D), (O = wt(D)) == null || O.removeEventListener(c, z);
    };
    (I = wt(D)) == null || I.addEventListener(c, z);
  });
  T.useEffect(() => {
    if (!n || !s)
      return;
    i.current.__escapeKeyBubbles = $, i.current.__outsidePressBubbles = E;
    function D(O) {
      r(!1, O, "ancestor-scroll");
    }
    const I = De(o.floating);
    a && I.addEventListener("keydown", S ? L : R, S), b && I.addEventListener(c, F ? j : P, F);
    let z = [];
    return p && (pe(o.domReference) && (z = $t(o.domReference)), pe(o.floating) && (z = z.concat($t(o.floating))), !pe(o.reference) && o.reference && o.reference.contextElement && (z = z.concat($t(o.reference.contextElement)))), z = z.filter((O) => {
      var V;
      return O !== ((V = I.defaultView) == null ? void 0 : V.visualViewport);
    }), z.forEach((O) => {
      O.addEventListener("scroll", D, {
        passive: !0
      });
    }), () => {
      a && I.removeEventListener("keydown", S ? L : R, S), b && I.removeEventListener(c, F ? j : P, F), z.forEach((O) => {
        O.removeEventListener("scroll", D);
      });
    };
  }, [i, o, a, b, c, n, r, p, s, $, E, R, S, L, P, F, j]), T.useEffect(() => {
    w.current = !1;
  }, [b, c]);
  const _ = T.useMemo(() => ({
    onKeyDown: R,
    [pv[u]]: (D) => {
      d && r(!1, D.nativeEvent, "reference-press");
    }
  }), [R, r, d, u]), G = T.useMemo(() => ({
    onKeyDown: R,
    onMouseDown() {
      x.current = !0;
    },
    onMouseUp() {
      x.current = !0;
    },
    [fv[c]]: () => {
      w.current = !0;
    }
  }), [R, c]);
  return T.useMemo(() => s ? {
    reference: _,
    floating: G
  } : {}, [s, _, G]);
}
function hv(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = Qs(), i = T.useRef({}), [s] = T.useState(() => J0()), a = ea() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = r.reference;
    f && !pe(f) && q0("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = T.useState(r.reference), d = Xe((f, m, g) => {
    i.current.openEvent = f ? m : void 0, s.emit("openchange", {
      open: f,
      event: m,
      reason: g,
      nested: a
    }), n == null || n(f, m, g);
  }), u = T.useMemo(() => ({
    setPositionReference: c
  }), []), p = T.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return T.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: d,
    elements: p,
    events: s,
    floatingId: o,
    refs: u
  }), [t, d, p, s, o, u]);
}
function ei(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = hv({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [i, s] = T.useState(null), [a, l] = T.useState(null), d = (o == null ? void 0 : o.reference) || i, u = T.useRef(null), p = Zo();
  Ee(() => {
    d && (u.current = d);
  }, [d]);
  const f = j0({
    ...e,
    elements: {
      ...o,
      ...a && {
        reference: a
      }
    }
  }), m = T.useCallback((x) => {
    const $ = pe(x) ? {
      getBoundingClientRect: () => x.getBoundingClientRect(),
      contextElement: x
    } : x;
    l($), f.refs.setReference($);
  }, [f.refs]), g = T.useCallback((x) => {
    (pe(x) || x === null) && (u.current = x, s(x)), (pe(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    x !== null && !pe(x)) && f.refs.setReference(x);
  }, [f.refs]), y = T.useMemo(() => ({
    ...f.refs,
    setReference: g,
    setPositionReference: m,
    domReference: u
  }), [f.refs, g, m]), b = T.useMemo(() => ({
    ...f.elements,
    domReference: d
  }), [f.elements, d]), w = T.useMemo(() => ({
    ...f,
    ...r,
    refs: y,
    elements: b,
    nodeId: t
  }), [f, y, b, t, r]);
  return Ee(() => {
    r.dataRef.current.floatingContext = w;
    const x = p == null ? void 0 : p.nodesRef.current.find(($) => $.id === t);
    x && (x.context = w);
  }), T.useMemo(() => ({
    ...f,
    context: w,
    refs: y,
    elements: b
  }), [f, y, b, w]);
}
function mv(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: o,
    dataRef: i,
    elements: s
  } = e, {
    enabled: a = !0,
    visibleOnly: l = !0
  } = t, c = T.useRef(!1), d = T.useRef(), u = T.useRef(!0);
  T.useEffect(() => {
    if (!a) return;
    const f = Le(s.domReference);
    function m() {
      !n && $e(s.domReference) && s.domReference === st(De(s.domReference)) && (c.current = !0);
    }
    function g() {
      u.current = !0;
    }
    return f.addEventListener("blur", m), f.addEventListener("keydown", g, !0), () => {
      f.removeEventListener("blur", m), f.removeEventListener("keydown", g, !0);
    };
  }, [s.domReference, n, a]), T.useEffect(() => {
    if (!a) return;
    function f(m) {
      let {
        reason: g
      } = m;
      (g === "reference-press" || g === "escape-key") && (c.current = !0);
    }
    return o.on("openchange", f), () => {
      o.off("openchange", f);
    };
  }, [o, a]), T.useEffect(() => () => {
    clearTimeout(d.current);
  }, []);
  const p = T.useMemo(() => ({
    onPointerDown(f) {
      mu(f.nativeEvent) || (u.current = !1);
    },
    onMouseLeave() {
      c.current = !1;
    },
    onFocus(f) {
      if (c.current) return;
      const m = wt(f.nativeEvent);
      if (l && pe(m))
        try {
          if (gu() && Fg()) throw Error();
          if (!m.matches(":focus-visible")) return;
        } catch {
          if (!u.current && !qs(m))
            return;
        }
      r(!0, f.nativeEvent, "focus");
    },
    onBlur(f) {
      c.current = !1;
      const m = f.relatedTarget, g = f.nativeEvent, y = pe(m) && m.hasAttribute(Jt("focus-guard")) && m.getAttribute("data-type") === "outside";
      d.current = window.setTimeout(() => {
        var b;
        const w = st(s.domReference ? s.domReference.ownerDocument : document);
        !m && w === s.domReference || Pe((b = i.current.floatingContext) == null ? void 0 : b.refs.floating.current, w) || Pe(s.domReference, w) || y || r(!1, g, "focus");
      });
    }
  }), [i, s.domReference, r, l]);
  return T.useMemo(() => a ? {
    reference: p
  } : {}, [a, p]);
}
const Ml = "active", Dl = "selected";
function Fi(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let i = e;
  if (o && e) {
    const {
      [Ml]: s,
      [Dl]: a,
      ...l
    } = e;
    i = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [ms]: ""
    },
    ...i,
    ...t.map((s) => {
      const a = s ? s[n] : null;
      return typeof a == "function" ? e ? a(e) : null : a;
    }).concat(e).reduce((s, a) => (a && Object.entries(a).forEach((l) => {
      let [c, d] = l;
      if (!(o && [Ml, Dl].includes(c)))
        if (c.indexOf("on") === 0) {
          if (r.has(c) || r.set(c, []), typeof d == "function") {
            var u;
            (u = r.get(c)) == null || u.push(d), s[c] = function() {
              for (var p, f = arguments.length, m = new Array(f), g = 0; g < f; g++)
                m[g] = arguments[g];
              return (p = r.get(c)) == null ? void 0 : p.map((y) => y(...m)).find((y) => y !== void 0);
            };
          }
        } else
          s[c] = d;
    }), s), {})
  };
}
function ti(e) {
  e === void 0 && (e = []);
  const t = e.map((a) => a == null ? void 0 : a.reference), n = e.map((a) => a == null ? void 0 : a.floating), r = e.map((a) => a == null ? void 0 : a.item), o = T.useCallback(
    (a) => Fi(a, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = T.useCallback(
    (a) => Fi(a, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), s = T.useCallback(
    (a) => Fi(a, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return T.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: i,
    getItemProps: s
  }), [o, i, s]);
}
const gv = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function ni(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    open: r,
    floatingId: o
  } = e, {
    enabled: i = !0,
    role: s = "dialog"
  } = t, a = (n = gv.get(s)) != null ? n : s, l = Qs(), d = ea() != null, u = T.useMemo(() => a === "tooltip" || s === "label" ? {
    ["aria-" + (s === "label" ? "labelledby" : "describedby")]: r ? o : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": a === "alertdialog" ? "dialog" : a,
    "aria-controls": r ? o : void 0,
    ...a === "listbox" && {
      role: "combobox"
    },
    ...a === "menu" && {
      id: l
    },
    ...a === "menu" && d && {
      role: "menuitem"
    },
    ...s === "select" && {
      "aria-autocomplete": "none"
    },
    ...s === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [a, o, d, r, l, s]), p = T.useMemo(() => {
    const m = {
      id: o,
      ...a && {
        role: a
      }
    };
    return a === "tooltip" || s === "label" ? m : {
      ...m,
      ...a === "menu" && {
        "aria-labelledby": l
      }
    };
  }, [a, o, l, s]), f = T.useCallback((m) => {
    let {
      active: g,
      selected: y
    } = m;
    const b = {
      role: "option",
      ...g && {
        id: o + "-option"
      }
    };
    switch (s) {
      case "select":
        return {
          ...b,
          "aria-selected": g && y
        };
      case "combobox":
        return {
          ...b,
          ...g && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [o, s]);
  return T.useMemo(() => i ? {
    reference: u,
    floating: p,
    item: f
  } : {}, [i, u, p, f]);
}
const Bl = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase());
function dn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function vv(e, t) {
  const [n, r] = T.useState(e);
  return e && !n && r(!0), T.useEffect(() => {
    if (!e && n) {
      const o = setTimeout(() => r(!1), t);
      return () => clearTimeout(o);
    }
  }, [e, n, t]), n;
}
function yv(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    elements: {
      floating: r
    }
  } = e, {
    duration: o = 250
  } = t, s = (typeof o == "number" ? o : o.close) || 0, [a, l] = T.useState("unmounted"), c = vv(n, s);
  return !c && a === "close" && l("unmounted"), Ee(() => {
    if (r) {
      if (n) {
        l("initial");
        const d = requestAnimationFrame(() => {
          l("open");
        });
        return () => {
          cancelAnimationFrame(d);
        };
      }
      l("close");
    }
  }, [n, r]), {
    isMounted: c,
    status: a
  };
}
function Wu(e, t) {
  t === void 0 && (t = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: r,
    close: o,
    common: i,
    duration: s = 250
  } = t, a = e.placement, l = a.split("-")[0], c = T.useMemo(() => ({
    side: l,
    placement: a
  }), [l, a]), d = typeof s == "number", u = (d ? s : s.open) || 0, p = (d ? s : s.close) || 0, [f, m] = T.useState(() => ({
    ...dn(i, c),
    ...dn(n, c)
  })), {
    isMounted: g,
    status: y
  } = yv(e, {
    duration: s
  }), b = Ze(n), w = Ze(r), x = Ze(o), $ = Ze(i);
  return Ee(() => {
    const E = dn(b.current, c), S = dn(x.current, c), F = dn($.current, c), R = dn(w.current, c) || Object.keys(E).reduce((L, P) => (L[P] = "", L), {});
    if (y === "initial" && m((L) => ({
      transitionProperty: L.transitionProperty,
      ...F,
      ...E
    })), y === "open" && m({
      transitionProperty: Object.keys(R).map(Bl).join(","),
      transitionDuration: u + "ms",
      ...F,
      ...R
    }), y === "close") {
      const L = S || E;
      m({
        transitionProperty: Object.keys(L).map(Bl).join(","),
        transitionDuration: p + "ms",
        ...F,
        ...L
      });
    }
  }, [p, x, b, w, $, u, y, c]), {
    isMounted: g,
    styles: f
  };
}
const bv = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), xv = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "right",
  "bottom",
  "left",
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "padding",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "fontSize",
  "lineHeight",
  "borderWidth",
  "borderRadius",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "maxWidth",
  "maxHeight",
  "minWidth",
  "minHeight",
  "outlineWidth",
  "letterSpacing",
  "wordSpacing",
  "columnGap",
  "columnRuleWidth",
  "gridGap",
  "gridRowGap",
  "gridColumnGap",
  "perspective",
  "perspectiveOrigin",
  "transformOrigin",
  "translate",
  "boxShadow",
  "textShadow",
  "gap"
]), So = (...e) => {
  const t = Object.assign({}, ...e);
  return Object.entries(t).map(([n, r]) => {
    const o = bv(n), i = typeof r == "number" && xv.has(n) ? `${r}px` : r;
    return `${o}: ${i};`;
  }).join(" ");
}, EE = (e) => Array.isArray(e) ? e : [e], RE = (e, ...t) => e.filter((n) => !t.includes(n)), _u = (e) => e == null, AE = (e) => !_u(e);
function Bt(...e) {
  return (t) => {
    e.forEach((n) => {
      if (n) {
        if (typeof n == "function") {
          n(t);
          return;
        }
        n.current = t;
      }
    });
  };
}
function ju(e) {
  if (e == null)
    return null;
  const { overflowY: t, overflow: n, overflowX: r } = getComputedStyle(e), o = /auto|scroll|overlay|revert/g.test(t + r + n);
  return (e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth) && o ? e : ju(e.parentElement);
}
const Hu = (e) => typeof e == "number" && Number.isFinite(e), Hr = (e) => Hu(e) || typeof e == "string", wv = (e) => Object.keys(e), $v = (e, t) => {
  const n = { ...e };
  return t.forEach((r) => {
    delete n[r];
  }), n;
}, Nn = (e) => Hu(e) ? `${e}px` : e, PE = (e) => Object.fromEntries(
  Object.entries(e).filter(
    ([, t]) => !!t || t === 0 || t === !1
  )
), Cv = /^\+7/g;
var kv = /* @__PURE__ */ ((e) => (e.DEFAULT = "+7 NNN NNN-NN-NN", e.DIGIT10 = "10_DIGIT", e.DIGIT11 = "11_DIGIT", e.SYMBOLS12 = "12_SYMBOLS", e.SYMBOLS16 = "16_SYMBOLS", e))(kv || {});
const ME = (e, t = "+7 NNN NNN-NN-NN", n = "7") => {
  let r = Sv(e);
  const o = t === "+7 NNN NNN-NN-NN", i = t === "10_DIGIT", s = t === "11_DIGIT", a = t === "12_SYMBOLS", l = t === "16_SYMBOLS";
  (r[0] === "7" || r[0] === "8") && (r = r.slice(1));
  const c = /^(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(r);
  return c && o ? `+${n} ${c[1]} ${c[2]}-${c[3]}-${c[4]}` : c && l ? `+${n} ${c[1]} ${c[2]} ${c[3]} ${c[4]}` : c && (s || a) ? `${a ? "+" : ""}${n}${r}` : c && i ? `${r}` : null;
}, Sv = (e, t) => {
  let n = e == null ? void 0 : e.replace(/[^+\d]/g, "");
  return t != null && t.skipCountryCode || (n = n == null ? void 0 : n.replace(Cv, "")), n || "";
}, DE = (e, t, n) => {
  const r = String(e).replace(",", "."), o = r.includes(".") ? 2 : 0;
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: t,
    minimumFractionDigits: o,
    maximumFractionDigits: o,
    signDisplay: n ? "always" : "auto"
  }).format(Number(r));
}, BE = (e, t) => {
  const n = [2, 0, 1, 1, 1, 2];
  return t[e % 100 > 4 && e % 100 < 20 ? 2 : n[e % 10 < 5 ? e % 10 : 5]];
};
var Wn, An = ((Wn = function() {
  return An;
}).toString = Wn.toLocaleString = Wn[Symbol.toPrimitive] = function() {
  return "";
}, Wn.valueOf = function() {
  return !1;
}, new Proxy(Object.freeze(Wn), { get: function(e, t) {
  return e.hasOwnProperty(t) ? e[t] : An;
} })), Tv = function(e) {
  return e === An;
};
const ta = !!(typeof window < "u" && window.document && window.document.createElement), Ll = ta ? window : An, LE = ta ? document : An, IE = ta ? navigator : An, FE = (e) => !Tv(e);
function Ev(e, t, n, r) {
  if (!r)
    return;
  const o = t / 2, i = e / 2, s = 20, a = r;
  switch (n) {
    case "top-start":
    case "bottom-start": {
      a.style.margin = `0 0 0 ${o - s}px`;
      break;
    }
    case "top-end":
    case "bottom-end": {
      a.style.margin = `0 0 0 -${o - s}px`;
      break;
    }
    case "left-start":
    case "right-start": {
      a.style.margin = `${i - s}px 0 0 0`;
      break;
    }
    case "left-end":
    case "right-end": {
      a.style.margin = `0 0 ${i - s}px 0`;
      break;
    }
    default: {
      a.style.margin = "0 0 0 0";
      break;
    }
  }
}
function Rv(e) {
  const t = [];
  return e.forEach((n) => {
    switch (n) {
      case "top": {
        t.push(n, "top-start", "top-end");
        break;
      }
      case "bottom": {
        t.push(n, "bottom-start", "bottom-end");
        break;
      }
      case "left": {
        t.push(n, "left-start", "left-end");
        break;
      }
      case "right": {
        t.push(n, "right-start", "right-end");
        break;
      }
    }
  }), t;
}
const gt = (e) => {
  const t = e == null ? void 0 : e.colors.background.inverted.replace("#", "%23");
  return {
    top: {
      arrow: {
        height: "9px",
        width: "auto",
        left: 0,
        right: 0,
        bottom: "auto",
        top: "calc(100% - 1px)",
        bgImage: `url("data:image/svg+xml,%3Csvg fill='${t}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 9'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.5 8c3 0 6-8 10-8h-20c3.975 0 7 8 10 8Z' /%3E%3C/svg%3E")`
      },
      aligns: {
        center: "center top",
        start: "left top",
        end: "right top"
      }
    },
    bottom: {
      arrow: {
        height: "9px",
        width: "auto",
        left: 0,
        right: 0,
        top: "auto",
        bottom: "calc(100% - 2px)",
        bgImage: `url("data:image/svg+xml,%3Csvg fill='${t}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 9'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M18.5 0c-3 0-6 8-10 8h20c-3.975 0-7-8-10-8Z'/%3E%3C/svg%3E")`
      },
      aligns: {
        center: "center bottom",
        start: "left bottom",
        end: "right bottom"
      }
    },
    left: {
      arrow: {
        width: "9px",
        height: "auto",
        top: 0,
        bottom: 0,
        right: "auto",
        left: "calc(100% - 1px)",
        bgImage: `url("data:image/svg+xml,%3Csvg fill='${t}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 36'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 18c0-3-8-6-8-10v20c0-3.975 8-7 8-10Z'/%3E%3C/svg%3E")`
      },
      aligns: {
        center: "center left",
        start: "top left",
        end: "bottom left"
      }
    },
    right: {
      arrow: {
        width: "9px",
        height: "auto",
        top: 0,
        bottom: 0,
        left: "auto",
        right: "calc(100% - 2px)",
        bgImage: `url("data:image/svg+xml,%3Csvg fill='${t}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 36'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 18c0 3 8 6 8 10V8c0 3.975-8 7-8 10Z'/%3E%3C/svg%3E")`
      },
      aligns: {
        center: "center right",
        start: "top right",
        end: "bottom right"
      }
    }
  };
}, Av = v.div(
  ({ $placement: e = "top", $alignment: t = "center", theme: n }) => C`
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    background-color: ${n.colors.background.inverted};
    padding: 10px 12px;
    border-radius: 12px;
    max-width: 364px;
    min-width: 36px;
    min-height: 36px;

    &::before {
      content: '';
      position: absolute;
      z-index: 0;
      width: ${gt(n)[e].arrow.width};
      height: ${gt(n)[e].arrow.height};
      background-image: ${gt(n)[e].arrow.bgImage};
      background-repeat: no-repeat;
      background-position: ${gt(n)[e].aligns[t]};
      top: ${gt(n)[e].arrow.top};
      right: ${gt(n)[e].arrow.right};
      bottom: ${gt(n)[e].arrow.bottom};
      left: ${gt(n)[e].arrow.left};
    }
  `
), Pv = v(H)(
  ({ theme: { colors: e } }) => C`
    position: relative;
    color: ${e.text.inverted};
    overflow-wrap: break-word;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `
), VE = A((e, t) => {
  var O, V, N;
  const {
    text: n,
    placement: r = "top",
    children: o,
    position: i = "fixed",
    preferPositions: s = [],
    hideTooltip: a = !0,
    trigger: l = "hover",
    open: c,
    initialOpen: d,
    onOpenChange: u,
    style: p,
    ...f
  } = e, [m, g] = U(d), [y, b] = U(), w = c || m, x = c ? u : g, { context: $, refs: E, middlewareData: S, floatingStyles: F } = ei({
    open: w,
    strategy: i,
    middleware: [
      Au(13),
      Pu({
        boundary: y,
        fallbackPlacements: Rv([r, ...s || []])
      }),
      H0({
        apply({ availableWidth: B, elements: X }) {
          X.floating.getBoundingClientRect().width >= 364 && (X.floating.style.width = `${B}px`);
        }
      }),
      U0()
    ],
    placement: r,
    onOpenChange: x,
    whileElementsMounted: (B, X, te) => Eu(B, X, te, {
      layoutShift: !1
    })
  }), R = tv($, {
    enabled: l === "hover"
  }), L = mv($, {
    enabled: l === "focus"
  }), P = Jo($, {
    enabled: l === "click"
  }), j = K(() => {
    switch (l) {
      case "click":
        return P;
      case "focus":
        return L;
      default:
        return R;
    }
  }, [l, P, L, R]), { getReferenceProps: _, getFloatingProps: G } = ti([
    j,
    ni($, { role: "tooltip" }),
    Qo($)
  ]);
  Y(() => {
    var B;
    if ((B = $ == null ? void 0 : $.elements) != null && B.reference) {
      const { width: X, height: te } = $.elements.reference.getBoundingClientRect();
      Ev(te, X, $.placement, $.elements.floating);
    }
  }, [(O = $ == null ? void 0 : $.elements) == null ? void 0 : O.reference, (V = $ == null ? void 0 : $.elements) == null ? void 0 : V.floating, $ == null ? void 0 : $.placement]), Y(() => {
    var X;
    const B = ju(
      ((X = $.elements.reference) == null ? void 0 : X.parentElement) || null
    );
    B && b(B);
  }, [$.elements.reference]), Y(() => {
    var B;
    return $.elements.floating && ((B = S.hide) != null && B.referenceHidden) && a && ($.elements.floating.style.visibility = "hidden"), () => {
      $.elements.floating && ($.elements.floating.style.visibility = "visible");
    };
  }, [$.elements.floating, a, (N = S.hide) == null ? void 0 : N.referenceHidden]);
  const D = K(() => $ == null ? void 0 : $.placement.split("-")[0], [$ == null ? void 0 : $.placement]), I = K(() => {
    switch ($ == null ? void 0 : $.placement) {
      case "top-start":
      case "bottom-start":
      case "left-start":
      case "right-start":
        return "start";
      case "top-end":
      case "bottom-end":
      case "left-end":
      case "right-end":
        return "end";
      default:
        return "center";
    }
  }, [$ == null ? void 0 : $.placement]), z = K(() => Bt(E.setFloating, t), [E.setFloating, t]);
  return /* @__PURE__ */ M(We, { children: [
    tn(
      o,
      _({ ref: E.setReference, ...o.props })
    ),
    w && /* @__PURE__ */ h(
      Av,
      {
        $alignment: I,
        $placement: D,
        ...f,
        ...G({
          ref: z,
          style: {
            position: i,
            ...F,
            ...p
          }
        }),
        children: /* @__PURE__ */ h(Pv, { forwardedAs: "div", font: "p4RegularComp", children: n })
      }
    )
  ] });
}), OE = A((e, t) => {
  const {
    children: n,
    background: r = "primary",
    customBackground: o,
    badge: i,
    title: s,
    button: a,
    className: l,
    ...c
  } = e;
  return /* @__PURE__ */ M(
    Mv,
    {
      ...c,
      $background: r,
      $customBackground: o,
      ref: t,
      className: l,
      children: [
        i && /* @__PURE__ */ h(Bv, { children: i }),
        s && s,
        /* @__PURE__ */ h(Lv, { children: n }),
        a && /* @__PURE__ */ h(Dv, { children: a })
      ]
    }
  );
}), Mv = v.div`
  width: 100%;
  padding: 20px 0;
  border-radius: 32px;
  background: ${({ theme: e, $background: t, $customBackground: n }) => n || (t === "primary" ? e.colors.background.primaryElevated : e.colors.background.secondary)};
`, Dv = v.div`
  padding: 16px 20px 0 20px;
`, Bv = v.div`
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  gap: 4px;
`, Lv = v.div`
  width: 100%;
`, Iv = 2, Il = (e = "s20", t, n) => {
  const r = Et[e];
  return n ? r : t ? Et[t] : r / Iv;
}, Fv = v.div(
  ({ $space: e, $spacemob: t, $samespace: n, theme: r }) => C`
    height: ${Il(e, t, n)}px;
    min-width: ${Il(e, t, n)}px;

    @media (min-width: ${r.breakpoints.desktopXS}px) {
      ${e && `
        height: ${Et[e]}px;
        min-width: ${Et[e]}px;
      `}
    }
  `
), co = A((e, t) => {
  const { space: n = "s0", spacemob: r, samespace: o, ...i } = e;
  return /* @__PURE__ */ h(Fv, { ...i, ref: t, $samespace: o, $space: n, $spacemob: r });
}), _n = {
  24: {
    height: 24,
    minWidth: 24,
    borderRadius: 8,
    transformScale: 0.9166
  },
  32: {
    height: 32,
    minWidth: 32,
    borderRadius: 12,
    transformScale: 0.9375
  },
  44: {
    height: 44,
    minWidth: 44,
    borderRadius: 16,
    transformScale: 0.9545
  },
  52: {
    height: 52,
    minWidth: 52,
    borderRadius: 16,
    transformScale: 0.9615
  },
  64: {
    height: 64,
    minWidth: 64,
    borderRadius: 16,
    transformScale: 0.9687
  },
  72: {
    height: 72,
    minWidth: 72,
    borderRadius: 20,
    transformScale: 0.9722
  }
}, je = {
  primary: "primary",
  alternative: "alternative",
  alwaysWhite: "always-white",
  secondary: "secondary",
  secondaryInverted: "secondary-inverted",
  ghost: "ghost",
  ghostSecondary: "ghost-secondary",
  negative: "negative",
  negativeInverted: "negative-inverted",
  blur: "blur",
  scroll: "scroll"
}, Vv = v.button(({ $size: e = 44, $variant: t = "primary", fluid: n, theme: { colors: r } }) => {
  const o = {
    [je.primary]: {
      default: r.control.primaryActive,
      hover: `linear-gradient(${r.control.hoverPrimary},${r.control.hoverPrimary}), ${r.control.primaryActive}`
    },
    [je.secondary]: {
      default: r.control.tertiaryActive,
      hover: `linear-gradient(${r.background.hover},${r.background.hover}), ${r.control.tertiaryActive}`
    },
    [je.alternative]: {
      default: r.control.secondaryActive,
      hover: `linear-gradient(${r.control.hoverAlternative},${r.control.hoverAlternative}), ${r.control.secondaryActive}`
    },
    [je.alwaysWhite]: {
      default: r.constant.greyscale0,
      hover: `linear-gradient(${r.control.hoverPrimary},${r.control.hoverPrimary}), ${r.constant.greyscale0}`
    },
    [je.secondaryInverted]: {
      default: r.control.alternative,
      hover: `linear-gradient(${r.control.hoverPrimary},${r.control.hoverPrimary}), ${r.control.alternative}`
    },
    [je.blur]: {
      default: r.control.blur,
      hover: `linear-gradient(${r.background.hover},${r.background.hover}), ${r.control.blur}`
    },
    [je.ghost]: {
      default: "transparent",
      hover: r.background.hover
    },
    [je.ghostSecondary]: {
      default: "transparent",
      hover: r.background.hover
    },
    [je.negative]: {
      default: r.control.tertiaryActive,
      hover: `linear-gradient(${r.background.hover},${r.background.hover}), ${r.control.tertiaryActive}`
    },
    [je.negativeInverted]: {
      default: r.control.alternative,
      hover: `linear-gradient(${r.control.hoverPrimary},${r.control.hoverPrimary}), ${r.control.alternative}`
    },
    [je.scroll]: {
      default: r.control.blur,
      hover: `linear-gradient(${r.background.hover},${r.background.hover}), ${r.control.blur}`
    }
  };
  return C`
    all: unset;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    cursor: pointer;
    user-select: none;
    box-sizing: border-box;
    display: inline-grid;
    grid-auto-flow: column;
    justify-content: center;
    align-items: center;
    min-width: ${_n[e].minWidth}px;
    height: ${_n[e].height}px;
    border-radius: ${_n[e].borderRadius}px;
    background: ${o[t].default};
    backdrop-filter: ${t === "blur" || t === "scroll" ? "blur(20px)" : "none"};
    -webkit-backdrop-filter: ${t === "blur" || t === "scroll" ? "blur(20px)" : "none"};
    position: relative;
    width: ${n ? "100%" : "auto"};
    transition: transform ease-in-out;
    transition-duration: 125ms;

    &::before {
      content: '';
      display: none;
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: calc(${_n[e].borderRadius}px + 2px);
      border: 1px solid ${r.accent.active};
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: ${o[t].hover};
        background-blend-mode: ${t === "primary" || t === "secondary-inverted" || t === "negative-inverted" || t === "always-white" ? "multiply, normal" : "none"};
      }
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
      background: ${t === "ghost" || t === "ghost-secondary" ? "transparent" : r.control.inactive};
    }

    &:active:not(:disabled) {
      transform: scale(${_n[e].transformScale});
      transition-duration: 62.5ms;
      will-change: transform;
    }

    &:focus-visible::before {
      display: block;
    }
  `;
}), ri = A((e, t) => {
  const {
    children: n,
    variant: r = "primary",
    waiting: o,
    fluid: i,
    disabled: s,
    size: a = 44,
    type: l = "button",
    tabIndex: c,
    className: d,
    ...u
  } = e;
  return /* @__PURE__ */ M(
    Vv,
    {
      ...u,
      $variant: r,
      $size: a,
      fluid: i,
      tabIndex: c ?? (s ? -1 : 0),
      type: l,
      disabled: s,
      className: d,
      ref: t,
      "aria-live": o ? "polite" : "off",
      "aria-busy": !!o,
      children: [
        n,
        r !== "scroll" && r !== "ghost-secondary" && a !== 24 && a !== 64 && o && o({ buttonVariant: r, buttonSize: a })
      ]
    }
  );
}), xe = {
  primary: "primary",
  alternative: "alternative",
  alwaysWhite: "always-white",
  secondary: "secondary",
  secondaryInverted: "secondary-inverted",
  ghost: "ghost",
  ghostSecondary: "ghost-secondary",
  negative: "negative",
  negativeInverted: "negative-inverted",
  blur: "blur",
  scroll: "scroll"
}, $r = ({
  $variant: e = "primary",
  disabled: t,
  colors: n
}) => {
  const r = {
    [xe.primary]: n.constant.greyscale0,
    [xe.alternative]: n.text.inverted,
    [xe.secondary]: n.text.primary,
    [xe.secondaryInverted]: n.text.primary,
    [xe.ghost]: n.text.primary,
    [xe.alwaysWhite]: n.constant.greyscale800,
    [xe.blur]: n.constant.greyscale0,
    [xe.negative]: n.text.negative,
    [xe.negativeInverted]: n.text.negative
  };
  return C`
    color: ${t ? n.text.tertiary : r[e]};
  `;
}, oi = C`
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, na = ({
  variant: e = "primary",
  disabled: t,
  colors: n,
  loading: r
}) => {
  const o = {
    [xe.primary]: n.constant.greyscale0,
    [xe.alternative]: n.text.inverted,
    [xe.secondary]: n.icons.primary,
    [xe.secondaryInverted]: n.icons.primary,
    [xe.ghost]: n.text.primary,
    [xe.ghostSecondary]: n.icons.secondary,
    [xe.alwaysWhite]: n.constant.greyscale900,
    [xe.blur]: n.constant.greyscale0,
    [xe.negative]: n.text.negative,
    [xe.negativeInverted]: n.text.negative,
    [xe.scroll]: n.icons.primary
  };
  return C`
    svg {
      visibility: ${r ? "hidden" : "visible"};
      fill: ${t ? n.icons.secondary : o[e]};
    }
  `;
}, Ur = {
  24: {
    counter: {
      top: "-6px",
      left: "calc(100% - 10px)"
    },
    notification: {
      top: "1px",
      left: "calc(100% - 6px)"
    }
  },
  32: {
    counter: {
      top: "-6px",
      left: "calc(100% - 10px)"
    },
    notification: {
      top: "1px",
      left: "calc(100% - 6px)"
    }
  },
  44: {
    counter: {
      top: "-4px",
      left: "calc(100% - 12px)"
    },
    notification: {
      top: "2px",
      left: "calc(100% - 6px)"
    }
  },
  52: {
    counter: {
      top: "-5px",
      left: "calc(100% - 15px)"
    },
    notification: {
      top: "2px",
      left: "calc(100% - 6px)"
    }
  }
}, Ov = v(ri)(
  ({ variant: e = "primary", rounded: t, disabled: n, theme: { colors: r } }) => C`
    ${na({
    variant: e,
    disabled: n,
    colors: r
  })}
    ${t && `
      border-radius: 50%;
    `}
  `
), zv = v.div(
  ({ $size: e = 44, hasNotification: t, theme: { colors: n } }) => C`
    position: absolute;
    box-shadow: 0 0 0 2px ${n.background.primary};
    border-radius: 100px;
    top: ${t ? Ur[e].notification.top : Ur[e].counter.top};
    left: ${t ? Ur[e].notification.left : Ur[e].counter.left};
    display: flex;
  `
), Ce = A((e, t) => {
  const { children: n, counter: r, size: o, rounded: i = !1, as: s, ...a } = e;
  return /* @__PURE__ */ M(Ov, { ...a, size: o, rounded: i, forwardedAs: s, ref: t, children: [
    n,
    o !== 24 && r && /* @__PURE__ */ h(zv, { $size: o, hasNotification: (r == null ? void 0 : r.props.size) === "notification", children: r })
  ] });
}), ra = {
  32: {
    padding: "0 8px",
    textPadding: "0 4px",
    font: "c2BoldUppWide"
  },
  44: {
    padding: "0 10px",
    textPadding: "0 8px",
    font: "c1BoldUppWide"
  },
  52: {
    padding: "0 14px",
    textPadding: "0 8px",
    font: "c1BoldUppWide"
  },
  72: {
    padding: "0 24px",
    textPadding: "0 8px",
    font: "p4BoldUppWide"
  }
}, Fl = {
  32: {
    top: "-4px",
    left: "calc(100% - 12px)"
  },
  44: {
    top: "-6px",
    left: "calc(100% - 14px)"
  },
  52: {
    top: "-6px",
    left: "calc(100% - 18px)"
  },
  72: {
    top: "-6px",
    left: "calc(100% - 18px)"
  }
}, Nv = v(ri)(
  ({ variant: e = "primary", disabled: t, waiting: n, size: r = 44, theme: { colors: o } }) => C`
    padding: ${ra[r].padding};
    ${na({
    variant: e,
    disabled: t,
    colors: o,
    loading: !!n
  })}
  `
), Wv = v(H)(
  ({ $variant: e = "primary", disabled: t, $loading: n, $size: r = 44, theme: { colors: o } }) => C`
    padding: ${ra[r].textPadding};
    visibility: ${n ? "hidden" : "visible"};

    ${$r({
    $variant: e,
    disabled: t,
    colors: o
  })}

    ${oi}
  `
), _v = v.div(
  ({ $size: e = 44, hasNotification: t, theme: { colors: n } }) => C`
    position: absolute;
    box-shadow: 0 0 0 2px ${n.background.primary};
    border-radius: 100px;
    top: ${t ? "1px" : Fl[e].top};
    left: ${t ? "calc(100% - 6px)" : Fl[e].left};
    display: flex;
  `
), jv = A((e, t) => {
  const {
    variant: n = "primary",
    size: r = 44,
    children: o,
    icon: i,
    iconPosition: s = "left",
    disabled: a,
    waiting: l,
    counter: c,
    fluid: d,
    as: u,
    ...p
  } = e;
  return /* @__PURE__ */ M(
    Nv,
    {
      ...p,
      variant: n,
      size: r,
      disabled: a,
      waiting: l,
      ref: t,
      fluid: d,
      forwardedAs: u,
      children: [
        i && s === "left" && i,
        /* @__PURE__ */ h(
          Wv,
          {
            font: ra[r].font,
            $loading: !!l,
            disabled: a,
            $variant: n,
            $size: r,
            children: o
          }
        ),
        i && s === "right" && i,
        r !== 72 && c ? d ? c : /* @__PURE__ */ h(
          _v,
          {
            $size: r,
            hasNotification: (c == null ? void 0 : c.props.size) === "notification",
            children: c
          }
        ) : null
      ]
    }
  );
}), oa = {
  44: {
    padding: "0 16px 0 12px",
    textPadding: "0 8px",
    font: "c1BoldUppWide"
  },
  52: {
    padding: "0 20px 0 16px",
    textPadding: "0 8px",
    font: "c1BoldUppWide"
  },
  72: {
    padding: "0 20px 0 16px",
    textPadding: "0 8px",
    font: "p4BoldUppWide"
  }
}, Hv = v(ri)(
  ({ size: e = 44 }) => C`
    grid-template-columns: minmax(0, 1fr);
    padding: ${oa[e].padding};
  `
), Uv = v(H)(
  ({ $size: e = 44, $loading: t, $variant: n, disabled: r, theme: { colors: o } }) => C`
    padding: ${oa[e].textPadding};
    visibility: ${t ? "hidden" : "visible"};

    ${$r({
    $variant: n,
    disabled: r,
    colors: o
  })}

    ${oi}
  `
), Gv = v(H)(
  ({ $loading: e, $variant: t, disabled: n, theme: { colors: r } }) => C`
    min-width: fit-content;
    grid-column: 3/4;
    padding: 0 4px;

    visibility: ${e ? "hidden" : "visible"};

    ${$r({
    $variant: t,
    disabled: n,
    colors: r
  })}

    ${oi}

  &::after {
      content: '\\00a0' attr(data-currency);
    }
  `
), Kv = v(H)(
  ({ $loading: e, $variant: t, disabled: n, theme: { colors: r } }) => C`
    min-width: fit-content;
    grid-column: 2/3;
    opacity: 0.7;
    position: relative;
    padding: 0 4px;

    visibility: ${e ? "hidden" : "visible"};

    ${$r({
    $variant: t,
    disabled: n,
    colors: r
  })}

    ${oi}

  &::before {
      content: '';
      position: absolute;
      top: 45%;
      width: calc(100% - 8px);
      border-radius: 1px;
      height: 1px;
      background: ${n ? r.text.tertiary : t === "primary" ? r.constant.greyscale0 : t === "alternative" ? r.text.inverted : t === "always-white" ? r.constant.greyscale900 : r.constant.greyscale0};
    }

    &::after {
      content: '\\00a0' attr(data-currency);
    }
  `
), zE = A((e, t) => {
  const {
    variant: n = "primary",
    size: r = 44,
    disabled: o,
    waiting: i,
    children: s,
    priceCurrent: a,
    priceOld: l,
    currency: c = "₽",
    as: d,
    ...u
  } = e, p = K(() => oa[r].font, [r]), f = {
    $variant: n,
    disabled: o,
    $loading: !!i
  };
  return /* @__PURE__ */ M(
    Hv,
    {
      ...u,
      variant: n,
      size: r,
      disabled: o,
      waiting: i,
      forwardedAs: d,
      ref: t,
      children: [
        /* @__PURE__ */ h(Uv, { font: p, $size: r, ...f, children: s }),
        l && /* @__PURE__ */ h(Kv, { font: p, ...f, "data-currency": c, children: l }),
        /* @__PURE__ */ h(Gv, { font: p, ...f, "data-currency": c, children: a })
      ]
    }
  );
}), Uu = be({
  size: "medium",
  variant: "secondary"
}), Yv = {
  medium: {
    gap: 12
  },
  large: {
    gap: 12
  },
  carousel: {
    gap: 16
  }
}, Xv = v.div(
  ({ $size: e = "medium" }) => C`
    display: flex;
    gap: ${Yv[e].gap}px;
    justify-content: space-around;
  `
), Zv = v.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`, qv = v(ri)(
  ({ variant: e = "secondary", disabled: t, theme: { colors: n } }) => C`
    ${na({
    variant: e,
    disabled: t,
    colors: n
  })}
  `
), Jv = v(H)(
  ({ $variant: e, disabled: t, theme: { colors: n } }) => C`
    margin-top: 4px;
    ${$r({
    $variant: e,
    disabled: t,
    colors: n
  })}
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: center;
  `
), NE = A((e, t) => {
  const { variant: n = "secondary", size: r = "medium", children: o, ...i } = e, s = K(() => ({ size: r, variant: n }), [r, n]);
  return /* @__PURE__ */ h(Uu.Provider, { value: s, children: /* @__PURE__ */ h(Xv, { ...i, ref: t, $size: r, children: o }) });
}), Qv = { medium: 44, large: 52, carousel: 64 }, WE = A((e, t) => {
  const { children: n, text: r, disabled: o, as: i, ...s } = e, { size: a = "medium", variant: l = "secondary" } = se(Uu);
  return /* @__PURE__ */ M(Zv, { children: [
    /* @__PURE__ */ h(
      qv,
      {
        ...s,
        size: Qv[a],
        variant: l,
        disabled: o,
        forwardedAs: i,
        ref: t,
        children: n
      }
    ),
    /* @__PURE__ */ h(Jv, { $variant: l, disabled: o, font: "c1RegularComp", children: r })
  ] });
}), Gu = be({
  variant: "secondary"
}), Vl = {
  secondary: "secondary",
  secondaryInverted: "secondary-inverted"
}, ey = v.div(
  ({ twoLines: e }) => C`
    display: grid;
    grid-gap: 8px;
    ${e ? C`
          grid-template-columns: 1fr 1fr;
        ` : C`
          grid-auto-flow: column;
        `};
  `
), ty = v.button(({ disabled: e, $variant: t = "secondary", theme: { colors: n } }) => {
  const r = {
    [Vl.secondary]: {
      default: n.control.tertiaryActive,
      hover: `linear-gradient(${n.background.hover},${n.background.hover}), ${n.control.tertiaryActive}`
    },
    [Vl.secondaryInverted]: {
      default: n.control.alternative,
      hover: `linear-gradient(${n.control.hoverPrimary},${n.control.hoverPrimary}), ${n.control.alternative}`
    }
  };
  return C`
    all: unset;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    cursor: pointer;
    user-select: none;
    box-sizing: border-box;
    display: grid;
    justify-content: center;
    grid-gap: 4px;
    height: auto;
    border-radius: 20px;
    padding: 10px 12px;
    background: ${r[t].default};
    position: relative;
    width: 100%;
    transition: transform ease-in-out;
    transition-duration: 125ms;

    &::before {
      content: '';
      display: none;
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: 22px;
      border: 1px solid ${n.accent.active};
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: ${r[t].hover};
        background-blend-mode: ${t === "secondary" ? "multiply, normal" : "none"};
      }
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
      background: ${n.control.inactive};
    }

    &:active:not(:disabled) {
      transform: scale(0.9687);
      transition-duration: 62.5ms;
      will-change: transform;
    }

    &:focus-visible::before {
      display: block;
    }

    svg {
      justify-self: center;
      width: 24px;
      height: 24px;
      fill: ${e ? n.icons.secondary : n.icons.primary};
    }
  `;
}), ny = v(H)(
  ({ $disabled: e, theme: { colors: t } }) => C`
    color: ${e ? t.text.tertiary : t.icons.primary};
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `
), _E = A(
  (e, t) => {
    const { children: n, text: r, disabled: o, ...i } = e, { variant: s = "secondary" } = se(Gu);
    return /* @__PURE__ */ M(
      ty,
      {
        disabled: o,
        $variant: s,
        ...i,
        ref: t,
        children: [
          n,
          /* @__PURE__ */ h(ny, { font: "c1MediumComp", $disabled: o, children: r })
        ]
      }
    );
  }
), jE = A(
  (e, t) => {
    const { variant: n = "secondary", children: r, twoLines: o, ...i } = e, s = K(() => ({ variant: n }), [n]);
    return /* @__PURE__ */ h(Gu.Provider, { value: s, children: /* @__PURE__ */ h(ey, { ...i, twoLines: o, ref: t, children: r }) });
  }
), Ol = {
  primaryElevated: "primary-elevated",
  bar: "bar"
}, ry = v.div(({ $bgColor: e = "primary-elevated", $withShadow: t, theme: { colors: n, shadows: r } }) => {
  const o = {
    [Ol.primaryElevated]: n.background.primaryElevated,
    [Ol.bar]: n.background.bar
  };
  return C`
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: ${o[e]};
    box-shadow: ${e === "primary-elevated" && t ? r["shadow-upper-middle"] : "none"};
    padding-top: 8px;
    padding-bottom: 12px;
    backdrop-filter: ${e === "bar" ? "blur(40px)" : "none"};
  `;
}), HE = A((e, t) => {
  const { children: n, background: r = "primary-elevated", withShadow: o = !0, ...i } = e;
  return /* @__PURE__ */ h(ry, { ...i, $bgColor: r, $withShadow: o, ref: t, children: n });
}), Vi = {
  16: {
    width: 16,
    height: 16,
    mask: `url("data:image/svg+xml,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='5' fill='none' stroke='black' stroke-width='2' stroke-dasharray='26' stroke-dashoffset='0' stroke-linecap='round' /%3E%3C/svg%3E")`
  },
  24: {
    width: 24,
    height: 24,
    mask: `url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='12' cy='12' r='8.5' fill='none' stroke='black' stroke-width='3' stroke-dasharray='45' stroke-dashoffset='0' stroke-linecap='round' /%3E%3C/svg%3E")`
  },
  44: {
    width: 44,
    height: 44,
    mask: `url("data:image/svg+xml,%3Csvg viewBox='0 0 44 44' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='22' cy='22' r='15.5' fill='none' stroke='black' stroke-width='5' stroke-dasharray='83' stroke-dashoffset='0' stroke-linecap='round' /%3E%3C/svg%3E")`
  }
}, Oi = (e, t) => {
  const n = parseInt(e.split("#")[1], 16), r = n >> 16 & 255, o = n >> 8 & 255, i = n & 255;
  return "rgba(" + r + "," + o + "," + i + "," + t / 100 + ")";
}, Vt = {
  default: "default",
  inverted: "inverted",
  accent: "accent",
  negative: "negative",
  white: "white",
  black: "black",
  custom: "custom"
}, oy = v.span(({ $size: e = 24, $variant: t = "default", $color: n = "#fff", theme: { colors: r } }) => {
  const o = {
    [Vt.default]: r.icons.primary,
    [Vt.inverted]: r.text.inverted,
    [Vt.accent]: r.brand,
    [Vt.negative]: r.accent.negative,
    [Vt.white]: r.constant.greyscale0,
    [Vt.black]: r.constant.greyscale900,
    [Vt.custom]: n
  };
  return C`
    all: unset;
    flex: none;
    display: inline-block;
    width: ${Vi[e].width}px;
    height: ${Vi[e].height}px;
    background: conic-gradient(
      from 90deg,
      ${Oi(o[t], 0)} 0 35deg,
      ${Oi(o[t], 100)} 320deg,
      ${Oi(o[t], 0)} 320deg 360deg
    );
    mask: ${Vi[e].mask} center center no-repeat;
    animation: spinner 1s linear infinite;
    will-change: transform;
    @keyframes spinner {
      to {
        transform: rotate(360deg);
      }
    }
  `;
}), ia = A((e, t) => {
  const { variant: n = "default", size: r = 24, color: o, ...i } = e;
  return /* @__PURE__ */ h(
    oy,
    {
      ...i,
      $size: r,
      $variant: n,
      $color: o,
      ref: t,
      role: "status",
      "aria-live": "polite",
      "aria-label": "Загрузка"
    }
  );
}), iy = v(ia)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  margin: auto;
`, UE = ({ buttonVariant: e = "primary", buttonSize: t = 44, color: n }) => {
  const r = K(() => {
    switch (e) {
      case "primary":
      case "alternative":
      case "blur":
        return "white";
      case "negative":
        return "negative";
      case "custom":
        return "custom";
      default:
        return "black";
    }
  }, [e]);
  return /* @__PURE__ */ h(iy, { size: t === 32 ? 16 : 24, color: n, variant: r });
}, sy = () => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ h(
    "path",
    {
      d: "M21.7082 8.63438c-.0787-1.0307-.8658-2.3521-1.6529-2.98638-.8851-.64911-1.8048-1.24904-2.7548-1.79711-.9429-.56295-1.9151-1.07462-2.9123-1.53283-.5327-.21888-1.1039-.32677-1.6791-.31713-.5755-.01218-1.1472.0958-1.6792.31713-.997.45853-1.96914.9702-2.9122 1.53283C6.59599 4.77588 5.36288 5.648 5.36288 5.648c-.61048.51465-1.08138 1.16862-1.37821 1.90056-.08975.22132.08169.45144.3205.45144h.92699c.26547 0 .50469-.15025.65273-.3706.20904-.31113.46222-.59373.75404-.83804 0 0 1.01815-.71514 2.2746-1.47363.77866-.46136 1.58137-.88092 2.40457-1.25692.4392-.18149.9113-.27004 1.3864-.26005.475-.0079.9466.08057 1.3865.26005.8233.37573 1.626.7953 2.4045 1.25692.7845.44942 1.5438.94136 2.2746 1.47363.6499.52011 1.2998 1.60366 1.3648 2.44883 0 0 .1516 1.25691.1733 2.74571-.0013.9195-.0519 1.8382-.1516 2.7522-.1512.9571-.6437 1.827-1.3865 2.4489 0 0-1.0181.7368-2.2746 1.4953-.7786.4613-1.5813.8809-2.4045 1.2569-.4393.1815-.9113.27-1.3865.26-.4745.01-.9461-.0763-1.3864-.2535-.8234-.3757-1.62605-.7953-2.40457-1.2569-1.25645-.7369-2.2746-1.4953-2.2746-1.4953-.25694-.2057-.51388-.4994-.73601-.8316C5.7578 16.1449 5.52106 16 5.25998 16h-.94572c-.24188 0-.41259.2352-.3155.4567.32324.7376.84368 1.4574 1.36412 1.8768 0 0 1.23311.925 2.75482 1.8235.94289.563 1.915 1.0746 2.9122 1.5328.5333.2162 1.1045.3214 1.6792.3093.5754.0121 1.1471-.0958 1.6791-.3172.9971-.4585 1.9692-.9702 2.9123-1.5328 1.5217-.925 2.7548-1.8235 2.7548-1.8235.8996-.7584 1.496-1.8193 1.6791-2.9864.1208-1.1147.1821-2.2351.1837-3.3564-.0263-1.8156-.2099-3.34842-.2099-3.34842z",
      fill: "url(#paint0_linear_3930_7536)"
    }
  ),
  /* @__PURE__ */ h(
    "path",
    {
      d: "M3.50024 9.80498c0-.22102.17918-.40019.4002-.40019h6.20296c.2211 0 .4002.17917.4002.40019v1.20052c0 .2211-.1791.4002-.4002.4002H3.50024V9.80498z",
      fill: "#0066B3"
    }
  ),
  /* @__PURE__ */ h(
    "path",
    {
      d: "M3.5 12.6063h12.6061c.221 0 .4002.1791.4002.4002v1.2005c0 .221-.1792.4002-.4002.4002H3.90019c-.22102 0-.40019-.1792-.40019-.4002v-1.6007z",
      fill: "#EE2F53"
    }
  ),
  /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ M(
    "linearGradient",
    {
      id: "paint0_linear_3930_7536",
      x1: "12.9393",
      y1: "2",
      x2: "12.9393",
      y2: "22",
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ h("stop", { stopColor: "#0066B3" }),
        /* @__PURE__ */ h("stop", { offset: ".354167", stopColor: "#0066B3" }),
        /* @__PURE__ */ h("stop", { offset: ".6875", stopColor: "#EE2F53" }),
        /* @__PURE__ */ h("stop", { offset: "1", stopColor: "#EE2F53" })
      ]
    }
  ) })
] }), zi = {
  44: {
    height: 44,
    minWidth: 44,
    transformScale: 0.9545
  },
  52: {
    height: 52,
    minWidth: 52,
    transformScale: 0.9615
  }
}, sa = "#0D4CD3", ay = v.button(({ $size: e = 44, $loading: t, disabled: n, theme: { colors: r } }) => C`
    all: unset;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    cursor: pointer;
    user-select: none;
    box-sizing: border-box;
    display: inline-grid;
    grid-auto-flow: column;
    justify-content: center;
    align-items: center;
    padding: 0 19.5px;
    min-width: ${zi[e].minWidth}px;
    height: ${zi[e].height}px;
    border: 1px solid ${n ? r.background.strokeDisabled : sa};
    border-radius: 16px;
    background: ${r.constant.greyscale0};
    position: relative;
    transition: transform ease-in-out;
    transition-duration: 125ms;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
      background: ${r.control.inactive};
    }

    &:active:not(:disabled) {
      transform: scale(${zi[e].transformScale});
      transition-duration: 62.5ms;
      will-change: transform;
    }

    svg {
      visibility: ${t ? "hidden" : "visible"};
    }

    ${n && `
      svg {
        path {
          fill: ${r.icons.secondary};
        }
      }
    `}
  `), ly = v(H)(
  ({ $disabled: e, $loading: t, theme: { colors: n } }) => C`
    visibility: ${t ? "hidden" : "visible"};
    padding-left: 8px;
    color: ${e ? n.text.tertiary : sa};
  `
), GE = A((e, t) => {
  const { children: n, size: r = 44, disabled: o, waiting: i, tabIndex: s, ...a } = e;
  return /* @__PURE__ */ M(
    ay,
    {
      ...a,
      $size: r,
      $loading: !!i,
      disabled: o,
      "aria-live": i ? "polite" : "off",
      "aria-busy": !!i,
      tabIndex: s ?? (o ? -1 : 0),
      ref: t,
      children: [
        /* @__PURE__ */ h(sy, {}),
        /* @__PURE__ */ h(ly, { $loading: !!i, $disabled: o, font: "c1BoldUppWide", children: n }),
        i && i({ buttonVariant: "custom", buttonSize: r, color: sa })
      ]
    }
  );
});
function cy({ ...e }) {
  return /* @__PURE__ */ h(Ce, { "aria-label": "Закрыть", type: "button", ...e, children: /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-24-style-outline" }) });
}
const zl = {
  small: {
    titleFont: "p3MediumComp",
    descFont: "p4RegularComp"
  },
  normal: {
    titleFont: "h4Comp",
    descFont: "p3RegularComp"
  }
}, Jn = {
  desktop: {
    actionsMarginTop: 0,
    titleGridColumn: 2,
    descGridColumn: 2,
    actionsGridColumn: "3 / 4",
    actionsGridRow: "1 / 3"
  },
  mobile: {
    actionsMarginTop: "12px",
    titleGridColumn: "1 / 3",
    descGridColumn: "1 / 3",
    actionsGridColumn: "1 / 3",
    actionsGridRow: "auto"
  }
}, Nl = {
  grey: "grey",
  white: "white"
}, dy = v.div(({ $variant: e = "grey", $withShadow: t, theme: { colors: n, shadows: r } }) => {
  const o = {
    [Nl.grey]: n.background.secondary,
    [Nl.white]: n.background.primaryElevated
  };
  return C`
    display: grid;
    flex-basis: 100%;
    background: ${o[e]};
    padding: 16px;
    border-radius: 20px;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto;
    box-shadow: ${e === "white" && t ? r["shadow-low"] : "none"};
  `;
}), uy = v(H)(
  ({ $device: e = "desktop", theme: { colors: t } }) => C`
    overflow-wrap: break-word;
    word-break: break-word;
    color: ${t.text.primary};
    grid-column: ${Jn[e].titleGridColumn};
  `
), py = v(H)(
  ({ $device: e = "desktop", theme: { colors: t } }) => C`
    overflow-wrap: break-word;
    word-break: break-word;
    color: ${t.text.secondary};
    margin-top: 4px;
    grid-column: ${Jn[e].descGridColumn};
  `
), fy = v.div(
  ({ $device: e = "desktop" }) => C`
    margin-top: ${Jn[e].actionsMarginTop};
    display: flex;
    align-items: center;
    grid-column: ${Jn[e].actionsGridColumn};
    grid-row: ${Jn[e].actionsGridRow};

    :nth-child(2) {
      margin-left: 12px;
    }
  `
), KE = A((e, t) => {
  const {
    device: n = "desktop",
    variant: r = "grey",
    size: o = "normal",
    title: i,
    description: s,
    withCloseButton: a,
    onCloseClick: l,
    actions: c,
    withShadow: d = !0,
    ...u
  } = e;
  return /* @__PURE__ */ M(dy, { ...u, ref: t, $variant: r, $withShadow: d, children: [
    /* @__PURE__ */ h(uy, { $device: n, forwardedAs: "strong", font: zl[o].titleFont, children: i }),
    /* @__PURE__ */ h(py, { $device: n, forwardedAs: "p", font: zl[o].descFont, children: s }),
    /* @__PURE__ */ M(fy, { $device: n, children: [
      c.map((p, f) => /* @__PURE__ */ h(jv, { ...p }, f)),
      a && (c == null ? void 0 : c.length) < 2 && /* @__PURE__ */ h(
        cy,
        {
          size: o === "small" ? 32 : 44,
          variant: r === "white" ? "secondary" : "secondary-inverted",
          onClick: l
        }
      )
    ] })
  ] });
}), hy = ({ inverted: e, ...t }) => {
  const n = ie();
  return /* @__PURE__ */ h(
    q,
    {
      ...t,
      color: e ? n.colors.accent.positiveInverted : n.colors.accent.positive,
      iconPath: "granat/check-circle/size-24-style-fill"
    }
  );
}, my = ({ inverted: e, ...t }) => {
  const n = ie();
  return /* @__PURE__ */ h(
    q,
    {
      ...t,
      color: e ? n.colors.accent.negativeInverted : n.colors.accent.negative,
      iconPath: "granat/cross-circle/size-24-style-fill"
    }
  );
}, YE = ({ inverted: e, ...t }) => {
  const n = ie();
  return /* @__PURE__ */ h(
    q,
    {
      ...t,
      color: e ? n.colors.accent.activeInverted : n.colors.accent.active,
      iconPath: "granat/info-circle/size-24-style-fill"
    }
  );
}, XE = ({ inverted: e, ...t }) => {
  const n = ie();
  return /* @__PURE__ */ h(
    q,
    {
      ...t,
      color: e ? n.colors.accent.warningInverted : n.colors.accent.warning,
      iconPath: "granat/warning-circle/size-24-style-fill"
    }
  );
}, To = {
  grey: "grey",
  inverted: "inverted"
}, gy = v.div(
  ({ $variant: e = "grey", theme: { colors: t } }) => {
    const n = {
      [To.grey]: t.background.secondary,
      [To.inverted]: t.background.inverted
    };
    return C`
      flex-basis: 100%;
      display: flex;
      align-items: center;
      padding: 8px 12px;
      border-radius: 16px;
      overflow: hidden;
      background-color: ${n[e]};
    `;
  }
), vy = v.div`
  flex: none;
  position: relative;
  z-index: 0;
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 8px;

  svg {
    position: absolute;
    top: -2px;
    left: -2px;
    z-index: 1;
    width: 24px;
    height: 24px;
  }
`, yy = v(H)(({
  $variant: e = "grey",
  theme: { colors: t }
}) => {
  const n = {
    [To.grey]: t.text.primary,
    [To.inverted]: t.text.inverted
  };
  return C`
    overflow-wrap: break-word;
    word-break: break-word;
    color: ${n[e]};
  `;
}), ZE = A((e, t) => {
  const { description: n, variant: r = "grey", icon: o, ...i } = e;
  return /* @__PURE__ */ M(gy, { ...i, $variant: r, ref: t, children: [
    /* @__PURE__ */ h(vy, { children: tn(o, { inverted: r === "inverted" }) }),
    /* @__PURE__ */ h(yy, { forwardedAs: "p", font: "p4RegularComp", $variant: r, children: n })
  ] });
}), Be = {
  grey: "grey",
  white: "white",
  inverted: "inverted"
}, Cr = ({ colors: e }) => {
  const t = {
    [Be.grey]: e.background.secondary,
    [Be.white]: e.background.primaryElevated,
    [Be.inverted]: e.background.inverted
  }, n = {
    [Be.grey]: e.text.primary,
    [Be.white]: e.text.primary,
    [Be.inverted]: e.text.inverted
  }, r = {
    [Be.grey]: e.text.secondary,
    [Be.white]: e.text.secondary,
    [Be.inverted]: e.text.tertiary
  }, o = {
    [Be.grey]: e.text.primaryLink,
    [Be.white]: e.text.primaryLink,
    [Be.inverted]: e.text.primaryLinkInverted
  }, i = {
    [Be.grey]: e.icons.primary,
    [Be.white]: e.icons.primary,
    [Be.inverted]: e.text.inverted
  };
  return {
    bannerColor: t,
    titleColor: n,
    descColor: r,
    linkColor: o,
    buttonIconColor: i
  };
}, by = v.div(
  ({ $variant: e = "grey", $withShadow: t, $actionHref: n, theme: { colors: r, shadows: o } }) => C`
    flex-basis: 100%;
    position: relative;
    z-index: 0;
    display: grid;
    align-items: start;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto;
    box-sizing: border-box;
    padding: 12px 16px;
    border-radius: 20px;
    overflow: hidden;
    cursor: ${n ? "pointer" : "auto"};
    background-color: ${Cr({ colors: r }).bannerColor[e]};
    box-shadow: ${e === "white" && t ? o["shadow-low"] : "none"};
  `
), xy = v.div`
  grid-area: 1 / 1 / 2 / 2;
  align-self: start;
  position: relative;
  z-index: 0;
  display: block;
  width: 20px;
  height: 24px;
  margin-right: 8px;

  svg {
    position: relative;
    left: -2px;
    z-index: 1;
    width: 24px;
    height: 24px;
  }
`, wy = v(H)(
  ({ $variant: e = "grey", theme: { colors: t } }) => C`
    grid-column: 2 / 3;
    overflow-wrap: break-word;
    word-break: break-word;
    color: ${Cr({ colors: t }).titleColor[e]};
  `
), $y = v(H)(
  ({ $variant: e = "grey", $device: t, theme: { colors: n } }) => C`
    grid-column: ${t === "desktop" ? "2 / 3" : "1 / 4"};
    margin-top: 4px;
    overflow-wrap: break-word;
    word-break: break-word;
    color: ${Cr({ colors: n }).descColor[e]};
  `
), Cy = v.a(
  ({ $variant: e = "grey", theme: { colors: t } }) => C`
    all: unset;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    text-decoration: none;
    color: ${Cr({ colors: t }).linkColor[e]};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
  `
), ky = v(Ce)(
  ({ $bannerColor: e = "grey", theme: { colors: t } }) => C`
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    user-select: none;
    grid-column: 3 / 4;
    grid-row: 1 / 2;
    margin: -4px -8px -4px 8px;

    svg {
      fill: ${Cr({ colors: t }).buttonIconColor[e]};
    }
  `
);
function Sy({
  bannerColor: e,
  ...t
}) {
  return /* @__PURE__ */ h(ky, { "aria-label": "Закрыть", type: "button", $bannerColor: e, ...t, children: /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-24-style-outline" }) });
}
const qE = A((e, t) => {
  const {
    device: n = "desktop",
    variant: r = "grey",
    title: o,
    description: i,
    actionText: s,
    actionHref: a,
    withCloseButton: l,
    onCloseClick: c,
    icon: d,
    withShadow: u = !0,
    ...p
  } = e;
  return /* @__PURE__ */ M(
    by,
    {
      ...p,
      $variant: r,
      $withShadow: u,
      $actionHref: !!a,
      ref: t,
      children: [
        d && /* @__PURE__ */ h(xy, { children: d && tn(d, { inverted: r === "inverted" }) }),
        /* @__PURE__ */ h(wy, { forwardedAs: "strong", font: "p3MediumComp", $variant: r, children: o }),
        /* @__PURE__ */ M($y, { $device: n, forwardedAs: "p", font: "p4RegularComp", $variant: r, children: [
          i,
          s && a && /* @__PURE__ */ h(Cy, { href: a, $variant: r, children: s })
        ] }),
        l && /* @__PURE__ */ h(Sy, { size: 32, variant: "ghost", bannerColor: r, onClick: c })
      ]
    }
  );
}), Wl = {
  grey: "grey",
  white: "white"
}, Ty = v.div(({ $variant: e = "grey", action: t, theme: { colors: n } }) => {
  const r = {
    [Wl.grey]: n.control.tertiaryActive,
    [Wl.white]: n.control.alternative
  };
  return C`
    box-sizing: border-box;
    background-color: ${r[e]};
    display: flex;
    gap: 8px;
    position: relative;
    padding: 16px;
    border-radius: 16px;
    overflow: hidden;
    cursor: ${t ? "pointer" : "auto"};
  `;
}), Ey = v.div`
  width: 20px;
  height: 20px;

  svg {
    position: relative;
    left: -2px;
    top: -2px;
    width: 24px;
    height: 24px;
  }
`, Ry = v.div`
  width: 100%;
`, Ay = v(H)`
  overflow-wrap: break-word;
  word-break: break-word;
`, Py = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.secondary};
    overflow-wrap: break-word;
    word-break: break-word;
  `
), My = v.a(
  ({ theme: { colors: e } }) => C`
    all: unset;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    text-decoration: none;
    color: ${e.text.primaryLink};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
  `
), Dy = v.a`
  width: 20px;
  height: 20px;
  align-self: center;

  svg {
    position: relative;
    left: -2px;
    top: -2px;
  }
`, JE = A((e, t) => {
  const {
    variant: n = "grey",
    title: r,
    description: o,
    actionText: i,
    actionHref: s,
    withActionIcon: a,
    icon: l,
    customIcon: c,
    ...d
  } = e, u = ie();
  return /* @__PURE__ */ M(Ty, { ...d, $variant: n, action: !!s, ref: t, children: [
    l && /* @__PURE__ */ h(Ey, { children: l }),
    !l && c,
    /* @__PURE__ */ M(Ry, { children: [
      /* @__PURE__ */ h(Ay, { font: "p4RegularComp", forwardedAs: "div", children: r }),
      o && /* @__PURE__ */ M(Py, { forwardedAs: "div", font: "c1RegularComp", children: [
        o,
        i && s && /* @__PURE__ */ h(My, { href: s, children: i })
      ] })
    ] }),
    s && a && /* @__PURE__ */ h(Dy, { children: /* @__PURE__ */ h(
      q,
      {
        iconPath: "granat/chevron-right/size-24-style-outline",
        color: u.colors.icons.secondary
      }
    ) })
  ] });
}), By = {
  offset: {
    width: 0,
    left: 0
  },
  setOffset: () => {
  },
  size: 44,
  typography: "bold",
  variant: "primary",
  fluid: !1
}, aa = be(By);
function Ly({
  children: e,
  size: t,
  typography: n,
  variant: r,
  fluid: o
}) {
  const [i, s] = U({
    width: 0,
    left: 0
  }), a = K(
    () => ({
      offset: i,
      setOffset: s,
      size: t,
      typography: n,
      variant: r,
      fluid: o
    }),
    [i, t, n, r, o]
  );
  return /* @__PURE__ */ h(aa.Provider, { value: a, children: e });
}
const Ct = {
  32: {
    borderRadius: 12,
    height: 32,
    item: {
      height: 24,
      borderRadius: 8
    },
    highlightBorderRadius: 8,
    label: {
      padding: "0 8px"
    },
    icon: 16
  },
  44: {
    borderRadius: 16,
    height: 44,
    item: {
      height: 36,
      borderRadius: 12
    },
    highlightBorderRadius: 12,
    label: {
      padding: "6px 8px"
    },
    icon: 24
  }
}, Iy = {
  bold: {
    32: "c2BoldUppWide",
    44: "c1BoldUppWide"
  },
  regular: {
    32: "p4RegularComp",
    44: "p3RegularComp"
  }
}, Gr = {
  primary: "primary",
  secondary: "secondary"
}, la = ({ colors: e }) => {
  const t = {
    [Gr.primary]: e.background.secondary,
    [Gr.secondary]: e.background.primary
  }, n = {
    [Gr.primary]: e.control.alternative,
    [Gr.secondary]: e.background.secondary
  };
  return {
    bgColor: t,
    highlightBgColor: n
  };
}, Fy = v.div(
  ({ $size: e = 44, $fluid: t, $variant: n = "primary", theme: { colors: r } }) => C`
    box-sizing: border-box;
    padding: 4px;
    display: ${t ? "block" : "inline-block"};
    background-color: ${la({ colors: r }).bgColor[n]};
    border-radius: ${Ct[e].borderRadius}px;
    height: ${Ct[e].height}px;
    ${t && `
    ${Ku} {
      justify-content: space-between;
    }
    ${Yu} {
      width: 100%;
    }
  `}
  `
), Ku = v.div(
  ({ $size: e = 44, $variant: t = "primary", theme: { colors: n } }) => C`
    position: relative;
    display: flex;

    &::before {
      content: '';
      position: absolute;
      background-color: ${la({ colors: n }).highlightBgColor[t]};
      width: var(--highlight-width);
      height: 100%;
      border-radius: ${Ct[e].highlightBorderRadius}px;
      transform: translateX(var(--highlight-x-pos));
      transition: transform 0.2s;
      pointer-events: none;
    }
  `
), Vy = v.input`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
`, Yu = v.label(
  ({ $size: e = 44, $active: t, $disabled: n, $variant: r = "primary", theme: { colors: o } }) => C`
    all: unset;
    height: ${Ct[e].item.height}px;
    display: inline-grid;
    position: relative;
    align-items: center;
    justify-content: center;
    cursor: ${n ? "not-allowed" : "pointer"};
    border-radius: ${Ct[e].item.borderRadius}px;
    opacity: ${n && t ? 0.6 : 1};
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
    transition: background-color 0.2s;

    &::after {
      content: '';
      position: absolute;
      display: ${t ? "none" : "block"};
      width: 1px;
      height: 16px;
      border-radius: 0.5px;
      background-color: ${o.background.stroke};
    }
    &:first-child::after {
      display: none;
    }

    ${t && `
      & + [data-item="segmented-item"]::after {
        display: none;
      }
      background-color: ${n ? o.control.inactive : la({ colors: o }).highlightBgColor[r]};
    `}

    ${!t && !n && `
      &:hover {
        ${Xu}, ${Zu} {
          color: ${o.text.secondary};
        }
      }
    `}

    ${!n && `
      &:focus-visible {
        outline: 1px solid ${o.accent.active};
      }
    `}
  `
), Xu = v.div(
  ({ $disabled: e, $size: t = 44, theme: { colors: n } }) => C`
    color: ${e ? n.text.tertiary : n.text.primary};
    padding: ${Ct[t].label.padding};
    display: flex;
    align-items: center;
    gap: 2px;

    svg {
      width: ${Ct[t].icon}px;
      height: ${Ct[t].icon}px;
    }
  `
), Zu = v(H)(
  ({ $disabled: e, theme: { colors: t } }) => C`
    color: ${e ? t.text.tertiary : t.text.primary};
  `
), Oy = A((e, t) => {
  const { children: n, style: r, ...o } = e, { offset: i, size: s = 44, variant: a, fluid: l } = se(aa), c = K(
    () => ({
      "--highlight-x-pos": `${i.left}px`,
      "--highlight-width": `${i.width}px`
    }),
    [i]
  );
  return /* @__PURE__ */ h(
    Fy,
    {
      ...o,
      $size: s,
      $fluid: l,
      $variant: a,
      style: { ...r, ...c },
      ref: t,
      children: /* @__PURE__ */ h(Ku, { $size: s, $variant: a, children: n })
    }
  );
}), QE = A((e, t) => {
  const { size: n = 44, typography: r = "bold", variant: o = "primary", fluid: i, children: s, ...a } = e;
  return /* @__PURE__ */ h(Ly, { size: n, typography: r, fluid: i, variant: o, children: /* @__PURE__ */ h(Oy, { ref: t, ...a, children: s }) });
}), e3 = A(
  (e, t) => {
    const { children: n, active: r, disabled: o, icon: i, name: s, id: a, onChange: l, ...c } = e, {
      setOffset: d,
      size: u = 44,
      typography: p = "bold",
      variant: f,
      fluid: m
    } = se(aa), g = oe(null), [y, b] = U({
      width: 0,
      left: 0
    }), w = fe(() => {
      var $, E;
      b({
        width: o ? 0 : (($ = g == null ? void 0 : g.current) == null ? void 0 : $.offsetWidth) || 0,
        left: ((E = g == null ? void 0 : g.current) == null ? void 0 : E.offsetLeft) || 0
      });
    }, [o]);
    Y(() => {
      r && w();
    }, [r, w]), Y(() => {
      r && d(y);
    }, [r, y, d]), Y(() => {
      w();
    }, [w, u, m]);
    const x = K(() => Bt(g, t), [g, t]);
    return /* @__PURE__ */ M(
      Yu,
      {
        ...c,
        $size: u,
        ref: x,
        $active: r,
        $variant: f,
        $disabled: o,
        "data-item": "segmented-item",
        children: [
          /* @__PURE__ */ h(
            Vy,
            {
              type: "radio",
              id: a,
              name: s,
              onChange: l,
              disabled: o,
              checked: r
            }
          ),
          /* @__PURE__ */ M(Xu, { $disabled: o, $size: u, children: [
            i && i,
            n && /* @__PURE__ */ h(
              Zu,
              {
                $disabled: o,
                forwardedAs: "div",
                font: Iy[p][u],
                children: n
              }
            )
          ] })
        ]
      }
    );
  }
), zy = be({
  onCellClick: () => {
  }
});
function Ny({ children: e, onCellClick: t }) {
  const n = K(
    () => ({
      onCellClick: t
    }),
    [t]
  );
  return /* @__PURE__ */ h(zy.Provider, { value: n, children: e });
}
const Wy = v.div(
  ({ theme: { colors: e, shadows: t } }) => C`
    display: flex;
    flex-direction: column;
    padding: 6px;
    background-color: ${e.background.modal};
    box-shadow: ${t["shadow-high"]};
    border-radius: 16px;
    overflow: auto;
  `
), on = A((e, t) => {
  var x;
  const {
    children: n,
    onCellClick: r,
    anchorRef: o,
    open: i = !1,
    centered: s = !1,
    style: a,
    ...l
  } = e, [c, d] = U(i), [u, p] = U(a == null ? void 0 : a.width);
  Y(() => {
    p(a == null ? void 0 : a.width);
  }, [a == null ? void 0 : a.width]), Y(() => {
    d(i);
  }, [i]);
  const { context: f, refs: m, floatingStyles: g } = ei({
    open: c,
    placement: s ? "bottom" : "bottom-start",
    elements: {
      reference: o == null ? void 0 : o.current
    },
    middleware: [Au(4), Pu()],
    whileElementsMounted: ($, E, S) => Eu($, E, S, {
      layoutShift: !1
    })
  }), { getFloatingProps: y } = ti([
    Jo(f),
    Qo(f),
    ni(f)
  ]), b = () => {
    var $;
    if (($ = f == null ? void 0 : f.elements) != null && $.reference) {
      const { width: E } = f.elements.reference.getBoundingClientRect();
      p(E);
    }
  };
  Y(() => {
    if (!(a != null && a.width))
      return b(), window.addEventListener("resize", b), () => {
        window.removeEventListener("resize", b);
      };
  }, [(x = f == null ? void 0 : f.elements) == null ? void 0 : x.reference, a == null ? void 0 : a.width]);
  const w = K(() => Bt(m.setFloating, t), [m.setFloating, t]);
  return /* @__PURE__ */ h(We, { children: c && /* @__PURE__ */ h(Ny, { onCellClick: r, children: /* @__PURE__ */ h(
    Wy,
    {
      ...l,
      ...y({
        ref: w,
        style: {
          width: u,
          ...g,
          ...a
        }
      }),
      children: n
    }
  ) }) });
}), vt = {
  24: {
    size: "24px",
    font: "c1MediumComp",
    borderRadius: "8px"
  },
  32: {
    size: "32px",
    font: "c1MediumComp",
    borderRadius: "12px"
  },
  44: {
    size: "44px",
    font: "p4MediumComp",
    borderRadius: "16px"
  },
  52: {
    size: "52px",
    font: "p3MediumComp",
    borderRadius: "16px"
  },
  64: {
    size: "64px",
    font: "h4Comp",
    borderRadius: "20px"
  },
  80: {
    size: "80px",
    font: "h3Comp",
    borderRadius: "24px"
  }
}, t3 = A((e, t) => {
  const {
    onClick: n,
    lastName: r,
    firstName: o,
    size: i = 64,
    imageStroke: s = !1,
    icon: a = "noGender",
    className: l,
    children: c,
    ...d
  } = e, u = K(() => {
    const p = (o == null ? void 0 : o.slice(0, 1).toUpperCase()) || "", f = (r == null ? void 0 : r.slice(0, 1).toUpperCase()) || "";
    if (f || p)
      return i === 24 ? f || p : `${f}${p}`;
  }, [o, r, i]);
  return /* @__PURE__ */ h(
    _y,
    {
      ...d,
      ref: t,
      onClick: n,
      role: "img",
      $size: i,
      className: l,
      $stroke: !!c && s,
      children: c || u || a
    }
  );
}), _y = v.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  ${({ theme: e, $size: t, $stroke: n = !1 }) => C`
    width: ${vt[t].size};
    min-width: ${vt[t].size};
    max-width: ${vt[t].size};
    height: ${vt[t].size};
    min-height: ${vt[t].size};
    max-height: ${vt[t].size};
    border-radius: ${vt[t].borderRadius};
    color: ${e.colors.constant.greyscale0};
    background: ${e.colors.icons.tertiary};
    ${ae(vt[t].font)}
    border: ${n ? `1px solid ${e.colors.background.stroke}` : "none"};
  `}
  &::before {
    content: '';
    width: 0;
    padding-bottom: 100%;
  }

  img,
  svg {
    min-width: 100%;
    min-height: 100%;
    object-fit: contain;
    object-position: 50% 50%;
  }
`, jy = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ T.createElement("title", { id: t }, e) : null, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M20.28 21.9v1.94c7.43 4.28 11.17 2.14 11.17 11.82H1c0-10.02 3.74-7.54 11.17-11.82v-1.9c-1.31-.93-1.6-2.42-2.04-4.17h-.05c-.2 0-.39-.3-.39-.64 0-.1.05-.1.05-.2-.14-.19-.29-.48-.39-.82-.14-.53-.58-1.6-.19-2.14.39-.34.58.05.58.05-.53-2.82-1.26-6.56 2.67-7.73 0-2.43 9.23-1.36 10.3 2.63.54 1.55-.14 5.05-.14 5.05.14-.24.34-.34.53-.14.53.34-.05 1.8-.2 2.28-.1.44-.24.68-.38.93l.05.1c0 .33-.2.63-.4.63-.24 1.55-.67 3.3-1.89 4.13Z" })), Hy = A(jy), Uy = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ T.createElement("title", { id: t }, e) : null, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M7.69 22.94A14.24 14.24 0 0 0 8 19.99v-.28c0-.74-.05-1.71-.11-2.76l-.03-.53c-.04-.87-.05-1.63 0-2.32.08-1.36.34-2.42.87-3.33.98-1.71 2.05-1.97 2.05-1.97s0-2.51 4.05-3.3c.38-.11.79-.17 1.24-.17h.08a5.76 5.76 0 0 1 .14 0c1.88 0 3.66.86 4.8 2.25a12.43 12.43 0 0 1 2.97 7.2c.07.7.1 1.45.06 2.16a42.2 42.2 0 0 0-.12 3.04c.03 1.38.19 2.35.32 2.96.09.36-.21.74-.58.7-.93-.09-3.08-.23-4.26-.27v1.2c1.69.93 3.28 1.5 4.62 1.97l.6.21c1.9.69 3.39 1.22 4.4 2.44l.02-.01c.98 1.23 1.5 3.02 1.54 6.26v.41H1.33v-.4c.04-3.25.56-5.04 1.54-6.27l.02.01c1.01-1.22 2.5-1.75 4.4-2.44l.32-.11.28-.1.62-.22c1.24-.43 2.66-.91 4.14-1.75v-1.21l-.6.01c-1.18.04-2.81.19-3.78.28-.32.04-.6-.27-.6-.59l.02-.12Z" })), Gy = A(Uy), Ky = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ T.createElement("title", { id: t }, e) : null, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M14.31 5.88c-.28.15-.37.48-.27.79l.53 1.68c.1.33.4.55.73.55h1.2c.34 0 .64-.22.74-.55l.54-1.72c.1-.28.01-.6-.24-.75a3.53 3.53 0 0 0-3.23 0Zm1.06 4.03a.76.76 0 0 0-.73.56 87.23 87.23 0 0 0-1.62 6.52A88.99 88.99 0 0 0 12 23.8c-.04.34.06.67.28.92l2.88 3.37c.46.54 1.28.53 1.74-.01l2.8-3.36c.22-.25.32-.58.28-.91a93.77 93.77 0 0 0-1-6.83 91.84 91.84 0 0 0-1.63-6.52.77.77 0 0 0-.73-.56h-1.26Z" })), Yy = A(Ky), Xy = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ T.createElement("title", { id: t }, e) : null, /* @__PURE__ */ T.createElement("path", { fillRule: "evenodd", d: "M.67 35.36c.04-3.36.58-5.23 1.6-6.5l.02.01c1.06-1.27 2.61-1.82 4.6-2.53 1.62-.58 3.64-1.22 5.8-2.46v-.41c0-.6.04-1.17-.19-1.68-.59-.52-1.48-1.21-1.86-1.97l-.01-.01-.03-.08c-.3-.63-.53-1.3-.7-2h-.05c-.25 0-.4-.34-.4-.68v-.15c-.1-.2-.24-.49-.34-.88 0-.04-.02-.07-.04-.11-.2-.57-.56-1.55-.15-2l.01-.02a.47.47 0 0 1 .14-.18c.18-.12.31-.09.43.05 0-.53.04-2.07.56-3.67.66-2.21 1.59-4.76 5.94-4.76 4.35 0 5.28 2.55 5.94 4.76.52 1.6.56 3.14.56 3.67.12-.14.25-.17.43-.05.06.04.1.1.14.18l.01.01c.41.46.05 1.44-.15 2l-.04.12c-.1.4-.25.69-.35.88v.15c0 .34-.14.69-.39.69h-.05a10.46 10.46 0 0 1-.73 2.07h-.01c-.38.77-1.27 1.46-1.86 1.98-.23.51-.18 1.09-.18 1.68v.4c2.15 1.25 4.17 1.89 5.78 2.47 2 .7 3.55 1.26 4.6 2.53l.02-.01c1.03 1.27 1.57 3.14 1.61 6.5v.43H.67v-.43Z" })), Zy = A(Xy), n3 = () => {
  const e = ie();
  return /* @__PURE__ */ h(q, { width: 24, height: 24, color: e.colors.constant.greyscale0, icon: /* @__PURE__ */ h(Hy, {}) });
}, r3 = () => {
  const e = ie();
  return /* @__PURE__ */ h(q, { width: 24, height: 24, color: e.colors.constant.greyscale0, icon: /* @__PURE__ */ h(Gy, {}) });
}, o3 = () => {
  const e = ie();
  return /* @__PURE__ */ h(q, { width: 24, height: 24, color: e.colors.constant.greyscale0, icon: /* @__PURE__ */ h(Yy, {}) });
}, i3 = () => {
  const e = ie();
  return /* @__PURE__ */ h(q, { width: 24, height: 24, color: e.colors.constant.greyscale0, icon: /* @__PURE__ */ h(Zy, {}) });
}, ii = be({
  gap: "16px",
  device: "desktop"
}), ze = {
  desktop: {
    item: {
      paddingLeft: 40,
      text: "p2RegularComp",
      title: "h4Comp",
      titleMargin: "2px 0",
      subtitle: "p3RegularComp",
      beforeElement: {
        font: {
          default: "p3MediumComp",
          hasTitle: "p3BoldComp"
        },
        width: 28,
        height: 28,
        borderRadius: 14
      }
    },
    sublistItem: {
      text: "p3RegularComp",
      beforeTop: 10
    }
  },
  mobile: {
    item: {
      paddingLeft: 36,
      text: "p3RegularComp",
      title: "p3MediumComp",
      titleMargin: 0,
      subtitle: "p4RegularComp",
      beforeElement: {
        font: {
          default: "p4MediumComp",
          hasTitle: "p4BoldComp"
        },
        width: 24,
        height: 24,
        borderRadius: 12
      }
    },
    sublistItem: {
      text: "p4RegularComp",
      beforeTop: 8
    }
  }
}, qy = v.li(
  ({ $device: e = "desktop", $gap: t, hasTitle: n, theme: { colors: r } }) => C`
    position: relative;
    display: grid;
    gap: ${t || "16px"};
    padding-left: ${ze[e].item.paddingLeft}px;
    counter-increment: numbered-list-counter;

    &::before {
      content: counter(numbered-list-counter);
      position: absolute;
      ${ae(n ? ze[e].item.beforeElement.font.hasTitle : ze[e].item.beforeElement.font.default)};
      top: 0;
      left: 0;
      width: ${ze[e].item.beforeElement.width}px;
      height: ${ze[e].item.beforeElement.height}px;
      border-radius: ${ze[e].item.beforeElement.borderRadius}px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${r.background.secondary};
      color: ${r.text.primary};
    }
  `
), Jy = v(H)(
  ({ $device: e = "desktop", theme: { colors: t } }) => C`
    color: ${t.text.primary};
    margin: ${ze[e].item.titleMargin};
  `
), Qy = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.primary};
  `
), eb = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.primary};
  `
), s3 = A((e, t) => {
  const { title: n, subTitle: r, children: o, ariaLevel: i = 2, ...s } = e, { gap: a, device: l = "desktop" } = se(ii), c = K(() => {
    let d = !1;
    const u = Tt.toArray(o);
    return u.length === 1 && typeof u[0] == "string" && (d = !0), d;
  }, [o]);
  return /* @__PURE__ */ M(qy, { ...s, ref: t, $device: l, $gap: a, hasTitle: !!n, children: [
    n && /* @__PURE__ */ h(
      Jy,
      {
        role: "heading",
        "aria-level": i,
        forwardedAs: "div",
        $device: l,
        font: ze[l].item.title,
        children: n
      }
    ),
    r && /* @__PURE__ */ h(Qy, { forwardedAs: "div", font: ze[l].item.subtitle, children: r }),
    c && /* @__PURE__ */ h(
      eb,
      {
        forwardedAs: "div",
        font: ze[l].item.text,
        role: "heading",
        "aria-level": i,
        children: o
      }
    ),
    !c && o
  ] });
}), tb = v.ul(
  ({ $gap: e }) => C`
    all: unset;
    display: grid;
    gap: ${e || "16px"};
  `
), a3 = A((e, t) => {
  const { children: n, ...r } = e, { gap: o } = se(ii);
  return /* @__PURE__ */ h(tb, { ...r, ref: t, $gap: o, role: "list", children: n });
}), nb = v.li(
  ({ $device: e = "desktop", theme: { colors: t } }) => C`
    all: unset;
    ${ae(ze[e].sublistItem.text)};
    position: relative;
    padding-left: 16px;
    color: ${t.text.primary};

    &::before {
      content: '';
      top: ${ze[e].sublistItem.beforeTop}px;
      position: absolute;
      left: 0;
      z-index: 0;
      width: 4px;
      height: 4px;
      background-color: ${t.icons.secondary};
      border-radius: 2px;
    }
  `
), l3 = A((e, t) => {
  const { children: n, ...r } = e, { device: o = "desktop" } = se(ii);
  return /* @__PURE__ */ h(nb, { ...r, ref: t, $device: o, children: n });
}), rb = v.ol(
  ({ $gap: e }) => C`
    all: unset;
    flex: none;
    display: grid;
    gap: ${e || "16px"};
    counter-reset: numbered-list-counter;
  `
), c3 = A((e, t) => {
  const { children: n, device: r = "desktop", gap: o, ...i } = e, s = K(() => ({ gap: o, device: r }), [o, r]);
  return /* @__PURE__ */ h(ii.Provider, { value: s, children: /* @__PURE__ */ h(rb, { ...i, ref: t, role: "list", $gap: o, children: n }) });
}), si = be({
  gap: "16px",
  device: "desktop"
}), Cn = {
  desktop: {
    item: {
      text: "p2RegularComp",
      title: "h4Comp",
      subtitle: "p3RegularComp",
      beforeElement: {
        top: 8
      }
    },
    sublistItem: {
      text: "p3RegularComp",
      beforeTop: 10
    }
  },
  mobile: {
    item: {
      text: "p3RegularComp",
      title: "p3MediumComp",
      subtitle: "p4RegularComp",
      beforeElement: {
        top: 6
      }
    },
    sublistItem: {
      text: "p4RegularComp",
      beforeTop: 8
    }
  }
}, ob = v.li(
  ({ $device: e = "desktop", $gap: t, theme: { colors: n } }) => C`
    position: relative;
    display: grid;
    gap: ${t || "16px"};
    padding-left: 20px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: ${Cn[e].item.beforeElement.top}px;
      width: 8px;
      height: 8px;
      background-color: ${n.brand};
      border-radius: 4px;
    }
  `
), ib = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.primary};
  `
), sb = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.primary};
  `
), ab = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.primary};
  `
), d3 = A((e, t) => {
  const { title: n, subTitle: r, children: o, ariaLevel: i = 2, ...s } = e, { gap: a, device: l = "desktop" } = se(si), c = K(() => {
    let d = !1;
    const u = Tt.toArray(o);
    return u.length === 1 && typeof u[0] == "string" && (d = !0), d;
  }, [o]);
  return /* @__PURE__ */ M(ob, { ...s, ref: t, $device: l, $gap: a, children: [
    n && /* @__PURE__ */ h(
      ib,
      {
        role: "heading",
        "aria-level": i,
        forwardedAs: "div",
        font: Cn[l].item.title,
        children: n
      }
    ),
    r && /* @__PURE__ */ h(sb, { forwardedAs: "div", font: Cn[l].item.subtitle, children: r }),
    c && /* @__PURE__ */ h(
      ab,
      {
        forwardedAs: "div",
        font: Cn[l].item.text,
        role: "heading",
        "aria-level": i,
        children: o
      }
    ),
    !c && o
  ] });
}), lb = v.ul(
  ({ $gap: e }) => C`
    all: unset;
    display: grid;
    gap: ${e || "16px"};
  `
), u3 = A((e, t) => {
  const { children: n, ...r } = e, { gap: o } = se(si);
  return /* @__PURE__ */ h(lb, { ...r, ref: t, $gap: o, role: "list", children: n });
}), cb = v.li(
  ({ $device: e = "desktop", theme: { colors: t } }) => C`
    all: unset;
    ${ae(Cn[e].sublistItem.text)};
    position: relative;
    padding-left: 16px;
    color: ${t.text.primary};

    &::before {
      content: '';
      top: ${Cn[e].sublistItem.beforeTop}px;
      position: absolute;
      left: 0;
      width: 4px;
      height: 4px;
      background-color: ${t.icons.secondary};
      border-radius: 2px;
    }
  `
), p3 = A((e, t) => {
  const { children: n, ...r } = e, { device: o = "desktop" } = se(si);
  return /* @__PURE__ */ h(cb, { ...r, ref: t, $device: o, children: n });
}), db = v.ol(
  ({ $gap: e }) => C`
    all: unset;
    flex: none;
    display: grid;
    gap: ${e || "16px"};
  `
), f3 = A((e, t) => {
  const { children: n, device: r = "desktop", gap: o, ...i } = e, s = K(() => ({ gap: o, device: r }), [o, r]);
  return /* @__PURE__ */ h(si.Provider, { value: s, children: /* @__PURE__ */ h(db, { ...i, ref: t, role: "list", $gap: o, children: n }) });
}), Ni = {
  primary: "primary",
  secondary: "secondary",
  secondaryInverted: "secondary-inverted"
}, qu = {
  [Ni.primary]: {
    container: {
      gap: 0
    },
    wrapper: () => ({
      backgroundColor: "transparent",
      marginLeft: -16,
      width: `calc(100% + ${16 * 2}px)`
    })
  },
  [Ni.secondary]: {
    container: {
      gap: 8
    },
    wrapper: (e) => ({
      backgroundColor: e.colors.background.secondary
    })
  },
  [Ni.secondaryInverted]: {
    container: {
      gap: 8
    },
    wrapper: (e) => ({
      backgroundColor: e.colors.background.primary
    })
  }
}, ub = {
  44: {
    header: {
      paddingTop: 10,
      paddingBottom: 10
    }
  },
  52: {
    header: {
      paddingTop: 14,
      paddingBottom: 14
    }
  },
  64: {
    header: {
      paddingTop: 16,
      paddingBottom: 16
    }
  }
}, Ju = v.div`
  overflow: hidden;
  padding: 0 ${16}px;
  ${ae("p3RegularComp")};
  transition:
    height 0.2s ease,
    margin 0.2s ease;
  height: ${({ $isActive: e, $height: t }) => e ? t : 0}px;
  color: ${({ theme: e }) => e.colors.text.primary};
`, pb = v.div`
  width: 100%;
  text-align: left;
`, Eo = v.div`
  display: flex;
  transition: transform 0.2s ease;
`, Qu = v.button`
  display: flex;
  align-items: center;
  gap: ${12}px;
  cursor: pointer;
  border: none;
  background: none;
  padding: 0 ${16}px;
  border-radius: ${16}px;
  color: ${({ theme: e }) => e.colors.text.primary};
  font-size: inherit;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${({ theme: e }) => e.colors.text.secondary};

      ${Eo} {
        svg {
          fill: ${({ theme: e }) => e.colors.icons.secondary};
        }
      }
    }
  }

  &:focus-visible {
    outline: 1px solid ${({ theme: e }) => e.colors.accent.active};
  }

  &:disabled {
    cursor: default;
    color: ${({ theme: e }) => e.colors.text.tertiary};

    ${Eo} {
      svg {
        fill: ${({ theme: e }) => e.colors.icons.secondary};
      }
    }
  }
`, fb = v.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: ${16}px;
  transition: gap 0.12s ease;
  gap: ${({ $isActive: e }) => e ? 4 : 0}px;

  ${({ $variant: e, theme: t }) => C`
    ${So(qu[e].wrapper(t))}
  `}
  &:after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    z-index: 1;
    height: 1px;
    display: ${({ $variant: e }) => e === "primary" ? "block" : "none"};
    width: calc(100% - ${16 * 2}px);
    background-color: ${({ theme: e }) => e.colors.background.stroke};
  }

  ${({ $size: e }) => C`
    ${ae(
  { 44: "p3MediumComp", 52: "p3MediumComp", 64: "h4Comp" }[e]
)}
  `}
  ${Ju} {
    margin-bottom: ${({ $isActive: e }) => e ? 12 : 0}px;
  }

  ${Qu} {
    ${({ $size: e }) => C`
      ${So(ub[e].header)}
    `}
  }


  ${Eo} {
    ${({ $isActive: e }) => `
      ${e && C`
          transform: rotate(180deg);
        `}
    `}
  }
}`, hb = v.div`
  display: flex;
  flex-direction: column;
  ${({ $variant: e }) => C`
    ${So(qu[e].container)}
  `}
`, un = {
  Container: hb,
  Wrapper: fb,
  Header: Qu,
  Content: Ju,
  Arrow: Eo,
  Title: pb
}, mb = ({ size: e }) => {
  const t = ie();
  return e === 64 ? /* @__PURE__ */ h(q, { iconPath: "granat/chevron-down/size-32-style-outline", color: t.colors.icons.primary }) : /* @__PURE__ */ h(q, { iconPath: "granat/chevron-down/size-24-style-outline", color: t.colors.icons.primary });
}, gb = ({
  label: e,
  icon: t,
  onChange: n,
  disabled: r,
  children: o,
  size: i,
  variant: s,
  open: a,
  id: l
}) => {
  const c = oe(null), d = K(() => {
    var p;
    return ((p = c.current) == null ? void 0 : p.scrollHeight) ?? 0;
  }, [a, o]), u = () => {
    n == null || n(l);
  };
  return /* @__PURE__ */ M(un.Wrapper, { $size: i, $variant: s, $isActive: a, children: [
    /* @__PURE__ */ M(un.Header, { disabled: r, onClick: u, children: [
      t,
      /* @__PURE__ */ h(un.Title, { children: e }),
      /* @__PURE__ */ h(un.Arrow, { children: /* @__PURE__ */ h(mb, { size: i }) })
    ] }),
    /* @__PURE__ */ h(un.Content, { $isActive: a, $height: d, ref: c, children: o })
  ] });
}, h3 = ({
  items: e,
  onChange: t,
  size: n = 44,
  variant: r = "primary",
  ...o
}) => {
  const [i, s] = U(
    () => e.map((d, u) => ({ id: u, open: !1, ...d }))
  ), a = (d) => {
    s(
      (u) => u.map(({ id: p, open: f, ...m }) => p === d ? { id: p, open: !f, ...m } : { id: p, open: !1, ...m })
    ), t == null || t(d);
  }, c = K(() => e.every((d) => "open" in d), [e]) ? e : i;
  return /* @__PURE__ */ h(un.Container, { $variant: r, ...o, children: c.map(({ label: d, disabled: u, icon: p, children: f, open: m }, g) => /* @__PURE__ */ h(
    gb,
    {
      open: m,
      onChange: a,
      id: g,
      label: d,
      icon: p,
      disabled: u,
      size: n,
      variant: r,
      children: f
    },
    g
  )) });
}, m3 = A((e, t) => {
  const {
    children: n,
    variant: r = "default",
    shadowOff: o = !1,
    blurOff: i = !1,
    onClick: s,
    padding: a,
    ...l
  } = e;
  return /* @__PURE__ */ h(
    vb,
    {
      ...l,
      onClick: () => {
        s && s();
      },
      $variant: r,
      ref: t,
      $clickable: !!s,
      $shadowOff: o,
      $blurOff: i,
      $padding: a,
      children: n
    }
  );
}), vb = v.div`
  ${({ theme: e, $variant: t = "default", $clickable: n, $shadowOff: r, $blurOff: o, $padding: i }) => {
  const s = {
    default: e.colors.background.primary,
    alternative: e.colors.background.secondary,
    transparent: e.colors.control.blur,
    outline: e.colors.background.primary
  };
  return C`
      width: 100%;
      background: ${s[t]};
      border-radius: 24px;
      min-height: 120px;
      box-shadow: ${t === "default" && !r ? e.shadows["shadow-low"] : "none"};
      border: ${t === "outline" ? "1px solid rgba(188, 195, 208, 0.5)" : "none"};
      overflow: hidden;
      cursor: ${n ? "pointer" : "default"};
      transition: 0.3s ease-in-out;
      backdrop-filter: ${t === "transparent" && !o ? "blur(10px)" : "unset"};
      -webkit-backdrop-filter: ${t === "transparent" && !o ? "blur(10px)" : "unset"};
      padding: ${i || "0px"};
      &:hover,
      &:focus-visible {
        transform: translateY(-4px);
        box-shadow: ${t === "default" && e.shadows["shadow-middle"]};
      }
    `;
}}
`, yb = {
  size: void 0,
  type: void 0,
  variant: void 0,
  divider: void 0,
  activeStepColor: void 0,
  activeStep: void 0,
  total: void 0,
  completedSteps: void 0,
  warningSteps: void 0,
  errorSteps: void 0,
  onlyForward: void 0,
  onActiveStepChange: () => "",
  hideText: void 0,
  hideSubtitle: void 0,
  titleFont: void 0,
  subtitleFont: void 0
}, ca = be(yb);
function bb(e) {
  const {
    children: t,
    size: n,
    type: r,
    variant: o,
    divider: i,
    activeStepColor: s,
    activeStep: a,
    total: l,
    onActiveStepChange: c,
    completedSteps: d,
    errorSteps: u,
    onlyForward: p,
    hideText: f,
    hideSubtitle: m,
    warningSteps: g,
    titleFont: y,
    subtitleFont: b
  } = e, w = K(
    () => ({
      size: n,
      type: r,
      variant: o,
      divider: i,
      activeStepColor: s,
      activeStep: a,
      total: l,
      onActiveStepChange: c,
      completedSteps: d,
      errorSteps: u,
      onlyForward: p,
      hideText: f,
      hideSubtitle: m,
      warningSteps: g,
      titleFont: y,
      subtitleFont: b
    }),
    [
      n,
      r,
      o,
      i,
      s,
      a,
      l,
      c,
      d,
      u,
      p,
      f,
      m,
      g,
      y,
      b
    ]
  );
  return /* @__PURE__ */ h(ca.Provider, { value: w, children: t });
}
const xb = ({ status: e }) => {
  const t = ie(), { type: n } = se(ca), r = K(() => ({
    done: {
      color: t.colors.accent.positive,
      path: "granat/check/size-16-style-outline"
    },
    error: {
      color: t.colors.accent.negative,
      path: "granat/minus/size-16-style-outline"
    },
    warning: {
      color: t.colors.accent.warning,
      path: "granat/waiting/size-16-style-outline"
    }
  }), []);
  return /* @__PURE__ */ h(wb, { $type: n, color: r[e].color, children: /* @__PURE__ */ h(q, { iconPath: r[e].path, color: t.colors.constant.greyscale0 }) });
}, wb = v.div`
  width: ${({ $type: e }) => e === "minimal" ? "20px" : "24px"};
  height: ${({ $type: e }) => e === "minimal" ? "20px" : "24px"};
  border-radius: 50%;
  background: ${({ color: e }) => e};
  display: flex;
  justify-content: center;
  align-items: center;
`, $b = {
  horizontal: {
    24: "12px",
    48: "12px"
  },
  vertical: {
    24: "16px",
    48: "24px"
  },
  minimal: {
    24: "16px",
    48: "12px"
  }
}, g3 = A((e, t) => {
  const n = ie(), {
    size: r,
    variant: o,
    type: i,
    divider: s,
    activeStepColor: a,
    activeStep: l,
    total: c,
    completedSteps: d,
    errorSteps: u,
    warningSteps: p,
    onlyForward: f,
    onActiveStepChange: m,
    hideText: g,
    hideSubtitle: y,
    titleFont: b,
    subtitleFont: w
  } = se(ca), { title: x, subtitle: $, stepNumber: E, idx: S } = e, F = K(() => E || S + 1, [E, S]), R = K(() => l === S, [l, S]), L = K(() => S + 1 === c, [S, c]), P = K(() => f && S !== l, [f, l, S]), j = K(
    () => a === "alternative" ? n.colors.control.secondaryActive : n.colors.brand,
    [a]
  ), [_, G] = U(void 0);
  Y(() => {
    d != null && d.has(S) ? G("done") : u != null && u.has(S) ? G("error") : p != null && p.has(S) ? G("warning") : G(void 0);
  }, [u, d, p, S]);
  const D = () => /* @__PURE__ */ M(Tb, { type: i, children: [
    !g && x && /* @__PURE__ */ h(
      H,
      {
        as: "p",
        font: b || "p4MediumComp",
        color: P ? n.colors.text.tertiary : n.colors.text.primary,
        children: x
      }
    ),
    !g && !y && $ && /* @__PURE__ */ h(
      H,
      {
        as: "p",
        font: w || "c1RegularComp",
        color: P ? n.colors.text.tertiary : n.colors.text.secondary,
        children: $
      }
    )
  ] }), I = fe(() => {
    f || m && m(S);
  }, [m, f, S]);
  return /* @__PURE__ */ M(Cb, { type: i, ref: t, isLast: L, $size: r, children: [
    /* @__PURE__ */ M(kb, { type: i, children: [
      /* @__PURE__ */ M(
        Sb,
        {
          $size: r,
          $active: R,
          $activeStepColor: j,
          $variant: o,
          $type: i,
          onClick: I,
          $clickable: !f && !!m,
          children: [
            /* @__PURE__ */ h(
              H,
              {
                font: r === 48 ? "h3Wide" : "p4MediumComp",
                color: R ? n.colors.text.inverted : P ? n.colors.text.tertiary : n.colors.text.primary,
                children: F
              }
            ),
            _ && l !== S && /* @__PURE__ */ h(Rb, { $type: i, size: r, children: /* @__PURE__ */ h(xb, { status: _ }) })
          ]
        }
      ),
      i === "minimal" && /* @__PURE__ */ h(D, {}),
      !L && /* @__PURE__ */ h(Eb, { type: i, children: s && /* @__PURE__ */ h(eu, { direction: i === "vertical" ? "vertical" : "horizontal" }) })
    ] }),
    i !== "minimal" && /* @__PURE__ */ h(D, {})
  ] });
}), Cb = v.div`
  display: flex;
  flex-direction: ${({ type: e }) => e === "vertical" ? "row" : "column"};
  gap: ${({ type: e = "horizontal", $size: t = 48 }) => $b[e][t]};
  justify-content: ${({ type: e }) => e === "vertical" ? "fit-content" : "space-between"};
  flex-grow: ${({ isLast: e }) => e ? 0 : 1};
`, kb = v.div`
  display: flex;
  flex-direction: ${({ type: e }) => e === "vertical" ? "column" : "row"};
  align-items: center;
`, Sb = v.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  border-radius: 50%;
  cursor: ${({ $clickable: e }) => e ? "pointer" : "default"};
  width: ${({ $size: e }) => e === 48 ? "48px" : "24px"};
  height: ${({ $size: e }) => e === 48 ? "48px" : "24px"};
  background: ${({ theme: e, $active: t, $activeStepColor: n, $variant: r }) => t ? n : r === "alternative" ? e.colors.background.primaryElevated : e.colors.background.secondary};
  ${({ $disabled: e, theme: t }) => e && C`
      background: ${t.colors.background.secondary};
    `}
`, Tb = v.div`
  display: flex;
  flex-direction: column;
  ${({ type: e }) => e === "minimal" && C`
      padding-left: 12px;
    `}
`, Eb = v.div`
  flex-grow: 1;
  padding: 0 12px;
  ${({ type: e }) => e === "vertical" && C`
      min-height: 60px;
      padding: 12px 0;
    `}
`, Rb = v.div`
  position: absolute;
  bottom: 0;
  right: 0;
  ${({ size: e, $type: t }) => e === 48 && C`
      transform: ${t === "minimal" ? "translateX(25%)" : "translateX(50%)"};
    `}
`, v3 = A((e, t) => {
  const {
    type: n = "horizontal",
    size: r = 24,
    variant: o,
    children: i,
    divider: s = !0,
    activeStepColor: a = "brand",
    activeStep: l,
    completedSteps: c,
    errorSteps: d,
    warningSteps: u,
    onActiveStepChange: p,
    onlyForward: f,
    hideText: m,
    hideSubtitle: g,
    titleFont: y,
    subtitleFont: b,
    ...w
  } = e, x = Tt.map(
    i,
    (E, S) => ge.cloneElement(E, {
      idx: S,
      key: S
    })
  ), $ = K(() => Tt.count(i), [i]);
  return /* @__PURE__ */ h(
    bb,
    {
      size: r,
      type: n,
      variant: o,
      divider: s,
      activeStepColor: a,
      activeStep: l,
      total: $,
      onActiveStepChange: p,
      completedSteps: c,
      warningSteps: u,
      errorSteps: d,
      onlyForward: f,
      hideText: m,
      hideSubtitle: g,
      titleFont: y,
      subtitleFont: b,
      children: /* @__PURE__ */ h(Ab, { ...w, ref: t, type: n, children: x })
    }
  );
}), Ab = v.div`
  display: flex;
  width: ${({ type: e }) => e === "vertical" ? "fit-content" : "100%"};
  position: relative;
  flex-direction: ${({ type: e }) => e === "vertical" ? "column" : "horizontal"};
`, y3 = (e, t = {}) => {
  const {
    defActiveStep: n = 0,
    defCompletedSteps: r = /* @__PURE__ */ new Set(),
    defErroredSteps: o = /* @__PURE__ */ new Set(),
    defWarningSteps: i = /* @__PURE__ */ new Set()
  } = t, [s, a] = U(n), [l, c] = U(r), [d, u] = U(o), [p, f] = U(i), m = 0, g = K(() => e.length - 1, [e]), y = fe(() => {
    a(m), c(/* @__PURE__ */ new Set()), u(/* @__PURE__ */ new Set()), f(/* @__PURE__ */ new Set());
  }, []), b = fe(() => {
    a((S) => S == g ? m : S + 1);
  }, []), w = fe(() => {
    a((S) => S == m ? g : S - 1);
  }, []), x = fe(() => {
    u(
      (S) => S.has(s) ? new Set([...S].filter((F) => F !== s)) : S
    ), f(
      (S) => S.has(s) ? new Set([...S].filter((F) => F !== s)) : S
    ), c((S) => new Set(S).add(s)), b();
  }, [s]), $ = fe(() => {
    c(
      (S) => S.has(s) ? new Set([...S].filter((F) => F !== s)) : S
    ), f(
      (S) => S.has(s) ? new Set([...S].filter((F) => F !== s)) : S
    ), u((S) => new Set(S).add(s)), b();
  }, [s]), E = fe(() => {
    c(
      (S) => S.has(s) ? new Set([...S].filter((F) => F !== s)) : S
    ), u(
      (S) => S.has(s) ? new Set([...S].filter((F) => F !== s)) : S
    ), f((S) => new Set(S).add(s)), b();
  }, [s]);
  return {
    /**
     * Текущий активный шаг
     *
     */
    activeStep: s,
    /**
     * Сеттер активного шага
     *
     */
    setActiveStep: a,
    /**
     * Коллекция завершенных шагов
     *
     */
    completedSteps: l,
    /**
     * Коллекция шагов с ошибками
     *
     */
    erroredSteps: d,
    /**
     * Коллекция шагов с ожиданием
     *
     */
    warningSteps: p,
    /**
     * Функция сброса на начальное состояние
     *
     */
    handleReset: y,
    /**
     * Функция переключения на + 1 активный шаг
     *
     */
    handleNext: b,
    /**
     * Функция переключения на + 1 активный шаг
     *
     */
    handlePrev: w,
    /**
     * Функция добавления текущего шага в коллекцию завершенных и переключения на + 1 активный шаг
     *
     */
    handleComplete: x,
    /**
     * Функция добавления текущего шага в коллекцию шагов с ошибками и переключения на + 1 активный шаг
     *
     */
    handleError: $,
    /**
     * Функция добавления текущего шага в коллекцию шагов с предупреждением на + 1 активный шаг
     *
     */
    handleWarning: E
  };
}, Pb = v.div`
  display: flex;
  gap: 4px;
  width: 100%;
`, Mb = ({
  $completed: e,
  $color: t,
  $colorComplete: n,
  colors: r
}) => e ? n || r.accent.positive : t || r.background.stroke, Db = v.div(
  ({ $size: e = "m", $completed: t, $color: n, $colorComplete: r, $opacity: o, theme: { colors: i } }) => C`
    background: ${Mb({ $completed: t, $color: n, $colorComplete: r, colors: i })};
    height: ${{
    s: 4,
    m: 8
  }[e]}px;
    border-radius: 12px;
    width: 100%;
    ${o && !t && `
      opacity: ${o};
    `}
  `
), b3 = A((e, t) => {
  const {
    steps: n,
    size: r = "m",
    completedSteps: o,
    customStepColor: i,
    customCompleteStepColor: s,
    opacity: a,
    ...l
  } = e, c = K(() => new Array(n).fill(""), [n]);
  return /* @__PURE__ */ h(Pb, { ...l, ref: t, children: c.map((d, u) => /* @__PURE__ */ h(
    Db,
    {
      $size: r,
      $completed: o == null ? void 0 : o.has(u),
      $color: i,
      $colorComplete: s,
      $opacity: a
    },
    u
  )) });
}), x3 = (e) => {
  const [t, n] = U(0), [r, o] = U(/* @__PURE__ */ new Set()), i = 0, s = K(() => new Array(e).fill("").length - 1, [e]), a = () => {
    n((u) => u === s ? s : u + 1);
  }, l = () => {
    n((u) => u === i ? i : u - 1);
  }, c = fe(() => {
    o((u) => new Set(u).add(t)), a();
  }, [t]), d = fe(() => {
    o(
      (u) => u.has(t) ? new Set([...u].filter((p) => p !== t)) : new Set([...u].filter((p) => p !== t - 1))
    ), l();
  }, [t]);
  return {
    /** Коллекция завершенных шагов */
    completedSteps: r,
    /** Функция завершения текущего шага и переход на следующий */
    handleComplete: c,
    /** Функция отмены текущего шага и переход на предыдущий */
    handleCanceled: d
  };
}, gs = {
  16: {
    width: 16,
    height: 16,
    scale: 0.875
  },
  24: {
    width: 24,
    height: 24,
    scale: 0.9166
  },
  32: {
    width: 32,
    height: 32,
    scale: 0.9375
  }
}, Bb = v.span(
  ({ $disabled: e, $size: t = 24 }) => C`
    all: unset;
    flex: none;
    position: relative;
    display: inline-flex;
    width: ${gs[t].width}px;
    height: ${gs[t].height}px;

    @media (any-hover: hover) {
      &:hover {
        ${He} {
          filter: ${e ? "none" : "brightness(90%)"};
        }
      }
    }
  `
), He = v.svg`
  --checkbox__icon--display: block;
  position: relative;
  fill: none;
  flex: auto;
  transition-duration: 62.5ms;
  will-change: transform;
`, Ht = v.path(
  ({ theme: { colors: e } }) => C`
    fill: ${e.control.alternative};
  `
), Ut = v.path(
  ({ invalid: e, theme: { colors: t } }) => C`
    visibility: visible;
    stroke: ${e ? t.accent.negative : t.control.stroke};
  `
), kn = v.path(
  ({ theme: { colors: e } }) => C`
    visibility: hidden;
    fill: ${e.constant.greyscale0};
  `
), Qn = v.path(
  ({ theme: { colors: e } }) => C`
    visibility: hidden;
    fill: ${e.constant.greyscale0};
  `
), Lb = v.input(
  ({ invalid: e, useIndeterminate: t, $size: n = 24, theme: { colors: r } }) => C`
    all: unset;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    opacity: 0;
    cursor: pointer;

    &:active:not(:disabled) {
      ~ ${He} {
        transform: scale(${gs[n].scale});
      }
    }

    ${t && `
      ~ ${He} {
        ${Ht} {
          fill: ${e ? r.accent.negative : r.control.primaryActive};
        }
        ${Ut} {
          visibility: hidden;
        }
        ${Qn} {
          visibility: visible;
        }
        ${kn} {
          visibility: hidden;
        }
      }
    `}

    &:checked {
      ~ ${He} {
        ${Ht} {
          fill: ${e ? r.accent.negative : r.control.primaryActive};
        }
        ${Ut} {
          visibility: hidden;
        }
        ${kn} {
          visibility: visible;
        }
      }
    }

    &:disabled {
      cursor: not-allowed;
      ~ ${He} {
        ${Ht} {
          fill: ${r.control.inactive};
        }
        ${Ut} {
          visibility: hidden;
        }
        ${t && `
            ${Qn} {
              fill: ${r.icons.secondary};
          }
          `}
      }
    }

    &:disabled:checked {
      cursor: not-allowed;
      ~ ${He} {
        ${Ht} {
          fill: ${r.control.inactive};
        }
        ${Ut} {
          visibility: hidden;
        }
        ${kn} {
          visibility: visible;
          fill: ${r.icons.secondary};
        }
      }
    }
  `
), Ib = ({ size: e, invalid: t }) => /* @__PURE__ */ M(We, { children: [
  e === 16 && /* @__PURE__ */ M(
    He,
    {
      style: { display: "var(--checkbox__icon--display, none)" },
      "aria-hidden": !0,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h(Ht, { d: "M2.05 6.62c.13-1.75.2-2.62 1.07-3.5.88-.87 1.75-.94 3.5-1.06a18.74 18.74 0 0 1 2.76 0c1.75.12 2.62.19 3.5 1.07.87.87.94 1.74 1.07 3.49a18.76 18.76 0 0 1 0 2.77c-.13 1.74-.2 2.61-1.07 3.49-.88.87-1.75.94-3.5 1.07a18.76 18.76 0 0 1-2.77 0c-1.74-.13-2.61-.2-3.49-1.07-.87-.88-.94-1.75-1.07-3.5a18.73 18.73 0 0 1 0-2.76Z" }),
        /* @__PURE__ */ h(
          Ut,
          {
            invalid: t,
            strokeWidth: "1.5",
            d: "M2.8 6.67c.14-1.8.2-2.37.85-3.01.65-.65 1.23-.72 3.02-.86a17.98 17.98 0 0 1 2.66 0c1.8.14 2.37.2 3.02.86.64.64.71 1.22.85 3.01a17.99 17.99 0 0 1 0 2.66c-.14 1.8-.2 2.37-.85 3.02-.65.64-1.23.72-3.02.85a17.99 17.99 0 0 1-2.66 0c-1.8-.13-2.37-.2-3.02-.85-.64-.65-.71-1.23-.85-3.02a17.99 17.99 0 0 1 0-2.66Z"
          }
        ),
        /* @__PURE__ */ h(
          kn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.78 6.95a.75.75 0 0 0-1.06-1.06L7.33 8.27 6.28 7.22a.75.75 0 0 0-1.06 1.06L6.8 9.86c.3.3.77.3 1.06 0l2.92-2.91Z"
          }
        ),
        /* @__PURE__ */ h(
          Qn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.75 7.25a.75.75 0 1 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
          }
        )
      ]
    }
  ),
  e === 24 && /* @__PURE__ */ M(
    He,
    {
      style: { display: "var(--checkbox__icon--display, none)" },
      "aria-hidden": !0,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h(Ht, { d: "M3.08 9.92c.2-2.61.3-3.92 1.6-5.23C6 3.37 7.32 3.28 9.93 3.09a28.1 28.1 0 0 1 4.16 0c2.61.19 3.92.28 5.23 1.6 1.32 1.31 1.41 2.62 1.6 5.23a28.14 28.14 0 0 1 0 4.16c-.19 2.61-.28 3.92-1.6 5.24-1.3 1.3-2.62 1.4-5.23 1.6a28.14 28.14 0 0 1-4.16 0c-2.61-.2-3.92-.3-5.23-1.6-1.32-1.32-1.41-2.63-1.6-5.24a28.11 28.11 0 0 1 0-4.16Z" }),
        /* @__PURE__ */ h(
          Ut,
          {
            invalid: t,
            strokeWidth: "1.5",
            d: "M3.83 9.98c.2-2.67.3-3.68 1.39-4.76 1.08-1.09 2.1-1.2 4.76-1.39a27.36 27.36 0 0 1 4.04 0c2.67.2 3.68.3 4.76 1.39 1.09 1.08 1.2 2.1 1.39 4.76a27.32 27.32 0 0 1 0 4.04c-.2 2.67-.3 3.68-1.39 4.77-1.08 1.08-2.1 1.18-4.76 1.38a27.32 27.32 0 0 1-4.04 0c-2.67-.2-3.68-.3-4.76-1.38-1.09-1.09-1.2-2.1-1.4-4.77a27.35 27.35 0 0 1 0-4.04Z"
          }
        ),
        /* @__PURE__ */ h(
          kn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2 10.2a1 1 0 0 0-1.4-1.4L11 12.58l-1.3-1.3a1 1 0 0 0-1.4 1.42l2 2a1 1 0 0 0 1.4 0l4.5-4.5Z"
          }
        ),
        /* @__PURE__ */ h(
          Qn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z"
          }
        )
      ]
    }
  ),
  e === 32 && /* @__PURE__ */ M(
    He,
    {
      style: { display: "var(--checkbox__icon--display, none)" },
      "aria-hidden": !0,
      viewBox: "0 0 32 32",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h(Ht, { d: "M4.1 13.23c.27-3.49.4-5.23 2.15-6.98s3.5-1.88 6.98-2.14a37.47 37.47 0 0 1 5.54 0c3.49.26 5.23.39 6.98 2.14s1.88 3.5 2.14 6.98a37.47 37.47 0 0 1 0 5.54c-.26 3.49-.39 5.23-2.14 6.98s-3.5 1.88-6.98 2.14a37.47 37.47 0 0 1-5.54 0c-3.49-.26-5.23-.39-6.98-2.14s-1.88-3.49-2.14-6.98a37.47 37.47 0 0 1 0-5.54Z" }),
        /* @__PURE__ */ h(
          Ut,
          {
            invalid: t,
            strokeWidth: "2",
            d: "M4.86 13.29c.26-3.54.4-4.99 1.92-6.5 1.52-1.53 2.97-1.67 6.5-1.93a36.72 36.72 0 0 1 5.43 0c3.54.26 4.99.4 6.51 1.92 1.52 1.52 1.66 2.97 1.92 6.5a36.7 36.7 0 0 1 0 5.44c-.26 3.53-.4 4.98-1.92 6.5-1.52 1.53-2.97 1.66-6.5 1.93a36.75 36.75 0 0 1-5.43 0c-3.54-.27-4.99-.4-6.51-1.93-1.53-1.52-1.66-2.97-1.92-6.5a36.72 36.72 0 0 1 0-5.43Z"
          }
        ),
        /* @__PURE__ */ h(
          kn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.38 11.62c.5.48.5 1.28 0 1.76l-6 6c-.48.5-1.28.5-1.76 0l-2.5-2.5a1.25 1.25 0 0 1 1.76-1.76l1.62 1.61 5.12-5.11a1.25 1.25 0 0 1 1.76 0Z"
          }
        ),
        /* @__PURE__ */ h(
          Qn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 14.75a1.25 1.25 0 1 0 0 2.5h8a1.25 1.25 0 1 0 0-2.5h-8Z"
          }
        )
      ]
    }
  )
] });
function _l(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _l(Object(n), !0).forEach(function(r) {
      Fb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _l(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Fb(e, t, n) {
  return t = Vb(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Vb(e) {
  var t = Ob(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Ob(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ep = (e) => {
  throw Error(e);
}, da = (e) => {
  var t = e.label, n = e.labelledBy;
  t && n && ep("label and labelledBy cannot be passed at the same time");
  var r = K(() => ({
    "aria-label": t,
    "aria-labelledby": n
  }), [t, n]);
  return {
    labelProps: r
  };
}, ua = (e) => {
  var t = e.description, n = e.describedBy;
  t && n && ep("description and describedBy cannot be passed at the same time");
  var r = K(() => ({
    "aria-description": t,
    "aria-describedby": n
  }), [t, n]);
  return {
    descriptionProps: r
  };
}, zb = (e) => {
  var t = e.checked, n = e.posInSet, r = e.setSize, o = e.disabled, i = e.popupType, s = e.withSemanticRole, a = s === void 0 ? !0 : s, l = e.label, c = e.labelledBy, d = e.description, u = e.describedBy, p = da({
    labelledBy: c,
    label: l
  }), f = p.labelProps, m = ua({
    description: d,
    describedBy: u
  }), g = m.descriptionProps, y = K(() => dt(dt(dt({}, f), g), {}, {
    tabIndex: 0,
    role: a ? "radio" : void 0,
    "aria-disabled": o,
    "aria-checked": t,
    "aria-haspopup": i,
    "aria-posinset": n,
    "aria-setsize": r
  }), [o, t, i, n, a, r, f, g]);
  return {
    radioProps: y
  };
}, Nb = (e) => {
  var t = e.checked, n = e.posInSet, r = e.setSize, o = e.disabled, i = e.withSemanticRole, s = i === void 0 ? !0 : i, a = e.label, l = e.labelledBy, c = e.description, d = e.describedBy, u = da({
    labelledBy: l,
    label: a
  }), p = u.labelProps, f = ua({
    description: c,
    describedBy: d
  }), m = f.descriptionProps, g = K(() => dt(dt(dt({}, p), m), {}, {
    tabIndex: 0,
    role: s ? "checkbox" : void 0,
    "aria-disabled": o,
    "aria-checked": t,
    "aria-posinset": n,
    "aria-setsize": r
  }), [o, t, n, s, r, p, m]);
  return {
    checkboxProps: g
  };
}, Wb = (e) => {
  var t = e.checked, n = e.disabled, r = e.withSemanticRole, o = r === void 0 ? !0 : r, i = e.label, s = e.labelledBy, a = e.description, l = e.describedBy, c = da({
    labelledBy: s,
    label: i
  }), d = c.labelProps, u = ua({
    description: a,
    describedBy: l
  }), p = u.descriptionProps, f = K(() => dt(dt(dt({}, d), p), {}, {
    tabIndex: 0,
    role: o ? "switch" : void 0,
    "aria-disabled": n,
    "aria-checked": t
  }), [n, t, o, d, p]);
  return {
    switchProps: f
  };
};
const Wi = [null, !0, !1], tp = A((e, t) => {
  const {
    size: n = 24,
    checked: r,
    defaultChecked: o,
    onChange: i,
    invalid: s,
    useIndeterminate: a,
    nativeIndeterminateValue: l = !1,
    disabled: c,
    ...d
  } = e, u = typeof r < "u", p = typeof o < "u", [f, m] = U(
    p && o
  ), { checkboxProps: g } = Nb({
    checked: (u ? r : f) ?? l,
    disabled: c
  }), y = Wi.indexOf(f), b = y >= Wi.length - 1 ? 0 : y + 1, w = (x) => {
    u || (a ? (x.indeterminate = !0, m(Wi[b])) : m(x.target.checked)), i == null || i(x);
  };
  return /* @__PURE__ */ M(Bb, { $size: n, ref: t, $disabled: c, children: [
    /* @__PURE__ */ h(
      Lb,
      {
        checked: (u ? r : f) ?? l,
        role: g.role,
        type: "checkbox",
        onChange: w,
        disabled: c,
        $size: n,
        invalid: s,
        useIndeterminate: f === null || r === null,
        "aria-checked": g["aria-checked"],
        ...d
      }
    ),
    /* @__PURE__ */ h(Ib, { size: n, invalid: s })
  ] });
}), kt = {
  16: {
    switch: {
      size: {
        width: 28,
        height: 16
      }
    },
    switcher: {
      size: {
        width: 12,
        height: 12
      },
      translate: "2px, 2px",
      checkedTranslate: "14px, 2px",
      activeWidth: 16,
      activeCheckedTranslate: "10px, 2px"
    }
  },
  24: {
    switch: {
      size: {
        width: 42,
        height: 24
      }
    },
    switcher: {
      size: {
        width: 18,
        height: 18
      },
      translate: "3px, 3px",
      checkedTranslate: "21px, 3px",
      activeWidth: 24,
      activeCheckedTranslate: "15px, 3px"
    }
  },
  32: {
    switch: {
      size: {
        width: 56,
        height: 32
      }
    },
    switcher: {
      size: {
        width: 24,
        height: 24
      },
      translate: "4px, 4px",
      checkedTranslate: "28px, 4px",
      activeWidth: 32,
      activeCheckedTranslate: "20px, 4px"
    }
  }
}, _b = v.div(
  ({ $size: e = 24 }) => C`
    position: relative;
    width: ${kt[e].switch.size.width}px;
    height: ${kt[e].switch.size.height}px;
    outline: none;
    z-index: 0;
  `
), jb = v.input(
  ({ $size: e = 24, theme: { colors: t } }) => C`
    appearance: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    margin: 0;
    border-radius: 9999px;
    background: ${t.control.inactive};
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;

    &:checked {
      background: ${t.accent.positive};
      ~ ${uo} {
        transform: translate(${kt[e].switcher.checkedTranslate});
      }
    }

    &:active:not(:disabled) {
      ~ ${uo} {
        width: ${kt[e].switcher.activeWidth}px;
      }
    }

    &:active:checked:not(:disabled) {
      ~ ${uo} {
        transform: translate(${kt[e].switcher.activeCheckedTranslate});
      }
    }

    &:disabled {
      cursor: not-allowed;
    }

    &:focus-visible:not(:disabled) {
      outline: 1px solid ${t.accent.active};
      outline-offset: 1px;
    }
  `
), uo = v.div(
  ({ $size: e = 24, theme: { colors: t, shadows: n } }) => C`
    position: relative;
    z-index: 2;
    width: ${kt[e].switcher.size.width}px;
    height: ${kt[e].switcher.size.height}px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(${kt[e].switcher.translate});
    pointer-events: none;
    background: ${t.constant.greyscale0};
    border-radius: 9999px;
    transition: all 0.15s ease;
    box-shadow: ${n["shadow-low"]};
  `
), Hb = v.svg(
  ({ theme: { colors: e } }) => C`
    --switch__icon-lock--display: block;
    color: ${e.icons.tertiary};
    width: 16px;
    height: 16px;
  `
), Ub = () => /* @__PURE__ */ h(
  Hb,
  {
    style: { display: "var(--switch__icon-lock--display, none)" },
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ h(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.98 6.13a3.03 3.03 0 0 0-.8-.6l-.01-.14c-.09-1.64-.13-2.47-.99-3.36a4.7 4.7 0 0 0-.23-.22C10 1 9.35 1 8 1c-1.34 0-2.01 0-2.95.8l-.23.23c-.86.9-.9 1.72-.99 3.36v.13c-.29.14-.55.34-.81.6-.9.92-.93 1.72-1 3.34a12.02 12.02 0 0 0 0 1.08c.07 1.62.1 2.42 1 3.33.9.92 1.79.97 3.58 1.08a22.52 22.52 0 0 0 2.8 0c1.8-.1 2.69-.16 3.58-1.08.9-.9.93-1.71 1-3.33a12.05 12.05 0 0 0 0-1.08c-.07-1.62-.1-2.42-1-3.33ZM5.9 3.07c-.39.4-.47.64-.55 2.07a30.49 30.49 0 0 1 4.05-.1c.47.04.89.06 1.25.1-.08-1.43-.16-1.67-.55-2.07a1.7 1.7 0 0 0-.8-.5A6.52 6.52 0 0 0 8 2.5c-.72 0-1.04 0-1.3.06-.31.08-.58.28-.8.5ZM9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
      }
    )
  }
), w3 = A((e, t) => {
  const { size: n = 24, disabled: r, checked: o, defaultChecked: i, onChange: s, ...a } = e, l = typeof o < "u", c = typeof i < "u", [d, u] = U(c && i), { switchProps: p } = Wb({
    checked: l ? o : d
  }), f = (m) => {
    l || u(m.target.checked), s == null || s(m);
  };
  return /* @__PURE__ */ M(_b, { $size: n, ref: t, children: [
    /* @__PURE__ */ h(
      jb,
      {
        ...a,
        $size: n,
        role: p.role,
        type: "checkbox",
        checked: l ? o : d,
        disabled: r,
        "aria-checked": p["aria-checked"],
        onChange: f
      }
    ),
    /* @__PURE__ */ h(uo, { $size: n, children: n !== 16 && r && /* @__PURE__ */ h(Ub, {}) })
  ] });
}), vs = {
  16: {
    width: 16,
    height: 16,
    scale: 0.875
  },
  24: {
    width: 24,
    height: 24,
    scale: 0.9166
  },
  32: {
    width: 32,
    height: 32,
    scale: 0.9375
  }
}, Gb = v.span(
  ({ $disabled: e, $size: t = 24 }) => C`
    all: unset;
    flex: none;
    position: relative;
    display: inline-flex;
    width: ${vs[t].width}px;
    height: ${vs[t].height}px;

    @media (any-hover: hover) {
      &:hover {
        ${qe} {
          filter: ${e ? "none" : "brightness(90%)"};
        }
      }
    }
  `
), qe = v.svg`
  --radio__icon--display: block;
  position: relative;
  fill: none;
  flex: auto;
  transition-duration: 62.5ms;
  will-change: transform;
`, Sn = v.path(
  ({ theme: { colors: e } }) => C`
    fill: ${e.control.alternative};
  `
), Tn = v.path(
  ({ invalid: e, theme: { colors: t } }) => C`
    visibility: visible;
    stroke: ${e ? t.accent.negative : t.control.stroke};
  `
), er = v.path(
  ({ theme: { colors: e } }) => C`
    visibility: hidden;
    fill: ${e.constant.greyscale0};
  `
), Kb = v.input(
  ({ invalid: e, $size: t = 24, theme: { colors: n } }) => C`
  all: unset;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  opacity: 0;
  cursor: pointer;

  &:active:not(:disabled) {
    ~ ${qe} {
      transform: scale(${vs[t].scale});
    }
  }

  &:checked {
    ~ ${qe} {
      ${Sn} {
        fill: ${e ? n.accent.negative : n.control.primaryActive};
      }
      ${Tn} {
        visibility: hidden;
      }
      ${er} {
        visibility: visible;
      }
    }
  }

  &:disabled {
    cursor: not-allowed;
    ~ ${qe} {
      ${Sn} {
        fill: ${n.control.inactive};
      }
      ${Tn} {
        visibility: hidden;
      }
  }

  &:disabled:checked {
    cursor: not-allowed;
    ~ ${qe} {
      ${Sn} {
        fill: ${n.control.inactive};
      }
      ${Tn} {
        visibility: hidden;
      }
      ${er} {
        visibility: visible;
        fill: ${n.icons.secondary};
      }
    }
  }
`
), Yb = ({ size: e, invalid: t }) => /* @__PURE__ */ M(We, { children: [
  e === 16 && /* @__PURE__ */ M(
    qe,
    {
      style: { display: "var(--radio__icon--display, none)" },
      "aria-hidden": !0,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h(
          Sn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"
          }
        ),
        /* @__PURE__ */ h(
          Tn,
          {
            invalid: t,
            strokeWidth: "1.5",
            d: "M3 8a5 5 0 1 1 10 0A5 5 0 0 1 3 8Z"
          }
        ),
        /* @__PURE__ */ h(
          er,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
          }
        )
      ]
    }
  ),
  e === 24 && /* @__PURE__ */ M(
    qe,
    {
      style: { display: "var(--radio__icon--display, none)" },
      "aria-hidden": !0,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h(
          Sn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
          }
        ),
        /* @__PURE__ */ h(
          Tn,
          {
            invalid: t,
            strokeWidth: "1.5",
            d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
          }
        ),
        /* @__PURE__ */ h(
          er,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
          }
        )
      ]
    }
  ),
  e === 32 && /* @__PURE__ */ M(
    qe,
    {
      style: { display: "var(--radio__icon--display, none)" },
      "aria-hidden": !0,
      viewBox: "0 0 32 32",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ h(
          Sn,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 4a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z"
          }
        ),
        /* @__PURE__ */ h(
          Tn,
          {
            invalid: t,
            strokeWidth: "2",
            d: "M5 16a11 11 0 1 1 22 0 11 11 0 0 1-22 0Z"
          }
        ),
        /* @__PURE__ */ h(
          er,
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 9a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z"
          }
        )
      ]
    }
  )
] }), np = A((e, t) => {
  const { size: n = 24, disabled: r, checked: o, invalid: i = !1, ...s } = e, { radioProps: a } = zb({
    checked: o || !1,
    disabled: r
  });
  return /* @__PURE__ */ M(Gb, { $disabled: r, $size: n, ref: t, children: [
    /* @__PURE__ */ h(
      Kb,
      {
        ...s,
        type: "radio",
        $size: n,
        checked: o,
        invalid: i,
        disabled: r,
        role: a.role,
        "aria-checked": a["aria-checked"]
      }
    ),
    /* @__PURE__ */ h(Yb, { size: n, invalid: i })
  ] });
}), ai = be({
  size: "m"
}), ys = {
  16: {
    font: {
      name: "p4RegularComp",
      description: "c1RegularComp"
    },
    padding: 8
  },
  24: {
    font: {
      name: "p3RegularComp",
      description: "p4RegularComp"
    },
    padding: 10
  },
  32: {
    font: {
      name: "p2RegularComp",
      description: "p3RegularComp"
    },
    padding: 10
  }
}, Xb = v.ul(
  ({ separator: e, middle: t }) => C`
    list-style: none;
    padding: 0;
    margin: 0;

    ul {
      margin-left: 12px;
      ${e && `
    ${Gn}::after {
      display: block;
    }
    ${bs}:last-child {
      ${Gn}::after {
        display: block;
      }
    }
  `}
    }

    ${e && `
    ${Gn}::after {
      display: block;
    }
    ${bs}:last-child {
      ${Gn}::after {
        display: none;
      }
    }
  `}

    ${t && `
    ${rp} {
      align-items: center;
    }
  `}
  `
), bs = v.li``, Gn = v.label(
  ({ $size: e = 24, $disabled: t, theme: { colors: n } }) => C`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: 1fr auto 0;
    grid-column-gap: 12px;
    padding: ${`${ys[e].padding}px 0`};
    cursor: ${t ? "not-allowed" : "pointer"};

    &::after {
      content: '';
      display: none;
      position: relative;
      bottom: ${e === 24 ? "-8px" : "-10px"};
      height: 0;
      margin-top: -1px;
      border-top: 1px solid ${n.background.stroke};
    }

    @media (any-hover: hover) {
      &:hover {
        ${He}, ${qe} {
          filter: ${t ? "none" : "brightness(90%)"};
        }
      }
    }
  `
), rp = v.div(
  ({ $size: e }) => C`
    display: flex;
    grid-area: 1 / 1 / -1 / 2;
    margin: ${e === 32 ? "-2px 0" : 0};
    align-items: normal;
  `
), Zb = v(H)(
  ({ invalid: e, $disabled: t, theme: { colors: n } }) => C`
    display: flex;
    align-items: center;
    margin: 0;
    color: ${e ? n.text.negative : t ? n.text.secondary : n.text.primary};
  `
), qb = v(H)(({ invalid: e, $disabled: t, theme: { colors: n } }) => C`
    display: flex;
    align-items: center;
    margin: 0;
    align-self: center;
    color: ${e ? n.text.negative : n.text.secondary};
  `), $3 = A((e, t) => {
  const { children: n, size: r = "m", middle: o, separator: i, ...s } = e, a = K(() => ({ size: r }), [r]);
  return /* @__PURE__ */ h(ai.Provider, { value: a, children: /* @__PURE__ */ h(Xb, { ...s, separator: !!i, middle: !!o, ref: t, children: n }) });
}), Kr = { s: 16, m: 24, l: 32 }, op = A((e, t) => {
  const { children: n, disabled: r, label: o, description: i, invalid: s, ...a } = e, { size: l } = se(ai);
  return /* @__PURE__ */ M(Gn, { ...a, $size: Kr[l], $disabled: r, ref: t, children: [
    /* @__PURE__ */ h(rp, { $size: Kr[l], children: n }),
    o && /* @__PURE__ */ h(
      Zb,
      {
        font: ys[Kr[l]].font.name,
        invalid: s,
        $disabled: r,
        children: o
      }
    ),
    i && /* @__PURE__ */ h(
      qb,
      {
        font: ys[Kr[l]].font.description,
        invalid: s,
        $disabled: r,
        children: i
      }
    )
  ] });
}), Jb = { s: 16, m: 24, l: 32 }, C3 = A((e, t) => {
  const { label: n, description: r, disabled: o, invalid: i, components: s, ...a } = e, { size: l } = se(ai);
  return /* @__PURE__ */ h(
    op,
    {
      ...a,
      disabled: o,
      invalid: i,
      label: n,
      description: r,
      ref: t,
      children: /* @__PURE__ */ h(
        tp,
        {
          ...s == null ? void 0 : s.checkbox,
          disabled: o,
          invalid: i,
          size: Jb[l]
        }
      )
    }
  );
}), Qb = { s: 16, m: 24, l: 32 }, k3 = A((e, t) => {
  const { label: n, description: r, disabled: o, invalid: i, components: s, ...a } = e, { size: l } = se(ai);
  return /* @__PURE__ */ h(
    op,
    {
      ...a,
      disabled: o,
      invalid: i,
      label: n,
      description: r,
      ref: t,
      children: /* @__PURE__ */ h(np, { ...s == null ? void 0 : s.radio, disabled: o, invalid: i, size: Qb[l] })
    }
  );
}), S3 = A(
  ({ children: e, ...t }, n) => /* @__PURE__ */ h(bs, { ...t, ref: n, children: e })
), ex = $v(me, ["mobile"]), tx = wv(ex), pa = A((e, t) => /* @__PURE__ */ h(nx, { "data-testid": "flexbox", ...e, ref: t })), jl = ({
  inline: e,
  relatively: t,
  fillHeight: n,
  fillWidth: r,
  p: o,
  flexDirection: i,
  justifyContent: s,
  justifyItems: a,
  justifySelf: l,
  alignContent: c,
  alignItems: d,
  alignSelf: u,
  flexWrap: p,
  flex: f,
  flexGrow: m,
  flexShrink: g,
  flexBasis: y,
  order: b,
  gap: w,
  rowGap: x,
  columnGap: $
}) => C`
  display: ${e ? "inline-flex" : "flex"};
  position: ${t && "relative"};
  height: ${n ? "100%" : "unset"};
  width: ${r ? "100%" : "unset"};
  padding: ${Nn(o)};
  flex-direction: ${i};
  justify-content: ${s};
  justify-items: ${a};
  justify-self: ${l};
  align-content: ${c};
  align-items: ${d};
  align-self: ${u};
  flex-wrap: ${p};
  flex: ${Hr(f) && f};
  flex-grow: ${Hr(m) && m};
  flex-shrink: ${Hr(g) && g};
  flex-basis: ${Nn(y)};
  order: ${Hr(b) && b};
  gap: ${Nn(w)};
  row-gap: ${Nn(x)};
  column-gap: ${Nn($)};
`, nx = v.div`
  ${jl}

  ${({ theme: e, ...t }) => tx.reduce((n, r) => t[r] ? [
  ...n,
  C`
          @media (min-width: ${e.breakpoints[r]}px) {
            ${jl(t[r])}
          }
        `
] : n, [])}
`, rx = v.label(
  ({ $disabled: e, $align: t = "flex-start" }) => C`
    display: flex;
    align-items: ${{
    "flex-start": "flex-start",
    center: "center"
  }[t]};
    gap: 12px;
    cursor: ${e ? "not-allowed" : "pointer"};

    @media (any-hover: hover) {
      &:hover {
        ${He}, ${qe} {
          filter: ${e ? "none" : "brightness(90%)"};
        }
      }
    }
  `
), ox = v.div`
  display: flex;
`, ix = v.div`
  display: flex;
  flex-direction: column;
`, sx = v(H)(
  ({ $disabled: e, theme: { colors: t } }) => C`
    color: ${e ? t.text.secondary : t.text.primary};
  `
), ax = v(H)(({ theme: { colors: e } }) => C`
    margin-top: 4px;
    color: ${e.text.secondary};
  `), lx = v(H)(({ theme: { colors: e } }) => C`
    margin-top: 8px;
    color: ${e.text.negative};
  `), cx = v.div`
  display: flex;
  margin-left: auto;
`, ip = A((e, t) => {
  const {
    children: n,
    disabled: r,
    label: o,
    description: i,
    errorText: s,
    tooltip: a,
    align: l = "flex-start",
    ...c
  } = e;
  return /* @__PURE__ */ M(pa, { gap: 12, children: [
    /* @__PURE__ */ M(rx, { ...c, $disabled: r, $align: l, ref: t, children: [
      /* @__PURE__ */ h(ox, { children: n }),
      /* @__PURE__ */ M(ix, { children: [
        o && typeof o == "string" && /* @__PURE__ */ h(sx, { forwardedAs: "div", font: "p3RegularComp", $disabled: r, children: o }),
        o && typeof o != "string" && o,
        i && /* @__PURE__ */ h(ax, { forwardedAs: "div", font: "p4RegularComp", children: i }),
        s && /* @__PURE__ */ h(lx, { font: "p4RegularComp", children: s })
      ] })
    ] }),
    a && /* @__PURE__ */ h(cx, { children: a })
  ] });
}), T3 = A((e, t) => {
  const { disabled: n, component: r, ...o } = e;
  return /* @__PURE__ */ h(ip, { ...o, disabled: n, ref: t, children: /* @__PURE__ */ h(tp, { ...r == null ? void 0 : r.checkbox, disabled: n }) });
}), E3 = A((e, t) => {
  const { disabled: n, component: r, ...o } = e;
  return /* @__PURE__ */ h(ip, { ...o, disabled: n, ref: t, children: /* @__PURE__ */ h(np, { ...r == null ? void 0 : r.radio, disabled: n }) });
}), Ye = {
  32: {
    paddingTop: 6,
    paddingBottom: 6,
    radius: 12,
    font: "p4RegularComp"
  },
  44: {
    paddingTop: 10,
    paddingBottom: 10,
    radius: 16,
    font: "p3RegularComp"
  },
  52: {
    paddingTop: 14,
    paddingBottom: 14,
    radius: 16,
    font: "p3RegularComp"
  },
  64: {
    paddingTop: 20,
    paddingBottom: 20,
    withLabel: {
      paddingTop: 30,
      paddingBottom: 10
    },
    radius: 16,
    font: "p3RegularComp"
  },
  72: {
    paddingTop: 24,
    paddingBottom: 24,
    withLabel: {
      paddingTop: 34,
      paddingBottom: 14
    },
    withCaption: {
      up: {
        paddingTop: 34,
        paddingBottom: 14
      },
      down: {
        paddingTop: 14,
        paddingBottom: 34
      }
    },
    radius: 20,
    font: "p3RegularComp"
  }
}, Hl = {
  64: {
    onInputFocus: 10,
    default: 20
  },
  72: {
    onInputFocus: 14,
    default: 24
  }
}, Lt = (e, t) => ({
  primary: e.background.secondary,
  secondary: e.background.secondaryElevated
})[t], li = v.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`, dx = v.div(
  ({ $hasError: e, triggered: t, focused: n, $size: r, $isLoading: o, isLabelOutside: i, theme: { colors: s } }) => C`
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    pointer-events: none;
    visibility: ${o && (r === 64 || r === 72 && !i) && !t ? "hidden" : "visible"};

    ${(r === 64 || r === 72 && !i) && `
      box-sizing: border-box;
      width: 100%;
      position: absolute;
      margin-top: ${t ? Hl[r].onInputFocus : Hl[r].default}px;
      padding: 0 12px;
      z-index: 1;
      margin-bottom: 0;
    `}

    ${(r === 64 || r === 72 && !i) && t && `
      ${xs} {
        ${ae("p4RegularComp")};
      }
    `}

    ${e && !n && `
        ${xs} {
          color: ${s.text.negative};
        }
    `}
  `
), xs = v.label(
  ({ $size: e, $disabled: t, isLabelOutside: n, theme: { colors: r } }) => C`
    ${ae(e === 64 || e === 72 && !n ? "p3RegularComp" : "p4RegularComp")};
    color: ${t ? r.text.tertiary : r.text.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `
), ci = v.span`
  width: 16px;
  height: 16px;
  margin-left: 2px;
  margin-bottom: 4px;

  svg {
    margin-top: 1px;
  }
`, ux = v.div(
  ({ $isLoading: e, $captionPosition: t }) => C`
    display: flex;
    align-items: center;
    padding-left: 8px;
    pointer-events: none;
    box-sizing: border-box;
    width: 100%;
    position: absolute;
    visibility: ${e ? "hidden" : "visible"};
    top: ${t === "up" && "14px"};
    bottom: ${t === "down" && "14px"};
  `
), px = v.div(
  ({ $disabled: e, theme: { colors: t } }) => C`
    ${ae("p4RegularComp")};
    color: ${e ? t.text.tertiary : t.text.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `
), fx = v.div(
  ({
    $hasError: e,
    $size: t,
    $disabled: n,
    $readOnly: r,
    $isLoading: o,
    $variant: i,
    $hasInputValue: s,
    $withLabel: a,
    isLabelOutside: l,
    $radius: c,
    theme: { colors: d }
  }) => C`
    position: relative;
    display: flex;
    align-items: center;
    background: ${n || o ? d.background.disabled : Lt(d, i)};
    gap: 4px;
    padding-right: 8px;
    padding-left: 12px;
    outline-width: 1px;
    outline-style: solid;
    outline-color: ${e ? d.text.negative : t === 72 && l ? "transparent" : n || o ? d.background.strokeDisabled : d.background.stroke};
    border-radius: ${c || Ye[t].radius}px;
    transition: outline-color 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);

    ${!e && !n && !o && !r && `
      &:hover:not(:focus-within) {
        outline-color: ${d.control.secondaryActive};
      }
    `}

    ${!r && `
      &:has(${Ro}:focus-within) {
        outline-color: ${d.accent.active};

        ${Ro} {
          &::placeholder,
          &::-webkit-input-placeholder {
            color: ${d.text.tertiary};
          }
        }
      }
    `}

    ${(t === 64 || t === 72 && !l) && o && s && a && `
      ${sp} {
        margin-top: 20px;
      }
    `}
  `
), hx = v.div`
  width: 100%;
  position: relative;
`, Ul = ({
  $size: e,
  $withLabel: t,
  $withCaption: n,
  $captionPosition: r = "up",
  isLabelOutside: o
}) => {
  let i, s;
  return e === 64 && t ? (i = Ye[64].withLabel.paddingTop, s = Ye[64].withLabel.paddingBottom) : e === 72 && n ? (i = Ye[72].withCaption[r].paddingTop, s = Ye[72].withCaption[r].paddingBottom) : e === 72 && t && !n && !o ? (i = Ye[72].withLabel.paddingTop, s = Ye[72].withLabel.paddingBottom) : (i = Ye[e].paddingTop, s = Ye[e].paddingBottom), {
    paddingTop: i,
    paddingBottom: s
  };
}, Ro = v.input(
  ({
    $size: e,
    $withLabel: t,
    $isLoading: n,
    $withCaption: r,
    $variant: o,
    $captionPosition: i = "up",
    disabled: s,
    isLabelOutside: a,
    $inputLeftPadding: l,
    theme: { colors: c }
  }) => C`
    box-sizing: border-box;
    display: inline-block;
    width: 100%;
    border: none;
    background: transparent;
    padding-top: ${Ul({ $size: e, $withLabel: t, $withCaption: r, $captionPosition: i, isLabelOutside: a }).paddingTop}px;
    padding-bottom: ${Ul({
    $size: e,
    $withLabel: t,
    $withCaption: r,
    $captionPosition: i,
    isLabelOutside: a
  }).paddingBottom}px;
    padding-left: ${l ? `${l}px` : 0};
    padding-right: 4px;
    color: ${c.text.primary};
    ${ae(Ye[e].font)};
    cursor: text;
    outline: none;

    &:disabled {
      color: ${n ? "transparent" : c.text.tertiary};
      cursor: default;
    }

    &::placeholder,
    &::-webkit-input-placeholder {
      color: ${n ? "transparent" : s ? c.text.tertiary : c.text.secondary};
      -webkit-text-fill-color: currentcolor;
    }

    &:-webkit-autofill {
      box-shadow: inset 0 0 0 50px ${Lt(c, o)};
    }

    ${t && (e === 64 || e === 72 && !a) && `
      &:not(:focus) {
        &::placeholder {
          color: transparent;
        }
      }
    `}
  `
), Gl = v.div`
  display: flex;
`, sp = v(ia)``, fa = v(H)(
  ({ $hasError: e, theme: { colors: t } }) => C`
    display: flex;
    align-items: center;
    color: ${e ? t.text.negative : t.text.secondary};
    margin-top: 4px;
    overflow-wrap: break-word;
    word-break: break-word;
    pointer-events: none;
  `
), di = () => {
  const e = ie();
  return /* @__PURE__ */ h(q, { color: e.colors.icons.tertiary, iconPath: "granat/lock/size-16-style-outline" });
}, ui = () => {
  const e = ie();
  return /* @__PURE__ */ h(q, { iconPath: "granat/cross-circle/size-24-style-fill", color: e.colors.icons.secondary });
}, mx = typeof window < "u" ? nn : Y;
function gx(e, t, n, r) {
  const o = oe(t);
  mx(() => {
    o.current = t;
  }, [t]), Y(() => {
    const i = (n == null ? void 0 : n.current) ?? window;
    if (!(i && i.addEventListener)) return;
    const s = (a) => o.current(a);
    return i.addEventListener(e, s, r), () => {
      i.removeEventListener(e, s, r);
    };
  }, [e, n, r]);
}
const Ot = (e) => {
  const [t, n] = U(!1);
  return Y(() => {
    const r = window.matchMedia(e);
    r.matches !== t && n(r.matches);
    const o = () => n(r.matches);
    return r.addEventListener("change", o), () => r.removeEventListener("change", o);
  }, [t, e]), t;
}, vx = {
  isMobile: !1,
  isTablet: !1,
  isXs: !1,
  isSm: !1,
  isMd: !1,
  isLg: !1,
  isXL: !1
}, { tablet: Kl, desktopXS: Yl, desktopS: Xl, desktopM: Zl, desktopL: ql, desktopXL: Jl } = me, ap = be(vx), yx = ({ children: e }) => {
  const t = {
    isMobile: Ot(`(max-width:${Kl - 1}px)`),
    isTablet: Ot(`(min-width:${Kl}px) and (max-width:${Yl - 1}px)`),
    isXs: Ot(`(min-width:${Yl}px) and (max-width:${Xl - 1}px)`),
    isSm: Ot(`(min-width:${Xl}px) and (max-width:${Zl - 1}px)`),
    isMd: Ot(`(min-width:${Zl}px) and (max-width:${ql - 1}px)`),
    isLg: Ot(`(min-width:${ql}px) and (max-width:${Jl - 1}px)`),
    isXL: Ot(`(min-width:${Jl}px)`)
  };
  return /* @__PURE__ */ h(ap.Provider, { value: t, children: e });
}, Ln = () => se(ap), pi = (e, t, n = {}) => {
  const { mouseEvent: r = "click" } = n, o = oe();
  o.current = t;
  const i = (s) => {
    var a;
    !((a = e.current) != null && a.contains(s.target)) && o.current && o.current(s);
  };
  Y(() => (document.addEventListener(r, i, !0), document.addEventListener("touchend", i, !0), () => {
    document.removeEventListener(r, i, !0), document.removeEventListener("touchend", i, !0);
  }), [e, o, r]);
}, R3 = (e, t) => {
  const [n, r] = U(e);
  return Y(() => {
    const o = setTimeout(() => r(e), t || 500);
    return () => {
      clearTimeout(o);
    };
  }, [e, t]), n;
}, A3 = (e) => Y(() => e && e(), []), Ql = (e) => e ? {
  width: e.offsetWidth,
  height: e.offsetHeight
} : {
  width: 0,
  height: 0
}, bx = (e) => {
  const [t, n] = U(Ql(e ? e.current : void 0)), r = fe(
    function() {
      e.current && n(Ql(e.current));
    },
    [e]
  );
  return nn(() => {
    if (e.current)
      if (r(), typeof ResizeObserver == "function") {
        const o = new ResizeObserver(() => r());
        return o.observe(e.current), () => {
          o.disconnect();
        };
      } else
        return Ll.addEventListener("resize", r), () => {
          Ll.removeEventListener("resize", r);
        };
  }, [e.current]), t;
}, lp = (e) => {
  const {
    label: t,
    caption: n,
    captionPosition: r = "up",
    description: o,
    hasError: i,
    size: s = 44,
    value: a,
    disabled: l,
    readOnly: c,
    iconEnd: d,
    iconStart: u,
    waiting: p,
    onFocus: f,
    onBlur: m,
    onChange: g,
    children: y,
    onClear: b,
    isClearable: w,
    variant: x = "primary",
    className: $,
    clearThreshold: E = 0,
    inputWrapperRef: S = null,
    inputTypeIcon: F,
    isLabelOutside: R,
    inputLeftPadding: L,
    radius: P
  } = e, j = oe(null), _ = oe(null), G = oe(null), [D, I] = U(a), [z, O] = U(), [V, N] = U(), [B, X] = U(), te = D && String(D).length > 0, we = (Z) => {
    O(!0), N(!0), X(!0), f == null || f(Z);
  }, J = (Z) => {
    !te && O(!1), N(!1), m == null || m(Z);
  };
  pi(j, () => X(!1));
  const Q = (Z) => {
    I(Z.target.value), g == null || g(Z);
  }, ne = () => {
    var Z;
    I(""), b == null || b(), (Z = _.current) == null || Z.focus();
  };
  return Y(() => {
    I(a);
  }, [a]), Y(() => {
    te || document.activeElement == _.current ? O(!0) : O(!1);
  }, [D]), /* @__PURE__ */ M(li, { className: $, ref: j, children: [
    t && /* @__PURE__ */ M(
      dx,
      {
        $size: s,
        $hasError: i,
        triggered: z,
        focused: V,
        $isLoading: !!p,
        isLabelOutside: R,
        children: [
          /* @__PURE__ */ h(xs, { $size: s, $disabled: l, isLabelOutside: R, children: t }),
          l && /* @__PURE__ */ h(ci, { children: /* @__PURE__ */ h(di, {}) })
        ]
      }
    ),
    /* @__PURE__ */ M(
      fx,
      {
        $variant: x,
        $size: s,
        $hasError: i,
        $disabled: l,
        $readOnly: c,
        $isLoading: !!p,
        $hasInputValue: !!te,
        $withLabel: !!t,
        ref: S,
        isLabelOutside: R,
        $radius: P,
        children: [
          u && /* @__PURE__ */ h(Gl, { children: u }),
          p && p({ inputSize: s, style: { marginLeft: L } }),
          /* @__PURE__ */ M(hx, { children: [
            s === 72 && n && /* @__PURE__ */ h(ux, { $isLoading: !!p, $captionPosition: r, children: /* @__PURE__ */ h(px, { $disabled: l, children: n }) }),
            y({
              inputValue: D,
              inputRef: _,
              handleChange: Q,
              handleFocus: we,
              handleBlur: J
            })
          ] }),
          /* @__PURE__ */ M(Gl, { children: [
            d || (te && w && B && String(D).length > E && !c && !l ? /* @__PURE__ */ h(
              Ce,
              {
                variant: "ghost-secondary",
                disabled: l,
                size: 32,
                children: /* @__PURE__ */ h(ui, {}),
                onClick: ne,
                ref: G
              }
            ) : null),
            F && F
          ] })
        ]
      }
    ),
    o && /* @__PURE__ */ h(fa, { font: "c1RegularComp", $hasError: i, children: o })
  ] });
}, sn = A((e, t) => {
  const {
    label: n,
    caption: r,
    captionPosition: o,
    hasError: i,
    description: s,
    value: a,
    className: l,
    placeholder: c,
    disabled: d,
    readOnly: u,
    waiting: p,
    iconEnd: f,
    iconStart: m,
    variant: g = "primary",
    onChange: y,
    onFocus: b,
    onBlur: w,
    onClear: x,
    isClearable: $ = !0,
    type: E = "text",
    size: S = 44,
    clearThreshold: F = 0,
    inputWrapperRef: R,
    isSelect: L = !1,
    inputTypeIcon: P,
    isLabelOutside: j = !1,
    inputLeftPadding: _,
    radius: G,
    ...D
  } = e;
  return /* @__PURE__ */ h(
    lp,
    {
      value: a,
      hasError: i,
      label: n,
      caption: r,
      captionPosition: o,
      description: s,
      disabled: d,
      readOnly: u,
      waiting: p,
      size: S,
      variant: g,
      isClearable: $,
      onChange: y,
      onClear: x,
      onBlur: w,
      onFocus: b,
      className: l,
      iconEnd: f,
      iconStart: m,
      clearThreshold: F,
      inputWrapperRef: R,
      inputTypeIcon: P,
      isLabelOutside: j,
      inputLeftPadding: _,
      radius: G,
      children: ({ handleBlur: I, handleChange: z, handleFocus: O, inputRef: V, inputValue: N }) => /* @__PURE__ */ h(
        Ro,
        {
          ...D,
          placeholder: c,
          value: N,
          disabled: d || !!p,
          readOnly: L ? !0 : u,
          onChange: z,
          onFocus: O,
          onBlur: I,
          ref: Bt(V, t),
          type: E,
          $isLoading: !!p,
          $size: S,
          $withLabel: !!n,
          $variant: g,
          $withCaption: !!r,
          $captionPosition: o,
          isLabelOutside: j,
          $inputLeftPadding: _
        }
      )
    }
  );
}), P3 = ({ inputSize: e = 44, style: t }) => /* @__PURE__ */ h(sp, { size: e === 32 ? 16 : 24, style: t });
function ec(e) {
  const { anchorOffset: t = 0, focusOffset: n = 0 } = e.ownerDocument.getSelection() || {}, r = Math.min(t, n), o = Math.max(t, n);
  return [r, o];
}
function xx(e, [t, n]) {
  var r, o, i, s;
  const a = e.ownerDocument, l = a.createRange();
  l.setStart(e.firstChild || e, Math.min(t, (o = (r = e.textContent) === null || r === void 0 ? void 0 : r.length) !== null && o !== void 0 ? o : 0)), l.setEnd(e.lastChild || e, Math.min(n, (s = (i = e.textContent) === null || i === void 0 ? void 0 : i.length) !== null && s !== void 0 ? s : 0));
  const c = a.getSelection();
  c && (c.removeAllRanges(), c.addRange(l));
}
class wx {
  constructor(t) {
    this.element = t, this.maxLength = 1 / 0;
  }
  get value() {
    return this.element.innerText.replace(/\n\n$/, `
`);
  }
  set value(t) {
    this.element.innerHTML = t.replace(/\n$/, `

`);
  }
  get selectionStart() {
    return ec(this.element)[0];
  }
  get selectionEnd() {
    return ec(this.element)[1];
  }
  setSelectionRange(t, n) {
    xx(this.element, [t ?? 0, n ?? 0]);
  }
  select() {
    this.setSelectionRange(0, this.value.length);
  }
}
function $x(e) {
  const t = new wx(e);
  return new Proxy(e, {
    get(n, r) {
      if (r in t)
        return t[r];
      const o = n[r];
      return typeof o == "function" ? o.bind(n) : o;
    },
    set(n, r, o, i) {
      return Reflect.set(r in t ? t : n, r, o, i);
    }
  });
}
const Cx = (e) => e.isContentEditable ? $x(e) : e.querySelector("input,textarea") || e, kr = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class kx {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const t = this.past.pop();
    t && this.now && (this.future.push(this.now), this.updateElement(t, "historyUndo"));
  }
  redo() {
    const t = this.future.pop();
    t && this.now && (this.past.push(this.now), this.updateElement(t, "historyRedo"));
  }
  updateHistory(t) {
    if (!this.now) {
      this.now = t;
      return;
    }
    const n = this.now.value !== t.value, r = this.now.selection.some((o, i) => o !== t.selection[i]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = t);
  }
  updateElement(t, n) {
    this.now = t, this.updateElementState(t, { inputType: n, data: null });
  }
}
function Sx(e, ...t) {
  return t.every(({ value: n }) => n === e.value);
}
function Tx(e, ...t) {
  return t.every(({ value: n, selection: r }) => n === e.value && r[0] === e.selection[0] && r[1] === e.selection[1]);
}
function Ex({ value: e, selection: t }, n, r) {
  const [o, i] = t, s = typeof r == "function" ? r({ value: e, selection: t }) : r;
  return {
    value: e,
    selection: s === "replace" ? [o, Math.max(o + n.length, i)] : [o, i]
  };
}
function fi(e) {
  return typeof e == "string";
}
function tc(e, t, n, r) {
  let o = "";
  for (let i = t.length; i < e.length; i++) {
    const s = e[i] || "", a = (r == null ? void 0 : r.value[i]) === s;
    if (!fi(s) || s === n && !a)
      return o;
    o += s;
  }
  return o;
}
function cp(e, t) {
  return Array.isArray(t) ? e.length === t.length && Array.from(e).every((n, r) => {
    const o = t[r] || "";
    return fi(o) ? n === o : n.match(o);
  }) : t.test(e);
}
function Rx(e, t, n) {
  let r = null, o = null;
  const i = Array.from(e.value).reduce((a, l, c) => {
    const d = tc(t, a, l, n), u = a + d, p = t[u.length] || "";
    return r === null && c >= e.selection[0] && (r = u.length), o === null && c >= e.selection[1] && (o = u.length), fi(p) ? u + p : l.match(p) ? u + l : u;
  }, ""), s = tc(t, i, "", n);
  return {
    value: cp(i + s, t) ? i + s : i,
    selection: [r ?? i.length, o ?? i.length]
  };
}
function Ax({ value: e, selection: t }, n) {
  const [r, o] = t;
  let i = r, s = o;
  return { value: Array.from(e).reduce((l, c, d) => {
    const u = l + c;
    return r === d && (i = l.length), o === d && (s = l.length), u.match(n) ? u : l;
  }, ""), selection: [i, s] };
}
function Yr(e, t, n = null) {
  if (cp(e.value, t))
    return e;
  const { value: r, selection: o } = Array.isArray(t) ? Rx(e, t, n) : Ax(e, t);
  return {
    selection: o,
    value: Array.isArray(t) ? r.slice(0, t.length) : r
  };
}
function nc(e, t) {
  if (!Array.isArray(t))
    return e;
  const [n, r] = e.selection, o = [], i = Array.from(e.value).reduce((s, a, l) => {
    const c = t[l] || "";
    return l === n && o.push(s.length), l === r && o.push(s.length), fi(c) && c === a ? s : s + a;
  }, "");
  return o.length < 2 && o.push(...new Array(2 - o.length).fill(i.length)), {
    value: i,
    selection: [o[0], o[1]]
  };
}
class ws {
  constructor(t, n) {
    this.initialElementState = t, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const { value: r, selection: o } = Yr(this.initialElementState, this.getMaskExpression(this.initialElementState));
    this.value = r, this.selection = o;
  }
  addCharacters([t, n], r) {
    const { value: o, maskOptions: i } = this, s = this.getMaskExpression({
      value: o.slice(0, t) + r + o.slice(n),
      selection: [t + r.length, t + r.length]
    }), a = { value: o, selection: [t, n] }, l = nc(a, s), [c, d] = Ex(l, r, i.overwriteMode).selection, u = l.value.slice(0, c) + r, p = u.length, f = Yr({
      value: u + l.value.slice(d),
      selection: [p, p]
    }, s, a);
    if (// eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
    o.slice(0, c) === Yr({
      value: u,
      selection: [p, p]
    }, s, a).value || Tx(this, f))
      throw new Error("Invalid mask value");
    this.value = f.value, this.selection = f.selection;
  }
  deleteCharacters([t, n]) {
    if (t === n || !n)
      return;
    const { value: r } = this, o = this.getMaskExpression({
      value: r.slice(0, t) + r.slice(n),
      selection: [t, t]
    }), i = { value: r, selection: [t, n] }, s = nc(i, o), [a, l] = s.selection, c = s.value.slice(0, a) + s.value.slice(l), d = Yr({ value: c, selection: [a, a] }, o, i);
    this.value = d.value, this.selection = d.selection;
  }
  getMaskExpression(t) {
    const { mask: n } = this.maskOptions;
    return typeof n == "function" ? n(t) : n;
  }
}
class Px {
  constructor(t) {
    this.element = t, this.listeners = [];
  }
  listen(t, n, r) {
    const o = n;
    this.element.addEventListener(t, o, r), this.listeners.push(() => this.element.removeEventListener(t, o, r));
  }
  destroy() {
    this.listeners.forEach((t) => t());
  }
}
const Ue = {
  CTRL: 1,
  ALT: 2,
  SHIFT: 4,
  META: 8
}, tr = {
  Y: 89,
  Z: 90
};
function nr(e, t, n) {
  return e.ctrlKey === !!(t & Ue.CTRL) && e.altKey === !!(t & Ue.ALT) && e.shiftKey === !!(t & Ue.SHIFT) && e.metaKey === !!(t & Ue.META) && /**
   * We intentionally use legacy {@link KeyboardEvent#keyCode `keyCode`} property. It is more
   * "keyboard-layout"-independent than {@link KeyboardEvent#key `key`} or {@link KeyboardEvent#code `code`} properties.
   * @see {@link https://github.com/taiga-family/maskito/issues/315 `KeyboardEvent#code` issue}
   */
  e.keyCode === n;
}
function Mx(e) {
  return nr(e, Ue.CTRL, tr.Y) || // Windows
  nr(e, Ue.CTRL | Ue.SHIFT, tr.Z) || // Windows & Android
  nr(e, Ue.META | Ue.SHIFT, tr.Z);
}
function Dx(e) {
  return nr(e, Ue.CTRL, tr.Z) || // Windows & Android
  nr(e, Ue.META, tr.Z);
}
function In(e, t) {
  var n;
  const r = e.value;
  if (typeof t == "string")
    e.value = t;
  else {
    const [o, i] = t.selection;
    e.value = t.value, e.matches(":focus") && ((n = e.setSelectionRange) === null || n === void 0 || n.call(e, o, i));
  }
  e.value !== r && e.dispatchEvent(new Event(
    "input",
    /**
     * React handles this event only on bubbling phase
     *
     * here is the list of events that are processed in the capture stage, others are processed in the bubbling stage
     * https://github.com/facebook/react/blob/cb2439624f43c510007f65aea5c50a8bb97917e4/packages/react-dom-bindings/src/events/DOMPluginEventSystem.js#L222
     */
    { bubbles: !0 }
  ));
}
function Bx({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  const i = n ? e.slice(r).indexOf(`
`) + 1 || e.length : e.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : i, n ? i : o];
}
function Lx({ value: e, selection: t }, n) {
  const [r, o] = t;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((s) => Math.min(Math.max(s, 0), e.length));
}
const Ix = /\s+$/g, Fx = /^\s+/g, rc = /\s/;
function Vx({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  if (n) {
    const l = e.slice(r), [c] = l.match(Fx) || [
      ""
    ], d = l.trimStart().search(rc);
    return [
      r,
      d !== -1 ? r + c.length + d : e.length
    ];
  }
  const i = e.slice(0, o), [s] = i.match(Ix) || [""], a = i.trimEnd().split("").reverse().findIndex((l) => rc.exec(l));
  return [
    a !== -1 ? o - s.length - a : 0,
    o
  ];
}
function Ao(e = []) {
  return (t, ...n) => e.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), t);
}
function ha(e, t) {
  const n = Object.assign(Object.assign({}, kr), t), r = Ao(n.preprocessors), o = Ao(n.postprocessors), i = typeof e == "string" ? { value: e, selection: [0, 0] } : e, { elementState: s } = r({ elementState: i, data: "" }, "validation"), a = new ws(s, n), { value: l, selection: c } = o(a, i);
  return typeof e == "string" ? l : { value: l, selection: c };
}
class Ox extends kx {
  constructor(t, n) {
    super(), this.element = t, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new Px(this.element), this.options = Object.assign(Object.assign({}, kr), this.maskitoOptions), this.upcomingElementState = null, this.preprocessor = Ao(this.options.preprocessors), this.postprocessor = Ao(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (Mx(r))
        return r.preventDefault(), this.redo();
      if (Dx(r))
        return r.preventDefault(), this.undo();
    }), this.eventListener.listen("beforeinput", (r) => {
      var o, i, s;
      const a = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: Lx(this.elementState, a)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: Vx(this.elementState, a),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: Bx(this.elementState, a),
            force: !0
          });
        case "insertCompositionText":
          return;
        case "insertReplacementText":
          return;
        case "insertLineBreak":
        case "insertParagraph":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, (s = (o = r.data) !== null && o !== void 0 ? o : (
            // `event.data` for `contentEditable` is always `null` for paste/drop events
            (i = r.dataTransfer) === null || i === void 0 ? void 0 : i.getData("text/plain")
          )) !== null && s !== void 0 ? s : "");
      }
    }), this.eventListener.listen("input", () => {
      this.upcomingElementState && (this.updateElementState(this.upcomingElementState), this.upcomingElementState = null);
    }, { capture: !0 }), this.eventListener.listen("input", ({ inputType: r }) => {
      r !== "insertCompositionText" && (this.ensureValueFitsMask(), this.updateHistory(this.elementState));
    }), this.eventListener.listen("compositionend", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((t) => t == null ? void 0 : t());
  }
  updateElementState({ value: t, selection: n }, r) {
    const o = this.elementState.value;
    this.updateValue(t), this.updateSelectionRange(n), r && o !== t && this.dispatchInputEvent(r);
  }
  get elementState() {
    const { value: t, selectionStart: n, selectionEnd: r } = this.element;
    return {
      value: t,
      selection: [n ?? 0, r ?? 0]
    };
  }
  get maxLength() {
    const { maxLength: t } = this.element;
    return t === -1 ? 1 / 0 : t;
  }
  updateSelectionRange([t, n]) {
    var r;
    const { element: o } = this;
    o.matches(":focus") && (o.selectionStart !== t || o.selectionEnd !== n) && ((r = o.setSelectionRange) === null || r === void 0 || r.call(o, t, n));
  }
  updateValue(t) {
    this.element.value = t;
  }
  ensureValueFitsMask() {
    this.updateElementState(ha(this.elementState, this.options), {
      inputType: "insertText",
      data: null
    });
  }
  dispatchInputEvent(t = {
    inputType: "insertText",
    data: null
  }) {
    globalThis.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, t), { bubbles: !0, cancelable: !1 })));
  }
  handleDelete({ event: t, selection: n, isForward: r, force: o = !1 }) {
    const i = {
      value: this.elementState.value,
      selection: n
    }, [s, a] = i.selection, { elementState: l } = this.preprocessor({
      elementState: i,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), c = new ws(l, this.options), [d, u] = l.selection;
    c.deleteCharacters([d, u]);
    const p = this.postprocessor(c, i);
    if (!(i.value.slice(0, s) + i.value.slice(a) === p.value && !o && !this.element.isContentEditable)) {
      if (Sx(i, l, c, p))
        return t.preventDefault(), this.updateSelectionRange(r ? [u, u] : [d, d]);
      this.upcomingElementState = p;
    }
  }
  handleInsert(t, n) {
    const { options: r, maxLength: o, element: i, elementState: s } = this, { elementState: a, data: l = n } = this.preprocessor({
      data: n,
      elementState: s
    }, "insert"), c = new ws(a, r);
    try {
      c.addCharacters(a.selection, l);
    } catch {
      return t.preventDefault();
    }
    const [d, u] = a.selection, p = s.value.slice(0, d) + n + s.value.slice(u), f = this.postprocessor(c, s);
    if (f.value.length > o)
      return t.preventDefault();
    (p !== f.value || i.isContentEditable) && (this.upcomingElementState = f, r.overwriteMode === "replace" && p.length > o && this.dispatchInputEvent({ inputType: "insertText", data: n }));
  }
  handleEnter(t) {
    (this.isTextArea || this.element.isContentEditable) && this.handleInsert(t, `
`);
  }
}
const oc = typeof window < "u" ? nn : Y;
function zx(e) {
  return e && typeof e == "object" && "then" in e;
}
const dp = ({
  options: e = null,
  elementPredicate: t = Cx
} = {}) => {
  const [n, r] = U(null), [o, i] = U(null), s = fe((c) => {
    r(c);
  }, []), a = oe(t), l = oe(e);
  return a.current = t, l.current = e, oc(() => {
    if (!n)
      return;
    const c = t(n);
    zx(c) ? c.then((d) => {
      a.current === t && l.current === e && i(d);
    }) : i(c);
  }, [n, t, a, e, l]), oc(() => {
    if (!o || !e)
      return;
    const c = new Ox(o, e);
    return () => {
      c.destroy(), i(null);
    };
  }, [e, o]), s;
}, Sr = A((e, t) => {
  const {
    label: n,
    hasError: r,
    description: o,
    value: i,
    className: s,
    placeholder: a,
    disabled: l,
    readOnly: c,
    waiting: d,
    iconEnd: u,
    iconStart: p,
    variant: f = "primary",
    onChange: m,
    onFocus: g,
    onBlur: y,
    onClear: b,
    isClearable: w = !0,
    type: x = "text",
    size: $ = 44,
    clearThreshold: E = 0,
    inputWrapperRef: S,
    isSelect: F,
    inputTypeIcon: R,
    options: L,
    isLabelOutside: P,
    inputLeftPadding: j,
    radius: _,
    ...G
  } = e, D = dp({ options: L });
  return /* @__PURE__ */ h(
    lp,
    {
      value: i,
      hasError: r,
      label: n,
      description: o,
      disabled: l,
      readOnly: c,
      waiting: d,
      size: $,
      variant: f,
      isClearable: w,
      onChange: m,
      onClear: b,
      onBlur: y,
      onFocus: g,
      className: s,
      iconEnd: u,
      iconStart: p,
      clearThreshold: E,
      inputWrapperRef: S,
      inputTypeIcon: R,
      isLabelOutside: P,
      inputLeftPadding: j,
      radius: _,
      children: ({ handleBlur: I, handleFocus: z, inputRef: O, handleChange: V, inputValue: N }) => /* @__PURE__ */ h(
        Ro,
        {
          ...G,
          ref: Bt(D, O, t),
          placeholder: a,
          value: N,
          disabled: l || !!d,
          readOnly: F ? !0 : c,
          onInput: V,
          onFocus: z,
          onBlur: I,
          type: x,
          $isLoading: !!d,
          $size: $,
          $withLabel: !!n,
          $variant: f,
          isLabelOutside: P,
          $inputLeftPadding: j
        }
      )
    }
  );
});
function Qt(e, t, n) {
  const r = Math.min(Number(n), Math.max(Number(t), Number(e)));
  return e instanceof Date ? new Date(r) : r;
}
function Nx(e) {
  return e.replaceAll(/\W/g, "").length;
}
const up = (e) => {
  var t, n, r, o, i, s;
  return {
    day: (n = (t = e.match(/d/g)) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0,
    month: (o = (r = e.match(/m/g)) === null || r === void 0 ? void 0 : r.length) !== null && o !== void 0 ? o : 0,
    year: (s = (i = e.match(/y/g)) === null || i === void 0 ? void 0 : i.length) !== null && s !== void 0 ? s : 0
  };
};
function Wx(e) {
  return {
    day: String(e.getDate()).padStart(2, "0"),
    month: String(e.getMonth() + 1).padStart(2, "0"),
    year: String(e.getFullYear()).padStart(4, "0"),
    hours: String(e.getHours()).padStart(2, "0"),
    minutes: String(e.getMinutes()).padStart(2, "0"),
    seconds: String(e.getSeconds()).padStart(2, "0"),
    milliseconds: String(e.getMilliseconds()).padStart(3, "0")
  };
}
function _x(e, t) {
  return e.length < t.length ? !1 : e.split(/\D/).every((n) => !/^0+$/.exec(n));
}
function pp(e, t, n) {
  const r = Nx(t);
  return e.replace(n, "").match(new RegExp(`(\\D*\\d[^\\d\\s]*){1,${r}}`, "g")) || [];
}
function ma(e, t) {
  const n = t.replaceAll(/[^dmy]/g, ""), r = e.replaceAll(/\D+/g, ""), o = {
    day: r.slice(n.indexOf("d"), n.lastIndexOf("d") + 1),
    month: r.slice(n.indexOf("m"), n.lastIndexOf("m") + 1),
    year: r.slice(n.indexOf("y"), n.lastIndexOf("y") + 1)
  };
  return Object.fromEntries(Object.entries(o).filter(([i, s]) => !!s).sort(([i], [s]) => t.toLowerCase().indexOf(i.slice(0, 1)) > t.toLowerCase().indexOf(s.slice(0, 1)) ? 1 : -1));
}
function jx(e, t) {
  var n, r, o, i, s, a, l;
  const c = ((n = e.year) === null || n === void 0 ? void 0 : n.length) === 2 ? `20${e.year}` : e.year, d = new Date(Number(c ?? "0"), Number((r = e.month) !== null && r !== void 0 ? r : "1") - 1, Number((o = e.day) !== null && o !== void 0 ? o : "1"), Number((i = void 0) !== null && i !== void 0 ? i : "0"), Number((s = void 0) !== null && s !== void 0 ? s : "0"), Number((a = void 0) !== null && a !== void 0 ? a : "0"), Number((l = void 0) !== null && l !== void 0 ? l : "0"));
  return d.setFullYear(Number(c ?? "0")), d;
}
const fp = ", ";
function fr({ day: e, month: t, year: n, hours: r, minutes: o, seconds: i, milliseconds: s }, { dateMode: a, dateTimeSeparator: l = fp, timeMode: c }) {
  var d;
  const u = ((d = a.match(/y/g)) === null || d === void 0 ? void 0 : d.length) === 2 ? n == null ? void 0 : n.slice(-2) : n;
  return (a + (c ? l + c : "")).replaceAll(/d+/g, e ?? "").replaceAll(/m+/g, t ?? "").replaceAll(/y+/g, u ?? "").replaceAll(/H+/g, r ?? "").replaceAll("MSS", s ?? "").replaceAll(/M+/g, o ?? "").replaceAll(/S+/g, i ?? "").replaceAll(/^\D+/g, "").replaceAll(/\D+$/g, "");
}
const hp = {
  day: 31,
  month: 12,
  year: 9999
}, Hx = [".", ",", "б", "ю"], Ux = /* @__PURE__ */ new Date("0001-01-01"), Gx = /* @__PURE__ */ new Date("9999-12-31"), Kx = {
  hours: 23,
  minutes: 59,
  seconds: 59,
  milliseconds: 999
}, ga = [":", "."], mp = {
  hours: 2,
  minutes: 2,
  seconds: 2,
  milliseconds: 3
}, Yx = " ", Xx = "​", gp = "–", vp = "—", Po = "-", $s = "−", yp = "ー", Zx = ":", qx = "：";
function Jx({ dateString: e, dateModeTemplate: t, dateSegmentsSeparator: n, offset: r, selection: [o, i] }) {
  const s = ma(e, t), a = Object.entries(s), l = {};
  for (const [u, p] of a) {
    const f = fr(l, {
      dateMode: t
    }), m = hp[u], g = f.length && n.length, y = r + f.length + g + up(t)[u], b = y >= o && y === i;
    if (b && Number(p) > Number(m))
      return { validatedDateString: "", updatedSelection: [o, i] };
    if (b && Number(p) < 1)
      return { validatedDateString: "", updatedSelection: [o, i] };
    l[u] = p;
  }
  const c = fr(l, {
    dateMode: t
  }), d = c.length - e.length;
  return {
    validatedDateString: c,
    updatedSelection: [
      o + d,
      i + d
    ]
  };
}
const bp = /[\\^$.*+?()[\]{}|]/g, Qx = new RegExp(bp.source);
function Re(e) {
  return e && Qx.test(e) ? e.replaceAll(bp, String.raw`\$&`) : e;
}
function Ke(e, { prefix: t, postfix: n }) {
  var r, o;
  const i = new RegExp(`^${Re(t)}`), s = new RegExp(`${Re(n)}$`), [a = ""] = (r = e.match(i)) !== null && r !== void 0 ? r : [], [l = ""] = (o = e.match(s)) !== null && o !== void 0 ? o : [], c = e.replace(i, "").replace(s, "");
  return { extractedPrefix: a, extractedPostfix: l, cleanValue: c };
}
function e1(e, t) {
  let n = "";
  for (let r = 0; r < e.length; r++) {
    if (e[r] !== t[r])
      return n;
    n += e[r];
  }
  return n;
}
function Tr(e) {
  return e;
}
const t1 = /^0+$/;
function Mo(e, t, n = 0) {
  const r = e.padEnd(t.length, "0");
  if (Number(r) <= Number(t))
    return { validatedSegmentValue: e, prefixedZeroesCount: n };
  if (r.endsWith("0"))
    return Mo(`0${e.slice(0, t.length - 1)}`, t, n + 1);
  const o = e.slice(0, t.length - 1);
  return t1.exec(o) ? { validatedSegmentValue: "", prefixedZeroesCount: n } : Mo(`${o}0`, t, n);
}
function ic(e) {
  return e.replaceAll(new RegExp(qx, "g"), Zx);
}
function sc(e) {
  return e.replaceAll(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248));
}
function n1() {
  return ({ elementState: e, data: t }) => {
    const { value: n, selection: r } = e;
    return {
      elementState: {
        selection: r,
        value: ic(n)
      },
      data: ic(t)
    };
  };
}
function r1({ dateModeTemplate: e, dateSegmentSeparator: t, splitFn: n, uniteFn: r }) {
  return ({ value: o, selection: i }) => {
    var s;
    const [a, l] = i, { dateStrings: c, restPart: d = "" } = n(o), u = [];
    let p = 0;
    c.forEach((m) => {
      const g = ma(m, e), b = Object.entries(g).reduce((w, [x, $]) => {
        const { validatedSegmentValue: E, prefixedZeroesCount: S } = Mo($, `${hp[x]}`);
        return p += S, Object.assign(Object.assign({}, w), { [x]: E });
      }, {});
      u.push(fr(b, { dateMode: e }));
    });
    const f = r(u, o) + (!((s = c[c.length - 1]) === null || s === void 0) && s.endsWith(t) ? t : "") + d;
    return p && f.slice(l + p, l + p + t.length) === t && (p += t.length), {
      selection: [a + p, l + p],
      value: f
    };
  };
}
function va() {
  return ({ elementState: e, data: t }) => {
    const { value: n, selection: r } = e;
    return {
      elementState: {
        selection: r,
        value: sc(n)
      },
      data: sc(t)
    };
  };
}
function o1(e, t) {
  const n = up(t);
  return Object.fromEntries(Object.entries(e).map(([r, o]) => {
    const i = n[r];
    return [
      r,
      o.length === i && /^0+$/.exec(o) ? "1".padStart(i, "0") : o
    ];
  }));
}
function i1({ dateModeTemplate: e, min: t = Ux, max: n = Gx, rangeSeparator: r = "", dateSegmentSeparator: o = "." }) {
  return ({ value: i, selection: s }) => {
    const a = r && i.endsWith(r), l = pp(i, e, r);
    let c = "";
    for (const d of l) {
      c += c ? r : "";
      const u = ma(d, e);
      if (!_x(d, e)) {
        const m = o1(u, e), g = fr(m, { dateMode: e }), y = d.endsWith(o) ? o : "";
        c += g + y;
        continue;
      }
      const p = jx(u), f = Qt(p, t, n);
      c += fr(Wx(f), {
        dateMode: e
      });
    }
    return {
      selection: s,
      value: c + (a ? r : "")
    };
  };
}
function s1({ dateModeTemplate: e, dateSegmentsSeparator: t, rangeSeparator: n = "", dateTimeSeparator: r = fp }) {
  return ({ elementState: o, data: i }) => {
    var s;
    const a = n ? new RegExp(`${n}|-`) : r, l = i.split(a), c = i.includes(r) ? [(s = l[0]) !== null && s !== void 0 ? s : ""] : l;
    if (c.every((d) => d.trim().split(/\D/).filter(Boolean).length === e.split(t).length)) {
      const d = c.map((u) => a1(u, e, t)).join(n);
      return {
        elementState: o,
        data: `${d}${i.includes(r) && r + l[1] || ""}`
      };
    }
    return { elementState: o, data: i };
  };
}
function a1(e, t, n) {
  const r = e.split(/\D/).filter(Boolean), o = t.split(n);
  return r.map((s, a) => {
    var l, c;
    return a === o.length - 1 ? s : s.padStart((c = (l = o[a]) === null || l === void 0 ? void 0 : l.length) !== null && c !== void 0 ? c : 0, "0");
  }).join(n);
}
function l1(e) {
  const t = new RegExp(`${Re(e)}$`);
  return e ? ({ value: n, selection: r }, o) => {
    if (!n && !o.value.endsWith(e))
      return { value: n, selection: r };
    if (!n.endsWith(e) && !o.value.endsWith(e))
      return { selection: r, value: n + e };
    const i = o.value.replace(t, ""), s = o.selection[1] >= i.length, a = e1(i, n);
    return {
      selection: r,
      value: Array.from(e).reverse().reduce((l, c, d) => {
        const u = l.length - 1 - d, p = a[u] === c && s;
        return l[u] !== c || p ? l.slice(0, u + 1) + c + l.slice(u + 1) : l;
      }, n)
    };
  } : Tr;
}
function xp(e) {
  return e ? ({ value: t, selection: n }, r) => {
    if (t.startsWith(e) || // already valid
    !t && !r.value.startsWith(e))
      return { value: t, selection: n };
    const [o, i] = n, s = Array.from(e).reduce((l, c, d) => l[d] === c ? l : l.slice(0, d) + c + l.slice(d), t), a = s.length - t.length;
    return {
      selection: [o + a, i + a],
      value: s
    };
  } : Tr;
}
function c1({ dateModeTemplate: e, dateSegmentsSeparator: t, rangeSeparator: n = "" }) {
  return ({ elementState: r, data: o }) => {
    const { value: i, selection: s } = r;
    if (o === t)
      return {
        elementState: r,
        data: s[0] === i.length ? o : ""
      };
    const a = o.replaceAll(new RegExp(`[^\\d${Re(t)}${n}]`, "g"), "");
    if (!a)
      return { elementState: r, data: "" };
    const [l, c] = s;
    let d = c + o.length;
    const u = i.slice(0, l) + a + i.slice(d), p = pp(u, e, n);
    let f = "";
    const m = !!n && u.includes(n);
    for (const y of p) {
      const { validatedDateString: b, updatedSelection: w } = Jx({
        dateString: y,
        dateModeTemplate: e,
        dateSegmentsSeparator: t,
        offset: f.length,
        selection: [l, d]
      });
      if (y && !b)
        return { elementState: r, data: "" };
      d = w[1], f += m && !f ? b + n : b;
    }
    const g = f.slice(l, d);
    return {
      elementState: {
        selection: s,
        value: f.slice(0, l) + g.split(t).map((y) => "0".repeat(y.length)).join(t) + f.slice(d)
      },
      data: g
    };
  };
}
function Er(e, t, n) {
  return (r, o) => {
    const i = () => t(r, o);
    return r.addEventListener(e, i, n), () => r.removeEventListener(e, i, n);
  };
}
function wp(e) {
  return Er("focus", (t) => {
    t.value || In(t, e);
  });
}
function $p(e) {
  return (t) => {
    const n = t.ownerDocument;
    let r = 0;
    const o = () => r++, i = () => {
      r = Math.max(--r, 0);
    }, s = () => {
      var a, l;
      if (!t.matches(":focus"))
        return;
      if (r)
        return n.addEventListener("mouseup", s, {
          once: !0,
          passive: !0
        });
      const c = (a = t.selectionStart) !== null && a !== void 0 ? a : 0, d = (l = t.selectionEnd) !== null && l !== void 0 ? l : 0, [u, p] = e(t.value, [c, d]);
      (u > c || p < d) && t.setSelectionRange(Qt(c, u, p), Qt(d, u, p));
    };
    return n.addEventListener("selectionchange", s, { passive: !0 }), t.addEventListener("mousedown", o, { passive: !0 }), n.addEventListener("mouseup", i, { passive: !0 }), () => {
      n.removeEventListener("selectionchange", s), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", i);
    };
  };
}
function Cp(e) {
  return Er("blur", (t) => {
    t.value === e && In(t, "");
  });
}
const d1 = () => {
};
function u1({ step: e, fullMode: t, timeSegmentMaxValues: n }) {
  const r = p1(t);
  return e <= 0 ? d1 : (o) => {
    const i = (s) => {
      var a;
      if (s.key !== "ArrowUp" && s.key !== "ArrowDown")
        return;
      s.preventDefault();
      const l = (a = o.selectionStart) !== null && a !== void 0 ? a : 0, c = f1({
        segmentsIndexes: r,
        selectionStart: l
      });
      if (!c)
        return;
      const d = h1({
        selection: r.get(c),
        value: o.value,
        toAdd: s.key === "ArrowUp" ? e : -e,
        max: n[c]
      });
      In(o, {
        value: d,
        selection: [l, l]
      });
    };
    return o.addEventListener("keydown", i), () => o.removeEventListener("keydown", i);
  };
}
function p1(e) {
  return /* @__PURE__ */ new Map([
    ["hours", Xr(e, "HH")],
    ["milliseconds", Xr(e, "MSS")],
    ["minutes", Xr(e, "MM")],
    ["seconds", Xr(e, "SS")]
  ]);
}
function Xr(e, t) {
  const n = e.indexOf(t);
  return n === -1 ? [-1, -1] : [n, n + t.length];
}
function f1({ segmentsIndexes: e, selectionStart: t }) {
  for (const [n, r] of e.entries()) {
    const [o, i] = r;
    if (o <= t && t <= i)
      return n;
  }
  return null;
}
function h1({ selection: e, value: t, toAdd: n, max: r }) {
  const [o, i] = e, s = Number(t.slice(o, i).padEnd(i - o, "0")), a = m1(s + n, r + 1);
  return t.slice(0, o) + String(a).padStart(i - o, "0") + t.slice(i, t.length);
}
function m1(e, t) {
  return e < 0 && (e += Math.floor(Math.abs(e) / t + 1) * t), e % t;
}
function kp() {
  return ({ elementState: e }, t) => {
    const { value: n, selection: r } = e;
    if (!n || g1(n, r))
      return { elementState: e };
    const [o, i] = r, s = n.slice(o, i).replaceAll(/\d/g, "0"), a = n.slice(0, o) + s + n.slice(i);
    return t === "validation" || t === "insert" && o === i ? {
      elementState: { selection: r, value: a }
    } : {
      elementState: {
        selection: t === "deleteBackward" || t === "insert" ? [o, o] : [i, i],
        value: a
      }
    };
  };
}
function g1(e, [t, n]) {
  return n === e.length;
}
function v1({ mode: e, separator: t = ".", max: n, min: r }) {
  const o = e.split("/").join(t);
  return Object.assign(Object.assign({}, kr), { mask: Array.from(o).map((i) => t.includes(i) ? i : /\d/), overwriteMode: "replace", preprocessors: [
    va(),
    kp(),
    s1({
      dateModeTemplate: o,
      dateSegmentsSeparator: t
    }),
    c1({
      dateModeTemplate: o,
      dateSegmentsSeparator: t
    })
  ], postprocessors: [
    r1({
      dateModeTemplate: o,
      dateSegmentSeparator: t,
      splitFn: (i) => ({ dateStrings: [i] }),
      uniteFn: ([i = ""]) => i
    }),
    i1({
      min: r,
      max: n,
      dateModeTemplate: o,
      dateSegmentSeparator: t
    })
  ] });
}
function y1(e, t) {
  return Object.fromEntries(Object.entries(e).map(([n, r]) => [
    n,
    t(String(r), mp[n])
  ]));
}
function b1(e) {
  return y1(e, (t, n) => t.padStart(n, "0"));
}
const x1 = {
  HH: "hours",
  MM: "minutes",
  SS: "seconds",
  MSS: "milliseconds"
};
function w1(e, t) {
  const n = e.replaceAll(/\D+/g, "");
  let r = 0;
  return Object.fromEntries(t.split(/\W/).map((o) => {
    const i = n.slice(r, r + o.length);
    return r += o.length, [x1[o], i];
  }));
}
const $1 = /^\D*/, C1 = /\D*$/;
function ac({ hours: e = "", minutes: t = "", seconds: n = "", milliseconds: r = "" }) {
  return `${e}:${t}:${n}.${r}`.replace($1, "").replace(C1, "");
}
const k1 = new RegExp(`[${ga.map(Re).join("")}]$`);
function lc({ timeString: e, paddedMaxValues: t, offset: n, selection: [r, o], timeMode: i }) {
  const s = w1(e, i), a = Object.entries(s), l = {};
  let c = 0;
  for (const [f, m] of a) {
    const g = ac(l), y = t[f], b = g.length && 1, w = n + g.length + b + mp[f];
    if (w >= r && w <= o && Number(m) > Number(y))
      return { validatedTimeString: "", updatedTimeSelection: [r, o] };
    const { validatedSegmentValue: $, prefixedZeroesCount: E } = Mo(m, `${y}`);
    c += E, l[f] = $;
  }
  const [d = ""] = e.match(k1) || [], u = ac(l) + d, p = Math.max(u.length - e.length, 0);
  return {
    validatedTimeString: u,
    updatedTimeSelection: [
      r + c + p,
      o + c + p
    ]
  };
}
function S1({ prefix: e, postfix: t }) {
  return ({ elementState: n, data: r }) => {
    const { cleanValue: o } = Ke(r, {
      prefix: e,
      postfix: t
    });
    return {
      elementState: n,
      data: o
    };
  };
}
function Sp({ decimalSeparator: e, isNegativeAllowed: t, precision: n, thousandSeparator: r, prefix: o, postfix: i, decimalPseudoSeparators: s = [], pseudoMinuses: a = [], minusSign: l }) {
  const c = cc(o), d = String.raw`\d`, u = t ? `[${l}${a.map((y) => `\\${y}`).join("")}]?` : "", p = r ? `[${d}${Re(r).replaceAll(/\s/g, String.raw`\s`)}]*` : `[${d}]*`, f = Number.isFinite(n) ? n : "", m = n > 0 ? `([${Re(e)}${s.map(Re).join("")}]${d}{0,${f}})?` : "", g = cc(i);
  return new RegExp(`^${c}${u}${p}${m}${g}$`);
}
function cc(e) {
  return e ? `${e.split("").map((t) => `${Re(t)}?`).join("")}` : "";
}
function ya(e, t = ".") {
  const n = !!new RegExp(`^\\D*[${$s}\\${Po}${gp}${vp}${yp}]`).exec(e), r = Re(t), o = e.replaceAll(new RegExp(`${r}(?!\\d)`, "g"), "").replaceAll(new RegExp(`[^\\d${r}]`, "g"), "").replace(t, ".");
  return o ? +`${n ? Po : ""}${o}` : NaN;
}
function T1(e) {
  var t;
  const n = String(e), [r = "", o] = n.split("e-");
  let i = n;
  if (o) {
    const [, s] = r.split("."), a = Number(o) + ((t = s == null ? void 0 : s.length) !== null && t !== void 0 ? t : 0);
    i = e.toFixed(a);
  }
  return i;
}
function Tp(e, { decimalSeparator: t, thousandSeparator: n }) {
  const [r = "", o = ""] = e.split(t), [, i = "", s = ""] = new RegExp(`([^\\d${Re(n)}]+)?(.*)`).exec(r) || [];
  return { minus: i, integerPart: s, decimalPart: o };
}
function E1({ decimalSeparator: e, thousandSeparator: t, decimalPseudoSeparators: n = Hx }) {
  return n.filter((r) => r !== t && r !== e);
}
function R1({ decimalSeparator: e, precision: t, decimalZeroPadding: n, prefix: r, postfix: o }) {
  return t <= 0 || !n ? Tr : ({ value: i, selection: s }) => {
    const { cleanValue: a, extractedPrefix: l, extractedPostfix: c } = Ke(i, {
      prefix: r,
      postfix: o
    });
    if (Number.isNaN(ya(a, e)))
      return { value: i, selection: s };
    const [d, u = ""] = a.split(e);
    return {
      value: l + d + e + u.padEnd(t, "0") + c,
      selection: s
    };
  };
}
function A1({ prefix: e, postfix: t, decimalSeparator: n, thousandSeparator: r }) {
  return ({ value: o, selection: i }) => {
    const [s] = i, { cleanValue: a, extractedPrefix: l, extractedPostfix: c } = Ke(o, {
      prefix: e,
      postfix: t
    }), { minus: d, integerPart: u, decimalPart: p } = Tp(a, {
      decimalSeparator: n,
      thousandSeparator: r
    }), f = !u && !p && a.includes(n);
    return !u && !Number(p) && s === (d + l).length || f ? {
      selection: i,
      value: l + d + c
    } : { value: o, selection: i };
  };
}
function P1({ decimalSeparator: e, decimalPseudoSeparators: t, pseudoMinuses: n, prefix: r, postfix: o, minusSign: i }) {
  let s = !0;
  const a = Sp({
    decimalSeparator: e,
    decimalPseudoSeparators: t,
    pseudoMinuses: n,
    prefix: "",
    postfix: "",
    thousandSeparator: "",
    precision: 1 / 0,
    isNegativeAllowed: !0,
    minusSign: i
  });
  return ({ elementState: l, data: c }) => {
    if (!s)
      return { elementState: l, data: c };
    s = !1;
    const { value: d, selection: u } = l, [p, f] = u, { extractedPrefix: m, cleanValue: g, extractedPostfix: y } = Ke(d, {
      prefix: r,
      postfix: o
    }), b = ha({
      selection: [
        Math.max(p - m.length, 0),
        Qt(f - m.length, 0, g.length)
      ],
      value: g
    }, {
      mask: a
    }), [w, x] = b.selection;
    return {
      elementState: {
        selection: [
          w + m.length,
          x + m.length
        ],
        value: m + b.value + y
      },
      data: c
    };
  };
}
function M1({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = (s) => {
    const a = Re(t);
    return s.replace(
      // all leading zeroes followed by another zero
      new RegExp(`^(\\D+)?[0${a}]+(?=0)`),
      "$1"
    ).replace(
      // zero followed by not-zero digit
      new RegExp(`^(\\D+)?[0${a}]+(?=[1-9])`),
      "$1"
    );
  }, i = (s, a) => {
    const l = s.slice(0, a), c = s.slice(a).startsWith("0");
    return l.length - o(l).length + (c ? 1 : 0);
  };
  return ({ value: s, selection: a }) => {
    const [l, c] = a, { cleanValue: d, extractedPrefix: u, extractedPostfix: p } = Ke(s, {
      prefix: n,
      postfix: r
    }), f = d.includes(e), [m = "", g = ""] = d.split(e), y = o(m);
    if (m === y)
      return { value: s, selection: a };
    const b = l - i(s, l), w = c - i(s, c);
    return {
      value: u + y + (f ? e : "") + g + p,
      selection: [Math.max(b, 0), Math.max(w, 0)]
    };
  };
}
function D1({ min: e, max: t, decimalSeparator: n, minusSign: r }) {
  return ({ value: o, selection: i }) => {
    const s = ya(o, n), a = (
      /**
       * We cannot limit lower bound if user enters positive number.
       * The same for upper bound and negative number.
       * ___
       * @example (min = 5)
       * Empty input => Without this condition user cannot type 42 (the first digit will be rejected)
       * ___
       * @example (max = -10)
       * Value is -10 => Without this condition user cannot delete 0 to enter another digit
       */
      s > 0 ? Math.min(s, t) : Math.max(s, e)
    );
    if (s && a !== s) {
      const l = `${a}`.replace(".", n).replace(Po, r);
      return {
        value: l,
        selection: [l.length, l.length]
      };
    }
    return {
      value: o,
      selection: i
    };
  };
}
function B1({ decimalSeparator: e, thousandSeparator: t, decimalZeroPadding: n }) {
  return ({ elementState: r, data: o }, i) => {
    const { value: s, selection: a } = r, [l, c] = a, d = s.slice(l, c), u = n ? [e, t] : [t], p = n && l > s.indexOf(e) && !!d.match(/^0+$/gi);
    return i !== "deleteBackward" && i !== "deleteForward" || !u.includes(d) && !p ? {
      elementState: r,
      data: o
    } : {
      elementState: {
        value: s,
        selection: i === "deleteForward" ? [c, c] : [l, l]
      },
      data: o
    };
  };
}
function L1({ decimalSeparator: e, precision: t, prefix: n, postfix: r }) {
  const o = new RegExp(`^\\D*${Re(e)}`);
  return ({ elementState: i, data: s }) => {
    const { value: a, selection: l } = i, { cleanValue: c, extractedPrefix: d } = Ke(a, {
      prefix: n,
      postfix: r
    }), [u, p] = l, f = Qt(u - d.length, 0, c.length), m = Qt(p - d.length, 0, c.length);
    if (t <= 0 || c.slice(0, f).includes(e) || c.slice(m).includes(e) || !s.match(o))
      return { elementState: i, data: s };
    const g = /\d+/.exec(c.slice(0, f));
    return {
      elementState: i,
      data: g ? s : `0${s}`
    };
  };
}
function dc({ validCharacter: e, pseudoCharacters: t, prefix: n, postfix: r }) {
  const o = new RegExp(`[${t.join("")}]`, "gi");
  return ({ elementState: i, data: s }) => {
    const { value: a, selection: l } = i, { cleanValue: c, extractedPostfix: d, extractedPrefix: u } = Ke(a, {
      prefix: n,
      postfix: r
    });
    return {
      elementState: {
        selection: l,
        value: u + c.replace(o, e) + d
      },
      data: s.replace(o, e)
    };
  };
}
function I1({ decimalSeparator: e, prefix: t, postfix: n }) {
  return ({ elementState: r, data: o }) => {
    const { value: i, selection: s } = r, [a, l] = s, { cleanValue: c } = Ke(i, { prefix: t, postfix: n });
    return {
      elementState: r,
      data: !c.includes(e) || i.slice(a, l + 1).includes(e) ? o : o.replaceAll(new RegExp(Re(e), "gi"), "")
    };
  };
}
function F1({ thousandSeparator: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (!e)
    return Tr;
  const o = (...i) => i.every((s) => /\s/.test(s));
  return ({ value: i, selection: s }) => {
    const { cleanValue: a, extractedPostfix: l, extractedPrefix: c } = Ke(i, {
      prefix: n,
      postfix: r
    }), { minus: d, integerPart: u, decimalPart: p } = Tp(a, {
      decimalSeparator: t,
      thousandSeparator: e
    }), [f, m] = s;
    let [g, y] = s;
    const b = Array.from(u).reduceRight((w, x, $) => {
      const S = !(!$ && x === e) && w.length && (w.length + 1) % 4 === 0;
      return S && (x === e || o(x, e)) ? e + w : x === e && !S ? ($ && $ <= f && g--, $ && $ <= m && y--, w) : S ? ($ <= f && g++, $ <= m && y++, x + e + w) : x + w;
    }, "");
    return {
      value: c + d + b + (a.includes(t) ? t : "") + p + l,
      selection: [g, y]
    };
  };
}
function V1({ precision: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (e > 0)
    return Tr;
  const o = new RegExp(`${Re(t)}.*$`, "g");
  return ({ elementState: i, data: s }) => {
    const { value: a, selection: l } = i, { cleanValue: c, extractedPrefix: d, extractedPostfix: u } = Ke(a, {
      prefix: n,
      postfix: r
    }), [p, f] = l, m = d + c.replace(o, "") + u;
    return {
      elementState: {
        selection: [
          Math.min(p, m.length),
          Math.min(f, m.length)
        ],
        value: m
      },
      data: s.replace(o, "")
    };
  };
}
const uc = [0, 0];
function O1({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = M1({
    decimalSeparator: e,
    thousandSeparator: t,
    prefix: n,
    postfix: r
  });
  return Er("blur", (i) => {
    const s = o({
      value: i.value,
      selection: uc
    }, { value: "", selection: uc }).value;
    In(i, s);
  }, { capture: !0 });
}
function z1({ min: e, max: t, decimalSeparator: n }) {
  return Er("blur", (r, o) => {
    const i = ya(r.value, n), s = Qt(i, e, t);
    !Number.isNaN(i) && i !== s && In(r, ha(T1(s), o));
  }, { capture: !0 });
}
function N1({ decimalSeparator: e, prefix: t, postfix: n }) {
  return Er("blur", (r) => {
    const { cleanValue: o, extractedPostfix: i, extractedPrefix: s } = Ke(r.value, { prefix: t, postfix: n }), a = s + o.replace(new RegExp(`^(\\D+)?${Re(e)}`), `$10${e}`) + i;
    In(r, a);
  }, { capture: !0 });
}
function Ep({ max: e = Number.MAX_SAFE_INTEGER, min: t = Number.MIN_SAFE_INTEGER, precision: n = 0, thousandSeparator: r = Yx, decimalSeparator: o = ".", decimalPseudoSeparators: i, decimalZeroPadding: s = !1, prefix: a = "", postfix: l = "", minusSign: c = $s } = {}) {
  const d = [
    Po,
    gp,
    vp,
    yp,
    $s
  ].filter((f) => f !== r && f !== o && f !== c), u = E1({
    decimalSeparator: o,
    thousandSeparator: r,
    decimalPseudoSeparators: i
  }), p = a.endsWith(o) && n > 0 ? `${a}${Xx}` : a;
  return Object.assign(Object.assign({}, kr), { mask: Sp({
    decimalSeparator: o,
    precision: n,
    thousandSeparator: r,
    prefix: p,
    postfix: l,
    isNegativeAllowed: t < 0,
    minusSign: c
  }), preprocessors: [
    va(),
    P1({
      decimalSeparator: o,
      decimalPseudoSeparators: u,
      pseudoMinuses: d,
      prefix: p,
      postfix: l,
      minusSign: c
    }),
    S1({ prefix: p, postfix: l }),
    dc({
      validCharacter: c,
      pseudoCharacters: d,
      prefix: p,
      postfix: l
    }),
    dc({
      validCharacter: o,
      pseudoCharacters: u,
      prefix: p,
      postfix: l
    }),
    L1({
      decimalSeparator: o,
      precision: n,
      prefix: p,
      postfix: l
    }),
    B1({
      decimalSeparator: o,
      decimalZeroPadding: s,
      thousandSeparator: r
    }),
    V1({
      precision: n,
      decimalSeparator: o,
      prefix: p,
      postfix: l
    }),
    I1({
      decimalSeparator: o,
      prefix: p,
      postfix: l
    })
  ], postprocessors: [
    D1({ decimalSeparator: o, min: t, max: e, minusSign: c }),
    xp(p),
    l1(l),
    F1({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: p,
      postfix: l
    }),
    R1({
      decimalSeparator: o,
      decimalZeroPadding: s,
      precision: n,
      prefix: p,
      postfix: l
    }),
    A1({ prefix: p, postfix: l, decimalSeparator: o, thousandSeparator: r })
  ], plugins: [
    O1({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: p,
      postfix: l
    }),
    N1({
      decimalSeparator: o,
      prefix: p,
      postfix: l
    }),
    z1({ min: t, max: e, decimalSeparator: o })
  ], overwriteMode: s ? ({ value: f, selection: [m] }) => m <= f.indexOf(o) ? "shift" : "replace" : "shift" });
}
function W1(e, t) {
  const n = b1(e), r = new RegExp(`[^\\d${ga.map(Re).join("")}]+`);
  return ({ elementState: o, data: i }, s) => {
    if (s === "deleteBackward" || s === "deleteForward")
      return { elementState: o, data: i };
    const { value: a, selection: l } = o;
    if (s === "validation") {
      const { validatedTimeString: b, updatedTimeSelection: w } = lc({
        timeString: a,
        paddedMaxValues: n,
        offset: 0,
        selection: l,
        timeMode: t
      });
      return {
        elementState: {
          value: b,
          selection: w
        },
        data: i
      };
    }
    const c = i.replace(r, ""), [d, u] = l;
    let p = u + c.length;
    const f = a.slice(0, d) + c + a.slice(p), { validatedTimeString: m, updatedTimeSelection: g } = lc({
      timeString: f,
      paddedMaxValues: n,
      offset: 0,
      selection: [d, p],
      timeMode: t
    });
    if (f && !m)
      return { elementState: o, data: "" };
    p = g[1];
    const y = m.slice(d, p);
    return {
      elementState: {
        selection: l,
        value: m.slice(0, d) + "0".repeat(y.length) + m.slice(p)
      },
      data: y
    };
  };
}
function _1({ mode: e, timeSegmentMaxValues: t = {}, step: n = 0 }) {
  const r = Object.assign(Object.assign({}, Kx), t);
  return Object.assign(Object.assign({}, kr), { mask: Array.from(e).map((o) => ga.includes(o) ? o : /\d/), preprocessors: [
    va(),
    n1(),
    kp(),
    W1(r, e)
  ], plugins: [
    u1({
      fullMode: e,
      step: n,
      timeSegmentMaxValues: r
    })
  ], overwriteMode: "replace" });
}
function j1() {
  const e = (n) => n.replace(/^(\+?7?\s?8?)\s?/, ""), t = (n) => n.replace(/\D/g, "").length;
  return ({ elementState: n, data: r }) => {
    const { value: o, selection: i } = n;
    return {
      elementState: {
        selection: i,
        value: t(o) > 11 ? e(o) : o
      },
      data: t(r) >= 11 ? e(r) : r
    };
  };
}
const M3 = A((e, t) => {
  const {
    prefix: n = "+7 ",
    mask: r = [
      "+",
      "7",
      " ",
      /\d/,
      /\d/,
      /\d/,
      " ",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/
    ],
    ...o
  } = e, i = {
    mask: r,
    postprocessors: [
      // неудаляемый префикс страны
      xp(n)
    ],
    preprocessors: n === "+7 " ? [j1()] : void 0,
    plugins: [
      // при фокусе на инпут префикс передается в value
      wp(n),
      // при блюре префикс удаляется из value
      Cp(n),
      // запрещает ставить курсор перед неудаляемым префиксом страны
      $p((s, [a, l]) => [a === l ? n.length : 0, s.length])
    ]
  };
  return /* @__PURE__ */ h(
    Sr,
    {
      ...o,
      clearThreshold: n.length,
      ref: t,
      options: i,
      type: "tel",
      inputMode: "tel"
    }
  );
}), D3 = A((e, t) => {
  const {
    currency: n = "RUB",
    decimalSeparator: r = ",",
    precision: o = 0,
    min: i,
    max: s,
    onChange: a,
    getRawValue: l,
    ...c
  } = e, d = ` ${ru[n]}`, { plugins: u, ...p } = Ep({
    min: i,
    max: s,
    precision: o,
    decimalSeparator: r,
    thousandSeparator: " ",
    postfix: d
  }), f = {
    mask: p.mask,
    postprocessors: [...p.postprocessors],
    preprocessors: [...p.preprocessors],
    plugins: [
      ...u,
      wp(d),
      Cp(d),
      $p((y) => [0, y.length - d.length])
    ]
  }, m = (y) => y.replace(d, "").replace(/\s/g, "");
  return /* @__PURE__ */ h(
    Sr,
    {
      ...c,
      onChange: (y) => {
        a == null || a(y), l == null || l(m(y.target.value));
      },
      options: f,
      inputMode: o > 0 ? "decimal" : "numeric",
      ref: t,
      clearThreshold: d.length
    }
  );
}), B3 = A((e, t) => {
  const {
    mode: n = "dd/mm/yyyy",
    separator: r = ".",
    min: o = new Date(1920, 1, 1),
    max: i = new Date(2121, 1, 1),
    ...s
  } = e, a = v1({
    mode: n,
    min: o,
    max: i,
    separator: r
  });
  return /* @__PURE__ */ h(Sr, { ...s, options: a, inputMode: "numeric", ref: t });
}), L3 = A((e, t) => {
  const { mode: n = "HH:MM", step: r, timeSegmentMaxValues: o, ...i } = e, s = _1({
    mode: n,
    step: r,
    timeSegmentMaxValues: o
  });
  return /* @__PURE__ */ h(Sr, { ...i, options: s, inputMode: "numeric", ref: t });
}), H1 = ({ isShow: e, onClick: t, disabled: n }) => /* @__PURE__ */ h(Ce, { disabled: n, variant: "ghost-secondary", size: 32, onClick: t, children: /* @__PURE__ */ h(
  q,
  {
    iconPath: e ? "granat/hide/size-24-style-fill" : "granat/show/size-24-style-fill"
  }
) }), I3 = A((e, t) => {
  const [n, r] = U(!1), o = () => {
    r(!n);
  };
  return /* @__PURE__ */ h(
    U1,
    {
      ...e,
      ref: t,
      type: n || !e.value ? "text" : "password",
      isClearable: !1,
      iconEnd: e.disabled ? e == null ? void 0 : e.iconEnd : /* @__PURE__ */ h(
        H1,
        {
          onClick: o,
          isShow: n,
          disabled: !!(e != null && e.waiting)
        }
      )
    }
  );
}), U1 = v(sn)`
  input[type='password'] {
    font-family: Verdana;
    letter-spacing: 2px;
  }
`, F3 = A((e, t) => {
  const { inputProps: n, size: r = 44, children: o, open: i = !1, ...s } = e, a = oe(null), [l, c] = U(i), d = ie();
  return Y(() => {
    c(i);
  }, [i]), /* @__PURE__ */ M("div", { ref: t, children: [
    /* @__PURE__ */ h(
      sn,
      {
        ...n,
        size: r,
        iconStart: /* @__PURE__ */ h(
          q,
          {
            iconPath: "granat/search/size-24-style-outline",
            color: d.colors.icons.secondary
          }
        ),
        inputWrapperRef: a,
        inputLeftPadding: 4
      }
    ),
    /* @__PURE__ */ h(on, { ...s, open: l, anchorRef: a, children: o })
  ] });
}), ba = v(q)(
  ({ open: e }) => C`
    transition: transform 200ms ease;
    transform: rotate(${e ? 180 : 0}deg);
  `
), V3 = A((e, t) => {
  const { inputProps: n, open: r = !1, children: o, onButtonClick: i, iconEnd: s, ...a } = e, l = oe(null), [c, d] = U(r);
  return Y(() => {
    d(r);
  }, [r]), /* @__PURE__ */ M("div", { ref: t, children: [
    /* @__PURE__ */ h(
      sn,
      {
        ...n,
        isSelect: !0,
        isClearable: !1,
        inputWrapperRef: l,
        iconEnd: s,
        inputTypeIcon: /* @__PURE__ */ h(
          Ce,
          {
            size: 32,
            variant: "ghost-secondary",
            disabled: (n == null ? void 0 : n.disabled) || !!(n != null && n.waiting),
            children: /* @__PURE__ */ h(ba, { iconPath: "granat/chevron-down/size-24-style-outline", open: c }),
            onClick: (u) => i == null ? void 0 : i(u)
          }
        )
      }
    ),
    /* @__PURE__ */ h(on, { ...a, open: c, anchorRef: l, children: o })
  ] });
}), G1 = v(q)(
  ({ open: e }) => C`
    transition: transform 200ms ease;
    transform: rotate(${e ? 180 : 0}deg);
  `
), O3 = A((e, t) => {
  const { inputProps: n, open: r = !1, children: o, onButtonClick: i, iconStart: s, iconEnd: a, ...l } = e, c = oe(null), [d, u] = U(r);
  return Y(() => {
    u(r);
  }, [r]), /* @__PURE__ */ M("div", { ref: t, children: [
    /* @__PURE__ */ h(
      sn,
      {
        ...n,
        iconStart: s,
        iconEnd: a,
        isSelect: !0,
        size: 72,
        isLabelOutside: !0,
        isClearable: !1,
        inputWrapperRef: c,
        inputTypeIcon: /* @__PURE__ */ h(
          Ce,
          {
            size: 32,
            variant: "ghost-secondary",
            disabled: (n == null ? void 0 : n.disabled) || !!(n != null && n.waiting),
            children: /* @__PURE__ */ h(G1, { iconPath: "granat/chevron-down/size-24-style-outline", open: d }),
            onClick: (p) => i == null ? void 0 : i(p)
          }
        ),
        inputLeftPadding: 8,
        radius: 16
      }
    ),
    /* @__PURE__ */ h(on, { ...l, open: d, anchorRef: c, children: o })
  ] });
}), z3 = A((e, t) => /* @__PURE__ */ h(sn, { ...e, size: 72, isLabelOutside: !0, ref: t, inputLeftPadding: 8, radius: 16 })), N3 = A((e, t) => /* @__PURE__ */ h(Sr, { ...e, size: 72, isLabelOutside: !0, ref: t, inputLeftPadding: 8, radius: 16 })), K1 = {
  16: "c1RegularComp",
  20: "p4RegularComp",
  24: "p3RegularComp"
}, W3 = A((e, t) => {
  const n = ie(), {
    size: r = 20,
    placeholder: o = "123",
    withIcon: i = "false",
    variant: s = "default",
    value: a,
    onChange: l,
    onFocus: c,
    onBlur: d,
    inputRef: u,
    className: p,
    ...f
  } = e, [m, g] = U(!1), y = (x) => {
    l(x.target.value);
  }, b = (x) => {
    g(!0), c == null || c(x);
  }, w = (x) => {
    g(!1), d == null || d(x);
  };
  return /* @__PURE__ */ M(Y1, { className: p, ref: t, $focused: m, $variant: s, children: [
    i && /* @__PURE__ */ h(q, { color: n.colors.icons.secondary, iconPath: "granat/edit/size-16-style-outline" }),
    /* @__PURE__ */ h(
      X1,
      {
        ...f,
        ref: u,
        value: a,
        onBlur: w,
        onFocus: b,
        onChange: y,
        $size: r,
        $focused: m,
        placeholder: o,
        type: "text"
      }
    )
  ] });
}), Y1 = v.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 6px;
  transition: background-color 0.3s ease-in-out;
  cursor: text;
  border: ${({ $focused: e, theme: t }) => e ? `1px solid ${t.colors.accent.active}` : "1px solid transparent"};
  &:hover {
    background-color: ${({ theme: e, $variant: t = "default" }) => t === "default" ? e.colors.background.secondary : e.colors.background.primaryElevated};
  }
`, X1 = v.input`
  ${({ $size: e }) => ae(K1[e])};
  position: relative;
  padding: 0;
  outline: none;
  border: none;
  width: 100%;
  background: transparent;
  color: ${({ theme: e }) => e.colors.text.primary};

  &::placeholder {
    color: ${({ theme: e, $focused: t }) => t ? e.colors.text.tertiary : e.colors.text.secondary};
  }
`, at = {
  s: {
    paddingTop: 10,
    paddingBottom: 10,
    radius: 12,
    height: 78,
    font: "p4RegularComp",
    clearButtonTop: 6
  },
  m: {
    paddingTop: 10,
    paddingBottom: 10,
    radius: 16,
    height: 94,
    font: "p3RegularComp",
    clearButtonTop: 6
  },
  l: {
    paddingTop: 14,
    paddingBottom: 14,
    radius: 16,
    height: 102,
    font: "p3RegularComp",
    clearButtonTop: 10
  },
  xl: {
    paddingTop: 0,
    paddingBottom: 14,
    radius: 16,
    height: 76,
    font: "p3RegularComp",
    clearButtonTop: 10
  }
}, Z1 = v.div(
  ({ $hasError: e, focused: t, $size: n, $isShowClearButton: r, triggered: o, theme: { colors: i } }) => C`
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    pointer-events: none;

    ${n === "xl" && `
      box-sizing: border-box;
      height: 38px;
      padding-top: 14px;
      margin-bottom: 0;
      margin-left: 12px;
      margin-right: ${r ? 44 : 12}px;
    `}

    ${n === "xl" && o && `
      ${Cs} {
        ${ae("p4RegularComp")};
      }
    `}

    ${e && !t && `
        ${Cs} {
          color: ${i.text.negative};
        }
    `}
  `
), Cs = v.label(
  ({ $disabled: e, $size: t, theme: { colors: n } }) => C`
    ${ae(t === "xl" ? "p3RegularComp" : "p4RegularComp")};
    color: ${e ? n.text.tertiary : n.text.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `
), q1 = v.div(
  ({ $hasError: e, $size: t, $disabled: n, $readOnly: r, $variant: o, theme: { colors: i } }) => C`
    box-sizing: border-box;
    position: relative;
    background: ${n ? i.background.disabled : Lt(i, o)};
    border-width: 1px;
    border-style: solid;
    border-color: ${e ? i.text.negative : n ? i.background.strokeDisabled : i.background.stroke};
    border-radius: ${at[t].radius}px;
    transition: border-color 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);

    ${!e && !n && !r && `
      &:hover:not(:focus-within) {
        border-color: ${i.control.secondaryActive};
      }
    `}

    ${(n || r) && `
      pointer-events: none;
    `}
    
    ${!r && `
      &:has(${ks}:focus-within) {
        border-color: ${i.accent.active};

        ${ks} {
          &::placeholder,
          &::-webkit-input-placeholder {
            color: ${i.text.tertiary};
          }
        }
      }
    `}
  `
), J1 = v.div(
  ({ $size: e, isAutoResize: t }) => C`
    min-height: ${t ? null : `${at[e].height}px`};
    height: ${t ? null : `${at[e].height}px`};
    overflow-y: auto;
    width: 100%;
  `
), ks = v(Qd)(
  ({
    $size: e,
    $variant: t,
    $hasInputValue: n,
    $isShowClearButton: r,
    disabled: o,
    $withLabel: i,
    theme: { colors: s }
  }) => C`
    box-sizing: border-box;
    min-height: ${at[e].height - 4}px;
    overflow: hidden;
    width: 100%;
    border: none;
    border-radius: ${at[e].radius}px;
    background: transparent;
    padding-top: ${at[e].paddingTop}px;
    padding-bottom: ${at[e].paddingBottom}px;
    padding-left: 12px;
    padding-right: ${n && r ? 44 : 12}px;
    color: ${s.text.primary};
    ${ae(at[e].font)};
    cursor: text;
    outline: none;
    resize: none;

    &:disabled {
      color: ${s.text.tertiary};
      cursor: default;
    }

    &::placeholder,
    &::-webkit-input-placeholder {
      color: ${o ? s.text.tertiary : s.text.secondary};
      -webkit-text-fill-color: currentcolor;
    }

    &:-webkit-autofill {
      box-shadow: inset 0 0 0 50px ${Lt(s, t)};
    }

    ${i && e === "xl" && `
        &:not(:focus) {
          &::placeholder {
            color: transparent;
          }
        }
      `}
  `
), Q1 = v.div(
  ({ $size: e }) => C`
    padding-right: 8px;
    position: absolute;
    right: 0;
    top: ${at[e].clearButtonTop}px;
    z-index: 1;
  `
), ew = v(H)(
  ({ $descColor: e, $hasError: t, theme: { colors: n } }) => C`
    display: flex;
    align-items: center;
    color: ${e || (t ? n.text.negative : n.text.secondary)};
    margin-top: 4px;
    overflow-wrap: break-word;
    word-break: break-word;
    pointer-events: none;
  `
), ot = {
  Wrapper: li,
  LabelWrapper: Z1,
  Label: Cs,
  LabelIcon: ci,
  TextareaWrapper: q1,
  InnerWrapper: J1,
  Textarea: ks,
  ClearButtonWrapper: Q1,
  DescriptionText: ew
}, _3 = A((e, t) => {
  const {
    size: n = "m",
    onChange: r,
    onFocus: o,
    onBlur: i,
    value: s,
    label: a,
    description: l,
    placeholder: c,
    disabled: d,
    readOnly: u,
    hasError: p,
    variant: f = "primary",
    isClearable: m,
    onClear: g,
    isAutoResize: y,
    descColor: b,
    className: w
  } = e, [x, $] = U(s), [E, S] = U(), [F, R] = U(), [L, P] = U(), j = oe(null), _ = oe(null), G = x && String(x).length > 0, D = /* @__PURE__ */ M(
    ot.LabelWrapper,
    {
      $hasError: p,
      focused: E,
      triggered: F,
      $size: n,
      $isShowClearButton: m && L && !!G,
      children: [
        /* @__PURE__ */ h(ot.Label, { $disabled: d, $size: n, children: a }),
        d && /* @__PURE__ */ h(ot.LabelIcon, { children: /* @__PURE__ */ h(di, {}) })
      ]
    }
  ), I = (N) => {
    R(!0), S(!0), P(!0), o == null || o(N);
  }, z = (N) => {
    !G && R(!1), S(!1), i == null || i(N);
  };
  pi(_, () => P(!1));
  const O = (N) => {
    $(N.target.value), r == null || r(N);
  }, V = () => {
    var N;
    $(""), g == null || g(), (N = j.current) == null || N.focus();
  };
  return Y(() => {
    $(s);
  }, [s]), Y(() => {
    G || document.activeElement == j.current ? R(!0) : R(!1);
  }, [x]), /* @__PURE__ */ M(ot.Wrapper, { className: w, ref: _, children: [
    a && n !== "xl" && D,
    /* @__PURE__ */ M(
      ot.TextareaWrapper,
      {
        $variant: f,
        $size: n,
        $hasError: p,
        $disabled: d,
        $readOnly: u,
        children: [
          a && n === "xl" && D,
          /* @__PURE__ */ h(ot.InnerWrapper, { $size: n, isAutoResize: y, children: /* @__PURE__ */ h(
            ot.Textarea,
            {
              placeholder: c,
              value: x,
              disabled: d,
              readOnly: u,
              onChange: O,
              onFocus: I,
              onBlur: z,
              ref: Bt(j, t),
              $variant: f,
              $size: n,
              $hasInputValue: !!G,
              $isShowClearButton: m && L && !!G,
              $withLabel: !!a
            }
          ) }),
          G && m && L && !u && /* @__PURE__ */ h(ot.ClearButtonWrapper, { $size: n, children: /* @__PURE__ */ h(
            Ce,
            {
              variant: "ghost-secondary",
              disabled: d,
              size: 32,
              children: /* @__PURE__ */ h(ui, {}),
              onClick: V
            }
          ) })
        ]
      }
    ),
    l && /* @__PURE__ */ h(ot.DescriptionText, { font: "c1RegularComp", $hasError: p, $descColor: b, children: l })
  ] });
}), tw = {
  s: 32,
  m: 44,
  l: 52,
  xl: 72
}, j3 = A((e, t) => {
  const { inputProps: n, size: r = "m", children: o, open: i = !1, iconEnd: s, ...a } = e, l = oe(null), [c, d] = U(i);
  return Y(() => {
    d(i);
  }, [i]), /* @__PURE__ */ M("div", { ref: t, children: [
    /* @__PURE__ */ h(sn, { ...n, size: tw[r], inputWrapperRef: l, iconEnd: s }),
    /* @__PURE__ */ h(on, { ...a, open: c, anchorRef: l, children: o })
  ] });
}), mn = {
  s: {
    paddingTop: 2,
    paddingBottom: 2,
    radius: 12,
    font: "p4RegularComp"
  },
  m: {
    paddingTop: 4,
    paddingBottom: 4,
    radius: 16,
    font: "p3RegularComp"
  },
  l: {
    paddingTop: 10,
    paddingBottom: 10,
    radius: 16,
    font: "p3RegularComp"
  },
  xl: {
    paddingTop: 0,
    paddingBottom: 8,
    withOptions: {
      paddingTop: 4,
      paddingBottom: 4
    },
    radius: 20,
    font: "p3RegularComp"
  }
}, nw = v.div(
  ({ $hasError: e, triggered: t, focused: n, $size: r, theme: { colors: o } }) => C`
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    pointer-events: none;

    ${r === "xl" && `
      box-sizing: border-box;
      width: 100%;
      position: absolute;
      margin-top: ${t ? 14 : 24}px;
      padding: 0 12px;
      z-index: 1;
      margin-bottom: 0;
    `}

    ${r === "xl" && t && `
      ${Ss} {
        ${ae("p4RegularComp")};
      }
    `}

    ${e && !n && `
        ${Ss} {
          color: ${o.text.negative};
        }
    `}
  `
), Ss = v.label(
  ({ $size: e, $disabled: t, theme: { colors: n } }) => C`
    ${ae(e === "xl" ? "p3RegularComp" : "p4RegularComp")};
    color: ${t ? n.text.tertiary : n.text.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `
), rw = ({
  $isDropdown: e,
  $hasEndIcon: t,
  $isShowClearButton: n
}) => e ? n || t ? 76 : 44 : n || t ? 44 : 12, ow = v.div(
  ({
    $hasError: e,
    $size: t,
    $disabled: n,
    $readOnly: r,
    $isShowClearButton: o,
    $hasEndIcon: i,
    $variant: s,
    $isDropdown: a,
    theme: { colors: l }
  }) => C`
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    padding-top: ${{
    s: 3,
    m: 5,
    l: 3,
    xl: 33
  }[t]}px;
    padding-bottom: ${{
    s: 3,
    m: 5,
    l: 3,
    xl: 5
  }[t]}px;
    padding-left: ${{
    s: 4,
    m: 6,
    l: 4,
    xl: 12
  }[t]}px;
    padding-right: ${rw({ $isDropdown: a, $hasEndIcon: i, $isShowClearButton: o })}px;
    background: ${n ? l.background.disabled : Lt(l, s)};
    border-width: 1px;
    border-style: solid;
    border-color: ${e ? l.text.negative : n ? l.background.strokeDisabled : l.background.stroke};
    border-radius: ${mn[t].radius}px;
    transition: border-color 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);

    ${!e && !n && !r && `
      &:hover:not(:focus-within) {
        border-color: ${l.control.secondaryActive};
      }
    `}

    ${!r && `
      &:has(${Ts}:focus-within) {
        border-color: ${l.accent.active};

        ${Ts} {
          &::placeholder,
          &::-webkit-input-placeholder {
            color: ${l.text.tertiary};
          }
        }
      }
    `}
  `
), pc = ({
  $size: e,
  $options: t
}) => {
  let n, r;
  return e === "xl" && t ? (n = mn.xl.withOptions.paddingTop, r = mn.xl.withOptions.paddingBottom) : (n = mn[e].paddingTop, r = mn[e].paddingBottom), {
    paddingTop: n,
    paddingBottom: r
  };
}, Ts = v.input(
  ({ $size: e, $withLabel: t, $variant: n, disabled: r, $options: o, $limitOptions: i, theme: { colors: s } }) => C`
    box-sizing: border-box;
    display: inline-block;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: none;
    background: transparent;
    padding-top: ${pc({ $size: e, $options: o }).paddingTop}px;
    padding-bottom: ${pc({
    $size: e,
    $options: o
  }).paddingBottom}px;
    padding-left: ${o ? 4 : { s: 8, m: 6, l: 8, xl: 0 }[e]}px;
    color: ${s.text.primary};
    ${ae(mn[e].font)};
    text-overflow: ellipsis;
    cursor: text;
    outline: none;

    &:disabled {
      color: ${s.text.tertiary};
      cursor: default;
    }

    &::placeholder,
    &::-webkit-input-placeholder {
      color: ${i ? "transparent" : r ? s.text.tertiary : s.text.secondary};
      -webkit-text-fill-color: currentcolor;
    }

    &:-webkit-autofill {
      box-shadow: inset 0 0 0 50px ${Lt(s, n)};
    }

    ${t && e === "xl" && `
      &:not(:focus) {
        &::placeholder {
          color: transparent;
        }
      }
    `}
  `
), iw = v.div`
  display: flex;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translate(0, -50%);
`, yt = {
  Wrapper: li,
  LabelWrapper: nw,
  Label: Ss,
  LabelIcon: ci,
  InputWrapper: ow,
  Input: Ts,
  IconContainer: iw,
  Description: fa
}, sw = {
  s: 24,
  m: 32,
  l: 44,
  xl: 32
}, Rp = (e) => {
  const {
    label: t,
    placeholder: n,
    value: r,
    disabled: o,
    hasError: i,
    description: s,
    variant: a = "primary",
    isClearable: l,
    onClear: c,
    iconEnd: d,
    size: u = "m",
    onFocus: p,
    onBlur: f,
    onChange: m,
    onSelect: g,
    selected: y,
    readOnly: b,
    limitOptions: w,
    inputWrapperRef: x,
    inputRef: $,
    inputFieldIcon: E,
    isDropdown: S = !1,
    ...F
  } = e, [R, L] = U(r), [P, j] = U(y), [_, G] = U(), [D, I] = U(), [z, O] = U(), V = oe(null), N = oe(null), B = R && String(R).length > 0, X = y && y.length > 0, te = P && P.length > 0, we = X && te && y.length - P.length > 0;
  Y(() => {
    if (te && w) {
      const le = y && [...y].slice(0, w);
      j(le);
    } else
      j(y);
  }, [w, y]);
  const J = (le) => {
    G(!0), I(!0), O(!0), p == null || p(le);
  }, Q = (le) => {
    !B && !te && G(!1), I(!1), f == null || f(le);
  }, ne = (le) => {
    L(le.target.value), m == null || m(le);
  }, Z = () => {
    var le;
    L(""), c == null || c(), (le = V.current) == null || le.focus();
  }, ue = (le) => {
    const ve = P == null ? void 0 : P.filter((Se) => Se.value !== le);
    j(ve), g == null || g(le);
  };
  return Y(() => {
    L(r);
  }, [r]), Y(() => {
    B || te || document.activeElement == V.current ? G(!0) : G(!1);
  }, [R, te]), pi(N, () => O(!1)), /* @__PURE__ */ M(yt.Wrapper, { ref: N, children: [
    t && /* @__PURE__ */ M(
      yt.LabelWrapper,
      {
        $size: u,
        $hasError: i,
        triggered: _,
        focused: D,
        children: [
          /* @__PURE__ */ h(yt.Label, { $size: u, $disabled: o, children: t }),
          o && /* @__PURE__ */ h(yt.LabelIcon, { children: /* @__PURE__ */ h(di, {}) })
        ]
      }
    ),
    /* @__PURE__ */ M(
      yt.InputWrapper,
      {
        $variant: a,
        $size: u,
        $hasError: i,
        $disabled: o,
        $readOnly: b,
        ref: x,
        $isShowClearButton: l && z && !!B,
        $hasEndIcon: !!d,
        $isDropdown: S,
        children: [
          P == null ? void 0 : P.map((le) => /* @__PURE__ */ h(
            Ks,
            {
              size: sw[u],
              variant: a === "primary" ? "secondary" : "primary",
              disabled: o,
              onClick: (ve) => {
                ve.preventDefault(), ve.stopPropagation(), ue(le.value);
              },
              children: le.text
            },
            le.value
          )),
          w && we && /* @__PURE__ */ h(
            H,
            {
              font: u === "s" ? "p4RegularComp" : "p3RegularComp",
              children: `+ ${y.length - P.length}`
            }
          ),
          /* @__PURE__ */ h(
            yt.Input,
            {
              ...F,
              placeholder: n,
              value: R,
              onChange: ne,
              onFocus: J,
              onBlur: Q,
              $variant: a,
              $size: u,
              $withLabel: !!t,
              disabled: o,
              readOnly: b,
              $options: te,
              $limitOptions: !!w && we,
              ref: Bt(V, $ || null)
            }
          ),
          /* @__PURE__ */ M(yt.IconContainer, { children: [
            d || (B && l && z && !b && !o ? /* @__PURE__ */ h(
              Ce,
              {
                variant: "ghost-secondary",
                disabled: o,
                size: 32,
                children: /* @__PURE__ */ h(ui, {}),
                onClick: Z
              }
            ) : null),
            E && E
          ] })
        ]
      }
    ),
    s && /* @__PURE__ */ h(yt.Description, { font: "c1RegularComp", $hasError: i, children: s })
  ] });
}, H3 = A(
  (e, t) => {
    const { inputProps: n, size: r = "m", children: o, open: i, iconEnd: s, ...a } = e, l = oe(null), [c, d] = U(i);
    return Y(() => {
      d(i);
    }, [i]), /* @__PURE__ */ M("div", { ref: t, children: [
      /* @__PURE__ */ h(Rp, { ...n, size: r, inputWrapperRef: l, iconEnd: s }),
      /* @__PURE__ */ h(on, { ...a, open: c, anchorRef: l, children: o })
    ] });
  }
), jn = { increase: "increase", decrease: "decrease" }, Kt = {
  s: {
    height: 32,
    radius: 12,
    inputMinWidth: 44,
    font: "p4RegularComp",
    padding: "3px 4px",
    amountFont: "c2BoldUppWide"
  },
  m: {
    height: 44,
    radius: 16,
    inputMinWidth: 52,
    font: "p3RegularComp",
    padding: "5px 6px",
    amountFont: "c2BoldUppWide"
  },
  l: {
    height: 52,
    radius: 20,
    inputMinWidth: 52,
    font: "p3RegularComp",
    padding: "9px 10px",
    amountFont: "c1BoldUppWide"
  }
}, aw = v.label(
  ({ theme: { colors: e } }) => C`
    ${ae("p4RegularComp")};
    display: block;
    margin-bottom: 4px;
    color: ${e.text.secondary};
  `
), lw = v.div(
  ({ $disabled: e, $size: t, $variant: n, theme: { colors: r } }) => C`
    display: inline-flex;
    height: ${Kt[t].height}px;
    background-color: ${e ? r.background.disabled : {
    primary: r.background.secondary,
    secondary: r.background.secondaryElevated
  }[n]};
    border-width: 1px;
    border-style: solid;
    border-color: ${e ? r.background.strokeDisabled : r.background.stroke};
    border-radius: ${Kt[t].radius}px;
    padding: ${Kt[t].padding};
    transition: border-color 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);

    ${!e && `
      &:hover {
        border-color: ${r.control.secondaryActive};
      }
    `}

    &:has(${Ap}:focus-within) {
      border-color: ${r.accent.active};
    }
  `
), cw = v.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`, Ap = v.input(
  ({ $size: e, $width: t, theme: { colors: n } }) => C`
    position: relative;
    min-width: ${Kt[e].inputMinWidth}px;
    ${ae(Kt[e].font)};
    color: ${n.text.primary};
    top: 1px;
    text-align: center;
    width: ${t}px;
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: text;
    outline: none;

    &:disabled {
      color: ${n.text.tertiary};
    }
  `
), dw = v.span(
  ({ $size: e }) => C`
    position: absolute;
    ${ae(Kt[e].font)};
    top: -1000px;
    left: -1000px;
    visibility: hidden;
    white-space: pre;
    pointer-events: none;
  `
), uw = v.span(
  ({ $size: e, theme: { colors: t } }) => C`
    ${ae(Kt[e].amountFont)};
    color: ${t.text.tertiary};
  `
), U3 = A((e, t) => {
  const {
    size: n = "m",
    onChange: r,
    label: o,
    min: i = 0,
    max: s = 999,
    step: a = 1,
    disabled: l,
    value: c,
    variant: d = "primary",
    amount: u,
    iconRight: p,
    iconLeft: f,
    ...m
  } = e, [g, y] = U(c), [b, w] = l ? [!1, !1] : [g < s, g > i], [x, $] = U(0), E = oe(null);
  Y(() => {
    const D = String(c);
    y(D.replace(/\s/g, ""));
  }, [c]);
  const { plugins: S, ...F } = Ep({
    min: i,
    max: s,
    thousandSeparator: " "
  }), R = {
    mask: F.mask,
    postprocessors: [...F.postprocessors],
    preprocessors: [...F.preprocessors],
    plugins: [...S]
  }, L = dp({ options: R }), P = (D) => {
    const I = Number(g);
    return D === jn.increase ? I + a > s ? `${s}` : `${I + a}` : I - a < i ? `${i}` : `${I - a}`;
  }, j = (D) => {
    D.target.value !== c && (r == null || r(D.target.value));
  }, _ = (D) => {
    r == null || r(P(D));
  }, G = (D) => {
    D.key === "ArrowUp" && b && _(jn.increase), D.key === "ArrowDown" && w && _(jn.decrease);
  };
  return Y(() => {
    E.current !== null && $(E.current.offsetWidth);
  }, [g]), /* @__PURE__ */ M("div", { ref: t, children: [
    /* @__PURE__ */ h(aw, { children: o }),
    /* @__PURE__ */ M(lw, { $disabled: l, $size: n, $variant: d, children: [
      /* @__PURE__ */ h(
        Ce,
        {
          variant: "ghost",
          size: n === "s" ? 24 : 32,
          disabled: w ? l : !0,
          onClick: () => {
            w && _(jn.decrease);
          },
          children: f || /* @__PURE__ */ h(q, { iconPath: `granat/minus/size-${n === "s" ? 16 : 24}-style-outline` })
        }
      ),
      /* @__PURE__ */ M(cw, { children: [
        /* @__PURE__ */ h(
          Ap,
          {
            ...m,
            inputMode: "numeric",
            value: g,
            $size: n,
            onInput: j,
            onKeyDown: G,
            disabled: l,
            ref: L,
            $width: x
          }
        ),
        /* @__PURE__ */ h(dw, { ref: E, $size: n, children: g }),
        n !== "s" && u && /* @__PURE__ */ h(uw, { $size: n, children: u })
      ] }),
      /* @__PURE__ */ h(
        Ce,
        {
          variant: "ghost",
          size: n === "s" ? 24 : 32,
          disabled: b ? l : !0,
          onClick: () => {
            b && _(jn.increase);
          },
          children: p || /* @__PURE__ */ h(q, { iconPath: `granat/plus/size-${n === "s" ? 16 : 24}-style-outline` })
        }
      )
    ] })
  ] });
}), pw = {
  s: 32,
  m: 44,
  l: 52,
  xl: 72
}, G3 = A((e, t) => {
  const { inputProps: n, size: r = "m", children: o, open: i = !1, iconEnd: s, onButtonClick: a, ...l } = e, c = oe(null), [d, u] = U(i);
  return Y(() => {
    u(i);
  }, [i]), /* @__PURE__ */ M("div", { ref: t, children: [
    /* @__PURE__ */ h(
      sn,
      {
        ...n,
        size: pw[r],
        inputWrapperRef: c,
        iconEnd: s,
        inputTypeIcon: /* @__PURE__ */ h(
          Ce,
          {
            size: 32,
            variant: "ghost-secondary",
            disabled: n == null ? void 0 : n.disabled,
            children: /* @__PURE__ */ h(ba, { iconPath: "granat/chevron-down/size-24-style-outline", open: d }),
            onClick: (p) => a == null ? void 0 : a(p)
          }
        )
      }
    ),
    /* @__PURE__ */ h(on, { ...l, open: d, anchorRef: c, children: o })
  ] });
}), K3 = A(
  (e, t) => {
    const { inputProps: n, size: r = "m", children: o, open: i, iconEnd: s, onButtonClick: a, ...l } = e, c = oe(null), [d, u] = U(i);
    return Y(() => {
      u(i);
    }, [i]), /* @__PURE__ */ M("div", { ref: t, children: [
      /* @__PURE__ */ h(
        Rp,
        {
          ...n,
          size: r,
          inputWrapperRef: c,
          iconEnd: s,
          isDropdown: !0,
          inputFieldIcon: /* @__PURE__ */ h(
            Ce,
            {
              size: 32,
              variant: "ghost-secondary",
              disabled: n == null ? void 0 : n.disabled,
              children: /* @__PURE__ */ h(ba, { iconPath: "granat/chevron-down/size-24-style-outline", open: d }),
              onClick: (p) => a == null ? void 0 : a(p)
            }
          )
        }
      ),
      /* @__PURE__ */ h(on, { ...l, open: d, anchorRef: c, children: o })
    ] });
  }
), Ne = {
  32: {
    paddingTop: 6,
    paddingBottom: 6,
    radius: 12,
    font: "p4RegularComp",
    minHeight: 32,
    maxHeight: 136,
    iconTop: 0,
    spinnerTop: 8
  },
  44: {
    paddingTop: 10,
    paddingBottom: 10,
    radius: 16,
    font: "p3RegularComp",
    minHeight: 44,
    maxHeight: 144,
    iconTop: 6,
    spinnerTop: 10
  },
  52: {
    paddingTop: 14,
    paddingBottom: 14,
    radius: 16,
    font: "p3RegularComp",
    minHeight: 52,
    maxHeight: 152,
    iconTop: 10,
    spinnerTop: 14
  },
  64: {
    paddingTop: 20,
    paddingBottom: 10,
    withLabel: {
      paddingTop: 6,
      minHeight: 40
    },
    radius: 16,
    font: "p3RegularComp",
    minHeight: 64,
    maxHeight: 140,
    iconTop: 16,
    spinnerTop: 20,
    withValueSpinnerTop: 30
  },
  72: {
    paddingTop: 24,
    paddingBottom: 14,
    withLabel: {
      paddingTop: 10,
      minHeight: 48
    },
    radius: 20,
    font: "p3RegularComp",
    minHeight: 72,
    maxHeight: 148,
    iconTop: 18,
    spinnerTop: 24,
    withValueSpinnerTop: 34
  }
}, fc = {
  64: {
    onInputFocus: 8,
    default: 20
  },
  72: {
    onInputFocus: 12,
    default: 24
  }
}, fw = v.div(
  ({
    $hasError: e,
    triggered: t,
    focused: n,
    $size: r,
    $isLoading: o,
    $isShowClearButton: i,
    $hasEndIcon: s,
    theme: { colors: a }
  }) => C`
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    pointer-events: none;
    visibility: ${o && (r === 64 || r === 72) && !t ? "hidden" : "visible"};

    ${(r === 64 || r === 72) && `
      box-sizing: border-box;
      min-height: 24px;
      position: relative;
      margin-right: ${i || s ? 44 : 12}px;
      top: ${t ? fc[r].onInputFocus : fc[r].default}px;
      margin-bottom: 0;
    `}

    ${(r === 64 || r === 72) && t && `
      ${Es} {
        ${ae("p4RegularComp")};
      }
    `}

    ${e && !n && `
        ${Es} {
          color: ${a.text.negative};
        }
    `}
  `
), Es = v.label(
  ({ $size: e, $disabled: t, theme: { colors: n } }) => C`
    ${ae(e === 64 || e === 72 ? "p3RegularComp" : "p4RegularComp")};
    color: ${t ? n.text.tertiary : n.text.secondary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `
), hw = v.div(
  ({ $hasError: e, $size: t, $disabled: n, $readOnly: r, $variant: o, $isLoading: i, theme: { colors: s } }) => C`
    box-sizing: border-box;
    position: relative;
    display: flex;
    ${(t === 64 || t === 72) && `
      flex-direction: column;
    `}
    background: ${n || i ? s.background.disabled : Lt(s, o)};
    padding-left: 12px;
    outline-width: 1px;
    outline-style: solid;
    outline-color: ${e ? s.text.negative : n || i ? s.background.strokeDisabled : s.background.stroke};
    border-radius: ${Ne[t].radius}px;
    transition: outline-color 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);

    ${!e && !n && !i && !r && `
      &:hover:not(:focus-within) {
        outline-color: ${s.control.secondaryActive};
      }
    `}

    ${!r && `
      &:has(${Rs}:focus-within) {
        outline-color: ${s.accent.active};

        ${Rs} {
          &::placeholder,
          &::-webkit-input-placeholder {
            color: ${s.text.tertiary};
          }
        }
      }
    `}
  `
), mw = v.div(
  ({ $size: e }) => C`
    display: flex;
    max-height: ${Ne[e].maxHeight}px;
    overflow-y: auto;
    width: 100%;
  `
), hc = ({
  $size: e,
  $withLabel: t
}) => {
  let n, r;
  return (e === 64 || e === 72) && t ? (n = Ne[e].withLabel.paddingTop, r = Ne[e].withLabel.minHeight) : (n = Ne[e].paddingTop, r = Ne[e].minHeight), {
    paddingTop: n,
    minHeight: r
  };
}, Rs = v(Qd)(
  ({
    $size: e,
    $variant: t,
    $hasInputValue: n,
    $isShowClearButton: r,
    disabled: o,
    $withLabel: i,
    $hasEndIcon: s,
    $isLoading: a,
    theme: { colors: l }
  }) => C`
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    min-height: ${hc({ $size: e, $withLabel: i }).minHeight}px;
    border: none;
    border-radius: ${Ne[e].radius}px;
    background: transparent;
    padding-top: ${hc({ $size: e, $withLabel: i }).paddingTop}px;
    padding-bottom: ${Ne[e].paddingBottom}px;
    padding-right: ${n && r || s ? 44 : 12}px;
    padding-left: 0;
    color: ${l.text.primary};
    ${ae(Ne[e].font)};
    cursor: text;
    outline: none;
    resize: none;

    &:disabled {
      color: ${a ? "transparent" : l.text.tertiary};
      cursor: default;
    }

    &::placeholder,
    &::-webkit-input-placeholder {
      color: ${a ? "transparent" : o ? l.text.tertiary : l.text.secondary};
      -webkit-text-fill-color: currentcolor;
    }

    &:-webkit-autofill {
      box-shadow: inset 0 0 0 50px ${Lt(l, t)};
    }

    ${i && (e === 64 || e === 72) && `
        &:not(:focus) {
          &::placeholder {
            color: transparent;
          }
        }
      `}
  `
), gw = v.div(
  ({ $size: e }) => C`
    padding-right: 8px;
    position: absolute;
    right: 0;
    top: ${Ne[e].iconTop}px;
    z-index: 1;
  `
), vw = ({
  size: e,
  withValue: t
}) => (e === 64 || e === 72) && t ? Ne[e].withValueSpinnerTop : Ne[e].spinnerTop, it = {
  Wrapper: li,
  LabelWrapper: fw,
  Label: Es,
  LabelIcon: ci,
  InputWrapper: hw,
  InnerWrapper: mw,
  Input: Rs,
  Description: fa,
  IconWrapper: gw
}, Y3 = A((e, t) => {
  const {
    size: n = 44,
    onChange: r,
    onFocus: o,
    onBlur: i,
    value: s,
    label: a,
    description: l,
    placeholder: c,
    disabled: d,
    readOnly: u,
    hasError: p,
    variant: f = "primary",
    isClearable: m,
    onClear: g,
    iconEnd: y,
    waiting: b,
    inputWrapperRef: w = null,
    className: x,
    ...$
  } = e, [E, S] = U(s), [F, R] = U(), [L, P] = U(), [j, _] = U(), G = oe(null), D = oe(null), I = E && String(E).length > 0, z = n === 64 || n === 72, O = /* @__PURE__ */ M(
    it.LabelWrapper,
    {
      $size: n,
      $hasError: p,
      triggered: L,
      focused: F,
      $isLoading: !!b,
      $isShowClearButton: m && j && !!I,
      $hasEndIcon: !!y,
      children: [
        /* @__PURE__ */ h(it.Label, { $size: n, $disabled: d, children: a }),
        d && /* @__PURE__ */ h(it.LabelIcon, { children: /* @__PURE__ */ h(di, {}) })
      ]
    }
  ), V = (te) => {
    P(!0), R(!0), _(!0), o == null || o(te);
  }, N = (te) => {
    !I && P(!1), R(!1), i == null || i(te);
  };
  pi(D, () => _(!1));
  const B = (te) => {
    S(te.target.value), r == null || r(te);
  }, X = () => {
    var te;
    S(""), g == null || g(), (te = G.current) == null || te.focus();
  };
  return Y(() => {
    S(s);
  }, [s]), Y(() => {
    I || document.activeElement == G.current ? P(!0) : P(!1);
  }, [E]), /* @__PURE__ */ M(it.Wrapper, { className: x, ref: D, children: [
    a && !z && O,
    /* @__PURE__ */ M(
      it.InputWrapper,
      {
        $variant: f,
        $size: n,
        $hasError: p,
        $disabled: d,
        $readOnly: u,
        $isLoading: !!b,
        ref: w,
        children: [
          a && z && O,
          b && b({
            inputSize: n,
            style: { position: "absolute", top: vw({ size: n, withValue: L }) }
          }),
          /* @__PURE__ */ h(it.InnerWrapper, { $size: n, children: /* @__PURE__ */ h(
            it.Input,
            {
              ...$,
              placeholder: c,
              value: E,
              disabled: d || !!b,
              readOnly: u,
              onChange: B,
              onFocus: V,
              onBlur: N,
              ref: Bt(G, t),
              $isLoading: !!b,
              $variant: f,
              $size: n,
              $hasInputValue: !!I,
              $hasEndIcon: !!y,
              $isShowClearButton: m && j && !!I,
              $withLabel: !!a
            }
          ) }),
          /* @__PURE__ */ h(it.IconWrapper, { $size: n, children: y || (I && m && j && !u && !d ? /* @__PURE__ */ h(
            Ce,
            {
              variant: "ghost-secondary",
              disabled: d,
              size: 32,
              children: /* @__PURE__ */ h(ui, {}),
              onClick: X
            }
          ) : null) })
        ]
      }
    ),
    l && /* @__PURE__ */ h(it.Description, { font: "c1RegularComp", $hasError: p, children: l })
  ] });
}), yw = v.input(
  ({ theme: e, max: t = 100, min: n = 0, value: r, $thumbSize: o, disabled: i }) => {
    const s = e.colors.background.secondary, a = i ? e.colors.control.inactive : e.colors.brand, l = e.colors.background.primary, c = e.colors.brand, d = o ? `${o}px` : "24px", u = "4px", f = (Number(r) - Number(n)) / (Number(t) - Number(n)) * 100 + "% 100%", m = C`
      box-sizing: border-box;
      border: none;
      height: 4px;
      background: ${s};
      border-radius: 2px;
    `, g = C`
      height: ${u};
      border-radius: 2px;
      background-color: ${s};
      background-image: linear-gradient(${a}, ${a}),
        linear-gradient(${s}, ${s});
      background-size: ${f};
      background-position:
        left center,
        right center;
      background-repeat: no-repeat;
    `, y = C`
      height: ${u};
      background: ${a};
      border-radius: 2px;
    `, b = C`
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      box-sizing: border-box;
      border: none;
      width: ${d};
      height: ${d};
      border-radius: 50%;
      background-color: ${l};
      pointer-events: ${i ? "none" : "auto"};
      cursor: ${i ? "auto" : "pointer"};
      transition: 0.3s;
      box-shadow:
        0 8px 16px 0 rgba(0, 0, 0, 0.08),
        0 4px 24px 0 rgba(0, 0, 0, 0.12);
    `;
    return C`
      -webkit-appearance: none;
      appearance: none;
      background: transparent;
      cursor: ${i ? "auto" : "pointer"};
      pointer-events: ${i ? "none" : "auto"};
      width: 100%;
      border-radius: 2px;
      height: ${d};

      &:focus {
        outline: none;
      }

      //track styles
      &::-webkit-slider-runnable-track {
        ${g};
      }

      &::-moz-range-track {
        ${m};
      }

      &::-ms-track {
        ${m};
      }

      &::-moz-range-progress {
        ${y};
      }

      &::-ms-fill-lower {
        ${y};
      }

      //thumb styles
      &::-webkit-slider-thumb {
        margin-top: calc(0.5 * (${u} - ${d}));
        ${b};
      }
      &::-moz-range-thumb {
        ${b};
      }
      &::-ms-thumb {
        margin-top: 0;
        ${b};
      }

      // hover on thumb
      &::-webkit-slider-thumb:hover {
        background-color: ${c};
        transform: scale(1.05);
      }
      &::-moz-range-thumb:hover {
        background-color: ${c};
        transform: scale(1.05);
      }
      &::-ms-thumb:hover {
        background-color: ${c};
        transform: scale(1.05);
      }

      // active thumb
      &::-webkit-slider-thumb:active {
        background-color: ${c};
        transform: scale(1.05);
      }
      &::-moz-range-thumb:active {
        background-color: ${c};
        transform: scale(1.05);
      }
      &::-ms-thumb:active {
        background-color: ${c};
        transform: scale(1.05);
      }
    `;
  }
), bw = v.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`, xw = v.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`, ww = v.div`
  display: flex;
  justify-content: center;
  min-width: 24px;
`, Zr = {
  Input: yw,
  Wrapper: bw,
  TextContainer: xw,
  Mark: ww
}, X3 = A((e, t) => {
  const {
    min: n,
    max: r,
    step: o = 1,
    value: i,
    initialValue: s = 0,
    thumbSize: a = 24,
    label: l,
    onChange: c,
    marks: d,
    ...u
  } = e, p = ie(), [f, m] = U(i || s), g = fe(
    (y) => {
      y && m(y), c && c(y);
    },
    [c]
  );
  return /* @__PURE__ */ M(Zr.Wrapper, { children: [
    l && /* @__PURE__ */ h(H, { as: "p", font: "p4RegularComp", color: p.colors.text.secondary, children: l }),
    /* @__PURE__ */ h(
      Zr.Input,
      {
        ...u,
        ref: t,
        type: "range",
        value: f,
        min: n,
        max: r,
        step: o,
        $thumbSize: a,
        onChange: (y) => g(y.target.value)
      }
    ),
    /* @__PURE__ */ h(Zr.TextContainer, { children: d && d.length > 1 && d.map(({ label: y, value: b }, w) => /* @__PURE__ */ h(Zr.Mark, { children: /* @__PURE__ */ h(H, { as: "p", font: "p4RegularComp", color: p.colors.text.secondary, children: y }) }, b + w)) })
  ] });
}), $w = {
  activeTab: void 0,
  setActiveTab: () => {
  }
}, Pp = be($w);
function Cw({
  children: e,
  activeTab: t,
  defaultActiveTab: n,
  onActiveTabChange: r
}) {
  const o = typeof t < "u", i = typeof n < "u", [s, a] = U(
    i ? n : void 0
  ), l = K(
    () => ({
      activeTab: o ? t : s,
      setActiveTab: (c) => {
        r && r(c), o || a(c);
      }
    }),
    [s, r, o, t]
  );
  return /* @__PURE__ */ h(Pp.Provider, { value: l, children: e });
}
const kw = v.li(
  ({ active: e, theme: { colors: t } }) => C`
    all: unset;
    display: flex;
    position: relative;
    z-index: 0;
    flex: 1 1 100%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    padding: 4px 0;
    ${ae(e ? "c1MediumComp" : "c1RegularComp")};
    color: ${e ? t.control.activeTabbar : t.control.inactiveTabbar};
    gap: 4px;
  `
), Sw = v.a`
  all: unset;
  cursor: pointer;
  order: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
`, Tw = v.div(
  ({ $hasCounter: e, $hasNotification: t }) => C`
    order: 0;
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    mask-position: center center;
    mask-repeat: no-repeat;
    mask: ${e ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23000000' fill-rule='evenodd' d='M24 0H0v24h24v-6.055a9.001 9.001 0 0 1 0-17.89V0Z' clip-rule='evenodd'/%3E%3C/svg%3E")` : t ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23000000' fill-rule='evenodd' d='M20 0H0v24h24V4a4 4 0 1 1-4-4Z' clip-rule='evenodd'/%3E%3C/svg%3E")` : "none"};
  `
), Ew = v.div`
  position: absolute;
  top: 5px;
  left: 50%;
  z-index: 0;
  display: flex;
  margin-left: 5px;
`, Rw = v.div`
  order: 0;
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  mask: none;
  mask-position: center center;
  mask-repeat: no-repeat;
  ${({ $hasNotification: e, $hasCounter: t }) => C`
    mask: ${t ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23000000' fill-rule='evenodd' d='M24 0H0v24h24v-6.055a9.001 9.001 0 0 1 0-17.89V0Z' clip-rule='evenodd'/%3E%3C/svg%3E")` : e ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23000000' fill-rule='evenodd' d='M20 0H0v24h24V4a4 4 0 1 1-4-4Z' clip-rule='evenodd'/%3E%3C/svg%3E")` : "none"};
  `}
`, Z3 = A((e, t) => {
  const { onClick: n, id: r, label: o, link: i, icon: s, avatar: a, counter: l, className: c, ...d } = e, { activeTab: u, setActiveTab: p } = se(Pp), f = () => {
    p(r), n && n();
  }, m = K(() => {
    let y;
    return a && (y = ge.cloneElement(a, { size: 24 })), y;
  }, [a]), g = K(() => {
    let y;
    return s && (y = ge.cloneElement(s, { width: 24, height: 24 })), y;
  }, [s]);
  return /* @__PURE__ */ M(
    kw,
    {
      className: c,
      active: u === r,
      onClick: f,
      ref: t,
      ...d,
      children: [
        /* @__PURE__ */ h(Sw, { href: i, children: o }),
        !m && s && /* @__PURE__ */ h(
          Tw,
          {
            active: u === r,
            $hasNotification: (l == null ? void 0 : l.props.size) === "notification",
            $hasCounter: !!l && (l == null ? void 0 : l.props.size) !== "notification",
            children: g
          }
        ),
        m && /* @__PURE__ */ h(
          Rw,
          {
            $hasNotification: (l == null ? void 0 : l.props.size) === "notification",
            $hasCounter: !!l && (l == null ? void 0 : l.props.size) !== "notification",
            children: m
          }
        ),
        l && /* @__PURE__ */ h(Ew, { children: l })
      ]
    }
  );
}), Aw = v.menu(({ $transparent: e, $separator: t, $variant: n, theme: { colors: r } }) => {
  const o = {
    default: r.background.bar,
    alternative: r.background.primaryElevated,
    transparent: "transparent"
  };
  return C`
    all: unset;
    display: flex;
    position: relative;
    width: 100%;
    height: calc(52px + env(safe-area-inset-bottom));
    z-index: 0;
    background-color: ${e ? "transparent" : o[n]};
    backdrop-filter: ${e || n === "transparent" ? "unset" : "blur(10px)"};
    -webkit-backdrop-filter: ${e || n === "transparent" ? "unset" : "blur(10px)"};
    padding-bottom: env(safe-area-inset-bottom);

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;
      border-top: ${t ? `1px solid ${r.background.stroke}` : "none"};
    }
  `;
}), q3 = A((e, t) => {
  const {
    children: n,
    transparent: r = !1,
    separator: o = !0,
    activeTab: i,
    onActiveTabChange: s,
    className: a,
    defaultActiveTab: l,
    variant: c = "default",
    ...d
  } = e;
  return /* @__PURE__ */ h(
    Cw,
    {
      onActiveTabChange: s,
      activeTab: i,
      defaultActiveTab: l,
      children: /* @__PURE__ */ h(
        Aw,
        {
          ...d,
          className: a,
          $transparent: r,
          $separator: o,
          $variant: c,
          ref: t,
          ...d,
          children: n
        }
      )
    }
  );
}), Pw = {
  offset: {
    width: 0,
    left: 0
  },
  setOffset: () => {
  },
  size: 32,
  type: "button",
  accent: void 0,
  fluid: void 0,
  activeTab: void 0,
  setActiveTab: () => ""
}, xa = be(Pw);
function Mw(e) {
  const {
    children: t,
    size: n,
    type: r,
    accent: o,
    fluid: i,
    activeTab: s,
    defaultActiveTab: a,
    onActiveTabChange: l
  } = e, c = typeof s < "u", d = typeof a < "u", [u, p] = U({
    width: 0,
    left: 0
  }), [f, m] = U(
    d ? a : void 0
  ), g = K(
    () => ({
      offset: u,
      setOffset: p,
      size: n,
      type: r,
      accent: o,
      fluid: i,
      activeTab: c ? s : f,
      setActiveTab: (y) => {
        l && l(y), c || m(y);
      }
    }),
    [
      u,
      n,
      r,
      o,
      i,
      f,
      l,
      c,
      s
    ]
  );
  return /* @__PURE__ */ h(xa.Provider, { value: g, children: t });
}
const Dw = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ T.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ T.createElement("title", { id: t }, e) : null, /* @__PURE__ */ T.createElement("path", { d: "M6.2 8.998C7.002 10.338 7.404 11 8 11c.594 0 .997-.661 1.8-2.002l.164-.272c.725-1.209 1.088-1.813.83-2.27C10.533 6 9.83 6 8.42 6h-.842c-1.41 0-2.114 0-2.373.457-.258.456.105 1.06.83 2.269z" })), Bw = A(Dw), Do = {
  32: {
    radius: "12px",
    height: "32px",
    font: "p4MediumComp",
    padding: "6px 12px",
    strokePadding: "6px 0",
    counterMargin: "4px"
  },
  52: {
    radius: "16px",
    height: "52px",
    font: "p3MediumComp",
    padding: "14px 20px",
    strokePadding: "14px 0",
    counterMargin: "6px"
  },
  72: {
    radius: "20px",
    height: "72px",
    font: "h4Comp",
    padding: "24px 28px",
    strokePadding: "32px 2px 16px",
    counterMargin: "6px"
  }
}, J3 = A((e) => {
  var $, E;
  const { id: t, text: n, onClick: r, children: o, withArrow: i, className: s, ...a } = e, { setOffset: l, size: c, type: d, accent: u, fluid: p, activeTab: f, setActiveTab: m } = se(xa), g = oe(null), [y, b] = U({
    width: 0,
    left: 0
  }), w = fe(() => {
    var S, F;
    b({
      width: ((S = g == null ? void 0 : g.current) == null ? void 0 : S.offsetWidth) || 0,
      left: ((F = g == null ? void 0 : g.current) == null ? void 0 : F.offsetLeft) || 0
    });
  }, [($ = g == null ? void 0 : g.current) == null ? void 0 : $.offsetLeft, (E = g == null ? void 0 : g.current) == null ? void 0 : E.offsetWidth]);
  gx("resize", w);
  const x = () => {
    m(t), r && r();
  };
  return Y(() => {
    t === f && w();
  }, [f]), Y(() => {
    t === f && l(y);
  }, [y]), Y(() => {
    w();
  }, [c, d, p]), /* @__PURE__ */ h(Lw, { ...a, ref: g, className: s, children: /* @__PURE__ */ M(
    Iw,
    {
      type: "button",
      onClick: x,
      $type: d,
      $active: t === f,
      $accent: u,
      children: [
        /* @__PURE__ */ h(H, { as: "p", color: "currentColor", font: Do[c].font || "p4MediumComp", children: n }),
        o && /* @__PURE__ */ h(Fw, { $size: c, children: o }),
        !o && i && d !== "button" && /* @__PURE__ */ h(Vw, { "aria-hidden": !0, $open: t === f && d === "stroke", children: /* @__PURE__ */ h(q, { icon: /* @__PURE__ */ h(Bw, {}) }) })
      ]
    }
  ) });
}), Lw = v.li`
  box-sizing: border-box;
  position: relative;
  height: 100%;
  width: fit-content;
  z-index: 2;
`, Iw = v.button`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  outline: none;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  ${({ theme: e, $size: t = 32, $accent: n = !1, $type: r, $active: o }) => C`
    padding: ${r === "stroke" ? Do[t].strokePadding : Do[t].padding};
    color: ${o ? r === "stroke" ? e.colors.text.primary : e.colors.text.inverted : n ? e.colors.text.primary : e.colors.text.secondary};
    ${!o && C`
      &:hover {
        transition: 0.3s;
        color: ${e.colors.text.secondary};
      }
    `}

    &:focus-visible {
      border: ${`1px solid ${e.colors.accent.active}`};
    }
  `}
`, Fw = v.div`
  display: flex;
  margin-left: ${({ $size: e = 32 }) => Do[e].counterMargin};
`, Vw = v.div`
  display: flex;
  justify-items: center;
  width: 16px;
  height: 16px;
  transform: ${({ $open: e }) => e && "scaleY(-1)"};
  svg {
    fill: ${({ theme: e }) => e.colors.icons.primary};
  }
`, Ow = {
  32: {
    radius: "12px"
  },
  52: {
    radius: "16px"
  },
  72: {
    radius: "20px"
  }
}, zw = A(
  (e, t) => {
    const { children: n, className: r, ...o } = e, { offset: i, type: s, size: a, fluid: l } = se(xa);
    return /* @__PURE__ */ M(Nw, { ...o, ref: t, $size: a, className: r, $fluid: l, $type: s, children: [
      n,
      /* @__PURE__ */ h(Ww, { $width: i.width, $position: i.left, $type: s, $size: a })
    ] });
  }
), Nw = v.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  position: relative;
  gap: ${({ $size: e = 32, $type: t }) => t === "button" ? "0" : e === 32 ? "16px" : "24px"};
  height: ${({ $size: e = 32 }) => `${e}px`};
  width: ${({ $fluid: e }) => e ? "100%" : "fit-content"};
`, Ww = v.div`
  position: absolute;
  bottom: 0;
  width: ${({ $width: e }) => `${e}px`};
  height: ${({ $type: e }) => e === "stroke" ? "2px" : "100%"};
  border-radius: ${({ $size: e = 32 }) => Ow[e].radius};
  background-color: ${({ theme: e, $type: t }) => t === "stroke" ? e.colors.brand : e.colors.control.secondaryActive};
  transform: ${({ $position: e }) => `translateX(${e}px)`};
  transition: transform 0.3s;
  z-index: 1;
`, Q3 = A((e, t) => {
  const {
    children: n,
    size: r = 32,
    type: o = "button",
    accent: i,
    fluid: s,
    activeTab: a,
    defaultActiveTab: l,
    onActiveTabChange: c,
    ...d
  } = e;
  return /* @__PURE__ */ h(
    Mw,
    {
      size: r,
      type: o,
      accent: i,
      fluid: s,
      activeTab: a,
      defaultActiveTab: l,
      onActiveTabChange: c,
      children: /* @__PURE__ */ h(zw, { ...d, ref: t, children: n })
    }
  );
}), _w = v.div(
  ({ $withBottomContent: e, $position: t, theme: { colors: n } }) => C`
    position: ${t};
    min-height: 84px;
    top: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    padding: 20px 0;
    background-color: ${n.background.primaryElevated};
    backdrop-filter: blur(40px);
    border-radius: 0 0 32px 32px;

    ${e && `
      flex-direction: column;
      gap: 8px;
    `}
  `
), jw = v.div`
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  min-height: 44px;
`, Hw = v.div(
  ({ $titlePosition: e, $actionsWidth: t }) => C`
    ${e === "center" && `
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      left: 0;
      right: 0;
      padding: ${t && t > 0 ? `0 ${t + 20}px` : "0 52px"};
      text-align: center;
    `}
    ${e === "left" && `
        word-break: break-word;
        padding-right: ${t && t > 0 && `${t + 12}px`};
      `}
  `
), Uw = v.div`
  position: absolute;
  right: 20px;
  :nth-child(2) {
    margin-left: 12px;
  }
`, mc = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.secondary};
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `
), Gw = v(H)(
  ({ $titlePosition: e }) => C`
    ${e === "center" && `
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `}
  `
), Kw = v(Ce)`
  z-index: 1;
  position: absolute;
`, Yw = ({ ...e }) => {
  const t = ie();
  return /* @__PURE__ */ h(Kw, { ...e, children: /* @__PURE__ */ h(
    q,
    {
      iconPath: "granat/chevron-left/size-24-style-outline",
      color: t.colors.icons.primary
    }
  ) });
}, eR = A((e, t) => {
  const {
    children: n,
    subtitle: r,
    actions: o,
    withBackButton: i,
    onBackClick: s,
    subtitlePosition: a,
    titlePosition: l = "center",
    bottomContent: c,
    position: d = "sticky",
    className: u,
    ...p
  } = e, f = oe(null), { width: m } = bx(f);
  return /* @__PURE__ */ M(
    _w,
    {
      className: u,
      ref: t,
      ...p,
      $withBottomContent: !!c,
      $position: d,
      children: [
        /* @__PURE__ */ M(jw, { children: [
          i && l !== "left" && /* @__PURE__ */ h(Yw, { variant: "ghost", size: 32, onClick: s }),
          n && typeof n == "string" && /* @__PURE__ */ M(Hw, { $titlePosition: l, $actionsWidth: m, children: [
            r && l !== "left" && a === "up" && /* @__PURE__ */ h(mc, { font: "p4RegularComp", children: r }),
            /* @__PURE__ */ h(
              Gw,
              {
                forwardedAs: "div",
                font: l === "left" ? "h3Wide" : "p3MediumComp",
                $titlePosition: l,
                children: n
              }
            ),
            r && l !== "left" && a === "down" && /* @__PURE__ */ h(mc, { font: "p4RegularComp", children: r })
          ] }),
          n && typeof n != "string" && n,
          o && /* @__PURE__ */ h(Uw, { ref: f, children: o == null ? void 0 : o.map((g, y) => /* @__PURE__ */ h(Ce, { ...g }, y)) })
        ] }),
        c && c
      ]
    }
  );
}), Mp = {
  20: {
    font: "p4RegularComp",
    textUnderlineOffset: 5
  },
  24: {
    font: "p3RegularComp",
    textUnderlineOffset: 6
  }
}, Xw = v.ol`
  all: unset;
  flex: none;
  display: flex;
`, Zw = v.li`
  all: unset;
  margin: 0;

  &:not(:first-child) {
    margin: 0 0 0 4px;
  }
`, qw = v.a(
  ({ $size: e = 24, $active: t, theme: { colors: n } }) => C`
    all: unset;
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    grid-gap: 4px;
    gap: 4px;
    color: ${t ? n.text.primary : n.text.secondaryLink};
    cursor: pointer;
    text-decoration: none;
    text-underline-offset: ${Mp[e].textUnderlineOffset}px;
    text-decoration-thickness: 1px;
    ${t && `
    pointer-events: none;
    ${Dp} {
      color: ${n.text.primary};
    }
  `}

    @media (any-hover: hover) {
      &:hover {
        text-decoration: underline;
      }
    }
  `
), Dp = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.secondaryLink};
  `
), tR = A((e, t) => {
  const { size: n = 24, children: r, ...o } = e, i = K(() => {
    const s = Tt.toArray(r);
    return Tt.map(
      s,
      (a, l) => tn(a, {
        active: s.length > 1 && l === s.length - 1,
        metaContent: l + 1,
        size: n,
        oneLine: s.length === 1
      })
    );
  }, [r, n]);
  return /* @__PURE__ */ h(Xw, { ...o, itemScope: !0, itemType: "https://schema.org/BreadcrumbList", ref: t, children: i });
}), Jw = ({ size: e }) => {
  const t = ie();
  return e === 20 ? /* @__PURE__ */ h(
    q,
    {
      iconPath: "granat/chevron-left/size-16-style-outline",
      color: t.colors.text.secondaryLink
    }
  ) : /* @__PURE__ */ h(
    q,
    {
      iconPath: "granat/chevron-left/size-24-style-outline",
      color: t.colors.text.secondaryLink
    }
  );
}, Qw = ({ size: e }) => {
  const t = ie();
  return e === 20 ? /* @__PURE__ */ h(
    q,
    {
      iconPath: "granat/chevron-right/size-16-style-outline",
      color: t.colors.text.secondaryLink
    }
  ) : /* @__PURE__ */ h(
    q,
    {
      iconPath: "granat/chevron-right/size-24-style-outline",
      color: t.colors.text.secondaryLink
    }
  );
}, e2 = ({
  size: e = 24,
  oneLine: t
}) => t ? /* @__PURE__ */ h(Jw, { size: e }) : /* @__PURE__ */ h(Qw, { size: e }), nR = A((e, t) => {
  const { href: n, onClick: r, children: o, active: i, metaContent: s, size: a = 24, oneLine: l, ...c } = e, d = e2({ size: a, oneLine: l });
  return /* @__PURE__ */ M(
    Zw,
    {
      ...c,
      ref: t,
      itemProp: "itemListElement",
      itemScope: !0,
      itemType: "https://schema.org/ListItem",
      children: [
        /* @__PURE__ */ M(qw, { href: n, onClick: () => r == null ? void 0 : r(), itemProp: "item", $size: a, $active: i, children: [
          l && d,
          /* @__PURE__ */ h(Dp, { font: Mp[a].font, itemProp: "name", children: o }),
          !i && !l && d
        ] }),
        /* @__PURE__ */ h("meta", { itemProp: "position", content: s })
      ]
    }
  );
}), t2 = {
  32: {
    content: {
      borderRadius: 12,
      padding: 4,
      minWidth: 32,
      minHeight: 32
    }
  },
  44: {
    content: {
      borderRadius: 16,
      padding: 10,
      minWidth: 44,
      minHeight: 44
    }
  }
}, gn = v.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $isActive: e, theme: t, $variant: n }) => e ? n === "alternative" ? t.colors.control.alternative : t.colors.control.tertiaryActive : "transparent"};
  color: ${({ theme: e }) => e.colors.text.primary};
`, n2 = v.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${gn} {
    ${({ $size: e }) => So(t2[e].content)}
    ${({ $size: e }) => ({
  32: ae("p3MediumComp"),
  44: ae("h4Comp")
})[e]}
  }
`, r2 = v.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  min-width: 44px;
  min-height: 44px;
  cursor: pointer;

  &:hover:not(:disabled) ${gn} {
    ${({ $isActive: e, theme: t, $variant: n }) => e ? C`
            filter: brightness(92%);
          ` : C`
            background-color: ${n === "alternative" ? t.colors.control.hoverPrimary : t.colors.background.hover};
          `}
  }

  &:focus-visible ${gn} {
    outline: 1px solid ${({ theme: e }) => e.colors.accent.active};
    outline-offset: 2px;
  }

  &:active:not(:disabled) ${gn} {
    transform: scale(0.98);
  }

  &:disabled {
    cursor: default;

    ${gn} {
      background-color: ${({ $isActive: e, theme: t }) => e ? t.colors.control.inactive : "transparent"};
      color: ${({ theme: e }) => e.colors.text.tertiary};

      svg {
        color: ${({ theme: e }) => e.colors.icons.secondary};
      }
    }
  }
`, o2 = v.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({
  theme: {
    colors: { text: e }
  },
  $disabled: t
}) => t ? e.tertiary : e.primary};
  min-width: 44px;
  min-height: 44px;
`, Bo = {
  Container: n2,
  PageButton: r2,
  PageButtonContent: gn,
  Dots: o2
}, Kn = "...", qr = (e, t) => Array.from({ length: t - e + 1 }, (n, r) => e + r), i2 = (e, t) => {
  if (e <= 7)
    return qr(1, e);
  const n = (i, s, a) => [
    ...i,
    s,
    ...a
  ], r = (i) => i <= 4, o = (i) => i >= e - 3;
  return r(t) ? n(qr(1, 5), Kn, [e]) : o(t) ? n([1], Kn, qr(e - 4, e)) : n([1], Kn, [
    ...qr(t - 1, t + 1),
    Kn,
    e
  ]);
}, gc = ({ direction: e = "left" }) => e === "left" ? /* @__PURE__ */ h(q, { iconPath: "granat/chevron-left/size-24-style-outline" }) : /* @__PURE__ */ h(q, { iconPath: "granat/chevron-right/size-24-style-outline" }), _i = ({
  disabled: e,
  onClick: t,
  children: n,
  isActive: r = !1,
  variant: o
}) => /* @__PURE__ */ h(Bo.PageButton, { onClick: t, disabled: e, $isActive: r, children: /* @__PURE__ */ h(Bo.PageButtonContent, { $variant: o, $isActive: r, children: n }) }), rR = ({
  total: e,
  onChange: t,
  size: n = 44,
  disabled: r = !1,
  variant: o = "default",
  ...i
}) => {
  const [s, a] = U(1), l = i.current ?? s, c = (d) => {
    _u(i.current) ? a(d) : t == null || t(d);
  };
  return /* @__PURE__ */ M(Bo.Container, { ...i, $size: n, children: [
    e > 2 && /* @__PURE__ */ h(
      _i,
      {
        onClick: () => c(l - 1),
        disabled: l === 1 || r,
        variant: o,
        children: /* @__PURE__ */ h(gc, {})
      }
    ),
    i2(e, l).map(
      (d, u) => d !== Kn ? /* @__PURE__ */ h(
        _i,
        {
          isActive: d === l,
          disabled: r,
          onClick: () => c(d),
          variant: o,
          children: d
        },
        u
      ) : /* @__PURE__ */ h(Bo.Dots, { $disabled: r, children: /* @__PURE__ */ h(q, { iconPath: "granat/more/size-24-style-outline" }) }, u)
    ),
    e > 2 && /* @__PURE__ */ h(
      _i,
      {
        onClick: () => c(l + 1),
        disabled: l === e || r,
        variant: o,
        children: /* @__PURE__ */ h(gc, { direction: "right" })
      }
    )
  ] });
}, s2 = {
  activeId: void 0,
  setActiveId: () => {
  }
}, Bp = be(s2);
function a2({
  children: e,
  activeId: t,
  defaultActiveId: n,
  onActiveIdChange: r
}) {
  const o = typeof t < "u", i = typeof n < "u", [s, a] = U(
    i ? n : void 0
  ), l = K(
    () => ({
      activeId: o ? t : s,
      setActiveId: (c) => {
        r && r(c), o || a(c);
      }
    }),
    [s, r, o, t]
  );
  return /* @__PURE__ */ h(Bp.Provider, { value: l, children: e });
}
const l2 = (e, t) => ge.cloneElement(e, { color: t, width: 24, height: 24 }), oR = A((e, t) => {
  const { id: n, text: r, counter: o, icon: i, onClick: s, ...a } = e, { activeId: l, setActiveId: c } = se(Bp), d = ie(), u = () => {
    c(n), s && s();
  }, p = K(
    () => n === l ? d.colors.brand : d.colors.icons.secondary,
    [l, n]
  );
  return /* @__PURE__ */ M(c2, { ...a, ref: t, $active: n === l, tabIndex: 0, onClick: u, children: [
    i && l2(i, p),
    /* @__PURE__ */ h(
      H,
      {
        font: n === l ? "p3MediumComp" : "p3RegularComp",
        as: "p",
        color: n === l ? d.colors.brand : d.colors.text.primary,
        children: r
      }
    ),
    o && /* @__PURE__ */ h(d2, { size: 20, value: 1, variant: "primary" })
  ] });
}), c2 = v.li`
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  border-radius: 12px;
  gap: 16px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  ${({ theme: e, $active: t }) => C`
    background-color: ${t ? e.colors.background.primaryElevated : "transparent"};
    &:focus-visible {
      border: ${({ theme: n }) => `1px solid ${n.colors.accent.active}`};
    }
    ${!t && C`
      &:hover {
        background-color: ${({ theme: n }) => n.colors.background.hover};
      }
    `}
  `}
`, d2 = v(lu)`
  margin-left: 8px;
`, iR = A((e, t) => {
  const { activeId: n, defaultActiveId: r, children: o, onActiveIdChange: i, ...s } = e;
  return /* @__PURE__ */ h(
    a2,
    {
      activeId: n,
      defaultActiveId: r,
      onActiveIdChange: i,
      children: /* @__PURE__ */ h(u2, { ...s, ref: t, children: o })
    }
  );
}), u2 = v.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: fit-content;
  position: relative;
`;
var pn = /* @__PURE__ */ ((e) => (e.BIG = "big", e.SMALL = "small", e))(pn || {});
const Yt = {
  wrap: {
    gap: 8,
    width: 8,
    height: 8
  },
  size: {
    small: {
      width: 6,
      height: 6,
      margin: 1
    },
    big: {
      width: 8,
      height: 8,
      margin: 0
    }
  }
}, p2 = 5, f2 = v.div`
  width: ${(p2 * 2 - 1) * Yt.wrap.width}px;
  overflow: hidden;
`, h2 = v.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: ${Yt.wrap.gap}px;
  transition: transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
`, m2 = v.div`
  width: ${Yt.wrap.width}px;
  height: ${Yt.wrap.height}px;
  display: flex;
  align-items: center;
  justify-content: center;
`, g2 = v.div(
  ({ $isActive: e, $size: t, $variant: n, theme: { colors: r } }) => C`
    width: ${Yt.size[t].width}px;
    height: ${Yt.size[t].height}px;
    margin: 0 ${Yt.size[t].margin}px 0;
    border-radius: 100%;
    background-color: ${n === "default" ? r.icons.secondary : r.constant.greyscale0};
    opacity: ${e ? 1 : n === "default" ? 0.3 : 0.6};
    transition: all 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  `
), v2 = (e, t, n) => t <= 2 && n <= 3 || t >= e - 3 && n >= e - 4 || n + 1 === t || n - 1 === t || n === t ? pn.BIG : pn.SMALL, y2 = (e, t) => t > 2 && t < e - 3 ? 16 * (t - 2) : t >= e - 3 ? 16 * (e - 5) : 0, sR = A((e, t) => {
  const { length: n, current: r, variant: o = "default", ...i } = e, s = y2(n, r);
  return /* @__PURE__ */ h(f2, { ref: t, ...i, children: /* @__PURE__ */ h(h2, { style: { transform: `translateX(-${s}px)` }, children: Array.from({ length: n }, (a, l) => /* @__PURE__ */ h(m2, { children: /* @__PURE__ */ h(
    g2,
    {
      $isActive: l === r,
      $size: v2(n, r, l),
      $variant: o
    }
  ) }, l)) }) });
}), Lo = {
  s: {
    height: 4,
    font: "c1RegularComp",
    textMarginTop: 8
  },
  m: {
    height: 8,
    font: "c1RegularComp",
    textMarginTop: 8
  },
  l: {
    height: 32,
    font: "p4MediumComp",
    textMarginTop: 0
  }
}, bt = {
  loading: "loading",
  pause: "pause",
  error: "error",
  success: "success"
}, Lp = ({
  $status: e = "loading",
  $color: t,
  colors: n
}) => {
  const r = {
    [bt.loading]: t || n.accent.positive,
    [bt.pause]: n.accent.warning,
    [bt.error]: n.accent.negative,
    [bt.success]: n.accent.positive
  }, o = {
    [bt.loading]: n.text.secondary,
    [bt.pause]: n.text.secondary,
    [bt.error]: n.text.negative,
    [bt.success]: n.text.positive
  };
  return {
    barColor: r[e],
    textColor: o[e]
  };
}, b2 = v.div`
  position: relative;
`, x2 = v.div(
  ({ $size: e = "m", $color: t, $opacity: n, theme: { colors: r } }) => C`
    width: 100%;
    height: ${Lo[e].height}px;
    background-color: ${t || r.background.stroke};
    border-radius: 12px;
    ${n && `
      opacity: ${n};
    `}
  `
), w2 = v.div(
  ({ $status: e, $value: t, $color: n, theme: { colors: r } }) => C`
    position: absolute;
    top: 0;
    left: 0;
    width: calc(${t} * 1%);
    height: 100%;
    background-color: ${Lp({ $status: e, $color: n, colors: r }).barColor};
    border-radius: 12px;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: right;
    transition: 0.5s;
    transition-timing-function: cubic-bezier(0, 0, 1, 1);
  `
), vc = v(H)(
  ({ $size: e = "m", theme: { colors: t } }) => C`
    margin-top: ${Lo[e].textMarginTop}px;
    margin-right: ${e === "l" ? "8px" : 0};
    margin-left: ${e === "l" ? "8px" : 0};
    color: ${e === "l" ? t.constant.greyscale900 : t.text.secondary};
  `
), $2 = v.div(
  ({ $status: e }) => C`
    margin-top: ${e === "success" || e === "error" ? "4px" : "8px"};
    display: ${e === "success" || e === "error" ? "grid" : "block"};
    ${(e === "success" || e === "error") && `
    grid-template-columns: 1fr auto;
    align-items: center;
  `}
  `
), C2 = v(H)(
  ({ $status: e, theme: { colors: t } }) => C`
    color: ${Lp({ $status: e, colors: t }).textColor};
  `
), yc = 100, aR = A((e, t) => {
  const {
    value: n = 0,
    size: r = "m",
    withPercent: o,
    status: i = "loading",
    statusText: s,
    customLoadingColor: a,
    customBarColor: l,
    opacity: c,
    ...d
  } = e, u = K(() => n < 0 ? 0 : n >= yc ? yc : Math.floor(n), [n]), p = /* @__PURE__ */ M($2, { $status: i, children: [
    /* @__PURE__ */ h(C2, { forwardedAs: "div", $status: i, font: "c1RegularComp", children: s }),
    i === "success" ? /* @__PURE__ */ h(hy, {}) : i === "error" ? /* @__PURE__ */ h(my, {}) : null
  ] });
  return /* @__PURE__ */ M(We, { children: [
    /* @__PURE__ */ M(b2, { ...d, ref: t, children: [
      /* @__PURE__ */ h(x2, { $size: r, $color: l, $opacity: c }),
      /* @__PURE__ */ h(w2, { $value: u, $status: i, $color: a, children: r === "l" && /* @__PURE__ */ h(vc, { forwardedAs: "div", font: Lo[r].font, $size: r, children: i === "success" ? "Завершено" : i === "error" ? "Ошибка" : `${u}%` }) })
    ] }),
    r !== "l" && o && i === "loading" && /* @__PURE__ */ h(vc, { forwardedAs: "div", font: Lo[r].font, $size: r, children: `${u}%` }),
    r === "l" ? i === "error" ? p : null : i !== "loading" ? p : null
  ] });
}), k2 = ({ size: e = "m" }) => {
  const t = ie();
  return e === "l" ? /* @__PURE__ */ h(q, { iconPath: "granat/check/size-44-style-outline", color: t.colors.accent.positive }) : /* @__PURE__ */ h(q, { iconPath: "granat/check/size-24-style-outline", color: t.colors.accent.positive });
}, S2 = ({ size: e }) => {
  const t = ie();
  return e === "l" ? /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-44-style-outline", color: t.colors.accent.negative }) : /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-24-style-outline", color: t.colors.accent.negative });
}, Pn = {
  s: {
    width: 52,
    height: 52,
    font: "p4MediumComp",
    statusTextMaxWidth: "100px"
  },
  m: {
    width: 80,
    height: 80,
    font: "p3MediumComp",
    statusTextMaxWidth: "120px"
  },
  l: {
    width: 120,
    height: 120,
    font: "h3Wide",
    statusTextMaxWidth: "none"
  }
}, Jr = {
  loading: "loading",
  pause: "pause",
  error: "error",
  success: "success"
}, T2 = 57, ji = 2 * Math.PI * T2, E2 = 100, R2 = ({
  $status: e = "loading",
  $color: t,
  colors: n
}) => ({
  [Jr.loading]: t || n.accent.positive,
  [Jr.pause]: n.accent.warning,
  [Jr.error]: n.accent.negative,
  [Jr.success]: n.accent.positive
})[e], A2 = v.div`
  display: inline-grid;
  justify-items: center;
`, P2 = v.div(
  ({ $size: e = "m" }) => C`
    width: ${Pn[e].width}px;
    height: ${Pn[e].height}px;
    display: grid;
  `
), M2 = v.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  align-self: center;
  justify-self: center;
`, D2 = v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.primary};
  `
), B2 = v.svg(
  ({ $size: e = "m" }) => C`
    --progress-circle__icon--display: block;
    width: ${Pn[e].width}px;
    height: ${Pn[e].height}px;
    transform: rotate(-90deg);
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  `
), L2 = v.circle(
  ({ $color: e, $opacity: t, theme: { colors: n } }) => C`
    fill: none;
    stroke: ${e || n.background.stroke};
    stroke-width: 6px;
    ${t && `
      opacity: ${t};
    `}
  `
), I2 = v.circle(
  ({ $status: e, $color: t, $value: n, theme: { colors: r } }) => C`
    fill: none;
    stroke: ${R2({ $status: e, $color: t, colors: r })};
    stroke-width: 6px;
    stroke-linecap: round;
    stroke-dashoffset: ${ji};
    stroke-dasharray: calc(${ji} + (${ji} / ${E2} * ${n}));
    transition: 0.5s;
    transition-timing-function: cubic-bezier(0, 0, 1, 1);
  `
), F2 = v(H)(
  ({ $status: e, $size: t = "m", theme: { colors: n } }) => C`
    color: ${e === "error" ? n.text.negative : n.text.secondary};
    margin-top: 8px;
    max-width: ${Pn[t].statusTextMaxWidth};
    text-align: center;
  `
), bc = 100, lR = A((e, t) => {
  const {
    value: n = 0,
    children: r,
    size: o = "m",
    status: i = "loading",
    statusText: s,
    customLoadingColor: a,
    customBarColor: l,
    opacity: c,
    ...d
  } = e, u = K(() => n < 0 ? 0 : n >= bc ? bc : Math.floor(n), [n]);
  return /* @__PURE__ */ M(A2, { ...d, ref: t, children: [
    /* @__PURE__ */ M(P2, { $size: o, children: [
      /* @__PURE__ */ M(M2, { children: [
        (i === "loading" || i === "pause") && /* @__PURE__ */ h(D2, { forwardedAs: "div", font: Pn[o].font, children: r || `${u}%` }),
        i === "success" ? /* @__PURE__ */ h(k2, { size: o }) : i === "error" ? /* @__PURE__ */ h(S2, { size: o }) : null
      ] }),
      /* @__PURE__ */ M(
        B2,
        {
          $size: o,
          style: { display: "var(--progress-circle__icon--display, none)" },
          viewBox: "0 0 120 120",
          children: [
            /* @__PURE__ */ h(L2, { cx: "60", cy: "60", r: "57", $color: l, $opacity: c }),
            /* @__PURE__ */ h(
              I2,
              {
                $value: u,
                $status: i,
                cx: "60",
                cy: "60",
                r: "57",
                $color: a
              }
            )
          ]
        }
      )
    ] }),
    (i === "pause" || i === "error") && /* @__PURE__ */ h(F2, { $size: o, forwardedAs: "div", font: "c1RegularComp", $status: i, children: s })
  ] });
}), Ip = be(void 0), V2 = function({ timeout: t, children: n }) {
  return /* @__PURE__ */ h(Ip.Provider, { value: t, children: n });
}, O2 = () => {
  const e = se(Ip);
  if (e === void 0) throw new Error("useTimeout must be used within a TimeoutProvider");
  return e;
}, z2 = v.div`
  display: ${({ $view: e }) => e === "mobile" ? "grid" : "inline-grid"};
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto;
  align-items: center;
  box-sizing: border-box;
  width: ${({ $view: e }) => e === "mobile" ? "100%" : "auto"};
  max-width: ${({ $view: e }) => e === "mobile" ? "none" : "364px"};
  padding: 0 0 0 10px;
  border-radius: 16px;
  overflow: hidden;
  background: ${({ theme: e }) => e.colors.background.inverted};
`, N2 = v(H)`
  grid-column: 2 / 3;
  margin: 0;
  padding: 10px 0;
  overflow-wrap: break-word;
  word-break: break-word;
`, W2 = v("button")`
  all: unset;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  position: relative;
  z-index: 0;
  display: inline-block;
  grid-column: 3 / 4;
  background: transparent;
  border: 0;
  border-radius: 16px;
  height: 100%;
  padding: 10px 12px 10px 12px;
  margin: 0 0 0 13px;
  color: ${({ theme: e }) => e.colors.text.inverted};
  cursor: pointer;
  box-sizing: border-box;
  ${ae("p3MediumComp")};
  &::before {
    content: '';
    position: absolute;
    left: -1px;
    top: 8px;
    bottom: 8px;
    z-index: 1;
    border-left: ${({ theme: e }) => `1px solid ${e.colors.background.stroke}`};
  }
`, _2 = v.div`
  grid-area: 1 / 1 / 2 / 2;
  margin-right: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
`, Qr = {
  Snackbar: z2,
  IconWrapper: _2,
  Message: N2,
  Button: W2
}, cR = A((e, t) => {
  const {
    message: n,
    actionLabel: r,
    view: o,
    timeout: i = 5e3,
    className: s,
    onAction: a,
    onTimeout: l,
    icon: c,
    ...d
  } = e, u = ie(), p = Math.max(3e3, Math.min(15e3, i));
  return Y(() => {
    const f = setTimeout(() => {
      l && l();
    }, p);
    return () => {
      clearTimeout(f);
    };
  }, [p, l]), /* @__PURE__ */ M(Qr.Snackbar, { ...d, className: s, ref: t, $view: o, children: [
    /* @__PURE__ */ h(V2, { timeout: p, children: c && /* @__PURE__ */ h(Qr.IconWrapper, { children: tn(c, { inverted: !0, width: 20, height: 20 }) }) }),
    /* @__PURE__ */ h(Qr.Message, { forwardedAs: "p", color: u.colors.text.inverted, font: "p3RegularComp", children: n }),
    /* @__PURE__ */ h(Qr.Button, { type: "button", onClick: a, children: r })
  ] });
}), j2 = ({
  title: e,
  titleId: t,
  ...n
}, r) => /* @__PURE__ */ T.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: r, "aria-labelledby": t, ...n }, e ? /* @__PURE__ */ T.createElement("title", { id: t }, e) : null, /* @__PURE__ */ T.createElement("circle", { cx: 12, cy: 12, r: 10, fill: "none" })), H2 = A(j2), dR = () => {
  const e = O2();
  return /* @__PURE__ */ h(K2, { $value: e, children: /* @__PURE__ */ h(q, { icon: /* @__PURE__ */ h(H2, {}), width: 24, height: 24 }) });
}, U2 = Gs`
  100% {
    stroke-dashoffset: 63px;
  }
`, G2 = Gs`
  100% {
    transform: translateY(-100%);
  }
`, K2 = v.div`
  grid-area: 1 / 1 / 2 / 2;
  overflow: hidden;
  position: relative;
  left: 0;
  margin-right: 4px;
  z-index: 0;
  min-width: 24px;
  min-height: 24px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${ae("p4MediumComp")};
  &::before {
    content: '15 14 13 12 11 10 9 8 7 6 5 4 3 2 1 0';
    position: absolute;
    top: 24px;
    z-index: 1;
    line-height: 24px;
    word-spacing: 24px;
    text-align: center;
    ${({ theme: e, $value: t }) => C`
      color: ${e.colors.text.inverted};
      animation: ${G2} 16s steps(16, end) calc(${t + "ms"} - 16s) forwards;
    `}
    transform: translateY(0.5px);
  }
  & circle {
    stroke-width: 2px;
    stroke-dasharray: 63px;
    stroke-dashoffset: 126px;
    ${({ theme: e, $value: t }) => C`
      stroke: ${e.colors.control.primaryActive};
      animation: ${U2} ${t + "ms"} 0s linear forwards;
    `}
  }
  svg {
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }
`, uR = A((e, t) => {
  const n = ie(), { isMobile: r } = Ln(), { title: o, message: i, avatar: s, icon: a, ...l } = e, c = K(() => {
    let d;
    return s && (d = T.cloneElement(s, { size: 44 })), d;
  }, [s]);
  return /* @__PURE__ */ M(Y2, { ...l, ref: t, isMobile: r, children: [
    o && /* @__PURE__ */ h(
      X2,
      {
        font: r ? "p4BoldComp" : "p3BoldComp",
        color: n.colors.text.inverted,
        forwardedAs: "p",
        children: o
      }
    ),
    /* @__PURE__ */ h(
      Z2,
      {
        font: r ? "p4RegularComp" : "p3RegularComp",
        color: n.colors.text.inverted,
        forwardedAs: "p",
        children: i
      }
    ),
    c && /* @__PURE__ */ h(J2, { children: c }),
    !c && a && /* @__PURE__ */ h(q2, { children: T.cloneElement(a, { inverted: !0 }) })
  ] });
}), Y2 = v.div`
  ${({ theme: e, isMobile: t = !1 }) => C`
      padding: 8px 12px;
      grid-template-columns: auto 1fr;
      grid-template-rows: auto;
      background: ${e.colors.background.inverted};
      overflow: hidden;
      align-items: center;
      box-sizing: border-box;
      display: inline-grid;
      max-width: ${t ? "100%" : "364px"};
      border-radius: ${t ? "12px" : "16px"};
      width: ${t ? "100%" : "unset"};
    `}
`, X2 = v(H)`
  grid-column: 2 / 3;
  overflow-wrap: break-word;
  word-break: break-word;
`, Z2 = v(H)`
  grid-column: 2 / 3;
  overflow-wrap: break-word;
  word-break: break-word;
  margin: 0;
`, q2 = v.div`
  grid-area: 1 / 1 / 2 / 2;
  margin-right: 4px;
  position: relative;
  z-index: 1;
  width: 24px;
  height: 24px;
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -2px;
  left: -2px;
`, J2 = v.div`
  grid-area: 1 / 1 / 2 / 2;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  grid-row: 1 / 3;
`, Q2 = v(pa)(
  ({ filled: e, theme: { colors: t } }) => C`
    ${e && `
    background-color: ${t.background.lower};
  `}
  `
), Fp = Gs`
  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
`, e$ = v.div(
  ({ $height: e = 32, $radius: t = 4, theme: { colors: n } }) => C`
    width: 100%;
    height: ${e}px;
    border-radius: ${t}px;
    animation: ${Fp} 2s infinite ease-out;
    background-color: ${n.background.stroke};
  `
), t$ = v.div(
  ({ $height: e = 32, theme: { colors: t } }) => C`
    display: inline-flex;
    border-radius: 100px;
    min-height: ${e}px;
    min-width: ${e}px;
    max-height: ${e}px;
    max-width: ${e}px;
    animation: ${Fp} 2s infinite ease-out;
    background-color: ${t.background.stroke};
  `
), pR = A((e, t) => {
  const { children: n, filled: r, ...o } = e;
  return /* @__PURE__ */ h(Q2, { ...o, filled: r, ref: t, children: n });
}), fR = A((e, t) => {
  const { height: n, radius: r, ...o } = e;
  return /* @__PURE__ */ h(e$, { ...o, $height: n, $radius: r, ref: t });
}), hR = A(
  (e, t) => {
    const { height: n, ...r } = e;
    return /* @__PURE__ */ h(t$, { ...r, $height: n, ref: t });
  }
), n$ = v.div`
  min-height: 92px;
`, r$ = v.div(
  ({ $centered: e }) => C`
    display: flex;
    justify-content: ${e ? "center" : "normal"};
    gap: 4px;
  `
), o$ = v.input(
  ({ $variant: e = "primary", $loading: t, disabled: n, $hasError: r, $index: o, theme: { colors: i } }) => C`
    box-sizing: border-box;
    min-width: 42px;
    max-width: 52px;
    height: 64px;
    border-radius: 16px;
    background-color: ${{
    primary: i.background.secondary,
    secondary: i.background.secondaryElevated
  }[e]};
    border-width: 1px;
    border-style: solid;
    border-color: ${r ? i.accent.negative : i.background.stroke};
    ${ae("h4Comp")}
    color: ${n ? t ? i.text.primary : i.text.tertiary : i.text.primary};
    padding: 0;
    text-align: center;

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        border-color: ${r ? i.accent.negative : i.control.secondaryActive};
      }
    }

    &:disabled {
      pointer-events: none;
      border-color: ${i.background.strokeDisabled};
      background-color: ${!t && i.background.disabled};

      ${t && `
          &:nth-child(${o + 1}) {
            animation: loadingAnimation 1s ${o === 0 ? 0 : `.${o}`}s linear infinite;
          }
        `}
    }

    &:focus {
      outline: none;
      border-color: ${!r && i.accent.active};
    }

    @keyframes loadingAnimation {
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0.25;
      }
      0% {
        opacity: 1;
      }
    }
  `
), i$ = v(H)(
  ({ $centered: e, theme: { colors: t } }) => C`
    color: ${t.text.negative};
    text-align: ${e ? "center" : "left"};
  `
), s$ = A((e, t) => {
  const {
    fieldsCount: n = 4,
    loading: r,
    disabled: o,
    autoFocus: i = !0,
    variant: s = "primary",
    onComplete: a,
    onChange: l,
    isErrorAutoClear: c = !1,
    autoClearTimer: d = 3e3,
    centered: u,
    ...p
  } = e, [f, m] = U(new Array(n).fill("")), [g, y] = U([]), [b, w] = U(""), [x, $] = U(!1);
  Y(() => {
    y(
      (R) => Array(f.length).fill(null).map((L, P) => R[P] || Vh())
    );
  }, []);
  const E = (R) => R.target.select(), S = (R, L) => {
    const P = g[L - 1], j = g[L + 1];
    switch (R.key) {
      case "Backspace": {
        R.preventDefault(), f[L] ? m([
          ...f.slice(0, L),
          "",
          ...f.slice(L + 1, f.length)
        ]) : P && (m([
          ...f.slice(0, L - 1),
          "",
          ...f.slice(L, f.length)
        ]), P.current.focus());
        break;
      }
      case "ArrowLeft":
        R.preventDefault(), P && P.current.focus();
        break;
      case "ArrowRight":
        R.preventDefault(), j && j.current.focus();
        break;
    }
  }, F = (R, L) => {
    let P = R.target.value;
    if (P = P.replace(/[^\d]/gi, ""), !P) return;
    m(
      [
        ...f.slice(0, L),
        ...P.split(""),
        ...f.slice(L + P.length)
      ].slice(0, n)
    );
    const j = g[L + 1];
    P && L < f.length - 1 && j.current && j.current.focus();
  };
  return Y(() => {
    const R = f.join("");
    if (l == null || l(R), a && R.length === n && !x) {
      const L = (P) => {
        w(P);
      };
      a == null || a(R, L);
    }
    R.length < n && b && w("");
  }, [f, x]), Y(() => {
    f.join("").length === n ? $(!0) : $(!1);
  }, [f]), Y(() => {
    b && c && setTimeout(() => {
      var P;
      const R = Array(n).fill(""), L = g[0];
      w(""), m(R), (P = L.current) == null || P.focus();
    }, d);
  }, [b]), Y(() => {
    if ("OTPCredential" in window && navigator.credentials) {
      const R = new AbortController();
      return navigator.credentials.get({
        otp: { transport: ["sms"] },
        signal: R.signal
      }).then((L) => {
        g.map((P, j) => P.current.value = L.code[j]);
      }).catch((L) => {
        console.error(L);
      }), () => {
        R.abort();
      };
    }
  }, [g]), /* @__PURE__ */ M(n$, { ...p, ref: t, children: [
    /* @__PURE__ */ h(r$, { $centered: u, children: f.map((R, L) => /* @__PURE__ */ h(
      o$,
      {
        $index: L,
        value: R,
        onChange: (P) => F(P, L),
        onKeyDown: (P) => S(P, L),
        onFocus: E,
        ref: g[L],
        disabled: r ? !0 : o,
        $loading: r,
        $hasError: b.length > 0,
        $variant: s,
        inputMode: "numeric",
        autoFocus: !!(i && L === 0),
        autoComplete: "one-time-code"
      },
      L
    )) }),
    b && /* @__PURE__ */ M(We, { children: [
      /* @__PURE__ */ h(co, { space: "s8", spacemob: "s8" }),
      /* @__PURE__ */ h(i$, { forwardedAs: "div", font: "p4RegularComp", $centered: u, children: b })
    ] })
  ] });
}), a$ = (e) => String(e).length === 1 ? `0${e}` : `${e}`, l$ = (e) => {
  const t = Math.floor(e / 60), n = e % 60;
  return `${t}:${a$(n)}`;
}, c$ = (e) => {
  const {
    timerText: t,
    afterTimerLinkText: n,
    timerDuration: r = 30,
    onLinkClick: o,
    resendCode: i,
    centered: s
  } = e, [a, l] = U(r), [c, d] = U(!0), u = ie();
  return Y(() => {
    let f;
    return a !== 0 ? f = setInterval(() => {
      l((m) => m - 1);
    }, 1e3) : d(!1), () => clearInterval(f);
  }), c ? /* @__PURE__ */ M(
    d$,
    {
      centered: s,
      forwardedAs: "div",
      font: "p4RegularComp",
      color: u.colors.text.secondary,
      children: [
        t,
        " ",
        l$(a)
      ]
    }
  ) : /* @__PURE__ */ h(u$, { centered: s, forwardedAs: "a", font: "p4RegularComp", onClick: () => {
    o == null || o(), i && (d(!0), l(r));
  }, children: n });
}, d$ = v(H)(
  ({ centered: e }) => C`
    text-align: ${e ? "center" : "left"};
  `
), u$ = v(H)(
  ({ centered: e, theme: { colors: t } }) => C`
    color: ${t.text.primaryLink};
    cursor: pointer;
    text-align: ${e ? "center" : "left"};
  `
), p$ = v.div``, xc = v(H)(
  ({ $centered: e }) => C`
    text-align: ${e ? "center" : "left"};
    word-break: break-word;
  `
);
v(H)(
  ({ theme: { colors: e } }) => C`
    color: ${e.text.primaryLink};
    cursor: pointer;
  `
);
const mR = A((e, t) => {
  const {
    title: n,
    subtitle: r,
    isTimerEnabled: o = !0,
    timerText: i,
    afterTimerLinkText: s,
    timerDuration: a = 30,
    onLinkClick: l,
    resendCode: c,
    secondLink: d,
    centered: u,
    inputCodeProps: p,
    ...f
  } = e;
  return /* @__PURE__ */ M(p$, { ...f, ref: t, children: [
    n && /* @__PURE__ */ M(We, { children: [
      /* @__PURE__ */ h(xc, { $centered: u, forwardedAs: "div", font: "h4Wide", children: n }),
      /* @__PURE__ */ h(co, { space: "s8", spacemob: "s8" })
    ] }),
    r && /* @__PURE__ */ M(We, { children: [
      /* @__PURE__ */ h(xc, { $centered: u, forwardedAs: "div", font: "p3RegularComp", children: r }),
      /* @__PURE__ */ h(co, { space: "s24", spacemob: "s24" })
    ] }),
    /* @__PURE__ */ h(s$, { centered: u, ...p }),
    /* @__PURE__ */ h(co, { space: "s24", spacemob: "s24" }),
    /* @__PURE__ */ M(pa, { gap: 12, flexDirection: "column", alignItems: u ? "center" : "normal", children: [
      o && /* @__PURE__ */ h(
        c$,
        {
          timerDuration: a,
          timerText: i,
          afterTimerLinkText: s,
          onLinkClick: l,
          resendCode: c,
          centered: u
        }
      ),
      d && d
    ] })
  ] });
}), gR = A((e, t) => {
  const { title: n, subtitle: r, graphic: o, className: i, controls: s, children: a } = e, l = ie(), { isMobile: c } = Ln();
  return /* @__PURE__ */ M(f$, { className: i, ref: t, children: [
    o && /* @__PURE__ */ h(g$, { children: o }),
    /* @__PURE__ */ M(h$, { children: [
      /* @__PURE__ */ h(H, { as: "h3", font: "h3Wide", color: l.colors.text.primary, children: n }),
      r && /* @__PURE__ */ h(H, { as: "p", font: "p3RegularComp", color: l.colors.text.secondary, children: r })
    ] }),
    a,
    c && /* @__PURE__ */ h(m$, {}),
    s
  ] });
}), f$ = v.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  gap: 8px;
  @media (max-width: ${me.tablet}px) {
    height: 100%;
  }
`, h$ = v.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  word-break: break-word;
  text-align: center;
`, m$ = v.div`
  display: flex;
  flex-grow: 1;
`, g$ = v.div`
  min-height: 168px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 24px;
  img {
    max-width: 168px;
    max-height: 100%;
  }
`, vR = A((e, t) => {
  const { children: n, className: r, ...o } = e, { isMobile: i, isTablet: s } = Ln(), a = K(() => Array.isArray(n) ? n.map(
    (l) => T.cloneElement(l, { size: 52, fluid: i || s })
  ) : T.cloneElement(n, { size: 52, fluid: i || s }), [n, s, i]);
  return /* @__PURE__ */ h(v$, { ...o, ref: t, className: r, children: a });
}), v$ = v.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding-top: 24px;
  @media (min-width: ${me.desktopXS}px) {
    flex-direction: row;
    width: auto;
    flex-shrink: 0;
  }

  @media (max-width: ${me.tablet}px) {
    position: sticky;
    bottom: 0;
    padding: 8px 0 12px;
  }
`, yR = A((e, t) => {
  const n = ie(), { title: r, subtitle: o, ...i } = e;
  return /* @__PURE__ */ M(y$, { ...i, ref: t, children: [
    /* @__PURE__ */ h(ia, { size: 44 }),
    /* @__PURE__ */ M(b$, { children: [
      r && /* @__PURE__ */ h(H, { as: "h3", font: "h3Wide", color: n.colors.text.primary, children: r }),
      o && /* @__PURE__ */ h(H, { as: "p", font: "p3RegularComp", color: n.colors.text.secondary, children: o })
    ] })
  ] });
}), y$ = v.div`
  width: 100%;
  padding: 40px 0 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  @media (min-width: ${me.tablet}px) {
    padding: 80px 0;
  }
`, b$ = v.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 0 20px;
  word-break: break-word;
`, eo = {
  desktopS: {
    workspace: "1168px",
    marginNormal: "56px"
  },
  desktopM: {
    workspace: "1264px",
    marginNormal: "88px"
  },
  desktopL: {
    workspace: "1360px",
    marginNormal: "160px"
  },
  desktopXL: {
    workspace: "1552px",
    marginNormal: "184px"
  }
}, bR = ({ children: e, size: t = 12, ...n }) => /* @__PURE__ */ h(w$, { ...n, size: t, children: e }), xR = ({ children: e, margin: t = "normal", noMarginMobile: n = !0, ...r }) => /* @__PURE__ */ h(x$, { ...r, margin: t, noMarginMobile: n, children: e }), x$ = v.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin: ${({ noMarginMobile: e }) => e ? "0" : "0 20px"};
  max-width: 100%;
  box-sizing: border-box;
  min-height: 100%;
  @media (min-width: ${me.tablet}px) {
    gap: 32px;
    grid-template-columns: repeat(12, 1fr);
    margin: 0 40px;
  }
  @media (min-width: ${me.desktopS}px) {
    margin: ${({ margin: e }) => e === "wide" ? "0 40px" : `0 ${eo.desktopS.marginNormal}`};
  }
  @media (min-width: ${me.desktopM}px) {
    margin: ${({ margin: e }) => e === "wide" ? "0 40px" : `0 ${eo.desktopM.marginNormal}`};
  }
  @media (min-width: ${me.desktopL}px) {
    margin: ${({ margin: e }) => e === "wide" ? "0 40px" : `0 ${eo.desktopL.marginNormal}`};
  }
  @media (min-width: ${me.desktopXL}px) {
    max-width: ${eo.desktopXL.workspace};
    margin: 0 auto;
  }
`, w$ = v.div`
  width: 100%;
  grid-column: span 4;
  position: relative;
  @media (min-width: ${me.tablet}px) {
    grid-column: ${({ size: e }) => e ? `span ${e}` : "auto"};
  }
`, wc = /* @__PURE__ */ new Set();
function Rr(e, t, n) {
  e || wc.has(t) || (console.warn(t), wc.add(t));
}
function $$(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && Rr(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => o === "create" ? e : (t.has(o) || t.set(o, e(o)), t.get(o))
  });
}
function hr(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const As = (e) => Array.isArray(e);
function Vp(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function mr(e) {
  return typeof e == "string" || Array.isArray(e);
}
function $c(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function wa(e, t, n, r) {
  if (typeof t == "function") {
    const [o, i] = $c(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, i] = $c(r);
    t = t(n !== void 0 ? n : e.custom, o, i);
  }
  return t;
}
function hi(e, t, n) {
  const r = e.getProps();
  return wa(r, t, n !== void 0 ? n : r.custom, e);
}
const $a = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Ca = ["initial", ...$a], Ar = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], It = new Set(Ar), Ge = (e) => e * 1e3, Je = (e) => e / 1e3, C$ = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, k$ = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), S$ = {
  type: "keyframes",
  duration: 0.8
}, T$ = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, E$ = (e, { keyframes: t }) => t.length > 2 ? S$ : It.has(e) ? e.startsWith("scale") ? k$(t[1]) : C$ : T$;
function R$({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: i, repeatType: s, repeatDelay: a, from: l, elapsed: c, ...d }) {
  return !!Object.keys(d).length;
}
function ka(e, t) {
  return e[t] || e.default || e;
}
const A$ = {
  skipAnimations: !1,
  useManualTiming: !1
}, P$ = (e) => e !== null;
function mi(e, { repeat: t, repeatType: n = "loop" }, r) {
  const o = e.filter(P$), i = t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !i || r === void 0 ? o[i] : r;
}
const Ae = (e) => e;
function M$(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, o = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function a(c) {
    i.has(c) && (l.schedule(c), e()), c(s);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, d = !1, u = !1) => {
      const f = u && r ? t : n;
      return d && i.add(c), f.has(c) || f.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), i.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (s = c, r) {
        o = !0;
        return;
      }
      r = !0, [t, n] = [n, t], n.clear(), t.forEach(a), r = !1, o && (o = !1, l.process(c));
    }
  };
  return l;
}
const to = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], D$ = 40;
function Op(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => n = !0, s = to.reduce((b, w) => (b[w] = M$(i), b), {}), { read: a, resolveKeyframes: l, update: c, preRender: d, render: u, postRender: p } = s, f = () => {
    const b = performance.now();
    n = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(b - o.timestamp, D$), 1), o.timestamp = b, o.isProcessing = !0, a.process(o), l.process(o), c.process(o), d.process(o), u.process(o), p.process(o), o.isProcessing = !1, n && t && (r = !1, e(f));
  }, m = () => {
    n = !0, r = !0, o.isProcessing || e(f);
  };
  return { schedule: to.reduce((b, w) => {
    const x = s[w];
    return b[w] = ($, E = !1, S = !1) => (n || m(), x.schedule($, E, S)), b;
  }, {}), cancel: (b) => {
    for (let w = 0; w < to.length; w++)
      s[to[w]].cancel(b);
  }, state: o, steps: s };
}
const { schedule: ce, cancel: tt, state: Te, steps: Hi } = Op(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Ae, !0), zp = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, B$ = 1e-7, L$ = 12;
function I$(e, t, n, r, o) {
  let i, s, a = 0;
  do
    s = t + (n - t) / 2, i = zp(s, r, o) - e, i > 0 ? n = s : t = s;
  while (Math.abs(i) > B$ && ++a < L$);
  return s;
}
function Pr(e, t, n, r) {
  if (e === t && n === r)
    return Ae;
  const o = (i) => I$(i, 0, 1, e, n);
  return (i) => i === 0 || i === 1 ? i : zp(o(i), t, r);
}
const Np = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Wp = (e) => (t) => 1 - e(1 - t), _p = /* @__PURE__ */ Pr(0.33, 1.53, 0.69, 0.99), Sa = /* @__PURE__ */ Wp(_p), jp = /* @__PURE__ */ Np(Sa), Hp = (e) => (e *= 2) < 1 ? 0.5 * Sa(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ta = (e) => 1 - Math.sin(Math.acos(e)), Up = Wp(Ta), Gp = Np(Ta), Kp = (e) => /^0[^.\s]+$/u.test(e);
function F$(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Kp(e) : !0;
}
let Fn = Ae, nt = Ae;
process.env.NODE_ENV !== "production" && (Fn = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, nt = (e, t) => {
  if (!e)
    throw new Error(t);
});
const Yp = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Xp = (e) => (t) => typeof t == "string" && t.startsWith(e), Zp = Xp("--"), V$ = Xp("var(--"), Ea = (e) => V$(e) ? O$.test(e.split("/*")[0].trim()) : !1, O$ = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, z$ = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function N$(e) {
  const t = z$.exec(e);
  if (!t)
    return [,];
  const [, n, r, o] = t;
  return [`--${n ?? r}`, o];
}
const W$ = 4;
function qp(e, t, n = 1) {
  nt(n <= W$, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = N$(e);
  if (!r)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(r);
  if (i) {
    const s = i.trim();
    return Yp(s) ? parseFloat(s) : s;
  }
  return Ea(o) ? qp(o, t, n + 1) : o;
}
const Pt = (e, t, n) => n > t ? t : n < e ? e : n, Vn = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, rr = {
  ...Vn,
  transform: (e) => Pt(0, 1, e)
}, no = {
  ...Vn,
  default: 1
}, or = (e) => Math.round(e * 1e5) / 1e5, Ra = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu, _$ = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu, j$ = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function Mr(e) {
  return typeof e == "string";
}
function H$(e) {
  return e == null;
}
const Dr = (e) => ({
  test: (t) => Mr(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), xt = /* @__PURE__ */ Dr("deg"), Qe = /* @__PURE__ */ Dr("%"), ee = /* @__PURE__ */ Dr("px"), U$ = /* @__PURE__ */ Dr("vh"), G$ = /* @__PURE__ */ Dr("vw"), Cc = {
  ...Qe,
  parse: (e) => Qe.parse(e) / 100,
  transform: (e) => Qe.transform(e * 100)
}, K$ = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), kc = (e) => e === Vn || e === ee, Sc = (e, t) => parseFloat(e.split(", ")[t]), Tc = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/u);
  if (o)
    return Sc(o[1], t);
  {
    const i = r.match(/^matrix\((.+)\)$/u);
    return i ? Sc(i[1], e) : 0;
  }
}, Y$ = /* @__PURE__ */ new Set(["x", "y", "z"]), X$ = Ar.filter((e) => !Y$.has(e));
function Z$(e) {
  const t = [];
  return X$.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const Mn = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: Tc(4, 13),
  y: Tc(5, 14)
};
Mn.translateX = Mn.x;
Mn.translateY = Mn.y;
const Jp = (e) => (t) => t.test(e), q$ = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Qp = [Vn, ee, Qe, xt, G$, U$, q$], Ec = (e) => Qp.find(Jp(e)), Xt = /* @__PURE__ */ new Set();
let Ps = !1, Ms = !1;
function ef() {
  if (Ms) {
    const e = Array.from(Xt).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const o = Z$(r);
      o.length && (n.set(r, o), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([i, s]) => {
        var a;
        (a = r.getValue(i)) === null || a === void 0 || a.set(s);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Ms = !1, Ps = !1, Xt.forEach((e) => e.complete()), Xt.clear();
}
function tf() {
  Xt.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Ms = !0);
  });
}
function J$() {
  tf(), ef();
}
class Aa {
  constructor(t, n, r, o, i, s = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = o, this.element = i, this.isAsync = s;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Xt.add(this), Ps || (Ps = !0, ce.read(tf), ce.resolveKeyframes(ef))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: o } = this;
    for (let i = 0; i < t.length; i++)
      if (t[i] === null)
        if (i === 0) {
          const s = o == null ? void 0 : o.get(), a = t[t.length - 1];
          if (s !== void 0)
            t[0] = s;
          else if (r && n) {
            const l = r.readValue(n, a);
            l != null && (t[0] = l);
          }
          t[0] === void 0 && (t[0] = a), o && s === void 0 && o.set(t[0]);
        } else
          t[i] = t[i - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Xt.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Xt.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Pa = (e, t) => (n) => !!(Mr(n) && j$.test(n) && n.startsWith(e) || t && !H$(n) && Object.prototype.hasOwnProperty.call(n, t)), nf = (e, t, n) => (r) => {
  if (!Mr(r))
    return r;
  const [o, i, s, a] = r.match(Ra);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(i),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, Q$ = (e) => Pt(0, 255, e), Ui = {
  ...Vn,
  transform: (e) => Math.round(Q$(e))
}, Gt = {
  test: /* @__PURE__ */ Pa("rgb", "red"),
  parse: /* @__PURE__ */ nf("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Ui.transform(e) + ", " + Ui.transform(t) + ", " + Ui.transform(n) + ", " + or(rr.transform(r)) + ")"
};
function eC(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const Ds = {
  test: /* @__PURE__ */ Pa("#"),
  parse: eC,
  transform: Gt.transform
}, vn = {
  test: /* @__PURE__ */ Pa("hsl", "hue"),
  parse: /* @__PURE__ */ nf("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Qe.transform(or(t)) + ", " + Qe.transform(or(n)) + ", " + or(rr.transform(r)) + ")"
}, Me = {
  test: (e) => Gt.test(e) || Ds.test(e) || vn.test(e),
  parse: (e) => Gt.test(e) ? Gt.parse(e) : vn.test(e) ? vn.parse(e) : Ds.parse(e),
  transform: (e) => Mr(e) ? e : e.hasOwnProperty("red") ? Gt.transform(e) : vn.transform(e)
};
function tC(e) {
  var t, n;
  return isNaN(e) && Mr(e) && (((t = e.match(Ra)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(_$)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const rf = "number", of = "color", nC = "var", rC = "var(", Rc = "${}", oC = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function gr(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let i = 0;
  const a = t.replace(oC, (l) => (Me.test(l) ? (r.color.push(i), o.push(of), n.push(Me.parse(l))) : l.startsWith(rC) ? (r.var.push(i), o.push(nC), n.push(l)) : (r.number.push(i), o.push(rf), n.push(parseFloat(l))), ++i, Rc)).split(Rc);
  return { values: n, split: a, indexes: r, types: o };
}
function sf(e) {
  return gr(e).values;
}
function af(e) {
  const { split: t, types: n } = gr(e), r = t.length;
  return (o) => {
    let i = "";
    for (let s = 0; s < r; s++)
      if (i += t[s], o[s] !== void 0) {
        const a = n[s];
        a === rf ? i += or(o[s]) : a === of ? i += Me.transform(o[s]) : i += o[s];
      }
    return i;
  };
}
const iC = (e) => typeof e == "number" ? 0 : e;
function sC(e) {
  const t = sf(e);
  return af(e)(t.map(iC));
}
const Mt = {
  test: tC,
  parse: sf,
  createTransformer: af,
  getAnimatableNone: sC
}, aC = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function lC(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Ra) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let i = aC.has(t) ? 1 : 0;
  return r !== n && (i *= 100), t + "(" + i + o + ")";
}
const cC = /\b([a-z-]*)\(.*?\)/gu, Bs = {
  ...Mt,
  getAnimatableNone: (e) => {
    const t = e.match(cC);
    return t ? t.map(lC).join(" ") : e;
  }
}, Ac = {
  ...Vn,
  transform: Math.round
}, Ma = {
  // Border props
  borderWidth: ee,
  borderTopWidth: ee,
  borderRightWidth: ee,
  borderBottomWidth: ee,
  borderLeftWidth: ee,
  borderRadius: ee,
  radius: ee,
  borderTopLeftRadius: ee,
  borderTopRightRadius: ee,
  borderBottomRightRadius: ee,
  borderBottomLeftRadius: ee,
  // Positioning props
  width: ee,
  maxWidth: ee,
  height: ee,
  maxHeight: ee,
  size: ee,
  top: ee,
  right: ee,
  bottom: ee,
  left: ee,
  // Spacing props
  padding: ee,
  paddingTop: ee,
  paddingRight: ee,
  paddingBottom: ee,
  paddingLeft: ee,
  margin: ee,
  marginTop: ee,
  marginRight: ee,
  marginBottom: ee,
  marginLeft: ee,
  // Transform props
  rotate: xt,
  rotateX: xt,
  rotateY: xt,
  rotateZ: xt,
  scale: no,
  scaleX: no,
  scaleY: no,
  scaleZ: no,
  skew: xt,
  skewX: xt,
  skewY: xt,
  distance: ee,
  translateX: ee,
  translateY: ee,
  translateZ: ee,
  x: ee,
  y: ee,
  z: ee,
  perspective: ee,
  transformPerspective: ee,
  opacity: rr,
  originX: Cc,
  originY: Cc,
  originZ: ee,
  // Misc
  zIndex: Ac,
  backgroundPositionX: ee,
  backgroundPositionY: ee,
  // SVG
  fillOpacity: rr,
  strokeOpacity: rr,
  numOctaves: Ac
}, dC = {
  ...Ma,
  // Color props
  color: Me,
  backgroundColor: Me,
  outlineColor: Me,
  fill: Me,
  stroke: Me,
  // Border props
  borderColor: Me,
  borderTopColor: Me,
  borderRightColor: Me,
  borderBottomColor: Me,
  borderLeftColor: Me,
  filter: Bs,
  WebkitFilter: Bs
}, Da = (e) => dC[e];
function lf(e, t) {
  let n = Da(e);
  return n !== Bs && (n = Mt), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const uC = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function pC(e, t, n) {
  let r = 0, o;
  for (; r < e.length && !o; ) {
    const i = e[r];
    typeof i == "string" && !uC.has(i) && gr(i).values.length && (o = e[r]), r++;
  }
  if (o && n)
    for (const i of t)
      e[i] = lf(n, o);
}
class cf extends Aa {
  constructor(t, n, r, o, i) {
    super(t, n, r, o, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let c = t[l];
      if (typeof c == "string" && (c = c.trim(), Ea(c))) {
        const d = qp(c, n.current);
        d !== void 0 && (t[l] = d), l === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !K$.has(r) || t.length !== 2)
      return;
    const [o, i] = t, s = Ec(o), a = Ec(i);
    if (s !== a)
      if (kc(s) && kc(a))
        for (let l = 0; l < t.length; l++) {
          const c = t[l];
          typeof c == "string" && (t[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let o = 0; o < t.length; o++)
      F$(t[o]) && r.push(o);
    r.length && pC(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Mn[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && t.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    var t;
    const { element: n, name: r, unresolvedKeyframes: o } = this;
    if (!n || !n.current)
      return;
    const i = n.getValue(r);
    i && i.jump(this.measuredOrigin, !1);
    const s = o.length - 1, a = o[s];
    o[s] = Mn[r](n.measureViewportBox(), window.getComputedStyle(n.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
function Ba(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
function gi(e) {
  return typeof e == "function";
}
let po;
function fC() {
  po = void 0;
}
const et = {
  now: () => (po === void 0 && et.set(Te.isProcessing || A$.useManualTiming ? Te.timestamp : performance.now()), po),
  set: (e) => {
    po = e, queueMicrotask(fC);
  }
}, Pc = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Mt.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function hC(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function mC(e, t, n, r) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], s = Pc(o, t), a = Pc(i, t);
  return Fn(s === a, `You are trying to animate ${t} from "${o}" to "${i}". ${o} is not an animatable value - to enable this animation set ${o} to a value animatable to ${i} via the \`style\` property.`), !s || !a ? !1 : hC(e) || (n === "spring" || gi(n)) && r;
}
const gC = 40;
class df {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: i = 0, repeatType: s = "loop", ...a }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = et.now(), this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: i,
      repeatType: s,
      ...a
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > gC ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && J$(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.resolvedAt = et.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: o, velocity: i, delay: s, onComplete: a, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !mC(t, r, o, i))
      if (s)
        this.options.duration = 0;
      else {
        l == null || l(mi(t, this.options, n)), a == null || a(), this.resolveFinishedPromise();
        return;
      }
    const d = this.initPlayback(t, n);
    d !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...d
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
function uf(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const vC = 5;
function pf(e, t, n) {
  const r = Math.max(t - vC, 0);
  return uf(n - e(r), t - r);
}
const Gi = 1e-3, yC = 0.01, Mc = 10, bC = 0.05, xC = 1;
function wC({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, i;
  Fn(e <= Ge(Mc), "Spring duration must be 10 seconds or less");
  let s = 1 - t;
  s = Pt(bC, xC, s), e = Pt(yC, Mc, Je(e)), s < 1 ? (o = (c) => {
    const d = c * s, u = d * e, p = d - n, f = Ls(c, s), m = Math.exp(-u);
    return Gi - p / f * m;
  }, i = (c) => {
    const u = c * s * e, p = u * n + n, f = Math.pow(s, 2) * Math.pow(c, 2) * e, m = Math.exp(-u), g = Ls(Math.pow(c, 2), s);
    return (-o(c) + Gi > 0 ? -1 : 1) * ((p - f) * m) / g;
  }) : (o = (c) => {
    const d = Math.exp(-c * e), u = (c - n) * e + 1;
    return -Gi + d * u;
  }, i = (c) => {
    const d = Math.exp(-c * e), u = (n - c) * (e * e);
    return d * u;
  });
  const a = 5 / e, l = CC(o, i, a);
  if (e = Ge(e), isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: s * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const $C = 12;
function CC(e, t, n) {
  let r = n;
  for (let o = 1; o < $C; o++)
    r = r - e(r) / t(r);
  return r;
}
function Ls(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const kC = ["duration", "bounce"], SC = ["stiffness", "damping", "mass"];
function Dc(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function TC(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!Dc(e, SC) && Dc(e, kC)) {
    const n = wC(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function La({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const o = e[0], i = e[e.length - 1], s = { done: !1, value: o }, { stiffness: a, damping: l, mass: c, duration: d, velocity: u, isResolvedFromDuration: p } = TC({
    ...r,
    velocity: -Je(r.velocity || 0)
  }), f = u || 0, m = l / (2 * Math.sqrt(a * c)), g = i - o, y = Je(Math.sqrt(a / c)), b = Math.abs(g) < 5;
  n || (n = b ? 0.01 : 2), t || (t = b ? 5e-3 : 0.5);
  let w;
  if (m < 1) {
    const x = Ls(y, m);
    w = ($) => {
      const E = Math.exp(-m * y * $);
      return i - E * ((f + m * y * g) / x * Math.sin(x * $) + g * Math.cos(x * $));
    };
  } else if (m === 1)
    w = (x) => i - Math.exp(-y * x) * (g + (f + y * g) * x);
  else {
    const x = y * Math.sqrt(m * m - 1);
    w = ($) => {
      const E = Math.exp(-m * y * $), S = Math.min(x * $, 300);
      return i - E * ((f + m * y * g) * Math.sinh(S) + x * g * Math.cosh(S)) / x;
    };
  }
  return {
    calculatedDuration: p && d || null,
    next: (x) => {
      const $ = w(x);
      if (p)
        s.done = x >= d;
      else {
        let E = 0;
        m < 1 && (E = x === 0 ? Ge(f) : pf(w, x, $));
        const S = Math.abs(E) <= n, F = Math.abs(i - $) <= t;
        s.done = S && F;
      }
      return s.value = s.done ? i : $, s;
    }
  };
}
function Bc({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: i = 500, modifyTarget: s, min: a, max: l, restDelta: c = 0.5, restSpeed: d }) {
  const u = e[0], p = {
    done: !1,
    value: u
  }, f = (R) => a !== void 0 && R < a || l !== void 0 && R > l, m = (R) => a === void 0 ? l : l === void 0 || Math.abs(a - R) < Math.abs(l - R) ? a : l;
  let g = n * t;
  const y = u + g, b = s === void 0 ? y : s(y);
  b !== y && (g = b - u);
  const w = (R) => -g * Math.exp(-R / r), x = (R) => b + w(R), $ = (R) => {
    const L = w(R), P = x(R);
    p.done = Math.abs(L) <= c, p.value = p.done ? b : P;
  };
  let E, S;
  const F = (R) => {
    f(p.value) && (E = R, S = La({
      keyframes: [p.value, m(p.value)],
      velocity: pf(x, R, p.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: i,
      restDelta: c,
      restSpeed: d
    }));
  };
  return F(0), {
    calculatedDuration: null,
    next: (R) => {
      let L = !1;
      return !S && E === void 0 && (L = !0, $(R), F(R)), E !== void 0 && R >= E ? S.next(R - E) : (!L && $(R), p);
    }
  };
}
const EC = /* @__PURE__ */ Pr(0.42, 0, 1, 1), RC = /* @__PURE__ */ Pr(0, 0, 0.58, 1), ff = /* @__PURE__ */ Pr(0.42, 0, 0.58, 1), hf = (e) => Array.isArray(e) && typeof e[0] != "number", Lc = {
  linear: Ae,
  easeIn: EC,
  easeInOut: ff,
  easeOut: RC,
  circIn: Ta,
  circInOut: Gp,
  circOut: Up,
  backIn: Sa,
  backInOut: jp,
  backOut: _p,
  anticipate: Hp
}, Ic = (e) => {
  if (Array.isArray(e)) {
    nt(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return Pr(t, n, r, o);
  } else if (typeof e == "string")
    return nt(Lc[e] !== void 0, `Invalid easing type '${e}'`), Lc[e];
  return e;
}, AC = (e, t) => (n) => t(e(n)), ut = (...e) => e.reduce(AC), en = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, he = (e, t, n) => e + (t - e) * n;
function Ki(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function PC({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, i = 0, s = 0;
  if (!t)
    o = i = s = n;
  else {
    const a = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - a;
    o = Ki(l, a, e + 1 / 3), i = Ki(l, a, e), s = Ki(l, a, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
function Io(e, t) {
  return (n) => n > 0 ? t : e;
}
const Yi = (e, t, n) => {
  const r = e * e, o = n * (t * t - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, MC = [Ds, Gt, vn], DC = (e) => MC.find((t) => t.test(e));
function Fc(e) {
  const t = DC(e);
  if (Fn(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === vn && (n = PC(n)), n;
}
const Vc = (e, t) => {
  const n = Fc(e), r = Fc(t);
  if (!n || !r)
    return Io(e, t);
  const o = { ...n };
  return (i) => (o.red = Yi(n.red, r.red, i), o.green = Yi(n.green, r.green, i), o.blue = Yi(n.blue, r.blue, i), o.alpha = he(n.alpha, r.alpha, i), Gt.transform(o));
}, Is = /* @__PURE__ */ new Set(["none", "hidden"]);
function BC(e, t) {
  return Is.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function LC(e, t) {
  return (n) => he(e, t, n);
}
function Ia(e) {
  return typeof e == "number" ? LC : typeof e == "string" ? Ea(e) ? Io : Me.test(e) ? Vc : VC : Array.isArray(e) ? mf : typeof e == "object" ? Me.test(e) ? Vc : IC : Io;
}
function mf(e, t) {
  const n = [...e], r = n.length, o = e.map((i, s) => Ia(i)(i, t[s]));
  return (i) => {
    for (let s = 0; s < r; s++)
      n[s] = o[s](i);
    return n;
  };
}
function IC(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = Ia(e[o])(e[o], t[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
}
function FC(e, t) {
  var n;
  const r = [], o = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const s = t.types[i], a = e.indexes[s][o[s]], l = (n = e.values[a]) !== null && n !== void 0 ? n : 0;
    r[i] = l, o[s]++;
  }
  return r;
}
const VC = (e, t) => {
  const n = Mt.createTransformer(t), r = gr(e), o = gr(t);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? Is.has(e) && !o.values.length || Is.has(t) && !r.values.length ? BC(e, t) : ut(mf(FC(r, o), o.values), n) : (Fn(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), Io(e, t));
};
function gf(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? he(e, t, n) : Ia(e)(e, t);
}
function OC(e, t, n) {
  const r = [], o = n || gf, i = e.length - 1;
  for (let s = 0; s < i; s++) {
    let a = o(e[s], e[s + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[s] || Ae : t;
      a = ut(l, a);
    }
    r.push(a);
  }
  return r;
}
function vf(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = e.length;
  if (nt(i === t.length, "Both input and output ranges must be the same length"), i === 1)
    return () => t[0];
  if (i === 2 && e[0] === e[1])
    return () => t[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = OC(t, r, o), a = s.length, l = (c) => {
    let d = 0;
    if (a > 1)
      for (; d < e.length - 2 && !(c < e[d + 1]); d++)
        ;
    const u = en(e[d], e[d + 1], c);
    return s[d](u);
  };
  return n ? (c) => l(Pt(e[0], e[i - 1], c)) : l;
}
function yf(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = en(0, t, r);
    e.push(he(n, 1, o));
  }
}
function bf(e) {
  const t = [0];
  return yf(t, e.length - 1), t;
}
function zC(e, t) {
  return e.map((n) => n * t);
}
function NC(e, t) {
  return e.map(() => t || ff).splice(0, e.length - 1);
}
function Fo({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = hf(r) ? r.map(Ic) : Ic(r), i = {
    done: !1,
    value: t[0]
  }, s = zC(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : bf(t),
    e
  ), a = vf(s, t, {
    ease: Array.isArray(o) ? o : NC(t, o)
  });
  return {
    calculatedDuration: e,
    next: (l) => (i.value = a(l), i.done = l >= e, i)
  };
}
const Fs = 2e4;
function xf(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Fs; )
    t += n, r = e.next(t);
  return t >= Fs ? 1 / 0 : t;
}
const WC = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => ce.update(t, !0),
    stop: () => tt(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Te.isProcessing ? Te.timestamp : et.now()
  };
}, _C = {
  decay: Bc,
  inertia: Bc,
  tween: Fo,
  keyframes: Fo,
  spring: La
}, jC = (e) => e / 100;
class Fa extends df {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: r, element: o, keyframes: i } = this.options, s = (o == null ? void 0 : o.KeyframeResolver) || Aa, a = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new s(i, a, n, r, o), this.resolver.scheduleResolve();
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: o = 0, repeatType: i, velocity: s = 0 } = this.options, a = gi(n) ? n : _C[n] || Fo;
    let l, c;
    a !== Fo && typeof t[0] != "number" && (process.env.NODE_ENV !== "production" && nt(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), l = ut(jC, gf(t[0], t[1])), t = [0, 100]);
    const d = a({ ...this.options, keyframes: t });
    i === "mirror" && (c = a({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -s
    })), d.calculatedDuration === null && (d.calculatedDuration = xf(d));
    const { calculatedDuration: u } = d, p = u + o, f = p * (r + 1) - o;
    return {
      generator: d,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: u,
      resolvedDuration: p,
      totalDuration: f
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: R } = this.options;
      return { done: !0, value: R[R.length - 1] };
    }
    const { finalKeyframe: o, generator: i, mirroredGenerator: s, mapPercentToKeyframes: a, keyframes: l, calculatedDuration: c, totalDuration: d, resolvedDuration: u } = r;
    if (this.startTime === null)
      return i.next(0);
    const { delay: p, repeat: f, repeatType: m, repeatDelay: g, onUpdate: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - d / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const b = this.currentTime - p * (this.speed >= 0 ? 1 : -1), w = this.speed >= 0 ? b < 0 : b > d;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = d);
    let x = this.currentTime, $ = i;
    if (f) {
      const R = Math.min(this.currentTime, d) / u;
      let L = Math.floor(R), P = R % 1;
      !P && R >= 1 && (P = 1), P === 1 && L--, L = Math.min(L, f + 1), !!(L % 2) && (m === "reverse" ? (P = 1 - P, g && (P -= g / u)) : m === "mirror" && ($ = s)), x = Pt(0, 1, P) * u;
    }
    const E = w ? { done: !1, value: l[0] } : $.next(x);
    a && (E.value = a(E.value));
    let { done: S } = E;
    !w && c !== null && (S = this.speed >= 0 ? this.currentTime >= d : this.currentTime <= 0);
    const F = this.holdTime === null && (this.state === "finished" || this.state === "running" && S);
    return F && o !== void 0 && (E.value = mi(l, this.options, o)), y && y(E.value), F && this.finish(), E;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? Je(t.calculatedDuration) : 0;
  }
  get time() {
    return Je(this.currentTime);
  }
  set time(t) {
    t = Ge(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = Je(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = WC, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = t((i) => this.tick(i))), n && n();
    const o = this.driver.now();
    this.holdTime !== null ? this.startTime = o - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = o) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const wf = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]), $f = (e) => Array.isArray(e) && typeof e[0] == "number", HC = 10, UC = (e, t) => {
  let n = "";
  const r = Math.max(Math.round(t / HC), 2);
  for (let o = 0; o < r; o++)
    n += e(en(0, r - 1, o)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
}, GC = {
  linearEasing: void 0
};
function KC(e, t) {
  const n = Ba(e);
  return () => {
    var r;
    return (r = GC[t]) !== null && r !== void 0 ? r : n();
  };
}
const Vo = /* @__PURE__ */ KC(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing");
function Cf(e) {
  return !!(typeof e == "function" && Vo() || !e || typeof e == "string" && (e in Vs || Vo()) || $f(e) || Array.isArray(e) && e.every(Cf));
}
const Yn = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Vs = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Yn([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Yn([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Yn([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Yn([0.33, 1.53, 0.69, 0.99])
};
function kf(e, t) {
  if (e)
    return typeof e == "function" && Vo() ? UC(e, t) : $f(e) ? Yn(e) : Array.isArray(e) ? e.map((n) => kf(n, t) || Vs.easeOut) : Vs[e];
}
function YC(e, t, n, { delay: r = 0, duration: o = 300, repeat: i = 0, repeatType: s = "loop", ease: a, times: l } = {}) {
  const c = { [t]: n };
  l && (c.offset = l);
  const d = kf(a, o);
  return Array.isArray(d) && (c.easing = d), e.animate(c, {
    delay: r,
    duration: o,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: i + 1,
    direction: s === "reverse" ? "alternate" : "normal"
  });
}
const XC = /* @__PURE__ */ Ba(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Oo = 10, ZC = 2e4;
function qC(e) {
  return gi(e.type) || e.type === "spring" || !Cf(e.ease);
}
function JC(e, t) {
  const n = new Fa({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const o = [];
  let i = 0;
  for (; !r.done && i < ZC; )
    r = n.sample(i), o.push(r.value), i += Oo;
  return {
    times: void 0,
    keyframes: o,
    duration: i - Oo,
    ease: "linear"
  };
}
const Sf = {
  anticipate: Hp,
  backInOut: jp,
  circInOut: Gp
};
function QC(e) {
  return e in Sf;
}
class Oc extends df {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, element: o, keyframes: i } = this.options;
    this.resolver = new cf(i, (s, a) => this.onKeyframesResolved(s, a), n, r, o), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    var r;
    let { duration: o = 300, times: i, ease: s, type: a, motionValue: l, name: c, startTime: d } = this.options;
    if (!(!((r = l.owner) === null || r === void 0) && r.current))
      return !1;
    if (typeof s == "string" && Vo() && QC(s) && (s = Sf[s]), qC(this.options)) {
      const { onComplete: p, onUpdate: f, motionValue: m, element: g, ...y } = this.options, b = JC(t, y);
      t = b.keyframes, t.length === 1 && (t[1] = t[0]), o = b.duration, i = b.times, s = b.ease, a = "keyframes";
    }
    const u = YC(l.owner.current, c, t, { ...this.options, duration: o, times: i, ease: s });
    return u.startTime = d ?? this.calcStartTime(), this.pendingTimeline ? (u.timeline = this.pendingTimeline, this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: p } = this.options;
      l.set(mi(t, this.options, n)), p && p(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: o,
      times: i,
      type: a,
      ease: s,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return Je(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return Je(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = Ge(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: n } = t;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return Ae;
      const { animation: r } = n;
      r.timeline = t, r.onfinish = null;
    }
    return Ae;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: o, type: i, ease: s, times: a } = t;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: d, onComplete: u, element: p, ...f } = this.options, m = new Fa({
        ...f,
        keyframes: r,
        duration: o,
        type: i,
        ease: s,
        times: a,
        isGenerator: !0
      }), g = Ge(this.time);
      c.setWithVelocity(m.sample(g - Oo).value, m.sample(g).value, Oo);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: o, repeatType: i, damping: s, type: a } = t;
    return XC() && r && wf.has(r) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !o && i !== "mirror" && s !== 0 && a !== "inertia";
  }
}
function ek(e, t) {
  let n;
  const r = () => {
    const { currentTime: o } = t, s = (o === null ? 0 : o.value) / 100;
    n !== s && e(s), n = s;
  };
  return ce.update(r, !0), () => tt(r);
}
const tk = Ba(() => window.ScrollTimeline !== void 0);
class Va {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t) {
    const n = this.animations.map((r) => {
      if (tk() && r.attachTimeline)
        r.attachTimeline(t);
      else
        return r.pause(), ek((o) => {
          r.time = r.duration * o;
        }, t);
    });
    return () => {
      n.forEach((r, o) => {
        r && r(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
const Oa = (e, t, n, r = {}, o, i) => (s) => {
  const a = ka(r, e) || {}, l = a.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - Ge(l);
  let d = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (p) => {
      t.set(p), a.onUpdate && a.onUpdate(p);
    },
    onComplete: () => {
      s(), a.onComplete && a.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : o
  };
  R$(a) || (d = {
    ...d,
    ...E$(e, d)
  }), d.duration && (d.duration = Ge(d.duration)), d.repeatDelay && (d.repeatDelay = Ge(d.repeatDelay)), d.from !== void 0 && (d.keyframes[0] = d.from);
  let u = !1;
  if ((d.type === !1 || d.duration === 0 && !d.repeatDelay) && (d.duration = 0, d.delay === 0 && (u = !0)), u && !i && t.get() !== void 0) {
    const p = mi(d.keyframes, a);
    if (p !== void 0)
      return ce.update(() => {
        d.onUpdate(p), d.onComplete();
      }), new Va([]);
  }
  return !i && Oc.supports(d) ? new Oc(d) : new Fa(d);
}, nk = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), rk = (e) => As(e) ? e[e.length - 1] || 0 : e;
function Br(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function vi(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class za {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Br(this.subscriptions, t), () => vi(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let i = 0; i < o; i++) {
          const s = this.subscriptions[i];
          s && s(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const zc = 30, ok = (e) => !isNaN(parseFloat(e)), ir = {
  current: void 0
};
class Tf {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "11.8.0", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      const i = et.now();
      this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = et.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = ok(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Rr(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new za());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), ce.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return ir.current && ir.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = et.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > zc)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, zc);
    return uf(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Dn(e, t) {
  return new Tf(e, t);
}
function ik(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Dn(n));
}
function sk(e, t) {
  const n = hi(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...i } = n || {};
  i = { ...i, ...r };
  for (const s in i) {
    const a = rk(i[s]);
    ik(e, s, a);
  }
}
const yi = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), ak = "framerAppearId", Ef = "data-" + yi(ak);
function Rf(e) {
  return e.props[Ef];
}
function Af(e) {
  if (It.has(e))
    return "transform";
  if (wf.has(e))
    return yi(e);
}
class lk extends Tf {
  constructor() {
    super(...arguments), this.values = [];
  }
  add(t) {
    const n = Af(t);
    n && (Br(this.values, n), this.update());
  }
  update() {
    this.set(this.values.length ? this.values.join(", ") : "auto");
  }
}
const ke = (e) => !!(e && e.getVelocity);
function ck(e) {
  return !!(ke(e) && e.add);
}
function Os(e, t) {
  var n;
  if (!e.applyWillChange)
    return;
  let r = e.getValue("willChange");
  if (!r && !(!((n = e.props.style) === null || n === void 0) && n.willChange) && (r = new lk("auto"), e.addValue("willChange", r)), ck(r))
    return r.add(t);
}
function dk({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Na(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  var i;
  let { transition: s = e.getDefaultTransition(), transitionEnd: a, ...l } = t;
  r && (s = r);
  const c = [], d = o && e.animationState && e.animationState.getState()[o];
  for (const u in l) {
    const p = e.getValue(u, (i = e.latestValues[u]) !== null && i !== void 0 ? i : null), f = l[u];
    if (f === void 0 || d && dk(d, u))
      continue;
    const m = {
      delay: n,
      ...ka(s || {}, u)
    };
    let g = !1;
    if (window.MotionHandoffAnimation) {
      const b = Rf(e);
      if (b) {
        const w = window.MotionHandoffAnimation(b, u, ce);
        w !== null && (m.startTime = w, g = !0);
      }
    }
    Os(e, u), p.start(Oa(u, p, f, e.shouldReduceMotion && It.has(u) ? { type: !1 } : m, e, g));
    const y = p.animation;
    y && c.push(y);
  }
  return a && Promise.all(c).then(() => {
    ce.update(() => {
      a && sk(e, a);
    });
  }), c;
}
function zs(e, t, n = {}) {
  var r;
  const o = hi(e, t, n.type === "exit" ? (r = e.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = o || {};
  n.transitionOverride && (i = n.transitionOverride);
  const s = o ? () => Promise.all(Na(e, o, n)) : () => Promise.resolve(), a = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: d = 0, staggerChildren: u, staggerDirection: p } = i;
    return uk(e, t, d + c, u, p, n);
  } : () => Promise.resolve(), { when: l } = i;
  if (l) {
    const [c, d] = l === "beforeChildren" ? [s, a] : [a, s];
    return c().then(() => d());
  } else
    return Promise.all([s(), a(n.delay)]);
}
function uk(e, t, n = 0, r = 0, o = 1, i) {
  const s = [], a = (e.variantChildren.size - 1) * r, l = o === 1 ? (c = 0) => c * r : (c = 0) => a - c * r;
  return Array.from(e.variantChildren).sort(pk).forEach((c, d) => {
    c.notify("AnimationStart", t), s.push(zs(c, t, {
      ...i,
      delay: n + l(d)
    }).then(() => c.notify("AnimationComplete", t)));
  }), Promise.all(s);
}
function pk(e, t) {
  return e.sortNodePosition(t);
}
function fk(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((i) => zs(e, i, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = zs(e, t, n);
  else {
    const o = typeof t == "function" ? hi(e, t, n.custom) : t;
    r = Promise.all(Na(e, o, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const hk = Ca.length;
function Pf(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Pf(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < hk; n++) {
    const r = Ca[n], o = e.props[r];
    (mr(o) || o === !1) && (t[r] = o);
  }
  return t;
}
const mk = [...$a].reverse(), gk = $a.length;
function vk(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => fk(e, n, r)));
}
function yk(e) {
  let t = vk(e), n = Nc(), r = !0;
  const o = (l) => (c, d) => {
    var u;
    const p = hi(e, d, l === "exit" ? (u = e.presenceContext) === null || u === void 0 ? void 0 : u.custom : void 0);
    if (p) {
      const { transition: f, transitionEnd: m, ...g } = p;
      c = { ...c, ...g, ...m };
    }
    return c;
  };
  function i(l) {
    t = l(e);
  }
  function s(l) {
    const { props: c } = e, d = Pf(e.parent) || {}, u = [], p = /* @__PURE__ */ new Set();
    let f = {}, m = 1 / 0;
    for (let y = 0; y < gk; y++) {
      const b = mk[y], w = n[b], x = c[b] !== void 0 ? c[b] : d[b], $ = mr(x), E = b === l ? w.isActive : null;
      E === !1 && (m = y);
      let S = x === d[b] && x !== c[b] && $;
      if (S && r && e.manuallyAnimateOnMount && (S = !1), w.protectedKeys = { ...f }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && E === null || // If we didn't and don't have any defined prop for this animation type
      !x && !w.prevProp || // Or if the prop doesn't define an animation
      hr(x) || typeof x == "boolean")
        continue;
      const F = bk(w.prevProp, x);
      let R = F || // If we're making this variant active, we want to always make it active
      b === l && w.isActive && !S && $ || // If we removed a higher-priority variant (i is in reverse order)
      y > m && $, L = !1;
      const P = Array.isArray(x) ? x : [x];
      let j = P.reduce(o(b), {});
      E === !1 && (j = {});
      const { prevResolvedValues: _ = {} } = w, G = {
        ..._,
        ...j
      }, D = (O) => {
        R = !0, p.has(O) && (L = !0, p.delete(O)), w.needsAnimating[O] = !0;
        const V = e.getValue(O);
        V && (V.liveStyle = !1);
      };
      for (const O in G) {
        const V = j[O], N = _[O];
        if (f.hasOwnProperty(O))
          continue;
        let B = !1;
        As(V) && As(N) ? B = !Vp(V, N) : B = V !== N, B ? V != null ? D(O) : p.add(O) : V !== void 0 && p.has(O) ? D(O) : w.protectedKeys[O] = !0;
      }
      w.prevProp = x, w.prevResolvedValues = j, w.isActive && (f = { ...f, ...j }), r && e.blockInitialAnimation && (R = !1), R && (!(S && F) || L) && u.push(...P.map((O) => ({
        animation: O,
        options: { type: b }
      })));
    }
    if (p.size) {
      const y = {};
      p.forEach((b) => {
        const w = e.getBaseTarget(b), x = e.getValue(b);
        x && (x.liveStyle = !0), y[b] = w ?? null;
      }), u.push({ animation: y });
    }
    let g = !!u.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (g = !1), r = !1, g ? t(u) : Promise.resolve();
  }
  function a(l, c) {
    var d;
    if (n[l].isActive === c)
      return Promise.resolve();
    (d = e.variantChildren) === null || d === void 0 || d.forEach((p) => {
      var f;
      return (f = p.animationState) === null || f === void 0 ? void 0 : f.setActive(l, c);
    }), n[l].isActive = c;
    const u = s(l);
    for (const p in n)
      n[p].protectedKeys = {};
    return u;
  }
  return {
    animateChanges: s,
    setActive: a,
    setAnimateFunction: i,
    getState: () => n,
    reset: () => {
      n = Nc(), r = !0;
    }
  };
}
function bk(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Vp(t, e) : !1;
}
function zt(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Nc() {
  return {
    animate: zt(!0),
    whileInView: zt(),
    whileHover: zt(),
    whileTap: zt(),
    whileDrag: zt(),
    whileFocus: zt(),
    exit: zt()
  };
}
class Ft {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class xk extends Ft {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = yk(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    hr(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) === null || t === void 0 || t.call(this);
  }
}
let wk = 0;
class $k extends Ft {
  constructor() {
    super(...arguments), this.id = wk++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const o = this.node.animationState.setActive("exit", !t);
    n && !t && o.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const Ck = {
  animation: {
    Feature: xk
  },
  exit: {
    Feature: $k
  }
}, Mf = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function bi(e, t = "page") {
  return {
    point: {
      x: e[`${t}X`],
      y: e[`${t}Y`]
    }
  };
}
const kk = (e) => (t) => Mf(t) && e(t, bi(t));
function lt(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function pt(e, t, n, r) {
  return lt(e, t, kk(n), r);
}
const Wc = (e, t) => Math.abs(e - t);
function Sk(e, t) {
  const n = Wc(e.x, t.x), r = Wc(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Df {
  constructor(t, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: i = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const u = Zi(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, f = Sk(u.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !f)
        return;
      const { point: m } = u, { timestamp: g } = Te;
      this.history.push({ ...m, timestamp: g });
      const { onStart: y, onMove: b } = this.handlers;
      p || (y && y(this.lastMoveEvent, u), this.startEvent = this.lastMoveEvent), b && b(this.lastMoveEvent, u);
    }, this.handlePointerMove = (u, p) => {
      this.lastMoveEvent = u, this.lastMoveEventInfo = Xi(p, this.transformPagePoint), ce.update(this.updatePoint, !0);
    }, this.handlePointerUp = (u, p) => {
      this.end();
      const { onEnd: f, onSessionEnd: m, resumeAnimation: g } = this.handlers;
      if (this.dragSnapToOrigin && g && g(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Zi(u.type === "pointercancel" ? this.lastMoveEventInfo : Xi(p, this.transformPagePoint), this.history);
      this.startEvent && f && f(u, y), m && m(u, y);
    }, !Mf(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const s = bi(t), a = Xi(s, this.transformPagePoint), { point: l } = a, { timestamp: c } = Te;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: d } = n;
    d && d(t, Zi(a, this.history)), this.removeListeners = ut(pt(this.contextWindow, "pointermove", this.handlePointerMove), pt(this.contextWindow, "pointerup", this.handlePointerUp), pt(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), tt(this.updatePoint);
  }
}
function Xi(e, t) {
  return t ? { point: t(e.point) } : e;
}
function _c(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Zi({ point: e }, t) {
  return {
    point: e,
    delta: _c(e, Bf(t)),
    offset: _c(e, Tk(t)),
    velocity: Ek(t, 0.1)
  };
}
function Tk(e) {
  return e[0];
}
function Bf(e) {
  return e[e.length - 1];
}
function Ek(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = Bf(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > Ge(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const i = Je(o.timestamp - r.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const s = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function Lf(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const jc = Lf("dragHorizontal"), Hc = Lf("dragVertical");
function If(e) {
  let t = !1;
  if (e === "y")
    t = Hc();
  else if (e === "x")
    t = jc();
  else {
    const n = jc(), r = Hc();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function Ff() {
  const e = If(!0);
  return e ? (e(), !1) : !0;
}
function yn(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
const Vf = 1e-4, Rk = 1 - Vf, Ak = 1 + Vf, Of = 0.01, Pk = 0 - Of, Mk = 0 + Of;
function Ie(e) {
  return e.max - e.min;
}
function Dk(e, t, n) {
  return Math.abs(e - t) <= n;
}
function Uc(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = he(t.min, t.max, e.origin), e.scale = Ie(n) / Ie(t), e.translate = he(n.min, n.max, e.origin) - e.originPoint, (e.scale >= Rk && e.scale <= Ak || isNaN(e.scale)) && (e.scale = 1), (e.translate >= Pk && e.translate <= Mk || isNaN(e.translate)) && (e.translate = 0);
}
function sr(e, t, n, r) {
  Uc(e.x, t.x, n.x, r ? r.originX : void 0), Uc(e.y, t.y, n.y, r ? r.originY : void 0);
}
function Gc(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Ie(t);
}
function Bk(e, t, n) {
  Gc(e.x, t.x, n.x), Gc(e.y, t.y, n.y);
}
function Kc(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Ie(t);
}
function ar(e, t, n) {
  Kc(e.x, t.x, n.x), Kc(e.y, t.y, n.y);
}
function Lk(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? he(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? he(n, e, r.max) : Math.min(e, n)), e;
}
function Yc(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function Ik(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: Yc(e.x, n, o),
    y: Yc(e.y, t, r)
  };
}
function Xc(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function Fk(e, t) {
  return {
    x: Xc(e.x, t.x),
    y: Xc(e.y, t.y)
  };
}
function Vk(e, t) {
  let n = 0.5;
  const r = Ie(e), o = Ie(t);
  return o > r ? n = en(t.min, t.max - r, e.min) : r > o && (n = en(e.min, e.max - o, t.min)), Pt(0, 1, n);
}
function Ok(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const Ns = 0.35;
function zk(e = Ns) {
  return e === !1 ? e = 0 : e === !0 && (e = Ns), {
    x: Zc(e, "left", "right"),
    y: Zc(e, "top", "bottom")
  };
}
function Zc(e, t, n) {
  return {
    min: qc(e, t),
    max: qc(e, n)
  };
}
function qc(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Jc = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), bn = () => ({
  x: Jc(),
  y: Jc()
}), Qc = () => ({ min: 0, max: 0 }), ye = () => ({
  x: Qc(),
  y: Qc()
});
function Ve(e) {
  return [e("x"), e("y")];
}
function zf({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Nk({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function Wk(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function qi(e) {
  return e === void 0 || e === 1;
}
function Ws({ scale: e, scaleX: t, scaleY: n }) {
  return !qi(e) || !qi(t) || !qi(n);
}
function Wt(e) {
  return Ws(e) || Nf(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Nf(e) {
  return ed(e.x) || ed(e.y);
}
function ed(e) {
  return e && e !== "0%";
}
function zo(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function td(e, t, n, r, o) {
  return o !== void 0 && (e = zo(e, o, r)), zo(e, n, r) + t;
}
function _s(e, t = 0, n = 1, r, o) {
  e.min = td(e.min, t, n, r, o), e.max = td(e.max, t, n, r, o);
}
function Wf(e, { x: t, y: n }) {
  _s(e.x, t.translate, t.scale, t.originPoint), _s(e.y, n.translate, n.scale, n.originPoint);
}
const nd = 0.999999999999, rd = 1.0000000000001;
function _k(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let i, s;
  for (let a = 0; a < o; a++) {
    i = n[a], s = i.projectionDelta;
    const { visualElement: l } = i.options;
    l && l.props.style && l.props.style.display === "contents" || (r && i.options.layoutScroll && i.scroll && i !== i.root && wn(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), s && (t.x *= s.x.scale, t.y *= s.y.scale, Wf(e, s)), r && Wt(i.latestValues) && wn(e, i.latestValues));
  }
  t.x < rd && t.x > nd && (t.x = 1), t.y < rd && t.y > nd && (t.y = 1);
}
function xn(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function od(e, t, n, r, o = 0.5) {
  const i = he(e.min, e.max, o);
  _s(e, t, n, i, r);
}
function wn(e, t) {
  od(e.x, t.x, t.scaleX, t.scale, t.originX), od(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function _f(e, t) {
  return zf(Wk(e.getBoundingClientRect(), t));
}
function jk(e, t, n) {
  const r = _f(e, n), { scroll: o } = t;
  return o && (xn(r.x, o.offset.x), xn(r.y, o.offset.y)), r;
}
const jf = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Hk = /* @__PURE__ */ new WeakMap();
class Uk {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ye(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (d) => {
      const { dragSnapToOrigin: u } = this.getProps();
      u ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(bi(d, "page").point);
    }, i = (d, u) => {
      const { drag: p, dragPropagation: f, onDragStart: m } = this.getProps();
      if (p && !f && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = If(p), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), Ve((y) => {
        let b = this.getAxisMotionValue(y).get() || 0;
        if (Qe.test(b)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const x = w.layout.layoutBox[y];
            x && (b = Ie(x) * (parseFloat(b) / 100));
          }
        }
        this.originPoint[y] = b;
      }), m && ce.postRender(() => m(d, u)), Os(this.visualElement, "transform");
      const { animationState: g } = this.visualElement;
      g && g.setActive("whileDrag", !0);
    }, s = (d, u) => {
      const { dragPropagation: p, dragDirectionLock: f, onDirectionLock: m, onDrag: g } = this.getProps();
      if (!p && !this.openGlobalLock)
        return;
      const { offset: y } = u;
      if (f && this.currentDirection === null) {
        this.currentDirection = Gk(y), this.currentDirection !== null && m && m(this.currentDirection);
        return;
      }
      this.updateAxis("x", u.point, y), this.updateAxis("y", u.point, y), this.visualElement.render(), g && g(d, u);
    }, a = (d, u) => this.stop(d, u), l = () => Ve((d) => {
      var u;
      return this.getAnimationState(d) === "paused" && ((u = this.getAxisMotionValue(d).animation) === null || u === void 0 ? void 0 : u.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new Df(t, {
      onSessionStart: o,
      onStart: i,
      onMove: s,
      onSessionEnd: a,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: jf(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: i } = this.getProps();
    i && ce.postRender(() => i(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !ro(t, o, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let s = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (s = Lk(s, this.constraints[t], this.elastic[t])), i.set(s);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, i = this.constraints;
    n && yn(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = Ik(o.layoutBox, n) : this.constraints = !1, this.elastic = zk(r), i !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && Ve((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = Ok(o.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !yn(t))
      return !1;
    const r = t.current;
    nt(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const i = jk(r, o.root, this.visualElement.getTransformPagePoint());
    let s = Fk(o.layout.layoutBox, i);
    if (n) {
      const a = n(Nk(s));
      this.hasMutatedConstraints = !!a, a && (s = zf(a));
    }
    return s;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: i, dragSnapToOrigin: s, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = Ve((d) => {
      if (!ro(d, n, this.currentDirection))
        return;
      let u = l && l[d] || {};
      s && (u = { min: 0, max: 0 });
      const p = o ? 200 : 1e6, f = o ? 40 : 1e7, m = {
        type: "inertia",
        velocity: r ? t[d] : 0,
        bounceStiffness: p,
        bounceDamping: f,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...u
      };
      return this.startAxisValueAnimation(d, m);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return Os(this.visualElement, t), r.start(Oa(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    Ve((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    Ve((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    Ve((n) => {
      const { drag: r } = this.getProps();
      if (!ro(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, i = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: s, max: a } = o.layout.layoutBox[n];
        i.set(t[n] - he(s, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!yn(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    Ve((s) => {
      const a = this.getAxisMotionValue(s);
      if (a && this.constraints !== !1) {
        const l = a.get();
        o[s] = Vk({ min: l, max: l }, this.constraints[s]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), Ve((s) => {
      if (!ro(s, t, null))
        return;
      const a = this.getAxisMotionValue(s), { min: l, max: c } = this.constraints[s];
      a.set(he(l, c, o[s]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Hk.set(this.visualElement, this);
    const t = this.visualElement.current, n = pt(t, "pointerdown", (l) => {
      const { drag: c, dragListener: d = !0 } = this.getProps();
      c && d && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      yn(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, i = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), ce.read(r);
    const s = lt(window, "resize", () => this.scalePositionWithinConstraints()), a = o.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (Ve((d) => {
        const u = this.getAxisMotionValue(d);
        u && (this.originPoint[d] += l[d].translate, u.set(u.get() + l[d].translate));
      }), this.visualElement.render());
    });
    return () => {
      s(), n(), i(), a && a();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: i = !1, dragElastic: s = Ns, dragMomentum: a = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: i,
      dragElastic: s,
      dragMomentum: a
    };
  }
}
function ro(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function Gk(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class Kk extends Ft {
  constructor(t) {
    super(t), this.removeGroupControls = Ae, this.removeListeners = Ae, this.controls = new Uk(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Ae;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const id = (e) => (t, n) => {
  e && ce.postRender(() => e(t, n));
};
class Yk extends Ft {
  constructor() {
    super(...arguments), this.removePointerDownListener = Ae;
  }
  onPointerDown(t) {
    this.session = new Df(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: jf(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: id(t),
      onStart: id(n),
      onMove: r,
      onEnd: (i, s) => {
        delete this.session, o && ce.postRender(() => o(i, s));
      }
    };
  }
  mount() {
    this.removePointerDownListener = pt(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const xi = be(null);
function Xk() {
  const e = se(xi);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, o = yr();
  Y(() => r(o), []);
  const i = fe(() => n && n(o), [o, n]);
  return !t && n ? [!1, i] : [!0];
}
const Wa = be({}), Hf = be({}), fo = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function sd(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Hn = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ee.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = sd(e, t.target.x), r = sd(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, Zk = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = Mt.parse(e);
    if (o.length > 5)
      return r;
    const i = Mt.createTransformer(e), s = typeof o[0] != "number" ? 1 : 0, a = n.x.scale * t.x, l = n.y.scale * t.y;
    o[0 + s] /= a, o[1 + s] /= l;
    const c = he(a, l, 0.5);
    return typeof o[2 + s] == "number" && (o[2 + s] /= c), typeof o[3 + s] == "number" && (o[3 + s] /= c), i(o);
  }
}, No = {};
function qk(e) {
  Object.assign(No, e);
}
const { schedule: _a, cancel: wR } = Op(queueMicrotask, !1);
class Jk extends Oh {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: i } = t;
    qk(Qk), i && (n.group && n.group.add(i), r && r.register && o && r.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), fo.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: i } = this.props, s = r.projection;
    return s && (s.isPresent = i, o || t.layoutDependency !== n || n === void 0 ? s.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? s.promote() : s.relegate() || ce.postRender(() => {
      const a = s.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), _a.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Uf(e) {
  const [t, n] = Xk(), r = se(Wa);
  return h(Jk, { ...e, layoutGroup: r, switchLayoutGroup: se(Hf), isPresent: t, safeToRemove: n });
}
const Qk = {
  borderRadius: {
    ...Hn,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Hn,
  borderTopRightRadius: Hn,
  borderBottomLeftRadius: Hn,
  borderBottomRightRadius: Hn,
  boxShadow: Zk
}, Gf = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], e4 = Gf.length, ad = (e) => typeof e == "string" ? parseFloat(e) : e, ld = (e) => typeof e == "number" || ee.test(e);
function t4(e, t, n, r, o, i) {
  o ? (e.opacity = he(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    n4(r)
  ), e.opacityExit = he(t.opacity !== void 0 ? t.opacity : 1, 0, r4(r))) : i && (e.opacity = he(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let s = 0; s < e4; s++) {
    const a = `border${Gf[s]}Radius`;
    let l = cd(t, a), c = cd(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || ld(l) === ld(c) ? (e[a] = Math.max(he(ad(l), ad(c), r), 0), (Qe.test(c) || Qe.test(l)) && (e[a] += "%")) : e[a] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = he(t.rotate || 0, n.rotate || 0, r));
}
function cd(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const n4 = /* @__PURE__ */ Kf(0, 0.5, Up), r4 = /* @__PURE__ */ Kf(0.5, 0.95, Ae);
function Kf(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(en(e, t, r));
}
function dd(e, t) {
  e.min = t.min, e.max = t.max;
}
function Fe(e, t) {
  dd(e.x, t.x), dd(e.y, t.y);
}
function ud(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function pd(e, t, n, r, o) {
  return e -= t, e = zo(e, 1 / n, r), o !== void 0 && (e = zo(e, 1 / o, r)), e;
}
function o4(e, t = 0, n = 1, r = 0.5, o, i = e, s = e) {
  if (Qe.test(t) && (t = parseFloat(t), t = he(s.min, s.max, t / 100) - s.min), typeof t != "number")
    return;
  let a = he(i.min, i.max, r);
  e === i && (a -= t), e.min = pd(e.min, t, n, a, o), e.max = pd(e.max, t, n, a, o);
}
function fd(e, t, [n, r, o], i, s) {
  o4(e, t[n], t[r], t[o], t.scale, i, s);
}
const i4 = ["x", "scaleX", "originX"], s4 = ["y", "scaleY", "originY"];
function hd(e, t, n, r) {
  fd(e.x, t, i4, n ? n.x : void 0, r ? r.x : void 0), fd(e.y, t, s4, n ? n.y : void 0, r ? r.y : void 0);
}
function md(e) {
  return e.translate === 0 && e.scale === 1;
}
function Yf(e) {
  return md(e.x) && md(e.y);
}
function gd(e, t) {
  return e.min === t.min && e.max === t.max;
}
function a4(e, t) {
  return gd(e.x, t.x) && gd(e.y, t.y);
}
function vd(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Xf(e, t) {
  return vd(e.x, t.x) && vd(e.y, t.y);
}
function yd(e) {
  return Ie(e.x) / Ie(e.y);
}
function bd(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class l4 {
  constructor() {
    this.members = [];
  }
  add(t) {
    Br(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (vi(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const i = this.members[o];
      if (i.isPresent !== !1) {
        r = i;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function c4(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, i = e.y.translate / t.y, s = (n == null ? void 0 : n.z) || 0;
  if ((o || i || s) && (r = `translate3d(${o}px, ${i}px, ${s}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: d, rotateX: u, rotateY: p, skewX: f, skewY: m } = n;
    c && (r = `perspective(${c}px) ${r}`), d && (r += `rotate(${d}deg) `), u && (r += `rotateX(${u}deg) `), p && (r += `rotateY(${p}deg) `), f && (r += `skewX(${f}deg) `), m && (r += `skewY(${m}deg) `);
  }
  const a = e.x.scale * t.x, l = e.y.scale * t.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
const d4 = (e, t) => e.depth - t.depth;
class u4 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    Br(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    vi(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(d4), this.isDirty = !1, this.children.forEach(t);
  }
}
function ho(e) {
  const t = ke(e) ? e.get() : e;
  return nk(t) ? t.toValue() : t;
}
function p4(e, t) {
  const n = et.now(), r = ({ timestamp: o }) => {
    const i = o - n;
    i >= t && (tt(r), e(i - t));
  };
  return ce.read(r, !0), () => tt(r);
}
function Zf(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function ja(e, t, n) {
  const r = ke(e) ? e : Dn(e);
  return r.start(Oa("", r, t, n)), r.animation;
}
const _t = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, Xn = typeof window < "u" && window.MotionDebug !== void 0, Ji = ["", "X", "Y", "Z"], f4 = { visibility: "hidden" }, xd = 1e3;
let h4 = 0;
function Qi(e, t, n, r) {
  const { latestValues: o } = t;
  o[e] && (n[e] = o[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function qf(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Rf(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", ce, !(o || i));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && qf(r);
}
function Jf({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(s = {}, a = t == null ? void 0 : t()) {
      this.id = h4++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Xn && (_t.totalNodes = _t.resolvedTargetDeltas = _t.recalculatedProjection = 0), this.nodes.forEach(v4), this.nodes.forEach($4), this.nodes.forEach(C4), this.nodes.forEach(y4), Xn && window.MotionDebug.record(_t);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = s, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new u4());
    }
    addEventListener(s, a) {
      return this.eventHandlers.has(s) || this.eventHandlers.set(s, new za()), this.eventHandlers.get(s).add(a);
    }
    notifyListeners(s, ...a) {
      const l = this.eventHandlers.get(s);
      l && l.notify(...a);
    }
    hasListeners(s) {
      return this.eventHandlers.has(s);
    }
    /**
     * Lifecycles
     */
    mount(s, a = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = Zf(s), this.instance = s;
      const { layoutId: l, layout: c, visualElement: d } = this.options;
      if (d && !d.current && d.mount(s), this.root.nodes.add(this), this.parent && this.parent.children.add(this), a && (c || l) && (this.isLayoutDirty = !0), e) {
        let u;
        const p = () => this.root.updateBlockedByResize = !1;
        e(s, () => {
          this.root.updateBlockedByResize = !0, u && u(), u = p4(p, 250), fo.hasAnimatedSinceResize && (fo.hasAnimatedSinceResize = !1, this.nodes.forEach($d));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && d && (l || c) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: p, hasRelativeTargetChanged: f, layout: m }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const g = this.options.transition || d.getDefaultTransition() || R4, { onLayoutAnimationStart: y, onLayoutAnimationComplete: b } = d.getProps(), w = !this.targetLayout || !Xf(this.targetLayout, m) || f, x = !p && f;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || x || p && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(u, x);
          const $ = {
            ...ka(g, "layout"),
            onPlay: y,
            onComplete: b
          };
          (d.shouldReduceMotion || this.options.layoutRoot) && ($.delay = 0, $.type = !1), this.startAnimation($);
        } else
          p || $d(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = m;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const s = this.getStack();
      s && s.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, tt(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(k4), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: s } = this.options;
      return s && s.getProps().transformTemplate;
    }
    willUpdate(s = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && qf(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let d = 0; d < this.path.length; d++) {
        const u = this.path[d];
        u.shouldResetTransform = !0, u.updateScroll("snapshot"), u.options.layoutRoot && u.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), s && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(wd);
        return;
      }
      this.isUpdating || this.nodes.forEach(x4), this.isUpdating = !1, this.nodes.forEach(w4), this.nodes.forEach(m4), this.nodes.forEach(g4), this.clearAllSnapshots();
      const a = et.now();
      Te.delta = Pt(0, 1e3 / 60, a - Te.timestamp), Te.timestamp = a, Te.isProcessing = !0, Hi.update.process(Te), Hi.preRender.process(Te), Hi.render.process(Te), Te.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, _a.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(b4), this.sharedNodes.forEach(S4);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, ce.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      ce.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const s = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ye(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, s ? s.layoutBox : void 0);
    }
    updateScroll(s = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === s && (a = !1), a) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: s,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const s = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Yf(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, d = c !== this.prevTransformTemplateValue;
      s && (a || Wt(this.latestValues) || d) && (o(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(s = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return s && (l = this.removeTransform(l)), A4(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var s;
      const { visualElement: a } = this.options;
      if (!a)
        return ye();
      const l = a.measureViewportBox();
      if (!(((s = this.scroll) === null || s === void 0 ? void 0 : s.wasRoot) || this.path.some(P4))) {
        const { scroll: d } = this.root;
        d && (xn(l.x, d.offset.x), xn(l.y, d.offset.y));
      }
      return l;
    }
    removeElementScroll(s) {
      var a;
      const l = ye();
      if (Fe(l, s), !((a = this.scroll) === null || a === void 0) && a.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c], { scroll: u, options: p } = d;
        d !== this.root && u && p.layoutScroll && (u.wasRoot && Fe(l, s), xn(l.x, u.offset.x), xn(l.y, u.offset.y));
      }
      return l;
    }
    applyTransform(s, a = !1) {
      const l = ye();
      Fe(l, s);
      for (let c = 0; c < this.path.length; c++) {
        const d = this.path[c];
        !a && d.options.layoutScroll && d.scroll && d !== d.root && wn(l, {
          x: -d.scroll.offset.x,
          y: -d.scroll.offset.y
        }), Wt(d.latestValues) && wn(l, d.latestValues);
      }
      return Wt(this.latestValues) && wn(l, this.latestValues), l;
    }
    removeTransform(s) {
      const a = ye();
      Fe(a, s);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !Wt(c.latestValues))
          continue;
        Ws(c.latestValues) && c.updateSnapshot();
        const d = ye(), u = c.measurePageBox();
        Fe(d, u), hd(a, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, d);
      }
      return Wt(this.latestValues) && hd(a, this.latestValues), a;
    }
    setTargetDelta(s) {
      this.targetDelta = s, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(s) {
      this.options = {
        ...this.options,
        ...s,
        crossfade: s.crossfade !== void 0 ? s.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Te.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(s = !1) {
      var a;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(s || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: p } = this.options;
      if (!(!this.layout || !(u || p))) {
        if (this.resolvedRelativeTargetAt = Te.timestamp, !this.targetDelta && !this.relativeTarget) {
          const f = this.getClosestProjectingParent();
          f && f.layout && this.animationProgress !== 1 ? (this.relativeParent = f, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ye(), this.relativeTargetOrigin = ye(), ar(this.relativeTargetOrigin, this.layout.layoutBox, f.layout.layoutBox), Fe(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = ye(), this.targetWithTransforms = ye()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Bk(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Fe(this.target, this.layout.layoutBox), Wf(this.target, this.targetDelta)) : Fe(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const f = this.getClosestProjectingParent();
            f && !!f.resumingFrom == !!this.resumingFrom && !f.options.layoutScroll && f.target && this.animationProgress !== 1 ? (this.relativeParent = f, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ye(), this.relativeTargetOrigin = ye(), ar(this.relativeTargetOrigin, this.target, f.target), Fe(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Xn && _t.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Ws(this.parent.latestValues) || Nf(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var s;
      const a = this.getLead(), l = !!this.resumingFrom || this !== a;
      let c = !0;
      if ((this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === Te.timestamp && (c = !1), c)
        return;
      const { layout: d, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(d || u))
        return;
      Fe(this.layoutCorrected, this.layout.layoutBox);
      const p = this.treeScale.x, f = this.treeScale.y;
      _k(this.layoutCorrected, this.treeScale, this.path, l), a.layout && !a.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (a.target = a.layout.layoutBox, a.targetWithTransforms = ye());
      const { target: m } = a;
      if (!m) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (ud(this.prevProjectionDelta.x, this.projectionDelta.x), ud(this.prevProjectionDelta.y, this.projectionDelta.y)), sr(this.projectionDelta, this.layoutCorrected, m, this.latestValues), (this.treeScale.x !== p || this.treeScale.y !== f || !bd(this.projectionDelta.x, this.prevProjectionDelta.x) || !bd(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", m)), Xn && _t.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(s = !0) {
      var a;
      if ((a = this.options.visualElement) === null || a === void 0 || a.scheduleRender(), s) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = bn(), this.projectionDelta = bn(), this.projectionDeltaWithTransform = bn();
    }
    setAnimationOrigin(s, a = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, d = { ...this.latestValues }, u = bn();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const p = ye(), f = l ? l.source : void 0, m = this.layout ? this.layout.source : void 0, g = f !== m, y = this.getStack(), b = !y || y.members.length <= 1, w = !!(g && !b && this.options.crossfade === !0 && !this.path.some(E4));
      this.animationProgress = 0;
      let x;
      this.mixTargetDelta = ($) => {
        const E = $ / 1e3;
        Cd(u.x, s.x, E), Cd(u.y, s.y, E), this.setTargetDelta(u), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (ar(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), T4(this.relativeTarget, this.relativeTargetOrigin, p, E), x && a4(this.relativeTarget, x) && (this.isProjectionDirty = !1), x || (x = ye()), Fe(x, this.relativeTarget)), g && (this.animationValues = d, t4(d, c, this.latestValues, E, w, b)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = E;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(s) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (tt(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ce.update(() => {
        fo.hasAnimatedSinceResize = !0, this.currentAnimation = ja(0, xd, {
          ...s,
          onUpdate: (a) => {
            this.mixTargetDelta(a), s.onUpdate && s.onUpdate(a);
          },
          onComplete: () => {
            s.onComplete && s.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const s = this.getStack();
      s && s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(xd), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const s = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: d } = s;
      if (!(!a || !l || !c)) {
        if (this !== s && this.layout && c && Qf(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || ye();
          const u = Ie(this.layout.layoutBox.x);
          l.x.min = s.target.x.min, l.x.max = l.x.min + u;
          const p = Ie(this.layout.layoutBox.y);
          l.y.min = s.target.y.min, l.y.max = l.y.min + p;
        }
        Fe(a, l), wn(a, d), sr(this.projectionDeltaWithTransform, this.layoutCorrected, a, d);
      }
    }
    registerSharedNode(s, a) {
      this.sharedNodes.has(s) || this.sharedNodes.set(s, new l4()), this.sharedNodes.get(s).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const s = this.getStack();
      return s ? s.lead === this : !0;
    }
    getLead() {
      var s;
      const { layoutId: a } = this.options;
      return a ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
    }
    getPrevLead() {
      var s;
      const { layoutId: a } = this.options;
      return a ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
    }
    getStack() {
      const { layoutId: s } = this.options;
      if (s)
        return this.root.sharedNodes.get(s);
    }
    promote({ needsReset: s, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), s && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const s = this.getStack();
      return s ? s.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: s } = this.options;
      if (!s)
        return;
      let a = !1;
      const { latestValues: l } = s;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const c = {};
      l.z && Qi("z", s, c, this.animationValues);
      for (let d = 0; d < Ji.length; d++)
        Qi(`rotate${Ji[d]}`, s, c, this.animationValues), Qi(`skew${Ji[d]}`, s, c, this.animationValues);
      s.render();
      for (const d in c)
        s.setStaticValue(d, c[d]), this.animationValues && (this.animationValues[d] = c[d]);
      s.scheduleRender();
    }
    getProjectionStyles(s) {
      var a, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return f4;
      const c = {
        visibility: ""
      }, d = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = ho(s == null ? void 0 : s.pointerEvents) || "", c.transform = d ? d(this.latestValues, "") : "none", c;
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        const g = {};
        return this.options.layoutId && (g.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, g.pointerEvents = ho(s == null ? void 0 : s.pointerEvents) || ""), this.hasProjected && !Wt(this.latestValues) && (g.transform = d ? d({}, "") : "none", this.hasProjected = !1), g;
      }
      const p = u.animationValues || u.latestValues;
      this.applyTransformsToTarget(), c.transform = c4(this.projectionDeltaWithTransform, this.treeScale, p), d && (c.transform = d(p, c.transform));
      const { x: f, y: m } = this.projectionDelta;
      c.transformOrigin = `${f.origin * 100}% ${m.origin * 100}% 0`, u.animationValues ? c.opacity = u === this ? (l = (a = p.opacity) !== null && a !== void 0 ? a : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : p.opacityExit : c.opacity = u === this ? p.opacity !== void 0 ? p.opacity : "" : p.opacityExit !== void 0 ? p.opacityExit : 0;
      for (const g in No) {
        if (p[g] === void 0)
          continue;
        const { correct: y, applyTo: b } = No[g], w = c.transform === "none" ? p[g] : y(p[g], u);
        if (b) {
          const x = b.length;
          for (let $ = 0; $ < x; $++)
            c[b[$]] = w;
        } else
          c[g] = w;
      }
      return this.options.layoutId && (c.pointerEvents = u === this ? ho(s == null ? void 0 : s.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((s) => {
        var a;
        return (a = s.currentAnimation) === null || a === void 0 ? void 0 : a.stop();
      }), this.root.nodes.forEach(wd), this.root.sharedNodes.clear();
    }
  };
}
function m4(e) {
  e.updateLayout();
}
function g4(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: i } = e.options, s = n.source !== e.layout.source;
    i === "size" ? Ve((u) => {
      const p = s ? n.measuredBox[u] : n.layoutBox[u], f = Ie(p);
      p.min = r[u].min, p.max = p.min + f;
    }) : Qf(i, n.layoutBox, r) && Ve((u) => {
      const p = s ? n.measuredBox[u] : n.layoutBox[u], f = Ie(r[u]);
      p.max = p.min + f, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[u].max = e.relativeTarget[u].min + f);
    });
    const a = bn();
    sr(a, r, n.layoutBox);
    const l = bn();
    s ? sr(l, e.applyTransform(o, !0), n.measuredBox) : sr(l, r, n.layoutBox);
    const c = !Yf(a);
    let d = !1;
    if (!e.resumeFrom) {
      const u = e.getClosestProjectingParent();
      if (u && !u.resumeFrom) {
        const { snapshot: p, layout: f } = u;
        if (p && f) {
          const m = ye();
          ar(m, n.layoutBox, p.layoutBox);
          const g = ye();
          ar(g, r, f.layoutBox), Xf(m, g) || (d = !0), u.options.layoutRoot && (e.relativeTarget = g, e.relativeTargetOrigin = m, e.relativeParent = u);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: d
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function v4(e) {
  Xn && _t.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function y4(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function b4(e) {
  e.clearSnapshot();
}
function wd(e) {
  e.clearMeasurements();
}
function x4(e) {
  e.isLayoutDirty = !1;
}
function w4(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function $d(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function $4(e) {
  e.resolveTargetDelta();
}
function C4(e) {
  e.calcProjection();
}
function k4(e) {
  e.resetSkewAndRotation();
}
function S4(e) {
  e.removeLeadSnapshot();
}
function Cd(e, t, n) {
  e.translate = he(t.translate, 0, n), e.scale = he(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function kd(e, t, n, r) {
  e.min = he(t.min, n.min, r), e.max = he(t.max, n.max, r);
}
function T4(e, t, n, r) {
  kd(e.x, t.x, n.x, r), kd(e.y, t.y, n.y, r);
}
function E4(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const R4 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Sd = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), Td = Sd("applewebkit/") && !Sd("chrome/") ? Math.round : Ae;
function Ed(e) {
  e.min = Td(e.min), e.max = Td(e.max);
}
function A4(e) {
  Ed(e.x), Ed(e.y);
}
function Qf(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !Dk(yd(t), yd(n), 0.2);
}
function P4(e) {
  var t;
  return e !== e.root && ((t = e.scroll) === null || t === void 0 ? void 0 : t.wasRoot);
}
const M4 = Jf({
  attachResizeListener: (e, t) => lt(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), es = {
  current: void 0
}, eh = Jf({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!es.current) {
      const e = new M4({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), es.current = e;
    }
    return es.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), D4 = {
  pan: {
    Feature: Yk
  },
  drag: {
    Feature: Kk,
    ProjectionNode: eh,
    MeasureLayout: Uf
  }
};
function Rd(e, t) {
  const n = t ? "pointerenter" : "pointerleave", r = t ? "onHoverStart" : "onHoverEnd", o = (i, s) => {
    if (i.pointerType === "touch" || Ff())
      return;
    const a = e.getProps();
    e.animationState && a.whileHover && e.animationState.setActive("whileHover", t);
    const l = a[r];
    l && ce.postRender(() => l(i, s));
  };
  return pt(e.current, n, o, {
    passive: !e.getProps()[r]
  });
}
class B4 extends Ft {
  mount() {
    this.unmount = ut(Rd(this.node, !0), Rd(this.node, !1));
  }
  unmount() {
  }
}
class L4 extends Ft {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = ut(lt(this.node.current, "focus", () => this.onFocus()), lt(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const th = (e, t) => t ? e === t ? !0 : th(e, t.parentElement) : !1;
function ts(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, bi(n));
}
class I4 extends Ft {
  constructor() {
    super(...arguments), this.removeStartListeners = Ae, this.removeEndListeners = Ae, this.removeAccessibleListeners = Ae, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), i = pt(window, "pointerup", (a, l) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: c, onTapCancel: d, globalTapTarget: u } = this.node.getProps(), p = !u && !th(this.node.current, a.target) ? d : c;
        p && ce.update(() => p(a, l));
      }, {
        passive: !(r.onTap || r.onPointerUp)
      }), s = pt(window, "pointercancel", (a, l) => this.cancelPress(a, l), {
        passive: !(r.onTapCancel || r.onPointerCancel)
      });
      this.removeEndListeners = ut(i, s), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (i) => {
        if (i.key !== "Enter" || this.isPressing)
          return;
        const s = (a) => {
          a.key !== "Enter" || !this.checkPressEnd() || ts("up", (l, c) => {
            const { onTap: d } = this.node.getProps();
            d && ce.postRender(() => d(l, c));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = lt(this.node.current, "keyup", s), ts("down", (a, l) => {
          this.startPress(a, l);
        });
      }, n = lt(this.node.current, "keydown", t), r = () => {
        this.isPressing && ts("cancel", (i, s) => this.cancelPress(i, s));
      }, o = lt(this.node.current, "blur", r);
      this.removeAccessibleListeners = ut(n, o);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && ce.postRender(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !Ff();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && ce.postRender(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = pt(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
      passive: !(t.onTapStart || t.onPointerStart)
    }), r = lt(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = ut(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const js = /* @__PURE__ */ new WeakMap(), ns = /* @__PURE__ */ new WeakMap(), F4 = (e) => {
  const t = js.get(e.target);
  t && t(e);
}, V4 = (e) => {
  e.forEach(F4);
};
function O4({ root: e, ...t }) {
  const n = e || document;
  ns.has(n) || ns.set(n, {});
  const r = ns.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(V4, { root: e, ...t })), r[o];
}
function z4(e, t, n) {
  const r = O4(t);
  return js.set(e, n), r.observe(e), () => {
    js.delete(e), r.unobserve(e);
  };
}
const N4 = {
  some: 0,
  all: 1
};
class W4 extends Ft {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: i } = t, s = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : N4[o]
    }, a = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: d, onViewportLeave: u } = this.node.getProps(), p = c ? d : u;
      p && p(l);
    };
    return z4(this.node.current, s, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(_4(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function _4({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const j4 = {
  inView: {
    Feature: W4
  },
  tap: {
    Feature: I4
  },
  focus: {
    Feature: L4
  },
  hover: {
    Feature: B4
  }
}, H4 = {
  layout: {
    ProjectionNode: eh,
    MeasureLayout: Uf
  }
}, wi = be({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), $i = be({}), Ha = typeof window < "u", Ua = Ha ? nn : Y, nh = be({ strict: !1 });
let Ad = !1;
function U4(e, t, n, r, o) {
  var i;
  const { visualElement: s } = se($i), a = se(nh), l = se(xi), c = se(wi).reducedMotion, d = oe();
  r = r || a.renderer, !d.current && r && (d.current = r(e, {
    visualState: t,
    parent: s,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: c
  }));
  const u = d.current, p = se(Hf);
  u && !u.projection && o && (u.type === "html" || u.type === "svg") && K4(d.current, n, o, p), Zd(() => {
    u && u.update(n, l);
  });
  const f = n[Ef], m = oe(!!f && !window.MotionHandoffIsComplete && ((i = window.MotionHasOptimisedAnimation) === null || i === void 0 ? void 0 : i.call(window, f)));
  return Ua(() => {
    u && (u.updateFeatures(), _a.render(u.render), m.current && u.animationState && u.animationState.animateChanges());
  }), Y(() => {
    u && (!m.current && u.animationState && u.animationState.animateChanges(), m.current = !1, Ad || (Ad = !0, queueMicrotask(G4)));
  }), u;
}
function G4() {
  window.MotionHandoffIsComplete = !0;
}
function K4(e, t, n, r) {
  const { layoutId: o, layout: i, drag: s, dragConstraints: a, layoutScroll: l, layoutRoot: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : rh(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: i,
    alwaysMeasureLayout: !!s || a && yn(a),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: c
  });
}
function rh(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : rh(e.parent);
}
function Y4(e, t, n) {
  return fe(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : yn(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function Ci(e) {
  return hr(e.animate) || Ca.some((t) => mr(e[t]));
}
function oh(e) {
  return !!(Ci(e) || e.variants);
}
function X4(e, t) {
  if (Ci(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || mr(n) ? n : void 0,
      animate: mr(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Z4(e) {
  const { initial: t, animate: n } = X4(e, se($i));
  return K(() => ({ initial: t, animate: n }), [Pd(t), Pd(n)]);
}
function Pd(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Md = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Bn = {};
for (const e in Md)
  Bn[e] = {
    isEnabled: (t) => Md[e].some((n) => !!t[n])
  };
function q4(e) {
  for (const t in e)
    Bn[t] = {
      ...Bn[t],
      ...e[t]
    };
}
const J4 = Symbol.for("motionComponentSymbol");
function Q4({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  e && q4(e);
  function i(a, l) {
    let c;
    const d = {
      ...se(wi),
      ...a,
      layoutId: eS(a)
    }, { isStatic: u } = d, p = Z4(a), f = r(a, u);
    if (!u && Ha) {
      tS(d, e);
      const m = nS(d);
      c = m.MeasureLayout, p.visualElement = U4(o, f, d, t, m.ProjectionNode);
    }
    return M($i.Provider, { value: p, children: [c && p.visualElement ? h(c, { visualElement: p.visualElement, ...d }) : null, n(o, a, Y4(f, p.visualElement, l), f, u, p.visualElement)] });
  }
  const s = A(i);
  return s[J4] = o, s;
}
function eS({ layoutId: e }) {
  const t = se(Wa).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function tS(e, t) {
  const n = se(nh).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? Fn(!1, r) : nt(!1, r);
  }
}
function nS(e) {
  const { drag: t, layout: n } = Bn;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const rS = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ga(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(rS.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function ih(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const i in n)
    e.style.setProperty(i, n[i]);
}
const sh = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function ah(e, t, n, r) {
  ih(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(sh.has(o) ? o : yi(o), t.attrs[o]);
}
function lh(e, { layout: t, layoutId: n }) {
  return It.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!No[e] || e === "opacity");
}
function Ka(e, t, n) {
  var r;
  const { style: o } = e, i = {};
  for (const s in o)
    (ke(o[s]) || t.style && ke(t.style[s]) || lh(s, e) || ((r = n == null ? void 0 : n.getValue(s)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (i[s] = o[s]);
  return n && o && typeof o.willChange == "string" && (n.applyWillChange = !1), i;
}
function ch(e, t, n) {
  const r = Ka(e, t, n);
  for (const o in e)
    if (ke(e[o]) || ke(t[o])) {
      const i = Ar.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[i] = e[o];
    }
  return r;
}
function Lr(e) {
  const t = oe(null);
  return t.current === null && (t.current = e()), t.current;
}
function oS({ applyWillChange: e = !1, scrapeMotionValuesFromProps: t, createRenderState: n, onMount: r }, o, i, s, a) {
  const l = {
    latestValues: sS(o, i, s, a ? !1 : e, t),
    renderState: n()
  };
  return r && (l.mount = (c) => r(o, c, l)), l;
}
const dh = (e) => (t, n) => {
  const r = se($i), o = se(xi), i = () => oS(e, t, r, o, n);
  return n ? i() : Lr(i);
};
function iS(e, t) {
  const n = Af(t);
  n && Br(e, n);
}
function Dd(e, t, n) {
  const r = Array.isArray(t) ? t : [t];
  for (let o = 0; o < r.length; o++) {
    const i = wa(e, r[o]);
    if (i) {
      const { transitionEnd: s, transition: a, ...l } = i;
      n(l, s);
    }
  }
}
function sS(e, t, n, r, o) {
  var i;
  const s = {}, a = [], l = r && ((i = e.style) === null || i === void 0 ? void 0 : i.willChange) === void 0, c = o(e, {});
  for (const y in c)
    s[y] = ho(c[y]);
  let { initial: d, animate: u } = e;
  const p = Ci(e), f = oh(e);
  t && f && !p && e.inherit !== !1 && (d === void 0 && (d = t.initial), u === void 0 && (u = t.animate));
  let m = n ? n.initial === !1 : !1;
  m = m || d === !1;
  const g = m ? u : d;
  return g && typeof g != "boolean" && !hr(g) && Dd(e, g, (y, b) => {
    for (const w in y) {
      let x = y[w];
      if (Array.isArray(x)) {
        const $ = m ? x.length - 1 : 0;
        x = x[$];
      }
      x !== null && (s[w] = x);
    }
    for (const w in b)
      s[w] = b[w];
  }), l && (u && d !== !1 && !hr(u) && Dd(e, u, (y) => {
    for (const b in y)
      iS(a, b);
  }), a.length && (s.willChange = a.join(","))), s;
}
const Ya = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), uh = () => ({
  ...Ya(),
  attrs: {}
}), ph = (e, t) => t && typeof e == "number" ? t.transform(e) : e, aS = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, lS = Ar.length;
function cS(e, t, n) {
  let r = "", o = !0;
  for (let i = 0; i < lS; i++) {
    const s = Ar[i], a = e[s];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (s.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const c = ph(a, Ma[s]);
      if (!l) {
        o = !1;
        const d = aS[s] || s;
        r += `${d}(${c}) `;
      }
      n && (t[s] = c);
    }
  }
  return r = r.trim(), n ? r = n(t, o ? "" : r) : o && (r = "none"), r;
}
function Xa(e, t, n) {
  const { style: r, vars: o, transformOrigin: i } = e;
  let s = !1, a = !1;
  for (const l in t) {
    const c = t[l];
    if (It.has(l)) {
      s = !0;
      continue;
    } else if (Zp(l)) {
      o[l] = c;
      continue;
    } else {
      const d = ph(c, Ma[l]);
      l.startsWith("origin") ? (a = !0, i[l] = d) : r[l] = d;
    }
  }
  if (t.transform || (s || n ? r.transform = cS(t, e.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: l = "50%", originY: c = "50%", originZ: d = 0 } = i;
    r.transformOrigin = `${l} ${c} ${d}`;
  }
}
function Bd(e, t, n) {
  return typeof e == "string" ? e : ee.transform(t + n * e);
}
function dS(e, t, n) {
  const r = Bd(t, e.x, e.width), o = Bd(n, e.y, e.height);
  return `${r} ${o}`;
}
const uS = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, pS = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function fS(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const i = o ? uS : pS;
  e[i.offset] = ee.transform(-r);
  const s = ee.transform(t), a = ee.transform(n);
  e[i.array] = `${s} ${a}`;
}
function Za(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: o,
  originY: i,
  pathLength: s,
  pathSpacing: a = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, d, u) {
  if (Xa(e, c, u), d) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: p, style: f, dimensions: m } = e;
  p.transform && (m && (f.transform = p.transform), delete p.transform), m && (o !== void 0 || i !== void 0 || f.transform) && (f.transformOrigin = dS(m, o !== void 0 ? o : 0.5, i !== void 0 ? i : 0.5)), t !== void 0 && (p.x = t), n !== void 0 && (p.y = n), r !== void 0 && (p.scale = r), s !== void 0 && fS(p, s, a, l, !1);
}
const qa = (e) => typeof e == "string" && e.toLowerCase() === "svg", hS = {
  useVisualState: dh({
    scrapeMotionValuesFromProps: ch,
    createRenderState: uh,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      ce.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), ce.render(() => {
        Za(n, r, qa(t.tagName), e.transformTemplate), ah(t, n);
      });
    }
  })
}, mS = {
  useVisualState: dh({
    applyWillChange: !0,
    scrapeMotionValuesFromProps: Ka,
    createRenderState: Ya
  })
};
function fh(e, t, n) {
  for (const r in t)
    !ke(t[r]) && !lh(r, n) && (e[r] = t[r]);
}
function gS({ transformTemplate: e }, t) {
  return K(() => {
    const n = Ya();
    return Xa(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function vS(e, t) {
  const n = e.style || {}, r = {};
  return fh(r, n, e), Object.assign(r, gS(e, t)), r;
}
function yS(e, t) {
  const n = {}, r = vS(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const bS = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function Wo(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || bS.has(e);
}
let hh = (e) => !Wo(e);
function xS(e) {
  e && (hh = (t) => t.startsWith("on") ? !Wo(t) : e(t));
}
try {
  xS(require("@emotion/is-prop-valid").default);
} catch {
}
function wS(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (hh(o) || n === !0 && Wo(o) || !t && !Wo(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function $S(e, t, n, r) {
  const o = K(() => {
    const i = uh();
    return Za(i, t, qa(r), e.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    fh(i, e.style, e), o.style = { ...i, ...o.style };
  }
  return o;
}
function CS(e = !1) {
  return (n, r, o, { latestValues: i }, s) => {
    const l = (Ga(n) ? $S : yS)(r, i, s, n), c = wS(r, typeof n == "string", e), d = n !== qd ? { ...c, ...l, ref: o } : {}, { children: u } = r, p = K(() => ke(u) ? u.get() : u, [u]);
    return zh(n, {
      ...d,
      children: p
    });
  };
}
function kS(e, t) {
  return function(r, { forwardMotionProps: o } = { forwardMotionProps: !1 }) {
    const s = {
      ...Ga(r) ? hS : mS,
      preloadedFeatures: e,
      useRender: CS(o),
      createVisualElement: t,
      Component: r
    };
    return Q4(s);
  };
}
const _o = { current: null }, Ja = { current: !1 };
function mh() {
  if (Ja.current = !0, !!Ha)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => _o.current = e.matches;
      e.addListener(t), t();
    } else
      _o.current = !1;
}
function SS(e, t, n) {
  for (const r in t) {
    const o = t[r], i = n[r];
    if (ke(o))
      e.addValue(r, o), process.env.NODE_ENV === "development" && Rr(o.version === "11.8.0", `Attempting to mix Framer Motion versions ${o.version} with 11.8.0 may not work as expected.`);
    else if (ke(i))
      e.addValue(r, Dn(o, { owner: e }));
    else if (i !== o)
      if (e.hasValue(r)) {
        const s = e.getValue(r);
        s.liveStyle === !0 ? s.jump(o) : s.hasAnimated || s.set(o);
      } else {
        const s = e.getStaticValue(r);
        e.addValue(r, Dn(s !== void 0 ? s : o, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const vr = /* @__PURE__ */ new WeakMap(), TS = [...Qp, Me, Mt], ES = (e) => TS.find(Jp(e)), Ld = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class RS {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, blockInitialAnimation: i, visualState: s }, a = {}) {
    this.applyWillChange = !1, this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Aa, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = et.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, ce.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = s;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = a, this.blockInitialAnimation = !!i, this.isControllingVariants = Ci(n), this.isVariantNode = oh(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...u } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in u) {
      const f = u[p];
      l[p] !== void 0 && ke(f) && f.set(l[p], !1);
    }
  }
  mount(t) {
    this.current = t, vr.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), Ja.current || mh(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : _o.current, process.env.NODE_ENV !== "production" && Rr(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    vr.delete(this.current), this.projection && this.projection.unmount(), tt(this.notifyUpdate), tt(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = It.has(t), o = n.on("change", (a) => {
      this.latestValues[t] = a, this.props.onUpdate && ce.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), i = n.on("renderRequest", this.scheduleRender);
    let s;
    window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      o(), i(), s && s(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in Bn) {
      const n = Bn[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[t] && o && r(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ye();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Ld.length; r++) {
      const o = Ld[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const i = "on" + o, s = t[i];
      s && (this.propEventSubscriptions[o] = this.on(o, s));
    }
    this.prevMotionValues = SS(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Dn(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    var r;
    let o = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return o != null && (typeof o == "string" && (Yp(o) || Kp(o)) ? o = parseFloat(o) : !ES(o) && Mt.test(n) && (o = lf(t, n)), this.setBaseTarget(t, ke(o) ? o.get() : o)), ke(o) ? o.get() : o;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props;
    let o;
    if (typeof r == "string" || typeof r == "object") {
      const s = wa(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      s && (o = s[t]);
    }
    if (r && o !== void 0)
      return o;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !ke(i) ? i : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new za()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class gh extends RS {
  constructor() {
    super(...arguments), this.KeyframeResolver = cf;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
}
function AS(e) {
  return window.getComputedStyle(e);
}
class vh extends gh {
  constructor() {
    super(...arguments), this.type = "html", this.applyWillChange = !0, this.renderInstance = ih;
  }
  readValueFromInstance(t, n) {
    if (It.has(n)) {
      const r = Da(n);
      return r && r.default || 0;
    } else {
      const r = AS(t), o = (Zp(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return _f(t, n);
  }
  build(t, n, r) {
    Xa(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Ka(t, n, r);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    ke(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class yh extends gh {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ye;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (It.has(n)) {
      const r = Da(n);
      return r && r.default || 0;
    }
    return n = sh.has(n) ? n : yi(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return ch(t, n, r);
  }
  build(t, n, r) {
    Za(t, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    ah(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = qa(t.tagName), super.mount(t);
  }
}
const PS = (e, t) => Ga(e) ? new yh(t) : new vh(t, {
  allowProjection: e !== qd
}), MS = /* @__PURE__ */ kS({
  ...Ck,
  ...j4,
  ...D4,
  ...H4
}, PS), St = /* @__PURE__ */ $$(MS);
class DS extends T.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function BS({ children: e, isPresent: t }) {
  const n = yr(), r = oe(null), o = oe({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: i } = se(wi);
  return Zd(() => {
    const { width: s, height: a, top: l, left: c } = o.current;
    if (t || !r.current || !s || !a)
      return;
    r.current.dataset.motionPopId = n;
    const d = document.createElement("style");
    return i && (d.nonce = i), document.head.appendChild(d), d.sheet && d.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${a}px !important;
            top: ${l}px !important;
            left: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(d);
    };
  }, [t]), h(DS, { isPresent: t, childRef: r, sizeRef: o, children: T.cloneElement(e, { ref: r }) });
}
const LS = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: i, mode: s }) => {
  const a = Lr(IS), l = yr(), c = K(
    () => ({
      id: l,
      initial: t,
      isPresent: n,
      custom: o,
      onExitComplete: (d) => {
        a.set(d, !0);
        for (const u of a.values())
          if (!u)
            return;
        r && r();
      },
      register: (d) => (a.set(d, !1), () => a.delete(d))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? [Math.random()] : [n]
  );
  return K(() => {
    a.forEach((d, u) => a.set(u, !1));
  }, [n]), T.useEffect(() => {
    !n && !a.size && r && r();
  }, [n]), s === "popLayout" && (e = h(BS, { isPresent: n, children: e })), h(xi.Provider, { value: c, children: e });
};
function IS() {
  return /* @__PURE__ */ new Map();
}
const oo = (e) => e.key || "";
function Id(e) {
  const t = [];
  return Tt.forEach(e, (n) => {
    Xd(n) && t.push(n);
  }), t;
}
const FS = ({ children: e, exitBeforeEnter: t, custom: n, initial: r = !0, onExitComplete: o, presenceAffectsLayout: i = !0, mode: s = "sync" }) => {
  nt(!t, "Replace exitBeforeEnter with mode='wait'");
  const a = K(() => Id(e), [e]), l = a.map(oo), c = oe(!0), d = oe(a), u = Lr(() => /* @__PURE__ */ new Map()), [p, f] = U(a), [m, g] = U(a);
  Ua(() => {
    c.current = !1, d.current = a;
    for (let w = 0; w < m.length; w++) {
      const x = oo(m[w]);
      l.includes(x) ? u.delete(x) : u.get(x) !== !0 && u.set(x, !1);
    }
  }, [m, l.length, l.join("-")]);
  const y = [];
  if (a !== p) {
    let w = [...a];
    for (let x = 0; x < m.length; x++) {
      const $ = m[x], E = oo($);
      l.includes(E) || (w.splice(x, 0, $), y.push($));
    }
    s === "wait" && y.length && (w = y), g(Id(w)), f(a);
    return;
  }
  process.env.NODE_ENV !== "production" && s === "wait" && m.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: b } = se(Wa);
  return h(We, { children: m.map((w) => {
    const x = oo(w), $ = a === m || l.includes(x), E = () => {
      if (u.has(x))
        u.set(x, !0);
      else
        return;
      let S = !0;
      u.forEach((F) => {
        F || (S = !1);
      }), S && (b == null || b(), g(d.current), o && o());
    };
    return h(LS, { isPresent: $, initial: !c.current || r ? void 0 : !1, custom: $ ? void 0 : n, presenceAffectsLayout: i, mode: s, onExitComplete: $ ? void 0 : E, children: w }, x);
  }) });
};
function Hs(e) {
  const t = Lr(() => Dn(e)), { isStatic: n } = se(wi);
  if (n) {
    const [, r] = U(e);
    Y(() => t.on("change", r), []);
  }
  return t;
}
function bh(e, t) {
  const n = Hs(t()), r = () => n.set(t());
  return r(), Ua(() => {
    const o = () => ce.preRender(r, !1, !0), i = e.map((s) => s.on("change", o));
    return () => {
      i.forEach((s) => s()), tt(r);
    };
  }), n;
}
const VS = (e) => e && typeof e == "object" && e.mix, OS = (e) => VS(e) ? e.mix : void 0;
function zS(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], o = e[1 + n], i = e[2 + n], s = e[3 + n], a = vf(o, i, {
    mixer: OS(i[0]),
    ...s
  });
  return t ? a(r) : a;
}
function NS(e) {
  ir.current = [], e();
  const t = bh(ir.current, e);
  return ir.current = void 0, t;
}
function jo(e, t, n, r) {
  if (typeof e == "function")
    return NS(e);
  const o = typeof t == "function" ? t : zS(t, n, r);
  return Array.isArray(e) ? Fd(e, o) : Fd([e], ([i]) => o(i));
}
function Fd(e, t) {
  const n = Lr(() => []);
  return bh(e, () => {
    n.length = 0;
    const r = e.length;
    for (let o = 0; o < r; o++)
      n[o] = e[o].get();
    return t(n);
  });
}
function xh(e, t, n) {
  var r;
  if (typeof e == "string") {
    let o = document;
    n ? ((r = n[e]) !== null && r !== void 0 || (n[e] = o.querySelectorAll(e)), e = n[e]) : e = o.querySelectorAll(e);
  } else e instanceof Element && (e = [e]);
  return Array.from(e || []);
}
function WS() {
  !Ja.current && mh();
  const [e] = U(_o.current);
  return process.env.NODE_ENV !== "production" && Rr(e !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), e;
}
function _S(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function jS(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = Zf(e) ? new yh(t) : new vh(t);
  n.mount(e), vr.set(e, n);
}
function HS(e, t = 100) {
  const n = La({ keyframes: [0, t], ...e }), r = Math.min(xf(n), Fs);
  return {
    type: "keyframes",
    ease: (o) => n.next(r * o).value / t,
    duration: Je(r)
  };
}
function Vd(e, t, n, r) {
  var o;
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : (o = r.get(t)) !== null && o !== void 0 ? o : e;
}
const US = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
};
function GS(e, t) {
  return hf(e) ? e[US(0, e.length, t)] : e;
}
function KS(e, t, n) {
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    o.at > t && o.at < n && (vi(e, o), r--);
  }
}
function YS(e, t, n, r, o, i) {
  KS(e, o, i);
  for (let s = 0; s < t.length; s++)
    e.push({
      value: t[s],
      at: he(o, i, r[s]),
      easing: GS(n, s)
    });
}
function XS(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const ZS = "easeInOut";
function qS(e, { defaultTransition: t = {}, ...n } = {}, r) {
  const o = t.duration || 0.3, i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), a = {}, l = /* @__PURE__ */ new Map();
  let c = 0, d = 0, u = 0;
  for (let p = 0; p < e.length; p++) {
    const f = e[p];
    if (typeof f == "string") {
      l.set(f, d);
      continue;
    } else if (!Array.isArray(f)) {
      l.set(f.name, Vd(d, f.at, c, l));
      continue;
    }
    let [m, g, y = {}] = f;
    y.at !== void 0 && (d = Vd(d, y.at, c, l));
    let b = 0;
    const w = (x, $, E, S = 0, F = 0) => {
      const R = JS(x), { delay: L = 0, times: P = bf(R), type: j = "keyframes", ..._ } = $;
      let { ease: G = t.ease || "easeOut", duration: D } = $;
      const I = typeof L == "function" ? L(S, F) : L, z = R.length;
      if (z <= 2 && j === "spring" || gi(j)) {
        let B = 100;
        if (z === 2 && tT(R)) {
          const we = R[1] - R[0];
          B = Math.abs(we);
        }
        const X = { ..._ };
        D !== void 0 && (X.duration = Ge(D));
        const te = HS(X, B);
        G = te.ease, D = te.duration;
      }
      D ?? (D = o);
      const O = d + I, V = O + D;
      P.length === 1 && P[0] === 0 && (P[1] = 1);
      const N = P.length - R.length;
      N > 0 && yf(P, N), R.length === 1 && R.unshift(null), YS(E, R, G, P, O, V), b = Math.max(I + D, b), u = Math.max(V, u);
    };
    if (ke(m)) {
      const x = Od(m, s);
      w(g, y, zd("default", x));
    } else {
      const x = xh(m, r, a), $ = x.length;
      for (let E = 0; E < $; E++) {
        g = g, y = y;
        const S = x[E], F = Od(S, s);
        for (const R in g)
          w(g[R], QS(y, R), zd(R, F), E, $);
      }
    }
    c = d, d += b;
  }
  return s.forEach((p, f) => {
    for (const m in p) {
      const g = p[m];
      g.sort(XS);
      const y = [], b = [], w = [];
      for (let $ = 0; $ < g.length; $++) {
        const { at: E, value: S, easing: F } = g[$];
        y.push(S), b.push(en(0, u, E)), w.push(F || "easeOut");
      }
      b[0] !== 0 && (b.unshift(0), y.unshift(y[0]), w.unshift(ZS)), b[b.length - 1] !== 1 && (b.push(1), y.push(null)), i.has(f) || i.set(f, {
        keyframes: {},
        transition: {}
      });
      const x = i.get(f);
      x.keyframes[m] = y, x.transition[m] = {
        ...t,
        duration: u,
        ease: w,
        times: b,
        ...n
      };
    }
  }), i;
}
function Od(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function zd(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function JS(e) {
  return Array.isArray(e) ? e : [e];
}
function QS(e, t) {
  return e[t] ? {
    ...e,
    ...e[t]
  } : { ...e };
}
const eT = (e) => typeof e == "number", tT = (e) => e.every(eT);
function wh(e, t, n, r) {
  const o = xh(e), i = o.length;
  nt(!!i, "No valid element provided.");
  const s = [];
  for (let a = 0; a < i; a++) {
    const l = o[a];
    vr.has(l) || jS(l);
    const c = vr.get(l), d = { ...n };
    typeof d.delay == "function" && (d.delay = d.delay(a, i)), s.push(...Na(c, { ...t, transition: d }, {}));
  }
  return new Va(s);
}
const nT = (e) => Array.isArray(e) && Array.isArray(e[0]);
function rT(e, t, n) {
  const r = [];
  return qS(e, t, n).forEach(({ keyframes: i, transition: s }, a) => {
    let l;
    ke(a) ? l = ja(a, i.default, s.default) : l = wh(a, i, s), r.push(l);
  }), new Va(r);
}
const oT = (e) => {
  function t(n, r, o) {
    let i;
    return nT(n) ? i = rT(n, r, e) : _S(r) ? i = wh(n, r, o) : i = ja(n, r, o), i;
  }
  return t;
}, Nd = oT(), iT = typeof document < "u" ? ge.useLayoutEffect : () => {
};
function Us(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
function Qa(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function sT() {
  return Qa(/^Mac/i);
}
function aT() {
  return Qa(/^iPhone/i);
}
function lT() {
  return Qa(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  sT() && navigator.maxTouchPoints > 1;
}
function cT() {
  return aT() || lT();
}
function Wd(e, t) {
  let n = window.getComputedStyle(e), r = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return r && t && (r = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), r;
}
function $h(e, t) {
  let n = e;
  for (Wd(n, t) && (n = n.parentElement); n && !Wd(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
var _d = "calc(100% - env(safe-area-inset-top) - 34px)", Ch = typeof window > "u", dT = {
  ease: "easeOut",
  duration: 0.2
}, uT = {
  ease: "linear",
  duration: 0.01
}, pT = 0.6, fT = 500;
function jd(e, t) {
  let n = e[0], r = Math.abs(e[0] - t);
  for (let o = 1; o < e.length; o++) {
    const i = Math.abs(e[o] - t);
    i < r && (n = e[o], r = i);
  }
  return n;
}
function hT(e) {
  const t = document.querySelector("body"), n = document.querySelector(`#${e}`);
  if (n) {
    const o = window.innerHeight, i = (o - 24) / o;
    t.style.backgroundColor = "#000", n.style.overflow = "hidden", n.style.willChange = "transform", n.style.transition = "transform 200ms ease-in-out, border-radius 200ms linear", n.style.transform = `translateY(calc(env(safe-area-inset-top) + ${24 / 2}px)) scale(${i})`, n.style.borderTopRightRadius = "10px", n.style.borderTopLeftRadius = "10px";
  }
}
function Hd(e) {
  const t = document.querySelector("body"), n = document.getElementById(e);
  function r() {
    n.style.removeProperty("overflow"), n.style.removeProperty("will-change"), n.style.removeProperty("transition"), t.style.removeProperty("background-color"), n.removeEventListener("transitionend", r);
  }
  n && (n.style.removeProperty("border-top-right-radius"), n.style.removeProperty("border-top-left-radius"), n.style.removeProperty("transform"), n.addEventListener("transitionend", r));
}
function mT(e) {
  for (let t = 0; t < e.length; t++)
    if (e[t + 1] > e[t])
      return !1;
  return !0;
}
function Ud({
  snapTo: e,
  sheetHeight: t
}) {
  return e < 0 && console.warn(
    `Snap point is out of bounds. Sheet height is ${t} but snap point is ${t + Math.abs(e)}.`
  ), Math.max(Math.round(e), 0);
}
function el(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n && (n.current = t);
    });
  };
}
function gT() {
  return typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
var tl = Ch ? Y : nn;
function vT(e, t) {
  const n = kh(e);
  Y(() => {
    t && !n && e ? hT(t) : t && !e && n && Hd(t);
  }, [e, n]), Y(() => () => {
    t && e && Hd(t);
  }, [e]);
}
function yT(e, t) {
  const n = kh(e), r = oe(!1), o = fe(() => {
    var i, s, a, l;
    r.current ? ((l = (a = t.current).onCloseEnd) == null || l.call(a), r.current = !1) : ((s = (i = t.current).onOpenEnd) == null || s.call(i), r.current = !0);
  }, [e, n]);
  return Y(() => {
    var i, s, a, l;
    !n && e ? (s = (i = t.current).onOpenStart) == null || s.call(i) : !e && n && ((l = (a = t.current).onCloseStart) == null || l.call(a));
  }, [e, n]), { handleAnimationComplete: o };
}
function bT() {
  const [e, t] = U({ height: 0, width: 0 });
  return tl(() => {
    function n() {
      t({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), e;
}
function kh(e) {
  const t = oe();
  return Y(() => {
    t.current = e;
  }), t.current;
}
function rs(e) {
  const t = oe();
  return tl(() => {
    t.current = e;
  }), fe((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
var xT = { bottom: 0, top: 0, left: 0, right: 0 };
function Sh() {
  const e = oe(null), t = fe(() => xT, []);
  return { constraintsRef: e, onMeasureDragConstraints: t };
}
var Th = be(
  void 0
), ki = () => {
  const e = se(Th);
  if (!e)
    throw Error("Sheet context error");
  return e;
}, Eh = be(void 0);
function wT({
  children: e
}) {
  const t = ki(), [n, r] = U(!!t.disableDrag);
  function o() {
    t.disableDrag || r(!1);
  }
  function i() {
    n || r(!0);
  }
  return /* @__PURE__ */ ge.createElement(
    Eh.Provider,
    {
      value: { disableDrag: n, setDragEnabled: o, setDragDisabled: i }
    },
    e
  );
}
var Rh = () => {
  const e = se(Eh);
  if (!e)
    throw Error("Sheet scroller context error");
  return e;
}, os = typeof window < "u" ? window.visualViewport : void 0, $T = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), io = 0, is;
function CT(e = {}) {
  const { isDisabled: t } = e;
  iT(() => {
    if (!t)
      return io++, io === 1 && (cT() ? is = ST() : is = kT()), () => {
        io--, io === 0 && is();
      };
  }, [t]);
}
function kT() {
  return Us(
    lr(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    lr(document.documentElement, "overflow", "hidden")
  );
}
function ST() {
  let e, t = 0;
  const n = (u) => {
    e = $h(u.target), !(e === document.documentElement && e === document.body) && (t = u.changedTouches[0].pageY);
  }, r = (u) => {
    if (e === void 0)
      return;
    if (e === document.documentElement || e === document.body) {
      u.preventDefault();
      return;
    }
    const p = u.changedTouches[0].pageY, f = e.scrollTop, m = e.scrollHeight - e.clientHeight;
    m !== 0 && ((f <= 0 && p > t || f >= m && p < t) && u.preventDefault(), t = p);
  }, o = (u) => {
    const p = u.target;
    Kd(p) && p !== document.activeElement && (u.preventDefault(), p.style.transform = "translateY(-2000px)", p.focus(), requestAnimationFrame(() => {
      p.style.transform = "";
    }));
  }, i = (u) => {
    const p = u.target;
    Kd(p) && (p.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      p.style.transform = "", os && (os.height < window.innerHeight ? requestAnimationFrame(() => {
        Gd(p);
      }) : os.addEventListener(
        "resize",
        () => {
          Gd(p);
        },
        { once: !0 }
      ));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, c = Us(
    lr(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    lr(document.documentElement, "overflow", "hidden"),
    lr(document.body, "marginTop", `-${l}px`)
  );
  window.scrollTo(0, 0);
  const d = Us(
    Un(document, "touchstart", n, {
      passive: !1,
      capture: !0
    }),
    Un(document, "touchmove", r, {
      passive: !1,
      capture: !0
    }),
    Un(document, "touchend", o, {
      passive: !1,
      capture: !0
    }),
    Un(document, "focus", i, !0),
    Un(window, "scroll", s)
  );
  return () => {
    c(), d(), window.scrollTo(a, l);
  };
}
function lr(e, t, n) {
  const r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Un(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Gd(e) {
  const t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    const n = $h(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      const r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top;
      o > r + e.clientHeight && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function Kd(e) {
  return e instanceof HTMLInputElement && !$T.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
var TT = {
  wrapper: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden",
    pointerEvents: "none"
  },
  backdrop: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    touchAction: "none",
    // Disable iOS body scrolling
    border: "none"
  },
  container: {
    zIndex: 2,
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  },
  headerWrapper: {
    width: "100%"
  },
  header: {
    height: "40px",
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  indicator: {
    width: "18px",
    height: "4px",
    borderRadius: "99px",
    backgroundColor: "#ddd"
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "0px",
    position: "relative"
  },
  scroller: {
    height: "100%",
    overflowY: "auto"
  }
}, ct = TT, Ah = A(
  ({
    onOpenStart: e,
    onOpenEnd: t,
    onClose: n,
    onCloseStart: r,
    onCloseEnd: o,
    onSnap: i,
    children: s,
    disableScrollLocking: a = !1,
    isOpen: l,
    snapPoints: c,
    rootId: d,
    mountPoint: u,
    style: p,
    detent: f = "full-height",
    initialSnap: m = 0,
    disableDrag: g = !1,
    prefersReducedMotion: y = !1,
    tweenConfig: b = dT,
    ...w
  }, x) => {
    const $ = oe(null), E = Hs(0), { height: S } = bT(), F = WS(), R = !!(y || F), L = {
      type: "tween",
      ...R ? uT : b
    }, P = Hs(0), j = jo(
      P,
      (B) => B + 2 >= S ? -1 : 9999999
    ), _ = jo(
      P,
      (B) => B + 2 >= S ? "hidden" : "visible"
    ), G = oe({
      onOpenStart: e,
      onOpenEnd: t,
      onCloseStart: r,
      onCloseEnd: o
    });
    tl(() => {
      G.current = {
        onOpenStart: e,
        onOpenEnd: t,
        onCloseStart: r,
        onCloseEnd: o
      };
    }), c && (c = c.map((B) => B > 0 && B <= 1 ? Math.round(B * S) : B < 0 ? S + B : B), console.assert(
      mT(c) || S === 0,
      `Snap points need to be in descending order got: [${c.join(
        ", "
      )}]`
    ));
    const D = rs((B, { delta: X }) => {
      const te = P.getVelocity();
      te > 0 && E.set(10), te < 0 && E.set(-10), P.set(Math.max(P.get() + X.y, 0));
    }), I = rs(() => {
      const B = document.activeElement;
      if (!B || !$.current)
        return;
      (B.tagName === "INPUT" || B.tagName === "TEXTAREA") && $.current.contains(B) && B.blur();
    }), z = rs((B, { velocity: X }) => {
      if (X.y > fT)
        n();
      else {
        const te = $.current.getBoundingClientRect().height, we = P.get();
        let J = 0;
        if (c) {
          const Z = c.map(
            (ue) => te - Math.min(ue, te)
          );
          f === "content-height" && !Z.includes(0) && Z.unshift(0), J = jd(Z, we);
        } else we / te > pT && (J = te);
        if (J = Ud({ snapTo: J, sheetHeight: te }), Nd(P, J, L), c && i) {
          const Z = Math.abs(Math.round(c[0] - J)), ue = c.indexOf(jd(c, Z));
          i(ue);
        }
        const Q = Math.round(te);
        J + 2 >= Q && n();
      }
      E.set(0);
    });
    Y(() => {
      if (!c || !i)
        return;
      const B = l ? m : c.length - 1;
      i(B);
    }, [l]), Nh(x, () => ({
      y: P,
      snapTo: (B) => {
        const X = $.current;
        if ((c == null ? void 0 : c[B]) !== void 0 && X) {
          const te = X.getBoundingClientRect().height, we = c[B], J = Ud({
            snapTo: te - we,
            sheetHeight: te
          });
          Nd(P, J, L), i && i(B), J >= te && n();
        }
      }
    })), vT(l, d), CT({ isDisabled: a || !l });
    const O = K(() => g ? void 0 : {
      drag: "y",
      dragElastic: 0,
      dragMomentum: !1,
      dragPropagation: !1,
      onDrag: D,
      onDragStart: I,
      onDragEnd: z
    }, [g, S]), V = {
      y: P,
      sheetRef: $,
      isOpen: l,
      initialSnap: m,
      snapPoints: c,
      detent: f,
      indicatorRotation: E,
      callbacks: G,
      dragProps: O,
      windowHeight: S,
      animationOptions: L,
      reduceMotion: R,
      disableDrag: g
    }, N = /* @__PURE__ */ ge.createElement(Th.Provider, { value: V }, /* @__PURE__ */ ge.createElement(
      St.div,
      {
        ...w,
        ref: x,
        style: { ...ct.wrapper, zIndex: j, visibility: _, ...p }
      },
      /* @__PURE__ */ ge.createElement(FS, null, l ? /* @__PURE__ */ ge.createElement(wT, null, Tt.map(
        s,
        (B, X) => tn(B, { key: `sheet-child-${X}` })
      )) : null)
    ));
    return Ch ? N : _h(N, u ?? document.body);
  }
);
Ah.displayName = "Sheet";
var ET = Ah, Ph = A(
  ({ children: e, style: t = {}, className: n = "", ...r }, o) => {
    const {
      y: i,
      isOpen: s,
      callbacks: a,
      snapPoints: l,
      initialSnap: c = 0,
      sheetRef: d,
      windowHeight: u,
      detent: p,
      animationOptions: f,
      reduceMotion: m
    } = ki(), { handleAnimationComplete: g } = yT(s, a), y = l ? l[0] - l[c] : 0, b = l ? l[0] : null, w = b !== null ? `min(${b}px, ${_d})` : _d;
    return /* @__PURE__ */ ge.createElement(
      St.div,
      {
        ...r,
        ref: el([d, o]),
        className: `react-modal-sheet-container ${n}`,
        style: {
          ...ct.container,
          ...t,
          ...p === "full-height" && { height: w },
          ...p === "content-height" && { maxHeight: w },
          y: i
        },
        initial: m ? !1 : { y: u },
        animate: { y, transition: f },
        exit: { y: u, transition: f },
        onAnimationComplete: g
      },
      e
    );
  }
);
Ph.displayName = "SheetContainer";
var RT = Ph, Mh = A(
  ({ children: e, style: t, disableDrag: n, className: r = "", ...o }, i) => {
    const s = ki(), a = Rh(), { constraintsRef: l, onMeasureDragConstraints: c } = Sh(), d = n || a.disableDrag ? void 0 : s.dragProps;
    return /* @__PURE__ */ ge.createElement(
      St.div,
      {
        ...o,
        ref: el([i, l]),
        className: `react-modal-sheet-content ${r}`,
        style: { ...ct.content, ...t },
        ...d,
        dragConstraints: l,
        onMeasureDragConstraints: c
      },
      e
    );
  }
);
Mh.displayName = "SheetContent";
var AT = Mh, Dh = A(
  ({ children: e, style: t, disableDrag: n, ...r }, o) => {
    const { indicatorRotation: i, dragProps: s } = ki(), { constraintsRef: a, onMeasureDragConstraints: l } = Sh(), c = n ? void 0 : s, d = jo(
      i,
      (p) => `translateX(2px) rotate(${p}deg)`
    ), u = jo(
      i,
      (p) => `translateX(-2px) rotate(${-1 * p}deg)`
    );
    return /* @__PURE__ */ ge.createElement(
      St.div,
      {
        ...r,
        ref: el([o, a]),
        style: { ...ct.headerWrapper, ...t },
        ...c,
        dragConstraints: a,
        onMeasureDragConstraints: l
      },
      e || /* @__PURE__ */ ge.createElement("div", { className: "react-modal-sheet-header", style: ct.header }, /* @__PURE__ */ ge.createElement(
        St.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...ct.indicator, transform: d }
        }
      ), /* @__PURE__ */ ge.createElement(
        St.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...ct.indicator, transform: u }
        }
      ))
    );
  }
);
Dh.displayName = "SheetHeader";
var PT = Dh, Yd = (e) => !!e.onClick || !!e.onTap, Bh = A(
  ({ style: e = {}, className: t = "", ...n }, r) => {
    const o = Yd(n) ? St.button : St.div, i = Yd(n) ? "auto" : "none";
    return /* @__PURE__ */ ge.createElement(
      o,
      {
        ...n,
        ref: r,
        className: `react-modal-sheet-backdrop ${t}`,
        style: { ...ct.backdrop, ...e, pointerEvents: i },
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }
    );
  }
);
Bh.displayName = "SheetBackdrop";
var MT = Bh, Lh = A(
  ({ draggableAt: e = "top", children: t, style: n, className: r = "", ...o }, i) => {
    const s = Rh();
    function a(u) {
      const { scrollTop: p, scrollHeight: f, clientHeight: m } = u;
      if (!(f > m))
        return;
      const y = p <= 0, b = f - p === m;
      e === "top" && y || e === "bottom" && b || e === "both" && (y || b) ? s.setDragEnabled() : s.setDragDisabled();
    }
    function l(u) {
      a(u.currentTarget);
    }
    function c(u) {
      a(u.currentTarget);
    }
    const d = gT() ? { onScroll: l, onTouchStart: c } : void 0;
    return /* @__PURE__ */ ge.createElement(
      "div",
      {
        ...o,
        ref: i,
        className: `react-modal-sheet-scroller ${r}`,
        style: { ...ct.scroller, ...n },
        ...d
      },
      t
    );
  }
);
Lh.displayName = "SheetScroller";
var DT = Lh, On = ET;
On.Container = RT;
On.Header = PT;
On.Content = AT;
On.Backdrop = MT;
On.Scroller = DT;
var fn = On;
const BT = { backgroundColor: "rgba(29, 32, 35, 0.4)", backdropFilter: "blur(4px)" }, Ih = A((e, t) => {
  const {
    isOpen: n = !1,
    title: r,
    subtitle: o,
    handlebar: i = !0,
    children: s,
    headerTextCenter: a = !1,
    closeButton: l,
    backButton: c,
    backdrop: d = !0,
    height: u = "full-height",
    closeOnBackdropTap: p = !0,
    className: f,
    id: m,
    onBack: g,
    onClose: y
  } = e, b = ie(), w = () => {
    g && g();
  }, x = () => {
    p && y();
  };
  return /* @__PURE__ */ M(
    LT,
    {
      rootId: m,
      className: f,
      isOpen: n,
      onClose: y,
      ref: t,
      detent: u,
      children: [
        /* @__PURE__ */ M(fn.Container, { style: { backgroundColor: b.colors.background.primary }, children: [
          /* @__PURE__ */ h(fn.Header, { children: /* @__PURE__ */ M(
            IT,
            {
              $center: a,
              $noTitle: !r,
              $hasBackdrop: d,
              $handlebar: i,
              children: [
                c && /* @__PURE__ */ h(zT, { size: 32, variant: "ghost", onClick: w, children: /* @__PURE__ */ h(q, { iconPath: "granat/chevron-left/size-24-style-outline" }) }),
                r && /* @__PURE__ */ h(
                  FT,
                  {
                    forwardedAs: "h4",
                    font: "h4Wide",
                    $paddingLeft: c && !a,
                    $paddingRight: l && !a,
                    $textCenter: a,
                    textAlign: a ? "center" : "unset",
                    children: r
                  }
                ),
                o && r && /* @__PURE__ */ h(
                  VT,
                  {
                    forwardedAs: "p",
                    font: "p4RegularComp",
                    color: b.colors.text.secondary,
                    textAlign: a ? "center" : "unset",
                    children: o
                  }
                ),
                l && /* @__PURE__ */ h(OT, { size: 32, variant: "secondary", onClick: y, children: /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-24-style-outline" }) })
              ]
            }
          ) }),
          /* @__PURE__ */ h(fn.Content, { disableDrag: !0, children: /* @__PURE__ */ h(fn.Scroller, { children: s }) })
        ] }),
        /* @__PURE__ */ h(
          fn.Backdrop,
          {
            onTap: x,
            style: d ? BT : { backgroundColor: "transparent" }
          }
        )
      ]
    }
  );
}), LT = v(fn)`
  .react-modal-sheet-container {
    border-top-left-radius: 32px !important;
    border-top-right-radius: 32px !important;
    padding-bottom: calc(env(safe-area-inset-bottom) + 20px);
  }
`, IT = v.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $center: e }) => e ? "center" : "flex-start"};
  justify-content: center;
  padding: ${({ $noTitle: e = !1 }) => e ? "10px" : "20px"};
  gap: 4px;
  box-sizing: border-box;
  position: relative;
  cursor: grab;
  ${({ $handlebar: e, $hasBackdrop: t, theme: n }) => e && C`
      &::before {
        content: '';
        width: 32px;
        height: 4px;
        border-radius: 2px;
        background: ${t ? n.colors.constant.greyscale0 : n.colors.icons.primary};
        opacity: 0.35;
        position: absolute;
        top: -8px;
        right: 50%;
        transform: translate(50%);
      }
    `}
`, FT = v(H)`
  box-sizing: border-box;
  padding: ${({ $textCenter: e }) => e ? "4px 40px" : "4px 0"};
  overflow-wrap: break-word;
  word-break: break-word;
  ${({ $paddingLeft: e }) => e && C`
      padding-left: 40px;
    `};
  ${({ $paddingRight: e }) => e && C`
      padding-right: 40px;
    `};
`, VT = v(H)`
  overflow-wrap: break-word;
  word-break: break-word;
`, OT = v(Ce)`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 3;
`, zT = v(Ce)`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 3;
`, CR = A((e, t) => {
  const { children: n, height: r = "content-height", ...o } = e;
  return /* @__PURE__ */ h(Ih, { ...o, ref: t, height: r, closeButton: !0, children: n });
}), kR = ({ negative: e, icon: t, ...n }) => {
  const r = ie();
  return /* @__PURE__ */ h(
    kg,
    {
      ...n,
      textColor: e ? r.colors.accent.negative : r.colors.text.primary,
      slotBefore: t ? /* @__PURE__ */ h(
        Eg,
        {
          iconColor: e ? r.colors.accent.negative : r.colors.icons.secondary,
          icon: t
        }
      ) : void 0
    }
  );
}, NT = (e) => {
  const {
    headerTextCenter: t,
    title: n,
    subtitle: r,
    backButton: o,
    onBack: i,
    onClose: s,
    closeButton: a,
    className: l,
    handlebar: c = !1,
    backdrop: d = !0,
    ...u
  } = e, p = ie();
  return /* @__PURE__ */ M(
    WT,
    {
      ...u,
      className: l,
      $center: t,
      $noTitle: !n,
      $hasBackdrop: d,
      $handlebar: c,
      children: [
        o && /* @__PURE__ */ h(HT, { size: 32, variant: "ghost", onClick: i, children: /* @__PURE__ */ h(q, { iconPath: "granat/chevron-left/size-24-style-outline" }) }),
        n && /* @__PURE__ */ h(_T, { forwardedAs: "h4", font: "h4Wide", $paddingLeft: o && !t, children: n }),
        r && n && /* @__PURE__ */ h(H, { as: "p", font: "p4RegularComp", color: p.colors.text.secondary, children: r }),
        a && /* @__PURE__ */ h(jT, { size: 32, variant: "secondary", onClick: s, children: /* @__PURE__ */ h(q, { iconPath: "granat/cross/size-24-style-outline" }) })
      ]
    }
  );
}, WT = v.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $center: e }) => e ? "center" : "flex-start"};
  justify-content: center;
  padding: ${({ $noTitle: e = !1 }) => e ? "10px" : "20px"};
  gap: 4px;
  box-sizing: border-box;
  position: relative;
  @media (max-width: ${me.tablet - 1}px) {
    ${({ $handlebar: e, $hasBackdrop: t, theme: n }) => e && C`
        &::before {
          content: '';
          width: 32px;
          height: 4px;
          border-radius: 2px;
          background: ${t ? n.colors.constant.greyscale0 : n.colors.icons.primary};
          opacity: 0.35;
          position: absolute;
          top: -8px;
          right: 50%;
          transform: translate(50%);
        }
      `}
  }
`, _T = v(H)`
  padding: 4px 0;
  ${({ $paddingLeft: e }) => e && C`
      padding-left: 40px;
    `};
`, jT = v(Ce)`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 3;
`, HT = v(Ce)`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 3;
`, UT = {
  s: "440px",
  m: "600px",
  l: "720px"
}, GT = A((e, t) => {
  const {
    children: n,
    size: r = "m",
    isOpen: o,
    onClose: i,
    title: s,
    subtitle: a,
    headerTextCenter: l,
    closeButton: c,
    backButton: d,
    onBack: u,
    backdrop: p = !0,
    handlebar: f = !0,
    root: m,
    id: g
  } = e, { isMobile: y } = Ln(), { refs: b, context: w } = ei({
    open: o,
    onOpenChange: i
  }), x = Jo(w), $ = ni(w), E = Qo(w, {
    outsidePressEvent: "mousedown",
    outsidePress: !!c
  }), { getFloatingProps: S } = ti([x, $, E]), F = yr(), { styles: R } = Wu(w, {
    duration: 300,
    initial: {
      opacity: 0,
      transform: y ? "translateY(50%)" : "scale(0.8)"
    },
    open: {
      opacity: 1,
      transform: y ? "translateY(0)" : "scale(1)"
    }
  });
  return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(Vu, { id: g, root: m, children: o && /* @__PURE__ */ h(KT, { lockScroll: !0, ref: t, $backdrop: p, children: /* @__PURE__ */ h(zu, { context: w, returnFocus: !1, initialFocus: -1, children: /* @__PURE__ */ M(
    YT,
    {
      style: R,
      $size: r,
      ref: b.setFloating,
      "aria-labelledby": F,
      ...S(),
      children: [
        /* @__PURE__ */ h(
          NT,
          {
            id: F,
            onClose: i,
            title: s,
            subtitle: a,
            headerTextCenter: l,
            closeButton: c,
            backButton: d,
            onBack: u,
            handlebar: f,
            backdrop: p
          }
        ),
        /* @__PURE__ */ M(XT, { children: [
          " ",
          n
        ] })
      ]
    }
  ) }) }) }) });
}), KT = v(Nu)`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: ${({ $backdrop: e }) => e ? "rgba(29, 32, 35, 0.4)" : "transparent"};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1;
  @media (min-width: ${me.tablet}px) {
    align-items: center;
  }
`, YT = v.div`
  position: relative;
  width: 100%;
  background: ${({ theme: e }) => e.colors.background.primary};
  display: flex;
  flex-direction: column;
  border-radius: 32px 32px 0 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: calc(100vh - 40px);
  height: auto;
  overflow: hidden;
  outline: none;
  padding-bottom: env(safe-area-inset-bottom);
  @media (min-width: ${me.tablet}px) {
    width: ${({ $size: e }) => UT[e]};
    border-radius: 32px;
  }
`, XT = v.div`
  overflow-y: auto;
`, SR = A((e, t) => {
  const { children: n, size: r = "m", height: o = "full-height", isOpen: i, onClose: s, ...a } = e, { isMobile: l } = Ln();
  return /* @__PURE__ */ h(We, { children: l ? /* @__PURE__ */ h(Ih, { ref: t, ...a, isOpen: i, onClose: s, height: o, children: n }) : /* @__PURE__ */ h(GT, { ref: t, ...a, isOpen: i, onClose: s, size: r, children: n }) });
}), TR = A((e, t) => {
  const {
    children: n,
    isOpen: r,
    onClose: o,
    title: i,
    subtitle: s,
    graphic: a,
    backgroundContent: l,
    backgroundColor: c,
    className: d,
    root: u,
    id: p,
    controls: f
  } = e, m = ie(), { isMobile: g } = Ln(), { refs: y, context: b } = ei({
    open: r,
    onOpenChange: o
  }), w = Jo(b), x = ni(b), $ = Qo(b, {
    outsidePressEvent: "mousedown",
    outsidePress: !1
  }), { getFloatingProps: E } = ti([w, x, $]), S = yr(), { styles: F } = Wu(b, {
    duration: 300,
    initial: {
      opacity: 0,
      transform: g ? "translateY(50%)" : "scale(0.8)"
    },
    open: {
      opacity: 1,
      transform: g ? "translateY(0)" : "scale(1)"
    }
  });
  return /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(Vu, { id: p, root: u, children: r && /* @__PURE__ */ h(ZT, { lockScroll: !0, ref: t, children: /* @__PURE__ */ h(zu, { context: b, returnFocus: !1, initialFocus: 1, children: /* @__PURE__ */ M(
    qT,
    {
      className: d,
      style: F,
      ref: y.setFloating,
      "aria-labelledby": S,
      ...E(),
      $backgroundColor: c,
      children: [
        (a || l) && /* @__PURE__ */ h(eE, { children: l ? null : a }),
        l && /* @__PURE__ */ h(QT, { children: l }),
        /* @__PURE__ */ M(JT, { children: [
          /* @__PURE__ */ h(
            H,
            {
              as: "h4",
              font: l ? "h3Wide" : "h4Wide",
              color: m.colors.text.primary,
              children: i
            }
          ),
          s && /* @__PURE__ */ h(
            H,
            {
              as: "p",
              font: l ? "p3MediumComp" : "p3RegularComp",
              color: m.colors.text.secondary,
              children: s
            }
          )
        ] }),
        n,
        f
      ]
    }
  ) }) }) }) });
}), ZT = v(Nu)`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: rgba(29, 32, 35, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1;
  @media (min-width: ${me.tablet}px) {
    align-items: center;
  }
`, qT = v.div`
  position: relative;
  width: 359px;
  background: ${({ theme: e }) => e.colors.background.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-radius: 32px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: calc(100vh - 40px);
  height: auto;
  overflow: hidden;
  padding: 32px 20px 20px 20px;
  margin-bottom: 8px;
  background: ${({ $backgroundColor: e, theme: t }) => e || t.colors.background.primary};
  @media (min-width: ${me.desktopXS}px) {
    min-width: 440px;
    max-width: 600px;
    width: fit-content;
    margin-bottom: 0;
  }
`, JT = v.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 100%;
  word-break: break-word;
  text-align: center;
`, QT = v.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: absolute;
  height: 324px;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
  img {
    object-fit: cover;
    object-position: top;
    width: 100%;
    max-height: 100%;
  }
`, eE = v.div`
  min-height: 168px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 24px;
`, ER = A((e, t) => {
  const { children: n, className: r, ...o } = e, i = K(() => Array.isArray(n) ? n.map((s) => T.cloneElement(s, { size: 52, fluid: !0 })) : T.cloneElement(n, { size: 52, fluid: !0 }), [n]);
  return /* @__PURE__ */ h(tE, { ...o, ref: t, className: r, children: i });
}), tE = v.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding-top: 24px;
  @media (min-width: ${me.desktopXS}px) {
    flex-direction: row;
  }
`, W = `${nu}/fonts`, k = Object.freeze({
  mtsSansRegular: "MTSSans-Regular",
  mtsSansMedium: "MTSSans-Medium",
  mtsSansBold: "MTSSans-Bold",
  mtsSansBlack: "MTSSans-Black",
  mtsCompactRegular: "MTSCompact-Regular",
  mtsCompactMedium: "MTSCompact-Medium",
  mtsCompactBold: "MTSCompact-Bold",
  mtsCompactBlack: "MTSCompact-Black",
  mtsTextRegular: "MTSText-Regular",
  mtsTextMedium: "MTSText-Medium",
  mtsTextBold: "MTSText-Bold",
  mtsTextBlack: "MTSText-Black",
  mtsWideRegular: "MTSWide-Regular",
  mtsWideMedium: "MTSWide-Medium",
  mtsWideLight: "MTSWide-Light",
  mtsWideBold: "MTSWide-Bold",
  mtsWideBlack: "MTSWide-Black"
}), nE = C`
  @font-face {
    font-family: 'MTS Sans';
    src: url('${W}/${k.mtsSansRegular}/${k.mtsSansRegular}.eot');
    src:
      url('${W}/${k.mtsSansRegular}/${k.mtsSansRegular}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsSansRegular}/${k.mtsSansRegular}.woff2') format('woff2'),
      url('${W}/${k.mtsSansRegular}/${k.mtsSansRegular}.woff') format('woff'),
      url('${W}/${k.mtsSansRegular}/${k.mtsSansRegular}.ttf') format('truetype'),
      url('${W}/${k.mtsSansRegular}/${k.mtsSansRegular}.svg#${k.mtsSansRegular}')
        format('svg');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Sans';
    src: url('${W}/${k.mtsSansMedium}/${k.mtsSansMedium}.eot');
    src:
      url('${W}/${k.mtsSansMedium}/${k.mtsSansMedium}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsSansMedium}/${k.mtsSansMedium}.woff2') format('woff2'),
      url('${W}/${k.mtsSansMedium}/${k.mtsSansMedium}.woff') format('woff'),
      url('${W}/${k.mtsSansMedium}/${k.mtsSansMedium}.ttf') format('truetype'),
      url('${W}/${k.mtsSansMedium}/${k.mtsSansMedium}.svg#${k.mtsSansMedium}')
        format('svg');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Sans';
    src: url('${W}/${k.mtsSansBold}/${k.mtsSansBold}.eot');
    src:
      url('${W}/${k.mtsSansBold}/${k.mtsSansBold}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsSansBold}/${k.mtsSansBold}.woff2') format('woff2'),
      url('${W}/${k.mtsSansBold}/${k.mtsSansBold}.woff') format('woff'),
      url('${W}/${k.mtsSansBold}/${k.mtsSansBold}.ttf') format('truetype'),
      url('${W}/${k.mtsSansBold}/${k.mtsSansBold}.svg#${k.mtsSansBold}')
        format('svg');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Sans';
    src: url('${W}/${k.mtsSansBlack}/${k.mtsSansBlack}.eot');
    src:
      url('${W}/${k.mtsSansBlack}/${k.mtsSansBlack}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsSansBlack}/${k.mtsSansBlack}.woff2') format('woff2'),
      url('${W}/${k.mtsSansBlack}/${k.mtsSansBlack}.woff') format('woff'),
      url('${W}/${k.mtsSansBlack}/${k.mtsSansBlack}.ttf') format('truetype'),
      url('${W}/${k.mtsSansBlack}/${k.mtsSansBlack}.svg#${k.mtsSansBlack}')
        format('svg');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
`, rE = C`
  @font-face {
    font-family: 'MTS Compact';
    src: url('${W}/${k.mtsCompactRegular}/${k.mtsCompactRegular}.eot');
    src:
      url('${W}/${k.mtsCompactRegular}/${k.mtsCompactRegular}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsCompactRegular}/${k.mtsCompactRegular}.woff2')
        format('woff2'),
      url('${W}/${k.mtsCompactRegular}/${k.mtsCompactRegular}.woff')
        format('woff'),
      url('${W}/${k.mtsCompactRegular}/${k.mtsCompactRegular}.ttf')
        format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Compact';
    src: url('${W}/${k.mtsCompactMedium}/${k.mtsCompactMedium}.eot');
    src:
      url('${W}/${k.mtsCompactMedium}/${k.mtsCompactMedium}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsCompactMedium}/${k.mtsCompactMedium}.woff2')
        format('woff2'),
      url('${W}/${k.mtsCompactMedium}/${k.mtsCompactMedium}.woff')
        format('woff'),
      url('${W}/${k.mtsCompactMedium}/${k.mtsCompactMedium}.ttf')
        format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Compact';
    src: url('${W}/${k.mtsCompactBold}/${k.mtsCompactBold}.eot');
    src:
      url('${W}/${k.mtsCompactBold}/${k.mtsCompactBold}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsCompactBold}/${k.mtsCompactBold}.woff2') format('woff2'),
      url('${W}/${k.mtsCompactBold}/${k.mtsCompactBold}.woff') format('woff'),
      url('${W}/${k.mtsCompactBold}/${k.mtsCompactBold}.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Compact';
    src: url('${W}/${k.mtsCompactBlack}/${k.mtsCompactBlack}.eot');
    src:
      url('${W}/${k.mtsCompactBlack}/${k.mtsCompactBlack}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsCompactBlack}/${k.mtsCompactBlack}.woff2')
        format('woff2'),
      url('${W}/${k.mtsCompactBlack}/${k.mtsCompactBlack}.woff') format('woff'),
      url('${W}/${k.mtsCompactBlack}/${k.mtsCompactBlack}.ttf')
        format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
`, oE = C`
  @font-face {
    font-family: 'MTS Text';
    src: url('${W}/${k.mtsTextRegular}/${k.mtsTextRegular}.eot');
    src:
      url('${W}/${k.mtsTextRegular}/${k.mtsTextRegular}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsTextRegular}/${k.mtsTextRegular}.woff2') format('woff2'),
      url('${W}/${k.mtsTextRegular}/${k.mtsTextRegular}.woff') format('woff'),
      url('${W}/${k.mtsTextRegular}/${k.mtsTextRegular}.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Text';
    src: url('${W}/${k.mtsTextMedium}/${k.mtsTextMedium}.eot');
    src:
      url('${W}/${k.mtsTextMedium}/${k.mtsTextMedium}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsTextMedium}/${k.mtsTextMedium}.woff2') format('woff2'),
      url('${W}/${k.mtsTextMedium}/${k.mtsTextMedium}.woff') format('woff'),
      url('${W}/${k.mtsTextMedium}/${k.mtsTextMedium}.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Text';
    src: url('${W}/${k.mtsTextBold}/${k.mtsTextBold}.eot');
    src:
      url('${W}/${k.mtsTextBold}/${k.mtsTextBold}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsTextBold}/${k.mtsTextBold}.woff2') format('woff2'),
      url('${W}/${k.mtsTextBold}/${k.mtsTextBold}.woff') format('woff'),
      url('${W}/${k.mtsTextBold}/${k.mtsTextBold}.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Text';
    src: url('${W}/${k.mtsTextBlack}/${k.mtsTextBlack}.eot');
    src:
      url('${W}/${k.mtsTextBlack}/${k.mtsTextBlack}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsTextBlack}/${k.mtsTextBlack}.woff2') format('woff2'),
      url('${W}/${k.mtsTextBlack}/${k.mtsTextBlack}.woff') format('woff'),
      url('${W}/${k.mtsTextBlack}/${k.mtsTextBlack}.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
`, iE = C`
  @font-face {
    font-family: 'MTS Wide';
    src: url('${W}/${k.mtsWideRegular}/${k.mtsWideRegular}.eot');
    src:
      url('${W}/${k.mtsWideRegular}/${k.mtsWideRegular}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsWideRegular}/${k.mtsWideRegular}.woff2') format('woff2'),
      url('${W}/${k.mtsWideRegular}/${k.mtsWideRegular}.woff') format('woff'),
      url('${W}/${k.mtsWideRegular}/${k.mtsWideRegular}.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Wide';
    src: url('${W}/${k.mtsWideMedium}/${k.mtsWideMedium}.eot');
    src:
      url('${W}/${k.mtsWideMedium}/${k.mtsWideMedium}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsWideMedium}/${k.mtsWideMedium}.woff2') format('woff2'),
      url('${W}/${k.mtsWideMedium}/${k.mtsWideMedium}.woff') format('woff'),
      url('${W}/${k.mtsWideMedium}/${k.mtsWideMedium}.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Wide';
    src: url('${W}/${k.mtsWideLight}/${k.mtsWideLight}.eot');
    src:
      url('${W}/${k.mtsWideLight}/${k.mtsWideLight}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsWideLight}/${k.mtsWideLight}.woff2') format('woff2'),
      url('${W}/${k.mtsWideLight}/${k.mtsWideLight}.woff') format('woff'),
      url('${W}/${k.mtsWideLight}/${k.mtsWideLight}.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Wide';
    src: url('${W}/${k.mtsWideBold}/${k.mtsWideBold}.eot');
    src:
      url('${W}/${k.mtsWideBold}/${k.mtsWideBold}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsWideBold}/${k.mtsWideBold}.woff2') format('woff2'),
      url('${W}/${k.mtsWideBold}/${k.mtsWideBold}.woff') format('woff'),
      url('${W}/${k.mtsWideBold}/${k.mtsWideBold}.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'MTS Wide';
    src: url('${W}/${k.mtsWideBlack}/${k.mtsWideBlack}.eot');
    src:
      url('${W}/${k.mtsWideBlack}/${k.mtsWideBlack}.eot?#iefix')
        format('embedded-opentype'),
      url('${W}/${k.mtsWideBlack}/${k.mtsWideBlack}.woff2') format('woff2'),
      url('${W}/${k.mtsWideBlack}/${k.mtsWideBlack}.woff') format('woff'),
      url('${W}/${k.mtsWideBlack}/${k.mtsWideBlack}.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
`, sE = C`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: neutralscale;
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
  }

  html {
    line-height: 1.15;
    box-sizing: border-box;
  }

  main {
    display: block;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }

  pre {
    font-family: monospace;
    font-size: 1em;
  }

  a {
    background-color: transparent;
    text-decoration: none;
    outline: none;
  }

  b,
  strong {
    font-weight: 700;
  }

  code,
  kbd,
  samp {
    font-family: monospace;
    font-size: 1em;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  img {
    border-style: none;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
  }

  input,
  textarea {
    text-decoration: none;
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  legend {
    color: inherit;
    display: table;
    max-width: 100%;
    white-space: normal;
  }

  progress {
    vertical-align: baseline;
  }

  textarea {
    overflow: auto;
  }

  [type='checkbox'],
  [type='radio'] {
    padding: 0;
  }

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  [type='search'] {
    outline-offset: -2px;
  }

  ::-webkit-file-upload-button {
    font: inherit;
  }

  details {
    display: block;
  }

  summary {
    display: list-item;
  }

  template {
    display: none;
  }

  *[hidden] {
    display: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  html,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
  }

  button {
    border: none;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;
    outline: none;
  }
`, aE = Wh`
  
  ${sE}
  ${nE}
  ${rE}
  ${iE}
  ${oE}
  
  * {
    -webkit-tap-highlight-color: transparent;
  }

`, RR = ({ children: e }) => /* @__PURE__ */ M(We, { children: [
  /* @__PURE__ */ h(aE, {}),
  /* @__PURE__ */ h(yx, { children: e })
] });
export {
  h3 as Accordion,
  kR as ActionCell,
  CR as ActionSheet,
  t3 as Avatar,
  nu as BASE_URL,
  bE as Badge,
  KE as BannerPrimary,
  qE as BannerSecondary,
  ZE as BannerTertiary,
  ri as BaseButton,
  HE as BottomButton,
  Ih as BottomSheet,
  tR as Breadcrumb,
  nR as BreadcrumbItem,
  f3 as BulletedList,
  d3 as BulletedListItem,
  u3 as BulletedSubList,
  p3 as BulletedSubListItem,
  o3 as BusinessIcon,
  jv as Button,
  Ce as ButtonIcon,
  NE as ButtonIconSet,
  jE as ButtonIconSetAlternative,
  _E as ButtonIconSetAlternativeItem,
  WE as ButtonIconSetItem,
  zE as ButtonPrice,
  m3 as CardBackground,
  OE as CardContent,
  kg as Cell,
  SE as CellData,
  Eg as CellIcon,
  TE as CellImage,
  iR as CellMenu,
  oR as CellMenuItem,
  $g as CellText,
  tp as Checkbox,
  C3 as CheckboxCell,
  T3 as CheckboxRow,
  xE as Chips,
  op as ControlCell,
  $3 as ControlList,
  vR as Controls,
  lu as Counter,
  om as DSLParser,
  tu as DSLRules,
  vE as DSLRulesGuide,
  eu as Divider,
  hy as DoneStatusIcon,
  V3 as Dropdown,
  G3 as DropdownAutocomplete,
  K3 as DropdownChipAutocomplete,
  on as Droplist,
  kE as Emblem,
  my as ErrorStatusIcon,
  pa as Flex,
  kv as FormatAliasPhone,
  GE as GosuslugiButton,
  xR as Grid,
  bR as GridItem,
  q as Icon,
  YE as InfoStatusIcon,
  W3 as InlineEdit,
  sn as Input,
  j3 as InputAutocomplete,
  H3 as InputChipAutocomplete,
  s$ as InputCode,
  B3 as InputDate,
  P3 as InputLoader,
  D3 as InputMoney,
  Y3 as InputMultiline,
  I3 as InputPassword,
  M3 as InputPhone,
  F3 as InputSearch,
  N3 as InputShapeScan,
  z3 as InputShapeText,
  U3 as InputStepper,
  L3 as InputTime,
  Qh as Link,
  S3 as ListItem,
  UE as Loader,
  yR as LoaderScreen,
  n3 as ManIcon,
  Sr as MaskedInput,
  ap as MediaBreakpointContext,
  yx as MediaBreakpointProvider,
  SR as Modal,
  TR as ModalCard,
  ER as ModalCardButtons,
  GT as ModalDesktop,
  yE as MoneyText,
  eR as Navbar,
  i3 as NoGenderIcon,
  c3 as NumberedList,
  s3 as NumberedListItem,
  a3 as NumberedSubList,
  l3 as NumberedSubListItem,
  mR as OTPScreen,
  rR as Pagination,
  sR as PaginationDotsClip,
  lR as ProgressCircle,
  aR as ProgressLinear,
  np as Radio,
  k3 as RadioCell,
  E3 as RadioRow,
  gR as ResultingScreen,
  QE as SegmentedControl,
  e3 as SegmentedControlItem,
  pR as SkeletonBody,
  hR as SkeletonCircle,
  fR as SkeletonRect,
  X3 as Slider,
  cR as Snackbar,
  O3 as SourceSelection,
  co as Spacer,
  ia as Spinner,
  CE as Spoiler,
  JE as StatusBanner,
  g3 as Step,
  v3 as Steps,
  b3 as StepsLine,
  RR as StyleProvider,
  w3 as Switch,
  J3 as Tab,
  q3 as Tabbar,
  Z3 as TabbarTab,
  Q3 as Tabs,
  H as Text,
  _3 as Textarea,
  dR as TimerIcon,
  wE as TitlePrimary,
  $E as TitleSecondary,
  uR as Toast,
  VE as Tooltip,
  XE as WarningStatusIcon,
  r3 as WomanIcon,
  me as breakpoints,
  $v as cleanObjectKeys,
  Sv as clearPhoneNumber,
  So as convertToCSS,
  ru as currencySymbols,
  BE as declOfNum,
  LE as document,
  ae as font,
  im as formatDecimal,
  DE as formatMoney,
  ME as formatPhoneNumber,
  Nn as getCssTemplateValue,
  ju as getScrollParentElement,
  hE as granatDarkTheme,
  fE as granatLightTheme,
  ta as isBrowser,
  AE as isNotNullable,
  _u as isNullable,
  Hu as isNumber,
  Hr as isNumberOrString,
  FE as isValueExists,
  bv as kebabize,
  gE as lavenderDarkTheme,
  mE as lavenderLightTheme,
  Bt as mergeRefs,
  IE as navigator,
  wv as objectKeys,
  RE as pull,
  PE as removeEmptyValues,
  Uo as shadows,
  Et as spacings,
  EE as toArray,
  Ln as useBreakpoint,
  pi as useClickOutside,
  R3 as useDebounce,
  A3 as useDidMount,
  gx as useEventListener,
  mx as useIsomorphicLayoutEffect,
  Ot as useMediaQuery,
  bx as useSize,
  x3 as useStepsLine,
  y3 as useStepsProgress,
  Ll as window
};
